export const Learnsets: import('../../../sim/dex-species').ModdedLearnsetDataTable = {
	bulbasaur: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["5E", "4E", "3E"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5L27", "4L27", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["5E", "4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5E", "4M", "3M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			grasswhistle: ["5E", "4E", "3E"],
			growl: ["5L3", "5S2", "4L3", "3L4", "3S1"],
			growth: ["5L25", "4L25", "3L32", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5E", "4E"],
			knockoff: ["4T"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5L7", "5S2", "4L7", "3L7", "3S1"],
			lightscreen: ["5M", "4E", "3E"],
			magicalleaf: ["5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["5E", "4E"],
			petaldance: ["5E", "4E", "3E"],
			poisonpowder: ["5L13", "4L13", "3L15"],
			powerwhip: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L19", "4L19", "3L20"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5L37", "4T", "4L37"],
			skullbash: ["5E", "4E", "3E"],
			sleeppowder: ["5L13", "4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5E", "4E"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M", "3L46", "3S0"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L21", "4L21", "3L25", "3S0"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L33", "4T", "4L33", "3L39", "3S0"],
			tackle: ["5L1", "5S2", "4L1", "3L1", "3S1"],
			takedown: ["5L15", "4L15"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L9", "5S2", "4L9", "3L10", "3S1"],
			worryseed: ["5L31", "4T", "4L31"],
		},
	},
	ivysaur: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5L31", "4L31", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			growl: ["5L1", "4L1", "3L1"],
			growth: ["5L28", "4L28", "3L38"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			leechseed: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonpowder: ["5L13", "4L13", "3L15"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L20", "4L20", "3L22"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["5L13", "4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L44", "4M", "4L44", "3M", "3L56"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L23", "4L23", "3L29"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L39", "4T", "4L39", "3L47"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L15", "4L15"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L9", "4L9", "3L10"],
			worryseed: ["5L36", "4T", "4L36"],
		},
	},
	venusaur: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5L31", "4L31", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frenzyplant: ["5T", "4T", "3T"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			growl: ["5L1", "4L1", "3L1"],
			growth: ["5L28", "4L28", "3L41"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			leechseed: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			petaldance: ["5L32", "4L32"],
			poisonpowder: ["5L13", "4L13", "3L15"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L20", "4L20", "3L22"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["5L13", "4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L53", "4M", "4L53", "3M", "3L65"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L23", "4L23", "3L29"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L45", "4T", "4L45", "3L53"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L15", "4L15"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L1", "4L1", "3L1"],
			worryseed: ["5L39", "4T", "4L39"],
		},
	},
	charmander: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			bellydrum: ["5E", "4E", "3E"],
			bite: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T"],
			crunch: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E", "3E"],
			dragonpulse: ["5E"],
			dragonrage: ["5L16", "4L16", "3L43"],
			dragonrush: ["5E", "4E"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			ember: ["5L7", "5S4", "4L7", "3L7", "3S0"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L25", "4L25"],
			firepledge: ["5T"],
			firepunch: ["4T", "3T"],
			firespin: ["5L43", "4L37", "3L49"],
			flameburst: ["5L28"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L37", "4M", "4L34", "3M", "3L31"],
			flareblitz: ["5E", "4E"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["5L1", "5S4", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			honeclaws: ["5M"],
			howl: ["4S1", "4S2", "4S3", "4S5"],
			incinerate: ["5M"],
			inferno: ["5L46"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["5E", "4E", "3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5E", "4E", "3E"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["4S1", "4S2", "4S3", "4S5"],
			rage: ["3L19"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "4S1", "4S2", "4S3", "4S5", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5L19", "4L19", "3L25"],
			scratch: ["5L1", "5S4", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L34", "4L28", "3L37"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L10", "5S4", "4L10", "3L13"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	charmeleon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonrage: ["5L17", "4L17", "3L48"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L28", "4L28"],
			firepledge: ["5T"],
			firepunch: ["4T", "3T"],
			firespin: ["5L50", "4L43", "3L55"],
			flameburst: ["5L32"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L43", "4M", "4L39", "3M", "3L34"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			inferno: ["5L54"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L13"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rage: ["3L20"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5L21", "4L21", "3L27"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L39", "4L32", "3L41"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L10", "4L10", "3L13"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	charizard: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["5L1", "4L1"],
			attract: ["5M", "4M", "3M"],
			blastburn: ["5T", "4T", "3T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "5L1", "4M", "4L1", "3M"],
			dragonpulse: ["4M"],
			dragonrage: ["5L17", "4L17", "3L54", "3S0"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L28", "4L28"],
			firepledge: ["5T"],
			firepunch: ["4T", "3T"],
			firespin: ["5L56", "4L49", "3L64", "3S0"],
			flameburst: ["5L32"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L47", "4M", "4L42", "3M", "3L34"],
			flareblitz: ["5L77", "4L66"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5L71", "4T", "4L59", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5L62"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rage: ["3L20"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			scaryface: ["5L21", "4L21", "3L27"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "5L1", "4M", "4L1"],
			skydrop: ["5M"],
			slash: ["5L41", "4L32", "3L44", "3S0"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			steelwing: ["4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			tailwind: ["4T"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			willowisp: ["5M", "4M"],
			wingattack: ["5L36", "4L36", "3L36", "3S0"],
		},
	},
	squirtle: {
		inherit: true,
		learnset: {
			aquajet: ["5E", "4E"],
			aquaring: ["5E", "4E"],
			aquatail: ["5L28", "4T", "4L28"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L16", "4L16", "3L18"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["5E", "4M"],
			bubble: ["5L7", "5S1", "4L7", "3L7", "3S0"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E"],
			flail: ["5E", "4E", "3E"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L40", "4L37", "3L47"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L34", "4T", "4L34"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "4E", "3E"],
			mist: ["5E", "4E", "3E"],
			muddywater: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "5L22", "4M", "4L22", "3M", "3L28"],
			raindance: ["5M", "5L37", "4M", "4L34", "3M", "3L33"],
			rapidspin: ["5L19", "4L19", "3L23"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["5L31", "4L31", "3L40"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			tailwhip: ["5L4", "5S1", "4L4", "3L4", "3S0"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L13", "4L13", "3L13"],
			waterpledge: ["5T"],
			waterpulse: ["5L25", "4M", "4L25", "3M"],
			waterspout: ["5E", "4E"],
			whirlpool: ["4M"],
			withdraw: ["5L10", "5S1", "4L10", "3L10", "3S0"],
			yawn: ["5E", "4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	wartortle: {
		inherit: true,
		learnset: {
			aquatail: ["5L32", "4T", "4L32"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L16", "4L16", "3L19"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["5L1", "4L1", "3L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L48", "4L44", "3L53"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L40", "4T", "4L40"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "5L24", "4M", "4L24", "3M", "3L31"],
			raindance: ["5M", "5L44", "4M", "4L40", "3M", "3L37"],
			rapidspin: ["5L20", "4L20", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["5L36", "4L36", "3L45"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L13", "4L13", "3L13"],
			waterpledge: ["5T"],
			waterpulse: ["5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["5L10", "4L10", "3L10"],
			zenheadbutt: ["4T"],
		},
	},
	blastoise: {
		inherit: true,
		learnset: {
			aquatail: ["5L32", "4T", "4L32"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L16", "4L16", "3L19"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["5L1", "4L1", "3L1"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "5L1", "4M", "4L1"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydrocannon: ["5T", "4T", "3T"],
			hydropump: ["5L60", "4L53", "3L68", "3S0"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L46", "4T", "4L46"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "5L24", "4M", "4L24", "3M", "3L31", "3S0"],
			raindance: ["5M", "5L53", "4M", "4L46", "3M", "3L42", "3S0"],
			rapidspin: ["5L20", "4L20", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			signalbeam: ["4T"],
			skullbash: ["5L39", "4L39", "3L55", "3S0"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L13", "4L13", "3L13"],
			waterpledge: ["5T"],
			waterpulse: ["5L28", "4M", "4L28", "3M"],
			whirlpool: ["4M"],
			withdraw: ["5L1", "4L1", "3L1"],
			zenheadbutt: ["4T"],
		},
	},
	caterpie: {
		inherit: true,
		learnset: {
			bugbite: ["5L15", "4T", "4L15"],
			snore: ["4T"],
			stringshot: ["5L1", "4T", "4L1", "3L1"],
			tackle: ["5L1", "4L1", "3L1"],
		},
	},
	metapod: {
		inherit: true,
		learnset: {
			bugbite: ["4T"],
			harden: ["5L1", "4L1", "3L1"],
			irondefense: ["4T"],
			stringshot: ["4T"],
		},
	},
	butterfree: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M", "3S0"],
			aircutter: ["5D", "4T"],
			attract: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L42", "4L40"],
			captivate: ["5L40", "4M", "4L36"],
			confusion: ["5L1", "5D", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L16", "4L16", "3L28"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			poisonpowder: ["5L12", "4L12", "3L13"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L24", "4L24", "3L34"],
			psychic: ["5M", "4M", "3M", "3S0"],
			psychup: ["5M", "4M"],
			quiverdance: ["5L46"],
			ragepowder: ["5L34"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5D", "4M"],
			round: ["5M"],
			safeguard: ["5M", "5L36", "4M", "4L34", "3M", "3L40"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["5L28", "4M", "4L28", "3L47"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["5L12", "4L12", "3L15", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L12", "4L12", "3L14"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L18", "4L18", "3L18"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5L30", "4T", "4L30"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			whirlwind: ["5L22", "4L22", "3L23"],
		},
	},
	weedle: {
		inherit: true,
		learnset: {
			bugbite: ["5L15", "4T", "4L15"],
			poisonsting: ["5L1", "4L1", "3L1"],
			stringshot: ["5L1", "4T", "4L1", "3L1"],
		},
	},
	kakuna: {
		inherit: true,
		learnset: {
			bugbite: ["4T"],
			harden: ["5L1", "4L1", "3L1"],
			irondefense: ["4T"],
			stringshot: ["4T"],
		},
	},
	beedrill: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L31", "4L31", "3L40"],
			aircutter: ["5D", "4T"],
			assurance: ["5L34", "4L34"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			brickbreak: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endeavor: ["5L40", "4T", "4L40", "3L45"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flash: ["5M", "4M"],
			focusenergy: ["5L13", "4L13", "3L15"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L1", "4L1", "3L1"],
			furycutter: ["5D", "4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pinmissile: ["5L28", "4L28", "3L35"],
			poisonjab: ["5M", "5L37", "4M", "4L37"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L22", "4L22", "3L30"],
			rage: ["5L19", "4L19", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M", "3S0"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T", "3S0"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L25", "4L25"],
			twineedle: ["5L16", "4L16", "3L20", "3S0"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			xscissor: ["5M", "4M"],
		},
	},
	pidgey: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L29", "4L29", "3L39"],
			aircutter: ["5E", "4T", "4E", "3E"],
			airslash: ["5L49", "5E", "4L49", "4E"],
			attract: ["5M", "4M", "3M"],
			bravebird: ["5E", "4E"],
			captivate: ["4M"],
			defog: ["5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5L25", "4L25", "3L31"],
			feintattack: ["5E", "4E", "3E"],
			fly: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gust: ["5L9", "5D", "4L9", "3L9"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hurricane: ["5L53"],
			mimic: ["3T"],
			mirrormove: ["5L45", "4L45", "3L47"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			quickattack: ["5L13", "4L13", "3L13"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L37", "4M", "4L37"],
			round: ["5M"],
			sandattack: ["5L5", "4L5", "3L5"],
			secretpower: ["5D", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "5D", "4M", "4E", "3M", "3E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["5L41", "4T", "4L41"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L21", "4T", "4L21"],
			uproar: ["5E", "4T", "4E"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L17", "4L17", "3L19"],
			wingattack: ["5L33", "4L33", "3L25"],
			workup: ["5M"],
		},
	},
	pidgeotto: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L32", "4L32", "3L43"],
			aircutter: ["4T"],
			airslash: ["5L57", "4L57"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5L27", "4L27", "3L34", "3S0"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gust: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hurricane: ["5L62"],
			mimic: ["3T"],
			mirrormove: ["5L52", "4L52", "3L52"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L13", "4L13", "3L13"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L42", "4M", "4L42"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M", "3S0"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["5L47", "4T", "4L47"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L22", "4T", "4L22"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L17", "4L17", "3L20"],
			wingattack: ["5L37", "4L37", "3L27", "3S0"],
			workup: ["5M"],
		},
	},
	pidgeot: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L32", "4L32", "3L48"],
			aircutter: ["4T"],
			airslash: ["5L62", "4L62"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5L27", "4L27", "3L34"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hurricane: ["5L68"],
			hyperbeam: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["5L56", "5S0", "4L56", "3L62"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L44", "4M", "4L44"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			skyattack: ["5S0", "4T", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["5L50", "4T", "4L50"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L22", "4T", "4L22"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L17", "5S0", "4L17", "3L20"],
			wingattack: ["5L38", "5S0", "4L38", "3L27"],
			workup: ["5M"],
		},
	},
	rattata: {
		inherit: true,
		learnset: {
			assurance: ["5L25", "4L25"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L10", "5E", "4L10", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["5E", "4E", "3T", "3E"],
			crunch: ["5L22", "4L22"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L31", "4L31", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			endeavor: ["5L34", "4T", "4L34", "3L41"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			finalgambit: ["5E"],
			flamewheel: ["5E", "4E", "3E"],
			focusenergy: ["5L7", "4L7", "3L20"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperfang: ["5L16", "4L16", "3L13"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["5D", "4M", "3M"],
			lastresort: ["5E", "4T", "4E"],
			mefirst: ["5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L13", "4L13", "3L27"],
			quickattack: ["5L4", "5D", "4L4", "3L7"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E"],
			reversal: ["5E", "4E", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L19", "4T", "4L19"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5L28", "4T", "4L28", "3L34"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5E", "4E", "3E"],
			uturn: ["5M", "4M"],
			wildcharge: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	raticate: {
		inherit: true,
		learnset: {
			assurance: ["5L29", "4L29"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L10", "4L10"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			crunch: ["5L24", "4L24"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L39", "4L39", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			endeavor: ["5L44", "4T", "4L44", "3L50"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			focusenergy: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hyperfang: ["5L16", "4L16", "3L13", "3S0"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L13", "4L13", "3L30"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L20", "4L20", "3L20", "3S0"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L19", "4T", "4L19"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5L34", "4T", "4L34", "3L40", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L1", "4M", "4L1"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "4M"],
			wildcharge: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	spearow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L17", "4M", "4L17", "3M", "3L25", "3S0"],
			agility: ["5L25", "4L25", "3L43"],
			aircutter: ["4T"],
			assurance: ["5L29", "4L29"],
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5L37", "4L37", "3L37"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4E", "3E", "3S0"],
			featherdance: ["5E", "4E"],
			feintattack: ["5E", "5D", "4E", "3E"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L9", "4L9", "3L13"],
			growl: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			leer: ["5L5", "4L5", "3L7", "3S0"],
			mimic: ["3T"],
			mirrormove: ["5L21", "4L21", "3L31"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L13", "4L13", "3L19"],
			quickattack: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L33", "4M", "4L33"],
			round: ["5M"],
			scaryface: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			skyattack: ["5E", "4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "5D", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5E", "4E", "3E"],
			twister: ["4T"],
			uproar: ["5E", "4E"],
			uturn: ["5M", "4M"],
			whirlwind: ["5E", "4E"],
			workup: ["5M"],
		},
	},
	fearow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L17", "4M", "4L17", "3M"],
			agility: ["5L29", "4L29", "3L47"],
			aircutter: ["4T"],
			assurance: ["5L35", "4L35"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5L47", "4L47", "3L40"],
			drillrun: ["5L53"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L1", "4L1", "3L1"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mirrormove: ["5L23", "4L23", "3L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L13", "4L13", "3L26"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L41", "4M", "4L41"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	ekans: {
		inherit: true,
		learnset: {
			acid: ["5L20", "4L20", "3L32"],
			acidspray: ["5L28"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			bite: ["5L9", "4L9", "3L13", "3S0"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			coil: ["5L44"],
			darkpulse: ["5D", "4M"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L36", "4T", "4L33"],
			gigadrain: ["4M", "3M"],
			glare: ["5L12", "4L12", "3L20"],
			gunkshot: ["5L49", "4T", "4L41"],
			haze: ["5L41", "4L36", "3L44"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["5E", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudbomb: ["5L33", "4L28"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonfang: ["5E", "4E", "3E"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L4", "4L4", "3L8", "3S0", "3S1"],
			poisontail: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5E", "4E"],
			screech: ["5L17", "4L17", "3L25"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snatch: ["5E", "4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5E", "4T", "4E", "3E"],
			spitup: ["5L25", "4L25", "3L37"],
			stockpile: ["5L25", "4L25", "3L37"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L25", "4L25", "3L37"],
			switcheroo: ["5E", "4E"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			wrap: ["5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	arbok: {
		inherit: true,
		learnset: {
			acid: ["5L20", "4L20", "3L38"],
			acidspray: ["5L32"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			coil: ["5L56"],
			crunch: ["5L22", "4L22"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L44", "4T", "4L42"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			glare: ["5L12", "4L12", "3L20", "3S0"],
			gunkshot: ["5L63", "4T", "4L56"],
			haze: ["5L51", "4L48", "3L56"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icefang: ["5L1", "4L1"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudbomb: ["5L39", "4L34"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			screech: ["5L17", "4L17", "3L28"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M", "3S0"],
			sludgewave: ["5M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			spitup: ["5L27", "4L28", "3L46"],
			stockpile: ["5L27", "4L28", "3L46"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L27", "4L28", "3L46"],
			thief: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			wrap: ["5L1", "4L1", "3L1"],
		},
	},
	pichu: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bestow: ["5E"],
			bide: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["5E", "4E", "4S5", "3E"],
			chargebeam: ["5M", "4M"],
			charm: ["5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["5E", "4E", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5E", "4E", "3E"],
			endeavor: ["4S5"],
			endure: ["5E", "4M", "4S5", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E"],
			flail: ["5E", "4E"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			followme: ["3S3"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M", "4S4"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L18", "4L18"],
			naturalgift: ["4M"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "4S4", "3M"],
			reversal: ["5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["3S0"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L13", "4L13", "3L11"],
			swift: ["4T", "3T"],
			tailwhip: ["5L5", "4L5", "3L6"],
			teeterdance: ["3S2"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "4S4", "3M"],
			thunderpunch: ["5E", "4E"],
			thundershock: ["5L1", "4L1", "3L1", "3S0", "3S1", "3S2", "3S3"],
			thunderwave: ["5M", "5L10", "4M", "4L10", "3T", "3L8"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			voltswitch: ["5M"],
			volttackle: ["5E", "4E", "4S4", "4S5", "3E"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E", "3S1"],
		},
	},
	pichuspikyeared: {
		inherit: true,
		learnset: {
			attract: ["4M"],
			captivate: ["4M"],
			chargebeam: ["4M"],
			charm: ["4L1"],
			doubleteam: ["4M"],
			endure: ["4M"],
			facade: ["4M"],
			flash: ["4M"],
			fling: ["4M"],
			frustration: ["4M"],
			grassknot: ["4M"],
			headbutt: ["4T"],
			helpinghand: ["4T", "4S0"],
			hiddenpower: ["4M"],
			irontail: ["4M"],
			lightscreen: ["4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["4L18"],
			naturalgift: ["4M"],
			painsplit: ["4S0"],
			protect: ["4M"],
			raindance: ["4M"],
			rest: ["4M"],
			return: ["4M"],
			rollout: ["4T"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["4M"],
			swagger: ["4M", "4S0"],
			sweetkiss: ["4L13"],
			swift: ["4T"],
			tailwhip: ["4L5"],
			thunder: ["4M"],
			thunderbolt: ["4M"],
			thundershock: ["4L1"],
			thunderwave: ["4M", "4L10"],
			toxic: ["4M"],
			uproar: ["4T"],
			volttackle: ["4S0"],
		},
	},
	pikachu: {
		inherit: true,
		learnset: {
			agility: ["5L37", "4L34", "3L33", "3S0", "3S8"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "5S26", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			discharge: ["5L42", "4L37"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L21", "4M", "4L18", "4S13", "3M", "3L15"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			electroball: ["5L18", "5S23", "5S24", "5S30"],
			encore: ["5S23"],
			endure: ["4M", "3T"],
			extremespeed: ["5S26"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L34", "5S29", "4L29"],
			flash: ["5M", "4M", "4S13", "3M"],
			fling: ["5M", "4M"],
			fly: ["5S24", "5S27", "3S2", "3S4", "3S6"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "5S25", "5S26", "5S27", "4M", "4S13"],
			growl: ["5L1", "4L1", "3L1", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			headbutt: ["5S28", "4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["5S24", "5S30", "4M", "4S21", "3M"],
			knockoff: ["4T"],
			lastresort: ["4S18"],
			lightscreen: ["5M", "5L45", "4M", "4L42", "4S11", "3M", "3L50", "3S0", "3S6", "3S7", "3S8"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			present: ["4S12", "4S15", "4S17", "4S18", "4S20", "4S22"],
			protect: ["5M", "5S27", "4M", "4S14", "4S16", "3M"],
			quickattack: ["5L13", "5S24", "5S25", "5S29", "5S30", "4L13", "4S11", "4S12", "4S15", "4S17", "4S18", "4S20", "4S21", "4S22", "3L11"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "4S19", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5S23"],
			slam: ["5L26", "4L21", "3L20"],
			sleeptalk: ["4M", "4S19", "3T"],
			snore: ["4T", "4S19", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["4S9", "4S11", "4S14", "4S16", "3S3", "3S5", "3S7"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L5", "5S28", "4L5", "4S9", "4S12", "4S15", "4S17", "4S20", "4S22", "3L6", "3S1", "3S2", "3S3", "3S4", "3S10"],
			teeterdance: ["5S23"],
			thunder: ["5M", "5L50", "5S25", "4M", "4L45", "4S14", "4S16", "3M", "3L41", "3S0", "3S6", "3S7", "3S8"],
			thunderbolt: ["5M", "5L29", "5S26", "5S27", "5S30", "4M", "4L26", "4S11", "4S13", "4S18", "4S21", "3M", "3L26", "3S0", "3S6", "3S7", "3S8"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["5L1", "5S28", "4L1", "4S12", "4S15", "4S20", "4S22", "3L1", "3S1", "3S5", "3S10"],
			thunderwave: ["5M", "5L10", "5S28", "4M", "4L10", "4S9", "4S17", "3T", "3L8", "3S1", "3S2", "3S3", "3S4", "3S5", "3S10"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M", "5S29"],
			volttackle: ["5S25", "5S29", "4S9", "4S21"],
			wildcharge: ["5M"],
			yawn: ["4S19"],
		},
	},
	raichu: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["5L1", "4L1", "3L1"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	sandshrew: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5E"],
			counter: ["5E", "4E", "3T", "3E"],
			crushclaw: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L3", "4L3", "3T", "3L6", "3S0"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L25", "4T", "4L25", "3T"],
			furyswipes: ["5L19", "4L19", "3L37"],
			gyroball: ["5M", "5L33", "4M", "4L33"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			metalclaw: ["5E", "4E", "3E"],
			mimic: ["3T"],
			mudshot: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L9", "4L9", "3L17", "3S0"],
			protect: ["5M", "4M", "3M"],
			rapidspin: ["5L13", "5E", "4L13", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["5E", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L21", "4T", "4L21", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			sandattack: ["5L7", "4L7", "3L11", "3S0"],
			sandstorm: ["5M", "5L37", "4M", "4L37", "3M", "3L53"],
			sandtomb: ["5L27", "4L27", "3L45"],
			scratch: ["5L1", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L31", "4L31", "3L23"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5D", "4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L15", "4T", "4L15", "3T", "3L30"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			xscissor: ["5M", "4M"],
		},
	},
	sandslash: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			crushclaw: ["5L22", "4L22"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L28", "4T", "4L28", "3T"],
			furyswipes: ["5L19", "4L19", "3L42"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "5L45", "4M", "4L45"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L9", "4L9", "3L17"],
			protect: ["5M", "4M", "3M"],
			rapidspin: ["5L13", "4L13"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L21", "4T", "4L21", "3T"],
			round: ["5M"],
			safeguard: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "5L52", "4M", "4L52", "3M", "3L62"],
			sandtomb: ["5L33", "4L33", "3L52"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L40", "4L40", "3L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L15", "4T", "4L15", "3T", "3L33"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			xscissor: ["5M", "4M"],
		},
	},
	nidoranf: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			bite: ["5L21", "4L21", "3L20"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["5L43", "4M", "4L43"],
			charm: ["5E", "4E", "3E"],
			chipaway: ["5E"],
			counter: ["5E", "4E", "3T", "3E"],
			crunch: ["5L37", "4L37", "3L47"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["5L9", "4L9", "3L12"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flatter: ["5L33", "4L33", "3L38"],
			focusenergy: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L19", "4L19", "3L30"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			irontail: ["5E", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["5L45", "4L45"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L13", "4L13", "3L17"],
			poisontail: ["5E"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "5D", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			skullbash: ["5E", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5D"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5D", "4T"],
			supersonic: ["5E", "4E", "3E"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L7", "4L7", "3L8"],
			takedown: ["5E", "4E", "3E"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L31", "4L31"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorina: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L23", "4L23", "3L22"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["5L50", "4M", "4L50"],
			counter: ["3T"],
			crunch: ["5L43", "4L43", "3L53"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L9", "4L9", "3L12"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flatter: ["5L38", "4L38", "3L43"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L20", "4L20", "3L34"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			helpinghand: ["5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonfang: ["5L58", "4L58"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L13", "4L13", "3L18"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L7", "4L7", "3L8"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L35", "4L35"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoqueen: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5L35", "4L23", "3T", "3L22"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L23"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthpower: ["5L43", "4T", "4L43"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			superpower: ["5L58", "4T", "4L58", "3L43"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	nidoranm: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["5L43", "4M", "4L43"],
			chipaway: ["5E"],
			confusion: ["5E", "4E", "3E"],
			counter: ["5E", "5D", "4E", "3T", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["5L9", "4L9", "3L12"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flatter: ["5L33", "4L33", "3L38"],
			focusenergy: ["5L7", "4L7", "3L8"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L19", "4L19", "3L30"],
			headbutt: ["4T"],
			headsmash: ["5E", "4E"],
			helpinghand: ["5L25", "4T", "4L25", "3L23"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hornattack: ["5L21", "4L21", "3L20"],
			horndrill: ["5L45", "4L45", "3L47"],
			icebeam: ["5M", "4M", "3M"],
			irontail: ["5E", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["5L1", "5D", "4L1", "3L1"],
			poisonjab: ["5M", "5L37", "4M", "4L37"],
			poisonsting: ["5L13", "4L13", "3L17"],
			poisontail: ["5E"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E", "4T", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5D", "4T"],
			supersonic: ["5E", "4E", "3E"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5E", "4E", "3E"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L31", "4L31"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidorino: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["5L50", "4M", "4L50"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L9", "4L9", "3L12"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flatter: ["5L38", "4L38", "3L43"],
			focusenergy: ["5L7", "4L7", "3L8"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L20", "4L20", "3L34"],
			headbutt: ["4T"],
			helpinghand: ["5L28", "4T", "4L28", "3L26"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hornattack: ["5L23", "4L23", "3L22"],
			horndrill: ["5L58", "4L58", "3L53"],
			icebeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			peck: ["5L1", "4L1", "3L1"],
			poisonjab: ["5M", "5L43", "4M", "4L43"],
			poisonsting: ["5L13", "4L13", "3L18"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L35", "4L35"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
		},
	},
	nidoking: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L23"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthpower: ["5L43", "4T", "4L43"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			megahorn: ["5L58", "4L58", "3L43"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L35", "4L23", "3L22"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	cleffa: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			aromatherapy: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["5L1", "4L1", "3L1"],
			copycat: ["5L13", "4L13"],
			counter: ["3T"],
			covet: ["5E", "4E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			encore: ["5L4", "4L4", "3L4"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "4E"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magicalleaf: ["5L16", "4L16", "3L17"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5E", "4E", "3T", "3E"],
			mimic: ["5E", "4E", "3T", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["5L1", "4L1", "3L1"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5L7", "4L7", "3L8"],
			sleeptalk: ["5D", "4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			splash: ["5E", "4E", "3E"],
			storedpower: ["5E"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L10", "4L10", "3L13"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			tickle: ["5E"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	clefairy: {
		inherit: true,
		learnset: {
			afteryou: ["5L52"],
			attract: ["5M", "4M", "3M"],
			bestow: ["5L25"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			cosmicpower: ["5L28", "4L25", "3L33"],
			counter: ["3T"],
			defensecurl: ["5L13", "4L13", "3T", "3L25"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L10", "4L10", "3L13"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			encore: ["5L4", "4L4", "3L5"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["5L16", "4L16", "3L17"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["5L37", "4T", "4L34"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			healingwish: ["5L49", "4L46"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "5L46", "4M", "4L40", "3M", "3L41"],
			luckychant: ["5L31", "4L28"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["5L55", "4L43", "3L45"],
			metronome: ["5L34", "4L31", "3T", "3L29"],
			mimic: ["3T"],
			minimize: ["5L19", "4L19", "3L21"],
			moonlight: ["5L40", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5L7", "4L7", "3L9"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			storedpower: ["5L43"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			wakeupslap: ["5L22", "4L22"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	clefable: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5L1", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			minimize: ["5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	vulpix: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["5L41", "4M", "4L37"],
			charm: ["3S1"],
			confuseray: ["5L17", "4L17", "3L21"],
			darkpulse: ["5D", "4M"],
			dig: ["5M", "4M", "3M", "3S1"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L1", "4L1", "3L1", "3S1"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4E"],
			extrasensory: ["5L51", "5E", "4L44", "4E"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			fireblast: ["5M", "5L54", "4M", "4L47", "3M"],
			firespin: ["5L14", "4L34", "3L41"],
			flail: ["5E", "4E", "3E"],
			flameburst: ["5L24"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L37", "4M", "4L24", "3M", "3L29"],
			flareblitz: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			grudge: ["5L47", "4L41", "3L37"],
			headbutt: ["4T"],
			heatwave: ["5E", "5D", "4T", "4E", "3E", "3S1"],
			hex: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5E", "4E", "3E"],
			hypnosis: ["5E", "4E", "3E"],
			imprison: ["5L21", "4L21", "3L25"],
			incinerate: ["5M"],
			inferno: ["5L44"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			payback: ["5M", "5L34", "4M", "4L31"],
			powerswap: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3E"],
			quickattack: ["5L11", "4L11", "3L13", "3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L7", "5D", "4M", "4L7", "3M", "3L9", "3S0"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "5L27", "4M", "4L27", "3M", "3L33"],
			secretpower: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["5E", "4T", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailslap: ["5E"],
			tailwhip: ["5L4", "4L4", "3L5", "3S0"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "5L31", "4M", "4L14", "3L17", "3S0"],
			zenheadbutt: ["4T"],
		},
	},
	ninetales: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			confuseray: ["5L1", "4L1", "3L1"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			energyball: ["5M"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firespin: ["3L45"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5S0", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			nastyplot: ["5L1", "4L1"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M", "5S0"],
			quickattack: ["5L1", "4L1", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5S0", "4M"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "5S0", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	igglybuff: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["5E", "4M"],
			charm: ["5L1", "4L1", "3L1", "3S0"],
			copycat: ["5L17", "4L17"],
			counter: ["3T"],
			covet: ["5E", "4E"],
			defensecurl: ["5L5", "4L5", "3T", "3L4", "3S0"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "5D", "4E", "3E"],
			feintattack: ["5E", "4E", "3E"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["5E", "4T", "4E"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5D", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lastresort: ["5E", "4T", "4E"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			perishsong: ["5E", "4E", "3E"],
			pound: ["5L9", "4L9", "3L9"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			punishment: ["5E"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["5E", "4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L13", "4L13", "3L14"],
			thunderwave: ["5M", "4M", "3T"],
			tickle: ["3S0"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
		},
	},
	jigglypuff: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5L33", "4L29", "3T", "3L34"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["5L5", "4L5", "3T", "3L4"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L13", "4L13", "3L14"],
			doubleedge: ["5L53", "4L49", "3T", "3L49"],
			doubleslap: ["5L25", "4L21", "3L24"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L37", "4M", "4L33"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypervoice: ["5L49", "4L45", "3L44"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["5L45", "4L41", "3T", "3L39"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			pound: ["5L9", "4L9", "3L9"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "5L29", "4M", "4L25", "3M", "3L29"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollout: ["5L21", "4T", "4L17", "3T", "3L19"],
			round: ["5M", "5L17"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			wakeupslap: ["5L41", "4L37"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	wigglytuff: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleslap: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	zubat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L33"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["5L25", "4T", "4L25", "3L31"],
			airslash: ["5L45", "4L41"],
			astonish: ["5L9", "4L9", "3L6"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L16"],
			bravebird: ["5E", "4E"],
			captivate: ["4M"],
			confuseray: ["5L21", "4L21", "3L26"],
			curse: ["5E", "4E", "3E"],
			defog: ["5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "4M", "3M"],
			gust: ["5E", "4E", "3E"],
			haze: ["5L41", "4L37", "3L46"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5E", "5D", "4E"],
			leechlife: ["5L1", "4L1", "3L1"],
			meanlook: ["5L29", "4L29", "3L36"],
			mimic: ["3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["5L37", "4L33", "3L41"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			quickattack: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["5D", "4T"],
			supersonic: ["5L5", "5D", "4L5", "3L6"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			whirlwind: ["5E", "4E", "3E"],
			wingattack: ["5L17", "4L17", "3L21"],
			zenheadbutt: ["5E", "4T", "4E"],
		},
	},
	golbat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L39"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["5L27", "4T", "4L27", "3L35"],
			airslash: ["5L57", "4L51"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confuseray: ["5L21", "4L21", "3L28"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			haze: ["5L51", "4L45", "3L56"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L1", "4L1", "3L1"],
			meanlook: ["5L33", "4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["5L45", "4L39", "3L49"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			screech: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			supersonic: ["5L1", "4L1", "3L1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			wingattack: ["5L17", "4L17", "3L21"],
			zenheadbutt: ["4T"],
		},
	},
	crobat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L39"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["5L27", "4T", "4L27", "3L35"],
			airslash: ["5L57", "4L51", "4S0"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L16"],
			captivate: ["4M"],
			confuseray: ["5L21", "4L21", "3L28"],
			crosspoison: ["5L1", "4L1"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			haze: ["5L51", "4L45", "3L56"],
			heatwave: ["4T", "4S0"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L1", "4L1", "3L1"],
			meanlook: ["5L33", "4L33", "3L42"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pluck: ["5M", "4M"],
			poisonfang: ["5L45", "4L39", "3L49"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			screech: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			skyattack: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "4S0", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T", "4S0"],
			supersonic: ["5L1", "4L1", "3L1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			wingattack: ["5L17", "4L17", "3L21"],
			xscissor: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	oddish: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1", "3S1"],
			acid: ["5L9", "4L9", "3L23", "3S0"],
			afteryou: ["5E"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			charm: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["5L37", "5D", "4M", "4L37", "3M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5E", "4E", "3E"],
			leechseed: ["3S1"],
			luckychant: ["5L25", "4L25"],
			megadrain: ["5L21", "4L21"],
			mimic: ["3T"],
			moonlight: ["5L33", "4L33", "3L32"],
			naturalgift: ["5L29", "4M", "4L29"],
			naturepower: ["5E"],
			petaldance: ["5L41", "4L41", "3L39"],
			poisonpowder: ["5L13", "4L13", "3L14", "3S0"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["5E", "4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stunspore: ["5L15", "4L15", "3L16", "3S0"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L5", "5D", "4L5", "3L7"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			synthesis: ["5E", "4T", "4E", "3E"],
			teeterdance: ["5E", "5D", "4E"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	gloom: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			acid: ["5L1", "4L1", "3L24", "3S0"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["5L47", "4M", "4L47", "3M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			luckychant: ["5L29", "4L29"],
			megadrain: ["5L23", "4L23"],
			mimic: ["3T"],
			moonlight: ["5L41", "4L41", "3L35", "3S0"],
			naturalgift: ["5L35", "4M", "4L35"],
			petaldance: ["5L53", "4L53", "3L44", "3S0"],
			poisonpowder: ["5L13", "4L13", "3L1"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["5L17", "4L17", "3L18", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stunspore: ["5L15", "4L15", "3L16"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L1", "4L1", "3L1"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	vileplume: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			aromatherapy: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			megadrain: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["5L53", "4L53", "3L44"],
			poisonpowder: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L65", "4M", "4L65", "3M"],
			stunspore: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	bellossom: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leafblade: ["5L1", "4L1"],
			leafstorm: ["5L53", "4L53"],
			magicalleaf: ["5L23", "4L23", "3L1"],
			megadrain: ["5L1", "4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["3L44"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M", "3L55"],
			stunspore: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L1", "4M", "4L1", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L1", "4L1", "3L1"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	paras: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5E", "4E"],
			aromatherapy: ["5L43", "4L38", "3L49"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bugbite: ["5E", "4T", "4E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			crosspoison: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M", "4E", "3E", "3S0"],
			flail: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L17", "4T", "3T"],
			gigadrain: ["5L38", "4M", "4L33", "3M", "3L43"],
			grassknot: ["5M", "4M"],
			growth: ["5L33", "4L27", "3L37"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			knockoff: ["4T"],
			leechlife: ["5L11", "4L11", "3L19"],
			leechseed: ["5E"],
			lightscreen: ["5M", "4E", "3E"],
			metalclaw: ["5E", "4E"],
			mimic: ["3T"],
			naturalgift: ["5E", "4M"],
			poisonpowder: ["5L6", "4L6", "3L13"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E"],
			pursuit: ["5E", "4E", "3E"],
			ragepowder: ["5L49"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slash: ["5L27", "4L22", "3L31", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spore: ["5L22", "4L17", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L6", "4L6", "3L7"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5E", "4E", "3E"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5D", "4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
			xscissor: ["5M", "5L54", "4M", "4L43"],
		},
	},
	parasect: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aromatherapy: ["5L51", "4L47", "3L59"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bugbite: ["4T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosspoison: ["5L1", "4L1"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L17", "4T", "3T"],
			gigadrain: ["5L44", "4M", "4L39", "3M", "3L51"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L37", "4L30", "3L43"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			leechlife: ["5L1", "4L1", "3L19"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			ragepowder: ["5L59"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slash: ["5L29", "4L22", "3L35"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spore: ["5L22", "4L17", "3L27"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
			xscissor: ["5M", "5L66", "4M", "4L55"],
		},
	},
	venonat: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bugbite: ["5E", "4T", "4E"],
			captivate: ["4M"],
			confusion: ["5L11", "4L11", "3L17"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "4M", "4E", "3M", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			leechlife: ["5L17", "4L17", "3L25"],
			mimic: ["3T"],
			morningsun: ["5E", "4E"],
			naturalgift: ["4M"],
			poisonfang: ["5L41", "4L41"],
			poisonpowder: ["5L13", "4L13", "3L20"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L25", "4L25", "3L33"],
			psychic: ["5M", "5L47", "4M", "4L47", "3M", "3L41"],
			ragepowder: ["5E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["5E", "4M", "3M"],
			signalbeam: ["5L35", "5E", "4T", "4L35", "4E", "3E"],
			skillswap: ["5E", "4M", "3M"],
			sleeppowder: ["5L29", "4L29", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L23", "4L23", "3L28"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L5", "4L5", "3L9"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5E", "4E"],
			venoshock: ["5M"],
			zenheadbutt: ["5L37", "4T", "4L37"],
		},
	},
	venomoth: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L59", "4L59"],
			captivate: ["4M"],
			confusion: ["5L11", "4L11", "3L17"],
			defog: ["4M"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L31", "4L31", "3L31"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L17", "4L17", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonfang: ["5L47", "4L47"],
			poisonpowder: ["5L13", "4L13", "3L20"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L25", "4L25", "3L36"],
			psychic: ["5M", "5L55", "4M", "4L55", "3M", "3L52", "3S0"],
			quiverdance: ["5L63"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["5L37", "4T", "4L37"],
			silverwind: ["5L1", "4M", "4L1", "3L1", "3S0"],
			skillswap: ["4M", "3M"],
			sleeppowder: ["5L29", "4L29", "3L42"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L23", "4L23", "3L28"],
			substitute: ["5M", "4M", "3T", "3S0"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L1", "4L1", "3L1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			zenheadbutt: ["5L41", "4T", "4L41"],
		},
	},
	diglett: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5E", "4E", "3E"],
			astonish: ["5L7", "5E", "4L7", "4E"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["5M", "5L18"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "5L34", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L29", "4T", "4L26"],
			earthquake: ["5M", "5L40", "4M", "4L37", "3M", "3L41"],
			echoedvoice: ["5M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			finalgambit: ["5E"],
			fissure: ["5L45", "4L40", "3L49"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["3L21"],
			growl: ["5L4", "4L4", "3L5"],
			headbutt: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			magnitude: ["5L15", "4L12", "3L9"],
			memento: ["5E"],
			mimic: ["3T"],
			mudbomb: ["5L26", "5E", "4L29", "4E"],
			mudslap: ["5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "4M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L37", "4L34", "3L33"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["5D", "4M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L23", "4T", "4L23"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5E", "4E", "3E"],
		},
	},
	dugtrio: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			astonish: ["5L7", "4L7"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M", "5L18"],
			captivate: ["4M"],
			charm: ["3S0"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "5L40", "4M", "4L18", "3M", "3L17"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L33", "4T", "4L28"],
			earthquake: ["5M", "5L50", "4M", "4L45", "3M", "3L51", "3S0"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5L57", "4L50", "3L64"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["3L21"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			magnitude: ["5L15", "4L12", "3L9"],
			mimic: ["3T"],
			mudbomb: ["5L28", "4L33"],
			mudslap: ["5L12", "4T", "4L15", "3T", "3L25"],
			naturalgift: ["4M"],
			nightslash: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "4M", "3S0"],
			sandtomb: ["5L26", "4L26", "3L26"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L45", "4L40", "3L38"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L23", "4T", "4L23"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5L1", "4L1", "3L1", "3S0"],
		},
	},
	meowth: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5E", "4E", "3E"],
			assist: ["5E", "4E", "4S5", "3E"],
			assurance: ["5L41", "4L41"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L6", "4L6", "4S4", "3L10", "3S2", "3S3"],
			bodyslam: ["3T"],
			captivate: ["5L46", "4M", "4L46"],
			charm: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L9", "4L9", "4S4", "4S5", "3L43"],
			feint: ["5L54", "4L54"],
			feintattack: ["5L22", "4L22", "3L25"],
			flail: ["5E", "4E"],
			flash: ["5M", "4M", "3M"],
			foulplay: ["5E"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L14", "5S6", "4L14", "4S4", "3L36"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hypnosis: ["5E", "5D", "4E", "3E"],
			icywind: ["4T", "3T"],
			irontail: ["5E", "4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["5E", "4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L38", "5S6", "4L38"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["5L49", "4L49"],
			odorsleuth: ["5E", "4E"],
			payback: ["5M", "4M"],
			payday: ["5L30", "4L30", "4S5", "3L18", "3S3"],
			petaldance: ["3S0"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			punishment: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "5D", "4L1", "4S5", "3L1", "3S0", "3S1", "3S2"],
			screech: ["5L17", "4L17", "4S4", "3L31"],
			secretpower: ["5D", "4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L33", "4L33", "3L40", "3S3"],
			sleeptalk: ["4M", "3T"],
			snatch: ["5E", "5S6", "4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5E", "4T", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T", "3L45"],
			swift: ["4T", "3T"],
			tailwhip: ["5E", "4E"],
			taunt: ["5M", "5L25", "4M", "4L25", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	persian: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			assurance: ["5L49", "4L49"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["5L56", "4M", "4L56"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L1", "4L1", "3L55"],
			feint: ["5L68", "4L68"],
			feintattack: ["5L22", "4L22", "3L25"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L14", "4L14", "3L42"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L44", "4L44"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["5L61", "4L61"],
			payback: ["5M", "4M"],
			payday: ["3L18"],
			powergem: ["5L32", "4L32"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L17", "4L17", "3L34"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L37", "4L37", "3L49"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T", "3L61"],
			swift: ["4T", "3T"],
			switcheroo: ["5L1", "4L1"],
			taunt: ["5M", "5L25", "4M", "4L25", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	psyduck: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5L48", "4L44"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["5D", "4M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5E", "4E"],
			confusion: ["5L18", "4L18", "3L16", "3S0"],
			counter: ["3T"],
			crosschop: ["5E", "4E", "3E"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L14", "4L14", "3L10", "3S0"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["5E", "5D", "4E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L27", "4L27", "3L40"],
			futuresight: ["5E", "4E", "3E"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5L53", "4L48", "3L50"],
			hypnosis: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E"],
			psychic: ["5M", "4M", "4E", "3E"],
			psychup: ["5M", "5L40", "4M", "4L35", "3T", "3L31"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scald: ["5M"],
			scratch: ["5L1", "4L1", "3L1", "3S1"],
			screech: ["5L31", "4L31", "3L23", "3S0"],
			secretpower: ["5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			signalbeam: ["4T"],
			sleeptalk: ["5E", "4M", "3T"],
			snore: ["4T", "3T"],
			soak: ["5L35"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["5E"],
			tailwhip: ["5L5", "4L5", "3L5", "3S0", "3S1"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L9", "4L9"],
			waterpulse: ["5L22", "4M", "4L22", "3M"],
			watersport: ["5L1", "5D", "4L1", "3L1", "3S1"],
			whirlpool: ["4M"],
			wonderroom: ["5L57"],
			worryseed: ["4T"],
			yawn: ["5E", "4E"],
			zenheadbutt: ["5L44", "4T", "4L40"],
		},
	},
	golduck: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5L56", "4L50"],
			aquajet: ["5L1", "4L1"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M", "3S0"],
			brine: ["4M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["3S0"],
			confusion: ["5L18", "4L18", "3L16"],
			counter: ["3T"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L14", "4L14", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L27", "4L27", "3L44"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5L63", "4L56", "3L58"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "5L44", "4M", "4L37", "3T", "3L31", "3S0"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scald: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L31", "4L31", "3L23"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			soak: ["5L37"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M", "3S0"],
			watergun: ["5L1", "4L1"],
			waterpulse: ["5L22", "4M", "4L22", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wonderroom: ["5L69"],
			worryseed: ["4T"],
			zenheadbutt: ["5L50", "4T", "4L44"],
		},
	},
	mankey: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			assurance: ["5L25", "4L25"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L49", "5E", "4L49", "4E"],
			counter: ["5E", "4E", "3T", "3E"],
			covet: ["5L1", "4L1"],
			crosschop: ["5L37", "4L37", "3L31"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			encore: ["5E", "4E"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			finalgambit: ["5L53"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L21"],
			focuspunch: ["5E", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L9", "4L9", "3L16"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			karatechop: ["5L13", "4L13", "3L11"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["5L1", "5D", "4T", "4L1", "3L6"],
			lowsweep: ["5M"],
			meditate: ["5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["5L45", "4L45"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E", "4E", "3E"],
			reversal: ["5E", "5D", "4E", "3E"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L21", "4L21", "3L41"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["5L17", "4L17", "3T", "3L26"],
			sleeptalk: ["5E", "4M", "3T"],
			smackdown: ["5M"],
			smellingsalts: ["5E", "4E", "3E"],
			snore: ["3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L33", "4M", "4L33", "3T", "3L36"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L41", "4L41", "3L46"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["5D", "4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["5M"],
		},
	},
	primeape: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			assurance: ["5L25", "4L25"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L59", "4L59"],
			counter: ["3T"],
			crosschop: ["5L41", "4L41", "3L35", "3S0"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			finalgambit: ["5L63"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "5L1", "4M", "4L1"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L21", "3S0"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L9", "4L9", "3L16"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			karatechop: ["5L13", "4L13", "3L11"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["5L1", "4T", "4L1", "3L1"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			punishment: ["5L53", "4L53"],
			rage: ["5L28", "4L28", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["3S0"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L21", "4L21", "3L53"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["5L17", "4L17", "3T", "3L26"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["3T"],
			spite: ["4T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L35", "4M", "4L35", "3T", "3L44"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L47", "4L47", "3L62"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			vacuumwave: ["4T"],
			workup: ["5M"],
		},
	},
	growlithe: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L42", "4L39", "3L43"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "5D", "4L1", "3L1", "3S1", "3S2"],
			bodyslam: ["5E", "5D", "4E", "3T", "3E"],
			captivate: ["4M"],
			charm: ["3S2"],
			closecombat: ["5E"],
			covet: ["5E"],
			crunch: ["5L45", "5E", "4L42", "4E", "3E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T"],
			doublekick: ["5E"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L6", "4L6", "3L7", "3S1"],
			endure: ["5D", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L28", "4L28"],
			firespin: ["5E", "4E", "3E"],
			flameburst: ["5L31"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L39", "4M", "4L34", "3M", "3L49", "3S2"],
			flamewheel: ["5L20", "4L20", "3L31", "3S0"],
			flareblitz: ["5L56", "5E", "4L48", "4E"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["5L51", "5E", "4T", "4L45", "4E", "3E"],
			helpinghand: ["5L17", "4T", "4L17", "3L37"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			irontail: ["5E", "4M", "3M"],
			leer: ["5L9", "4L9", "3L13", "3S0"],
			mimic: ["3T"],
			morningsun: ["5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L14", "4L14", "3L19", "3S0"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M", "5L48"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L25", "4L25"],
			roar: ["5M", "5L1", "4M", "4L1", "3M", "3L1", "3S1"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snarl: ["5E"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["5L34", "4L31", "3L25", "3S0", "3S2"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	arcanine: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["4S0"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			ember: ["3L1"],
			endure: ["4M", "3T"],
			extremespeed: ["5L39", "4L39", "4S0", "3L49"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flareblitz: ["4S0"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L1", "4L1", "3L1"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1", "4S0"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	poliwag: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L31", "4L31", "3L37"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5L21", "4L21", "3T", "3L31"],
			bubble: ["5L5", "4L5", "3L1", "3S0"],
			bubblebeam: ["5L25", "5E", "4L25", "4E", "3E"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L15", "4L15", "3L19"],
			doubleteam: ["5M", "4M", "3M"],
			encore: ["5E", "4E"],
			endeavor: ["5E", "4E"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L38", "4L38", "3L43"],
			hypnosis: ["5L8", "5D", "4L8", "3L7"],
			iceball: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["5E", "4E", "3E"],
			mist: ["5E", "5D", "4E", "3E"],
			mudbomb: ["5L41", "4L41"],
			mudshot: ["5L28", "5E", "4L28", "4E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "5L18", "4M", "4L18", "3M", "3L25"],
			refresh: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["5D", "4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["5E", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			wakeupslap: ["5L35", "4L35"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L11", "4L11", "3L13"],
			waterpulse: ["5E", "4M", "3M"],
			watersport: ["5L1", "5E", "4L1", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	poliwhirl: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L37", "4L37", "3L43"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5L21", "4L21", "3T", "3L35"],
			brickbreak: ["5M", "4M", "3M"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L27", "4L27"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L15", "4L15", "3L19"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L48", "4L48", "3L51"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudbomb: ["5L53", "4L53"],
			mudshot: ["5L32", "4L32"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "5L18", "4M", "4L18", "3M", "3L27"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			wakeupslap: ["5L43", "4L43"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L11", "4L11", "3L1"],
			waterpulse: ["4M", "3M"],
			watersport: ["5L1", "4L1"],
			whirlpool: ["4M"],
		},
	},
	poliwrath: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M", "3S0"],
			bubblebeam: ["5L1", "4L1"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			circlethrow: ["5L53"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5L32", "4L43", "3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["3S0"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["5L43", "4L53", "3L51"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M", "3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			submission: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	politoed: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5L37", "4T", "4L37"],
			brickbreak: ["5M", "4M", "3M"],
			bubblebeam: ["5L1", "4L1"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypervoice: ["5L48", "4L48"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icebeam: ["5M", "5S0", "4M", "3M"],
			icywind: ["4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			perishsong: ["5L1", "5S0", "4L1", "3L1"],
			protect: ["5M", "5S0", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M", "5S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L27", "4M", "4L27", "3T", "3L51"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	abra: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			encore: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["5E", "4T", "4E", "3T", "3E"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["5D", "4T"],
			guardsplit: ["5E"],
			guardswap: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["5E", "4T", "4E", "3T", "3E"],
			irontail: ["4M", "3M"],
			knockoff: ["5E", "4T", "4E", "3E"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powertrick: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["5L1", "5D", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	kadabra: {
		inherit: true,
		learnset: {
			allyswitch: ["5M", "5L24"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			disable: ["5L18", "4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L48", "4L42", "3L30"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			kinesis: ["5L1", "4L1", "3L1"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L28", "4L24", "3L21"],
			psychic: ["5M", "5L46", "4M", "4L40", "3M", "3L36"],
			psychocut: ["5L40", "4L34"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L36", "4L30", "3L25"],
			recycle: ["4M"],
			reflect: ["5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["5L42", "4T", "4L36", "3L33"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M", "5L34"],
			teleport: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5L52", "4T", "4L46", "3L43"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	alakazam: {
		inherit: true,
		learnset: {
			allyswitch: ["5M", "5L24"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "5L42", "4M", "4L36", "3M", "3L33", "3S0"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			disable: ["5L18", "4L18", "3L18"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L48", "4L42", "3L30", "3S0"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			kinesis: ["5L1", "4L1", "3L1"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["5L22", "4L22"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L28", "4L24", "3L21"],
			psychic: ["5M", "5L46", "4M", "4L40", "3M", "3L36", "3S0"],
			psychocut: ["5L40", "4L34"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L36", "4L30", "3L25"],
			recycle: ["4M"],
			reflect: ["5M", "5L30", "4M", "4L28", "3M", "3L23"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M", "5L34"],
			teleport: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5L52", "4T", "4L46", "3L43", "3S0"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	machop: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5E", "5D", "4E"],
			captivate: ["4M"],
			closecombat: ["5E", "4E"],
			counter: ["5E", "4E", "3T", "3E"],
			crosschop: ["5L43", "4L37", "3L40"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5L49", "4L46", "3T", "3L49"],
			earthquake: ["5M", "4M", "3M"],
			encore: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["5E", "4T", "4E", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L7", "4L7", "3L7"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L19", "4L13", "3L22"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["5E"],
			helpinghand: ["5D", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["5E", "4T", "4E", "3T"],
			incinerate: ["5M"],
			karatechop: ["5L10", "4L10", "3L13"],
			knockoff: ["5E"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4E", "3E"],
			lowkick: ["5L1", "5D", "4T", "4L1", "3L1"],
			lowsweep: ["5M", "5L13"],
			meditate: ["5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			powertrick: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L25", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollingkick: ["5E", "4E", "3E"],
			round: ["5M"],
			scaryface: ["5L46", "4L43", "3L43"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L22", "4L19", "3T", "3L19"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			smellingsalts: ["5E", "4E", "3E"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			submission: ["5L34", "4L31", "3L37"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5E", "4T", "4E", "3T"],
			tickle: ["5E"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["5L31", "4L25", "3L31"],
			wakeupslap: ["5L37", "4L34"],
			workup: ["5M"],
		},
	},
	machoke: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosschop: ["5L44", "4L40", "3L46"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5L55", "4L51", "3T", "3L59"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L19", "5S0", "4L13", "3L22"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			incinerate: ["5M"],
			karatechop: ["5L1", "4L10", "3L13"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			lowkick: ["5L1", "4T", "4L1", "3L1"],
			lowsweep: ["5M", "5L13", "5S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L25", "5S0", "4L22", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scaryface: ["5L51", "4L44", "3L51"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L22", "5S0", "4L19", "3T", "3L19"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			submission: ["5L36", "4L32", "3L41"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["5L32", "4L25", "3L33"],
			wakeupslap: ["5L40", "4L36"],
			workup: ["5M"],
		},
	},
	machamp: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			crosschop: ["5L44", "4L40", "3L46"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5L55", "4L51", "3T", "3L59"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L19", "4L13", "3L22", "3S0"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			incinerate: ["5M"],
			karatechop: ["5L1", "4L10", "3L13"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			lowkick: ["5L1", "4T", "4L1", "3L1"],
			lowsweep: ["5M", "5L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L25", "4L22", "3L25", "3S0"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scaryface: ["5L51", "4L44", "3L51"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L22", "4L19", "3T", "3L19", "3S0"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			submission: ["5L36", "4L32", "3L41"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["5L32", "4L25", "3L33", "3S0"],
			wakeupslap: ["5L40", "4L36"],
			wideguard: ["5L1"],
			workup: ["5M"],
		},
	},
	bellsprout: {
		inherit: true,
		learnset: {
			acid: ["5L23", "4L23", "3L23"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["5E", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			encore: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L35", "4T", "4L35"],
			gigadrain: ["5E", "4M", "3M"],
			grassknot: ["5M", "4M"],
			growth: ["5L7", "4L7", "3L6", "3S1"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5E", "4E", "3E"],
			knockoff: ["5L27", "4T", "4L27"],
			leechlife: ["5E", "4E", "3E"],
			magicalleaf: ["5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["5E", "4M"],
			poisonpowder: ["5L15", "4L15", "3L17"],
			powerwhip: ["5E"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L39", "4L39", "3L37"],
			reflect: ["5M", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5D", "4T"],
			slam: ["5L41", "4L41", "3L45"],
			sleeppowder: ["5L13", "4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stunspore: ["5L17", "4L17", "3L19"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L29", "4L29", "3L30"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			synthesis: ["5E", "5D", "4T", "4E", "3E"],
			teeterdance: ["3S0"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			weatherball: ["5E", "4E"],
			worryseed: ["5E", "4T", "4E"],
			wrap: ["5L11", "4L11", "3L11"],
			wringout: ["5L47", "4L47"],
		},
	},
	weepinbell: {
		inherit: true,
		learnset: {
			acid: ["5L23", "4L23", "3L24"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L35", "4T", "4L35"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			growth: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			knockoff: ["5L27", "4T", "4L27"],
			magicalleaf: ["3S0"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["4M"],
			poisonpowder: ["5L15", "4L15", "3L17"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L39", "4L39", "3L42"],
			reflect: ["5M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["5L41", "4L41", "3L54"],
			sleeppowder: ["5L13", "4L13", "3L15"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M", "3S0"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stunspore: ["5L17", "4L17", "3L19"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L29", "4L29", "3L33", "3S0"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L1", "4L1", "3L1"],
			worryseed: ["4T"],
			wrap: ["5L1", "4L1", "3L1"],
			wringout: ["5L47", "4L47"],
		},
	},
	victreebel: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			leafblade: ["5L47", "4L47"],
			leafstorm: ["5L47", "4L47"],
			leaftornado: ["5L27"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L1", "4L1", "3L1"],
			reflect: ["5M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeppowder: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L1", "4L1", "3L1"],
			stockpile: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L1", "4L1", "3L1"],
			sweetscent: ["5L1", "4L1", "3L1"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			vinewhip: ["5L1", "4L1", "3L1"],
			worryseed: ["4T"],
		},
	},
	tentacool: {
		inherit: true,
		learnset: {
			acid: ["5L12", "4L12", "3L19"],
			acidspray: ["5L26"],
			acupressure: ["5E", "5D", "4E"],
			aquaring: ["5E"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5E", "4E", "3E"],
			barrier: ["5L29", "4L26", "3L36"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			bubble: ["5E"],
			bubblebeam: ["5L19", "4L19", "3L25"],
			captivate: ["4M"],
			confuseray: ["5E", "4E", "3E"],
			constrict: ["5L8", "4L8", "3L12"],
			cut: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5D", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			hex: ["5L43"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L47", "4L40", "3L49"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["5E", "4T", "4E"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "4E", "3E"],
			muddywater: ["5E", "4E"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L36", "4M", "4L33"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			scald: ["5M"],
			screech: ["5L40", "4L36", "3L43"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M", "5L50"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L5", "5D", "4L5", "3L6"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5E"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L15", "4L15"],
			venoshock: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L33", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["5L22", "4L22", "3L30"],
			wringout: ["5L54", "4L43"],
		},
	},
	tentacruel: {
		inherit: true,
		learnset: {
			acid: ["5L12", "4L12", "3L19"],
			acidspray: ["5L26"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5L29", "4L26", "3L38"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["5L19", "4L19", "3L25"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1", "3L1"],
			cut: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hex: ["5L47"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L52", "4L49", "3L55"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L38", "4M", "4L36"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			scald: ["5M"],
			screech: ["5L43", "4L42", "3L47"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M", "5L56"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L1", "4L1", "3L1"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L15", "4L15"],
			venoshock: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L34", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wrap: ["5L22", "4L22", "3L30"],
			wringout: ["5L61", "4L55"],
		},
	},
	geodude: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5E"],
			block: ["5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M", "5L32"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["5E", "4E"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L46", "4L36", "3T", "3L46"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L39", "4M", "4L29", "3M", "3L36"],
			endure: ["5E", "4M", "3T"],
			explosion: ["5M", "5L43", "4M", "4L32", "3T", "3L41"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["5E", "4E"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			magnitude: ["5L15", "4L15", "3L16"],
			megapunch: ["5E", "4E", "3T", "3E"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L4", "4L4", "3L6"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L22", "4L25", "3L31"],
			rockclimb: ["5E", "4M"],
			rockpolish: ["5M", "5L8", "4M", "4L8"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L11", "4L11", "3L11"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L18", "4T", "4L22", "3T", "3L26"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["5L29", "4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M", "5L25"],
			snore: ["4T", "3T"],
			stealthrock: ["5L36", "4M"],
			stoneedge: ["5M", "5L50", "4M", "4L39"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	graveler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M", "5L36"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L58", "4L44", "3T", "3L62"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			magnitude: ["5L15", "4L15", "3L16"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "5L1", "4M", "4L1"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L11", "4L11", "3L1"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L18", "4T", "4L22", "3T", "3L29"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M", "5L27"],
			snore: ["4T", "3T"],
			stealthrock: ["5L42", "4M"],
			stoneedge: ["5M", "5L64", "4M", "4L49"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	golem: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M", "5L36"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L58", "4L44", "3T", "3L62"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L47", "4M", "4L33", "3M", "3L45"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L53", "4M", "4L38", "3T", "3L53"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["5L69"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			magnitude: ["5L15", "4L15", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockblast: ["5L22", "4L27", "3L37"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "5L1", "4M", "4L1"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L11", "4L11", "3L1"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "4L22", "3T", "3L29"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["5L31", "4L18", "3T", "3L21"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M", "5L27"],
			snore: ["4T", "3T"],
			stealthrock: ["5L42", "4M"],
			steamroller: ["5L18"],
			stoneedge: ["5M", "5L64", "4M", "4L49"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	ponyta: {
		inherit: true,
		learnset: {
			agility: ["5L37", "4L33", "3L38"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5L45", "4T", "4L42", "3L45"],
			captivate: ["5E", "4M"],
			charm: ["5E", "4E", "3E"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doublekick: ["5E", "4E", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L9", "4L10", "3L14"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L41", "4M", "4L37", "3M", "3L53"],
			firespin: ["5L25", "4L24", "3L25"],
			flamecharge: ["5M", "5L21"],
			flamethrower: ["5M", "4M", "3M"],
			flamewheel: ["5L13", "5E", "4L15", "4E", "3E"],
			flareblitz: ["5L49", "4L46"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L5"],
			headbutt: ["4T"],
			heatwave: ["5D", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			horndrill: ["5E", "4E"],
			hypnosis: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			inferno: ["5L33"],
			irontail: ["4M", "3M"],
			lowkick: ["5E"],
			mimic: ["3T"],
			morningsun: ["5E", "4E"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L17", "4L19", "3L19"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5D", "4L1", "3L1"],
			tailwhip: ["5L4", "4L6", "3L9"],
			takedown: ["5L29", "4L28", "3L31"],
			thrash: ["5E", "5D", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	rapidash: {
		inherit: true,
		learnset: {
			agility: ["5L37", "4L33", "3L38"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			bounce: ["5L45", "4T", "4L47", "3L50"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L41", "4M", "4L37", "3M", "3L63"],
			firespin: ["5L25", "4L24", "3L25"],
			flamecharge: ["5M", "5L21"],
			flamethrower: ["5M", "4M", "3M", "3S0"],
			flamewheel: ["5L13", "4L15"],
			flareblitz: ["5L49", "4L56"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L40", "4L40", "3L40"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5L33"],
			irontail: ["4M", "3M"],
			megahorn: ["5L1", "4L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			poisonjab: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M", "3S0"],
			stomp: ["5L17", "4L19", "3L19"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			takedown: ["5L29", "4L28", "3L31"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	slowpoke: {
		inherit: true,
		learnset: {
			amnesia: ["5L41", "4L43", "3L36"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			block: ["5E", "5D", "4T", "4E"],
			bodyslam: ["3T"],
			brine: ["5D", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L14", "5S2", "4L15", "3L17", "3S0"],
			curse: ["5L1", "4L1", "3L1", "3S1"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L19", "5S2", "4L20", "3L24", "3S0"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			growl: ["5L5", "4L6", "3L6", "3S1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["5L23", "5S2", "4T", "4L25", "3L29", "3S0"],
			healpulse: ["5L58"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			mefirst: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["5M"],
			raindance: ["5M", "5L49", "4M", "4L53", "3M"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "4E", "3M", "3E"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			slackoff: ["5L36", "4L39"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			stomp: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S1"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			watergun: ["5L9", "4L11", "3L13", "3S0"],
			waterpulse: ["5L28", "5S2", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			wonderroom: ["5E"],
			yawn: ["5L1", "5D", "4L1", "3L1", "3S1"],
			zenheadbutt: ["5L32", "5E", "4T", "4L34", "4E"],
		},
	},
	slowbro: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			amnesia: ["5L43", "4L47", "3L36"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L14", "4L15", "3L17"],
			counter: ["3T"],
			curse: ["5L1", "4L1", "3L1"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L19", "4L20", "3L24"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["5L23", "4T", "4L25", "3L29"],
			healpulse: ["5L68"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L49", "4M", "4L54", "3M", "3L44"],
			psychup: ["5M", "5L62", "4M", "4L67", "3T", "3L55"],
			psyshock: ["5M"],
			raindance: ["5M", "5L55", "4M", "4L61", "3M"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			slackoff: ["5L36", "4L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			watergun: ["5L9", "4L11", "3L13"],
			waterpulse: ["5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			withdraw: ["5L37", "4L37", "3L37"],
			yawn: ["5L1", "4L1", "3L1"],
			zenheadbutt: ["5L32", "4T", "4L34"],
		},
	},
	slowking: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L14", "4L15", "3L17"],
			counter: ["3T"],
			curse: ["5L1", "4L1", "3L1"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L19", "4L20", "3L24"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L5", "4L6", "3L6"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["5L23", "4T", "4L25", "3L29"],
			healpulse: ["5L58"],
			hiddenpower: ["5M", "5L1", "4M", "4L1", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L36", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powergem: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L45", "4M", "4L48", "3M", "3L40"],
			psychup: ["5M", "5L54", "4M", "4L57", "3T", "3L47"],
			psyshock: ["5M"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L41", "4M", "4L43", "3T", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			trumpcard: ["5L49", "4L53"],
			watergun: ["5L9", "4L11", "3L13"],
			waterpulse: ["5L28", "4M", "4L29", "3M"],
			whirlpool: ["4M"],
			yawn: ["5L1", "4L1", "3L1"],
			zenheadbutt: ["5L32", "4T", "4L34"],
		},
	},
	magnemite: {
		inherit: true,
		learnset: {
			chargebeam: ["5M", "4M"],
			discharge: ["5L43", "4L38"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L27"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gravity: ["5D", "4T"],
			gyroball: ["5M", "5L54", "4M", "4L49"],
			hiddenpower: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			lightscreen: ["5M", "4M"],
			lockon: ["5L30", "4L27", "3L32"],
			magiccoat: ["4T"],
			magnetbomb: ["5L33", "4L30"],
			magnetrise: ["5L49", "4T", "4L46"],
			metalsound: ["5L1", "5D", "4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["5L46", "4L43"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["5D", "4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5L38", "4L33", "3L44"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["5L14", "4L14", "3L16"],
			spark: ["5L22", "4L22", "3L26"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L11", "4L11", "3L11"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T", "3L38"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thundershock: ["5L6", "4L6", "3L6"],
			thunderwave: ["5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			zapcannon: ["5L59", "4L54", "3L50"],
		},
	},
	magneton: {
		inherit: true,
		learnset: {
			chargebeam: ["5M", "4M"],
			discharge: ["5L46", "4L40"],
			doubleedge: ["3T", "3S0"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L27"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L60", "4M", "4L54"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			lightscreen: ["5M", "4M"],
			lockon: ["5L30", "4L27", "3L35"],
			magiccoat: ["4T"],
			magnetbomb: ["5L34", "4L30"],
			magnetrise: ["5L54", "4T", "4L50"],
			metalsound: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mirrorshot: ["5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M", "3S0"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5L40", "4L34", "3L53"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["5L14", "4L14", "3L16"],
			spark: ["5L22", "4L22", "3L26"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L1", "4L1", "3L1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M", "3S0"],
			thunderbolt: ["5M", "4M", "3M"],
			thundershock: ["5L1", "4L1", "3L1"],
			thunderwave: ["5M", "5L17", "4M", "4L17", "3T", "3L21"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5L1", "4L1", "3L44"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			zapcannon: ["5L66", "4L60", "3L62"],
		},
	},
	magnezone: {
		inherit: true,
		learnset: {
			barrier: ["5L1", "4L1"],
			chargebeam: ["5M", "4M"],
			discharge: ["5L46", "4L40"],
			doubleteam: ["5M", "4M"],
			electroball: ["5L27"],
			endure: ["4M"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L60", "4M", "4L54"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M"],
			lockon: ["5L30", "4L27"],
			magiccoat: ["4T"],
			magnetbomb: ["5L34", "4L30"],
			magnetrise: ["5L54", "4T", "4L50"],
			metalsound: ["5L1", "4L1"],
			mirrorcoat: ["5L1", "4L1"],
			mirrorshot: ["5L50", "4L46"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			screech: ["5L40", "4L34"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["5L14", "4L14"],
			spark: ["5L22", "4L22"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			supersonic: ["5L1", "4L1"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thundershock: ["5L1", "4L1"],
			thunderwave: ["5M", "5L17", "4M", "4L17"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			zapcannon: ["5L66", "4L60"],
		},
	},
	farfetchd: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L37"],
			aerialace: ["5M", "5L13", "4M", "4L13", "3M", "3S1"],
			agility: ["5L31", "4L31", "3L36"],
			aircutter: ["5L21", "4T", "4L21"],
			airslash: ["5L49", "4L37"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			bravebird: ["5L55"],
			captivate: ["4M"],
			covet: ["5E", "4E"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L45", "4M", "4L43", "3L46"],
			featherdance: ["5E", "4E", "3E"],
			feint: ["5L43", "4L43"],
			flail: ["5E", "4E", "3E"],
			fly: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L7", "4L7", "3L16"],
			furycutter: ["5L1", "5D", "4T", "4L1", "3L26"],
			gust: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			knockoff: ["5L9", "4T", "4L9", "3L21"],
			lastresort: ["4T"],
			leafblade: ["5E", "5D", "4E"],
			leer: ["5L1", "4L1", "3L11"],
			mimic: ["3T"],
			mirrormove: ["5E", "4E", "3E"],
			mudslap: ["5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L33", "5E", "4L33", "4E"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			poisonjab: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quickattack: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E"],
			roost: ["5E", "5D", "4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L6"],
			secretpower: ["4M", "3M"],
			slash: ["5L19", "4L19", "3L41", "3S1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "4M", "4E", "3M", "3E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L25", "4M", "4L25", "3T", "3L31", "3S1"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5E"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			wish: ["3S0"],
			workup: ["5M"],
			yawn: ["3S0"],
		},
	},
	doduo: {
		inherit: true,
		learnset: {
			acupressure: ["5L28", "4L28"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L37", "4L37", "3L45"],
			aircutter: ["4T"],
			assurance: ["5E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bravebird: ["5E", "4E"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["5L32", "4L32"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5L41", "4L41", "3L37"],
			echoedvoice: ["5M"],
			endeavor: ["5L46", "5E", "4T", "4L46", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			flail: ["5E", "5D", "4E", "3E"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L14", "4L14", "3L13"],
			growl: ["5L1", "5D", "4L1", "3L1"],
			haze: ["5E", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mirrormove: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L19", "4L19", "3L9"],
			quickattack: ["5L5", "5E", "4L5", "4E", "3E"],
			rage: ["5L10", "4L10", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5D", "4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5E", "4E", "3E"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L50"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["3L21"],
			uproar: ["5L23", "4T", "4L23", "3L33"],
			workup: ["5M"],
		},
	},
	dodrio: {
		inherit: true,
		learnset: {
			acupressure: ["5L28", "4L28"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L41", "4L41", "3L60", "3S0"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5L47", "4L47", "3L47", "3S0"],
			echoedvoice: ["5M"],
			endeavor: ["5L54", "4T", "4L54"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L14", "4L14", "3L1"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L19", "4L19", "3L1"],
			quickattack: ["5L1", "4L1"],
			rage: ["5L1", "4L1", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L60"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5L34", "4L34", "3L21", "3S0"],
			uproar: ["5L23", "4T", "4L23", "3L38"],
			workup: ["5M"],
		},
	},
	seel: {
		inherit: true,
		learnset: {
			aquajet: ["5L31", "4L31"],
			aquaring: ["5L23", "4L23"],
			aquatail: ["5L43", "4T", "4L43"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L27", "4L27", "3L21"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["5L33", "4M", "4L33"],
			captivate: ["4M"],
			disable: ["5E", "4E", "3E"],
			dive: ["5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5L13", "5E", "4L13", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E", "3E"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L3", "4L3", "3L9"],
			hail: ["5M", "5L53", "4M", "3M"],
			headbutt: ["5L1", "5D", "4T", "4L1", "3L1"],
			helpinghand: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			horndrill: ["5E", "4E", "3E"],
			icebeam: ["5M", "5L47", "4M", "4L47", "3M", "3L41", "3S0"],
			iceshard: ["5L17", "4L17"],
			iciclespear: ["5E", "5D", "4E", "3E"],
			icywind: ["5L11", "4T", "4L11", "3T", "3L17"],
			irontail: ["5E"],
			lick: ["5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			perishsong: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L51", "4M", "4L51", "3M", "3L49", "3S0"],
			secretpower: ["4M", "3M"],
			signalbeam: ["5E", "4T", "4E"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["5E", "5D", "4M", "3T"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E"],
			stockpile: ["5E", "4E"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E"],
			takedown: ["5L37", "4L37", "3L37"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5E", "4M", "3M"],
			watersport: ["5L7", "4L7"],
			whirlpool: ["4M"],
		},
	},
	dewgong: {
		inherit: true,
		learnset: {
			aquajet: ["5L31", "4L31"],
			aquaring: ["5L23", "4L23"],
			aquatail: ["5L49", "4T", "4L43"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L27", "4L27", "3L1"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["5L33", "4M", "4L33"],
			captivate: ["4M"],
			dive: ["5M", "5L45", "4T", "4L41", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5L13", "4L13"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "5L65", "4M", "3M"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5L55", "4M", "4L47", "3M", "3L51"],
			iceshard: ["5L17", "4L17"],
			icywind: ["5L1", "4T", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L21", "4M", "4L21", "3M", "3L29"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L61", "4M", "4L51", "3M", "3L64"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L34", "4L34", "3L34"],
			signalbeam: ["5L1", "4T", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5L39", "4L37", "3L42"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	grimer: {
		inherit: true,
		learnset: {
			acidarmor: ["5L39", "4L39", "3L34"],
			acidspray: ["5E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			curse: ["5E", "4E", "3E"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L12", "4L12", "3L8"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "5L28", "4M", "4L28"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gunkshot: ["5L49", "4T", "4L44"],
			harden: ["5L4", "4L4", "3L4"],
			haze: ["5E", "4E", "3E"],
			helpinghand: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			imprison: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			lick: ["5E", "4E", "3E"],
			meanlook: ["5E", "4E", "3E"],
			memento: ["5L52", "4L49", "3L53"],
			mimic: ["3T"],
			minimize: ["5L17", "4L17", "3L19", "3S0"],
			mudbomb: ["5L23", "4L23"],
			mudslap: ["5L7", "4T", "4L7", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisongas: ["5L1", "4L1", "3L1"],
			poisonjab: ["5M", "4M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5E"],
			screech: ["5L33", "4L33", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M"],
			shadowpunch: ["5E", "4E", "3E", "3S0"],
			shadowsneak: ["5E", "4E"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L20", "4L20", "3L13"],
			sludgebomb: ["5M", "5L36", "4M", "4L36", "3M", "3L43", "3S0"],
			sludgewave: ["5M", "5L44"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E"],
			stockpile: ["5E", "4E"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
		},
	},
	muk: {
		inherit: true,
		learnset: {
			acidarmor: ["5L42", "4L44", "3L34"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L12", "4L12", "3L8"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "5L28", "4M", "4L28"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["5L58", "4T", "4L54"],
			harden: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			incinerate: ["5M"],
			memento: ["5L64", "4L65", "3L61"],
			mimic: ["3T"],
			minimize: ["5L17", "4L17", "3L19"],
			mudbomb: ["5L23", "4L23"],
			mudslap: ["5L1", "4T", "4L1", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisongas: ["5L1", "4L1", "3L1"],
			poisonjab: ["5M", "4M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5L33", "4L33", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L20", "4L20", "3L13"],
			sludgebomb: ["5M", "5L36", "4M", "4L36", "3M", "3L47"],
			sludgewave: ["5M", "5L50"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
		},
	},
	shellder: {
		inherit: true,
		learnset: {
			aquaring: ["5E"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L37", "4L32", "3L17", "3S0", "3S2"],
			avalanche: ["5E"],
			barrier: ["5E", "5D", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["5L44", "4M", "4L44"],
			bubblebeam: ["5E", "4E", "3E"],
			captivate: ["4M"],
			clamp: ["5L25", "4L25", "3L41"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L61"],
			icebeam: ["5M", "5L52", "4M", "4L49", "3M", "3L49"],
			iceshard: ["5L28", "4L28"],
			iciclespear: ["5L13", "5E", "4L13", "4E", "3L8", "3E", "3S0", "3S1"],
			icywind: ["5D", "4T", "3T"],
			irondefense: ["5L49", "4T", "4L40"],
			leer: ["5L20", "4L20", "3L33"],
			mimic: ["3T"],
			mudshot: ["5E", "4E"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "5L16", "4M", "4L16", "3M", "3L25"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E", "4E", "3E"],
			razorshell: ["5L32"],
			refresh: ["3S2"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5E", "4E"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["5L56"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L8", "4L8", "3L9", "3S0"],
			surf: ["5M", "4M", "3M", "3S2"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S1"],
			takedown: ["5E", "4E", "3E", "3S2"],
			toxic: ["5M", "4M", "3M"],
			twineedle: ["5E"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["5L40", "4M", "4L37"],
			withdraw: ["5L4", "5D", "4L4", "3L1", "3S0", "3S1"],
		},
	},
	cloyster: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L1", "4L1", "3L1"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "5S0", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			iciclecrash: ["5L52"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikecannon: ["5L13", "4L40", "3L41"],
			spikes: ["5L28", "4L28", "3L33"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L1", "4L1", "3L1"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L1", "4L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["5L1", "4L1", "3L1"],
		},
	},
	gastly: {
		inherit: true,
		learnset: {
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			confuseray: ["5L19", "4L19", "3L21"],
			curse: ["5L12", "4L12", "3L13"],
			darkpulse: ["5L36", "4M", "4L36"],
			destinybond: ["5L40", "4L40", "3L33"],
			disable: ["5E", "5D", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "5L33", "4M", "4L33", "3T", "3L28"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["5E", "4T", "4E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			grudge: ["5E", "4E", "3E"],
			haze: ["5E", "4E", "3E"],
			hex: ["5L43"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "5D", "4L1", "3L1"],
			icepunch: ["5E", "4T", "4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["5L1", "4L1", "3L1"],
			meanlook: ["5L8", "4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["5L47", "4L43", "3T", "3L41"],
			nightshade: ["5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "5L26", "4M", "4L26"],
			perishsong: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psywave: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "5L29", "4M", "4L29", "3M", "3L36"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5D"],
			smog: ["5E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5L5", "4T", "4L5", "3L8"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L22", "4T", "4L22"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["5E", "4T", "4E"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			willowisp: ["5M", "4M", "4E", "3E"],
		},
	},
	haunter: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L19", "5S0", "4L19", "3L21"],
			curse: ["5L12", "4L12", "3L13"],
			darkpulse: ["5L44", "4M", "4L44"],
			destinybond: ["5L50", "4L50", "3L39"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "5L39", "4M", "4L39", "3T", "3L31"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			hex: ["5L55"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["5L1", "4L1", "3L1"],
			meanlook: ["5L8", "4L8", "3L13"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["5L61", "4L55", "3T", "3L53"],
			nightshade: ["5L15", "4L15", "3L16"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "5L28", "5S0", "4M", "4L28"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["5M", "4M"],
			shadowpunch: ["5L25", "5S0", "4L25", "3L25"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5L1", "4T", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L22", "5S0", "4T", "4L22"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	gengar: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L19", "4L19", "3L21", "3S0"],
			counter: ["3T"],
			curse: ["5L12", "4L12", "3L13", "3S0"],
			darkpulse: ["5L44", "4M", "4L44"],
			destinybond: ["5L50", "4L50", "3L39"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "5L39", "4M", "4L39", "3T", "3L31"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hex: ["5L55"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lick: ["5L1", "4L1", "3L1"],
			meanlook: ["5L8", "4L8", "3L13"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["5L61", "4L55", "3T", "3L53"],
			nightshade: ["5L15", "4L15", "3L16", "3S0"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "5L28", "4M", "4L28"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "5L33", "4M", "4L33", "3M", "3L45"],
			shadowclaw: ["5M", "4M"],
			shadowpunch: ["5L25", "4L25", "3L25"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5L1", "4T", "4L1", "3L1", "3S0"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L22", "4T", "4L22"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	onix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			bind: ["5L1", "4L1", "3L8"],
			block: ["5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			curse: ["5L46", "4L38"],
			defensecurl: ["5E", "4E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L57", "4L46", "3T", "3L56"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5L41", "4L33", "3L30"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			heavyslam: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			ironhead: ["4T"],
			irontail: ["5L49", "4M", "4L38", "3M", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			rage: ["5L14", "4L14", "3L23"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockblast: ["5E", "4E"],
			rockclimb: ["5E", "4M"],
			rockpolish: ["5M", "5L30", "4M", "4L30"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L9", "4L9", "3L12"],
			rocktomb: ["5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["5E", "4T", "4E"],
			round: ["5M"],
			sandstorm: ["5M", "5L25", "4M", "4L22", "3M", "3L33"],
			sandtomb: ["5L54", "4L41", "3L49"],
			screech: ["5L6", "4L6", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["5L33", "4L25", "3L37"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M", "5L22"],
			snore: ["4T", "3T"],
			stealthrock: ["5L38", "5E", "4M"],
			stoneedge: ["5M", "5L62", "4M", "4L49"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	steelix: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L30"],
			bind: ["5L1", "4L1", "3L8"],
			block: ["4T"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L54", "4L41", "3L49"],
			curse: ["5L46", "4L38"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L57", "4L46", "3T", "3L56"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5L41", "4L33", "3L30"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L19"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icefang: ["5L1", "4L1"],
			ironhead: ["4T"],
			irontail: ["5L49", "4M", "4L38", "3M", "3L45"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M"],
			rage: ["5L14", "4L14", "3L23"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M", "4L30"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L9", "4L9", "3L12"],
			rocktomb: ["5M", "5L17", "4M", "4L17", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "5L25", "4M", "4L22", "3M", "3L33"],
			screech: ["5L6", "4L6", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			slam: ["5L33", "4L25", "3L37"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M", "5L22"],
			snore: ["4T", "3T"],
			stealthrock: ["5L38", "4M"],
			stoneedge: ["5M", "5L62", "4M", "4L49"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
		},
	},
	drowzee: {
		inherit: true,
		learnset: {
			assist: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bellydrum: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L9", "4L9", "3L11"],
			counter: ["3T"],
			disable: ["5L5", "4L7", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["5D", "4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["5E", "4T", "4E", "3T", "3E"],
			flash: ["5M", "4M", "3M"],
			flatter: ["5E", "4E"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L61", "4L53", "3L45"],
			grassknot: ["5M", "4M"],
			guardswap: ["5E", "4E"],
			headbutt: ["5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "5D", "4L1", "3L1"],
			icepunch: ["5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			meditate: ["5L21", "4L21", "3L27"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["5L53", "5E", "4L43", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisongas: ["5L17", "4L18", "3L21"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L25", "4L26"],
			psychic: ["5M", "5L49", "4M", "4L40", "3M", "3L31"],
			psychocut: ["5E", "5D", "4E"],
			psychup: ["5M", "5L33", "4M", "4L29", "3T", "3L37"],
			psyshock: ["5M", "5L57"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["5E", "4T", "4E", "3E"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L45", "4M", "4L37", "3T", "3L41"],
			synchronoise: ["5L37"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5E", "4T", "4E", "3T", "3E"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			wish: ["3S0"],
			zenheadbutt: ["5L41", "4T", "4L50"],
		},
	},
	hypno: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L61", "4L69", "3L57"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["5L13", "4T", "4L15", "3L17"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1"],
			icepunch: ["4T", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			meditate: ["5L21", "4L21", "3L29", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			nastyplot: ["5L53", "4L55"],
			naturalgift: ["4M"],
			nightmare: ["5L1", "4L1", "3T", "3L1"],
			poisongas: ["5L17", "4L18", "3L21"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L25", "4L28"],
			psychic: ["5M", "5L49", "4M", "4L50", "3M", "3L35", "3S0"],
			psychup: ["5M", "5L33", "4M", "4L33", "3T", "3L43"],
			psyshock: ["5M", "5L57"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M", "3S0"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L45", "4M", "4L45", "3T", "3L49"],
			switcheroo: ["5L1", "4L1"],
			synchronoise: ["5L37"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["5L41", "4T", "4L64"],
		},
	},
	krabby: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			amnesia: ["5E", "5D", "4E", "3E"],
			ancientpower: ["5E", "4T", "4E"],
			attract: ["5M", "4M", "3M"],
			bide: ["5E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			brine: ["5L39", "4M", "4L39"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L15", "4L15"],
			captivate: ["4M"],
			chipaway: ["5E"],
			crabhammer: ["5L41", "4L41", "3L45"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "4E", "3M", "3E"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flail: ["5L45", "5E", "4L45", "4E", "3L49", "3E"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["5L31", "4L31", "3L34"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L11", "4L11", "3L16"],
			haze: ["5E", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["5E", "4T", "4E", "3E"],
			leer: ["5L9", "4L9", "3L5"],
			metalclaw: ["5L21", "4L21"],
			mimic: ["3T"],
			mudshot: ["5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["5M", "5L29", "4M", "4L29", "3M", "3L38"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["5D", "4M", "3M"],
			slam: ["5L35", "5E", "4L35", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["5L25", "4L25", "3L27"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			visegrip: ["5L5", "5D", "4L5", "3L12"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["5M", "4M"],
		},
	},
	kingler: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			brine: ["5L51", "4M", "4L51"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L15", "4L15"],
			captivate: ["4M"],
			crabhammer: ["5L56", "4L56", "3L57"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flail: ["5L63", "4L63", "3L65"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			guillotine: ["5L37", "4L37", "3L38"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L11", "4L11", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["5L1", "4L9", "3L1"],
			metalclaw: ["5L21", "4L21", "3L1"],
			mimic: ["3T"],
			mudshot: ["5L19", "4L19", "3L23"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["5M", "5L32", "4M", "4L32", "3M", "3L42"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			slam: ["5L44", "4L44"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["5L25", "4L25", "3L27"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			visegrip: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wideguard: ["5L1"],
			xscissor: ["5M", "4M"],
		},
	},
	voltorb: {
		inherit: true,
		learnset: {
			charge: ["5L1", "4L1", "3L1"],
			chargebeam: ["5M", "5L22", "4M", "4L26"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L29"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L47", "4M", "4L43", "3T", "3L46"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "5L43", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			lightscreen: ["5M", "5L26", "4M", "4L22", "3M", "3L37"],
			magiccoat: ["4T"],
			magnetrise: ["5L40", "4T", "4L36"],
			mimic: ["3T"],
			mirrorcoat: ["5L50", "4L47", "3L49", "3S0"],
			naturalgift: ["5D", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L32"],
			round: ["5M"],
			screech: ["5L19", "4L19", "3L8"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L33", "4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5D", "4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["5L8", "4L8", "3L15"],
			spark: ["5L12", "4L12", "3L21", "3S0"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L36", "4T", "4L33", "3T", "3L42", "3S0"],
			tackle: ["5L5", "4L5", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	electrode: {
		inherit: true,
		learnset: {
			charge: ["5L1", "4L1", "3L1"],
			chargebeam: ["5M", "5L22", "4M", "4L26"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L29"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L57", "4M", "4L51", "3T", "3L54"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "5L51", "4M", "4L46"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			lightscreen: ["5M", "5L26", "4M", "4L22", "3M", "3L41"],
			magiccoat: ["4T"],
			magnetrise: ["5L46", "4T", "4L40"],
			mimic: ["3T"],
			mirrorcoat: ["5L62", "4L57", "3L59"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L34"],
			round: ["5M"],
			screech: ["5L19", "4L19", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L35", "4L29", "3T", "3L27"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			sonicboom: ["5L1", "4L1", "3L1"],
			spark: ["5L1", "4L1", "3L21"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L40", "4T", "4L35", "3T", "3L48"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	exeggcute: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			barrage: ["5L1", "5D", "4L1", "3L1"],
			bestow: ["5L53"],
			block: ["5E"],
			bulletseed: ["5L17", "4M", "4L17", "3M"],
			captivate: ["4M"],
			confusion: ["5L27", "4L27", "3L19"],
			curse: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "5D", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1"],
			ingrain: ["5E", "4E", "3E"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5L11", "4L11", "3L13"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E", "4E"],
			mimic: ["3T"],
			moonlight: ["5E", "4E", "3E"],
			naturalgift: ["5L37", "5E", "4M", "4L37"],
			naturepower: ["5E", "4E"],
			nightmare: ["3T"],
			poisonpowder: ["5L21", "4L21", "3L31"],
			powerswap: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L47", "4M", "4L47", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			reflect: ["5M", "5L7", "4M", "4L7", "4E", "3M", "3L7", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			skillswap: ["5E", "4M", "3M"],
			sleeppowder: ["5L23", "4L23", "3L37"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L43", "4M", "4L43", "3M", "3L43"],
			strength: ["5M", "4M", "3M"],
			stunspore: ["5L19", "4L19", "3L25"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["3S0"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5E", "5D", "4T", "4E", "3E"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trickroom: ["5M", "4M"],
			uproar: ["5L1", "4T", "4L1", "3L1"],
			wish: ["3S0"],
			worryseed: ["5L33", "4T", "4L33"],
		},
	},
	exeggutor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T", "3S0"],
			attract: ["5M", "4M", "3M"],
			barrage: ["5L1", "4L1", "3L1"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			eggbomb: ["5L27", "4L27", "3L31"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L1", "3S0"],
			leafstorm: ["5L47", "4L47"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M", "3S0"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M", "5L17"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5L1", "4T", "4L1"],
			selfdestruct: ["3T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L1", "4L1", "3L19"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trickroom: ["5M", "4M"],
			woodhammer: ["5L37", "4L37"],
			worryseed: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	cubone: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["5L7", "4L7", "3L9"],
			bonemerang: ["5L21", "4L21", "3L25"],
			bonerush: ["5L37", "4L37", "3L41"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5E"],
			counter: ["3T"],
			detect: ["5E", "4E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L43", "4L43", "3T", "3L45"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endeavor: ["5L41", "4T", "4L41"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L27", "4M", "4L27", "3L33"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "5L33", "4M", "4L33"],
			focusenergy: ["5L17", "4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["5L11", "4T", "4L11", "3L13"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["5E", "4E"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["5L13", "4L13", "3L17"],
			lowkick: ["5D", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L23", "4L23", "3L29"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M", "5L47"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skullbash: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["5L3", "4L3", "3L5"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L31", "4L31", "3L37"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	marowak: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			boneclub: ["5L1", "4L1", "3L1"],
			bonemerang: ["5L21", "4L21", "3L25"],
			bonerush: ["5L43", "4L43", "3L53"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L53", "4L53", "3T", "3L61"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M", "3S0"],
			echoedvoice: ["5M"],
			endeavor: ["5L49", "4T", "4L49"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L27", "4M", "4L27", "3L39"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "5L37", "4M", "4L37"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L17", "4L17", "3L21"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["5L13", "4L13", "3L17"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L23", "4L23", "3L32"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M", "5L59"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T", "3S0"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T", "3S0"],
			tailwhip: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L33", "4L33", "3L46"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	tyrogue: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5E", "4E"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L1", "5D", "4L1"],
			feint: ["5E", "5D"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["5L1", "5E", "4T", "4L1", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			highjumpkick: ["5E", "4E", "3E"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			machpunch: ["5E", "5D", "4E", "3E"],
			megakick: ["3T"],
			mimic: ["3T"],
			mindreader: ["5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			vacuumwave: ["5E", "4T", "4E"],
			workup: ["5M"],
		},
	},
	hitmonlee: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blazekick: ["5L45", "4L41"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "5L17", "4M", "4L17", "3M", "3L20"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L57", "4L53"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doublekick: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5L49", "4M", "4L45", "3T", "3L41"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L25", "4L25"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L21", "4L21", "3L21"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L37", "4L37", "3L36"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			highjumpkick: ["5L29", "4L29", "3L26", "3S0"],
			jumpkick: ["5L13", "4L13", "3L16"],
			knockoff: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			meditate: ["5L5", "4L5", "3L6"],
			megakick: ["5L53", "4L49", "3T", "3L46", "3S0"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["5L33", "4L33", "3L31", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L1", "4L1", "3L1"],
			reversal: ["5L61", "4L57", "3L51"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollingkick: ["5L9", "4L9", "3L11"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			wideguard: ["5L41"],
			workup: ["5M"],
		},
	},
	hitmonchan: {
		inherit: true,
		learnset: {
			agility: ["5L6", "4L6", "3L7"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5L16", "4L16"],
			captivate: ["4M"],
			closecombat: ["5L66", "4L56"],
			cometpunch: ["5L1", "4L1", "3L1"],
			counter: ["5L61", "4L51", "3T", "3L50"],
			detect: ["5L51", "4L46", "3L44"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L21", "4L21"],
			firepunch: ["5L36", "4T", "4L31", "3T", "3L26"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["5L56", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["5L36", "4T", "4L31", "3T", "3L26"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			machpunch: ["5L16", "4L16", "3L20"],
			megakick: ["3T"],
			megapunch: ["5L46", "4L41", "3T", "3L38", "3S0"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L11", "4L11", "3L13"],
			quickguard: ["5L31"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L1", "4L1", "3L1"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			skyuppercut: ["5L41", "4L36", "3L32", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5L36", "4T", "4L31", "3T", "3L26"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["5L26", "4T", "4L26"],
			workup: ["5M"],
		},
	},
	hitmontop: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			agility: ["5L37", "4L37", "3L37"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L55", "5S0", "4L51"],
			counter: ["5L28", "4L28", "3T", "3L31"],
			detect: ["5L51", "4L46", "3L43"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["5L60", "4T", "4L55", "3L49"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L33", "4L33"],
			focusenergy: ["5L6", "4L6", "3L7"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "5L42", "4M", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["5S0", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L10", "4L10", "3L13"],
			quickattack: ["5L15", "4L15", "3L19"],
			quickguard: ["5L46"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5L24", "4L24", "3L25"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L1", "4L1", "3L1"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollingkick: ["5L1", "4L1", "3L1"],
			rollout: ["4T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5S0", "4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			triplekick: ["5L19", "4L19", "3L20"],
			twister: ["4T"],
			vacuumwave: ["4T"],
			wideguard: ["5L46"],
			workup: ["5M"],
		},
	},
	lickitung: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L37"],
			counter: ["3T"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L9", "4L9", "3T", "3L12", "3S1"],
			dig: ["5M", "4M", "3M"],
			disable: ["5L25", "4L25", "3L34"],
			doubleedge: ["3T", "3S1"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			helpinghand: ["3S1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["5L13", "4T", "4L13", "3L18"],
			lick: ["5L1", "5D", "4L1", "3L1"],
			magnitude: ["5E", "4E", "3E"],
			mefirst: ["5L41", "4L37"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			muddywater: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerwhip: ["5L53", "4L49"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5L45", "4L41", "3L51"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L33", "4T", "4L33", "3T", "3S1"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			screech: ["5L49", "4L45", "3L45"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["5L29", "4L29", "3L40"],
			sleeptalk: ["5E", "5D", "4M", "4E", "3T", "3E"],
			smellingsalts: ["5E", "4E", "3E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L21", "4L21", "3L23"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L5", "4L5", "3L7"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["5M"],
			wrap: ["5L17", "4L17", "3L29"],
			wringout: ["5L57", "4L53"],
			zenheadbutt: ["5E", "4T"],
		},
	},
	lickilicky: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			block: ["4T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L37"],
			cut: ["5M", "4M"],
			defensecurl: ["5L9", "4L9"],
			dig: ["5M", "4M"],
			disable: ["5L25", "4L25"],
			doubleteam: ["5M", "4M"],
			dragontail: ["5M"],
			dreameater: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "5L61", "4M", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			irontail: ["4M"],
			knockoff: ["5L13", "4T", "4L13"],
			lick: ["5L1", "4L1"],
			mefirst: ["5L41", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			powerwhip: ["5L53", "4L49"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			refresh: ["5L45", "4L41"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rollout: ["5L33", "4T", "4L33"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			screech: ["5L49", "4L45"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			slam: ["5L29", "4L29"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stomp: ["5L21", "4L21"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			supersonic: ["5L5", "4L5"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			wrap: ["5L17", "4L17"],
			wringout: ["5L57", "4L53"],
			zenheadbutt: ["4T"],
		},
	},
	koffing: {
		inherit: true,
		learnset: {
			assurance: ["5L15", "4L15"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["5L19"],
			curse: ["5E", "4E"],
			darkpulse: ["5D", "4M"],
			destinybond: ["5L51", "5E", "4L46", "4E", "3L45", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L42", "4M", "4L37", "3T", "3L41"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			grudge: ["5E", "4E"],
			gyroball: ["5M", "5L37", "4M", "4L33"],
			haze: ["5L33", "4L28", "3L33"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			memento: ["5L55", "4L51", "3L49"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["5E", "4T", "4E", "3E"],
			payback: ["5M", "4M"],
			poisongas: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E"],
			psywave: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L24", "4L19", "3T", "3L17"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L28", "4L24", "3L21"],
			sludgebomb: ["5M", "5L46", "4M", "4L42", "3M"],
			sludgewave: ["5D"],
			smog: ["5L6", "5D", "4L6", "3L9"],
			smokescreen: ["5L10", "4L10", "3L25"],
			snore: ["4T", "3T"],
			spite: ["5E", "4T", "4E"],
			spitup: ["5E"],
			stockpile: ["5E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			willowisp: ["5M", "4M", "4E", "3E"],
		},
	},
	weezing: {
		inherit: true,
		learnset: {
			assurance: ["5L15", "4L15"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			clearsmog: ["5L19"],
			darkpulse: ["4M"],
			destinybond: ["5L59", "4L55", "3L51"],
			doublehit: ["5L39", "4L33"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L46", "4M", "4L40", "3T", "3L44"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			haze: ["5L33", "4L28", "3L33"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			memento: ["5L65", "4L63", "3L58"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisongas: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L24", "4L19", "3T", "3L1"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L28", "4L24", "3L21"],
			sludgebomb: ["5M", "5L52", "4M", "4L48", "3M"],
			smog: ["5L1", "4L1", "3L1"],
			smokescreen: ["5L1", "4L1", "3L25"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	rhyhorn: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["5L34"],
			counter: ["5E", "5D", "4E", "3T", "3E"],
			crunch: ["5E", "4E", "3E"],
			crushclaw: ["5E", "4E", "3E"],
			curse: ["5E", "4E", "3E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5D", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragonrush: ["5E", "4E"],
			drillrun: ["5L45"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L56", "4M", "4L49", "3M", "3L52"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5E", "4E"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L12", "4L13", "3L15"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L1", "5D", "4L1", "3L1"],
			horndrill: ["5L63", "4L37", "3L38"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5E", "4E"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["5E", "4M", "3M"],
			magnitude: ["5E", "4E", "3E"],
			megahorn: ["5L67", "4L57", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			roar: ["5M", "4M", "3M"],
			rockblast: ["5L23", "4L25", "3L29"],
			rockclimb: ["5E", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L19", "4L21", "3L24"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			skullbash: ["5E", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["5L8", "4L9", "3L10"],
			stoneedge: ["5M", "5L52", "4M", "4L45"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			tailwhip: ["5L1", "4L1", "3L1"],
			takedown: ["5L41", "4L33", "3L43"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	rhydon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M", "5L30"],
			captivate: ["4M"],
			chipaway: ["5L34"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			drillrun: ["5L47"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L62", "4M", "4L49", "3M", "3L58", "3S0"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L1", "4L1", "3L1"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hammerarm: ["5L42", "4L42"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L1", "4L1", "3L1"],
			horndrill: ["5L71", "4L37", "3L38"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			megahorn: ["5L77", "4L57", "3L66", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockblast: ["5L23", "4L25", "3L29"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L19", "4L21", "3L24", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["5L1", "4L1", "3L1"],
			stoneedge: ["5M", "5L56", "4M", "4L45"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			takedown: ["5L41", "4L33", "3L46"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			whirlpool: ["4M"],
		},
	},
	rhyperior: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			block: ["4T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L30"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			drillrun: ["5L47"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L62", "4M", "4L49"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furyattack: ["5L1", "4L1"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			hammerarm: ["5L42", "4L42"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hornattack: ["5L1", "4L1"],
			horndrill: ["5L71", "4L37"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			megahorn: ["5L77", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockblast: ["5L23", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rockwrecker: ["5L86", "4L61"],
			rollout: ["4T"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L19", "4L21"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["5L1", "4L1"],
			stoneedge: ["5M", "5L56", "4M", "4L45"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			tailwhip: ["5L1", "4L1"],
			takedown: ["5L41", "4L33"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			whirlpool: ["4M"],
		},
	},
	happiny: {
		inherit: true,
		learnset: {
			aromatherapy: ["5E", "4E"],
			attract: ["5M", "4M"],
			captivate: ["4M"],
			charm: ["5L1", "4L1"],
			copycat: ["5L5", "4L5"],
			counter: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["5E", "4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["5E", "4T", "4E"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["5E", "4T", "4E"],
			helpinghand: ["5E", "4T", "4E"],
			hiddenpower: ["5M", "4M"],
			icywind: ["4T"],
			incinerate: ["5M"],
			lastresort: ["5E", "4T", "4E"],
			lightscreen: ["5M", "4M"],
			metronome: ["5E", "4E"],
			mudbomb: ["5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["5E", "4M"],
			pound: ["5L1", "4L1"],
			present: ["5E", "4E"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			refresh: ["5L9", "4L9"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "4M", "4E"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			sweetkiss: ["5L12", "4L12"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	chansey: {
		inherit: true,
		learnset: {
			aromatherapy: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bestow: ["5L20"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["5E", "4E", "3T"],
			defensecurl: ["5L1", "4L31", "3T", "3L41"],
			doubleedge: ["5L54", "4L46", "3T", "3L57"],
			doubleslap: ["5L12", "4L16", "3L17"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			eggbomb: ["5L42", "4L38", "3L35"],
			endeavor: ["4T"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "5L34", "4M", "4L27"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["5E", "4T", "4E"],
			growl: ["5L1", "4L1", "3L1", "3S1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["5E", "4T", "4E", "3E"],
			healingwish: ["5L50", "4L42"],
			healpulse: ["5L38"],
			helpinghand: ["5E", "4T", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["5M", "5L46", "4M", "4L34", "3M", "3L49"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5E", "4E", "3T", "3E"],
			mimic: ["3T"],
			minimize: ["5L23", "4L20", "3L23"],
			mudbomb: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			pound: ["5L1", "4L1", "3L1", "3S1"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			refresh: ["5L9", "4L9", "3L9", "3S1"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["5L31", "4L23", "3L29"],
			skillswap: ["4M", "3M", "3S2"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["5L16", "4L12", "3T", "3L13", "3S2"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["3S2"],
			sweetscent: ["3S0"],
			tailwhip: ["5L5", "4L5", "3L5", "3S1"],
			takedown: ["5L27"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M", "3S2"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			wish: ["3S0"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	blissey: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bestow: ["5L20"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			defensecurl: ["5L1", "4L31", "3T", "3L33"],
			doubleedge: ["5L54", "4L46", "3T", "3L47"],
			doubleslap: ["5L12", "4L16", "3L13"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			eggbomb: ["5L42", "4L38", "3L28"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "5L34", "4M", "4L27"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			growl: ["5L1", "5S0", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			healingwish: ["5L50", "4L42"],
			healpulse: ["5L38"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["5M", "5L46", "4M", "4L34", "3M", "3L40"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			minimize: ["5L23", "4L20", "3L18"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["5L1", "5S0", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			refresh: ["5L9", "5S0", "4L9", "3L7"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["5L31", "4L23", "3L23"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["5L16", "4L12", "3T", "3L10"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L5", "5S0", "4L5", "3L4"],
			takedown: ["5L27"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	tangela: {
		inherit: true,
		learnset: {
			absorb: ["5L8", "4L8", "3L10"],
			amnesia: ["5E", "4E", "3E"],
			ancientpower: ["5L36", "4T", "4L33"],
			attract: ["5M", "4M", "3M"],
			bind: ["5L22", "4L22", "3L28"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confusion: ["5E", "4E", "3E"],
			constrict: ["5L1", "4L1", "3L1"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endeavor: ["5E", "4E"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L12", "4L12", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			ingrain: ["5L1", "4L1", "3L1", "3S0"],
			knockoff: ["5L33", "4T", "4L36"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5E", "5D", "4E", "3E"],
			megadrain: ["5L26", "5E", "4L26", "4E", "3L31", "3E"],
			mimic: ["3T"],
			morningsun: ["3S0"],
			naturalgift: ["5L40", "5E", "4M", "4L40"],
			naturepower: ["5E", "4E", "3E"],
			painsplit: ["4T"],
			poisonpowder: ["5L15", "4L15", "3L19"],
			powerswap: ["5E", "4E"],
			powerwhip: ["5L54", "4L54"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			ragepowder: ["5E"],
			reflect: ["5M", "4M", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5D", "4T"],
			shockwave: ["4M"],
			slam: ["5L43", "4L43", "3L40"],
			sleeppowder: ["5L5", "5D", "4L5", "3L4"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M", "3S0"],
			stunspore: ["5L29", "4L29", "3L37"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5L47", "4L47", "3L46"],
			toxic: ["5M", "4M", "3M"],
			vinewhip: ["5L19", "4L19", "3L22"],
			worryseed: ["4T"],
			wringout: ["5L50", "4L50"],
		},
	},
	tangrowth: {
		inherit: true,
		learnset: {
			absorb: ["5L8", "4L8"],
			aerialace: ["5M", "4M"],
			ancientpower: ["5L36", "4T", "4L33", "4S0"],
			attract: ["5M", "4M"],
			bind: ["5L22", "4L22"],
			block: ["5L57", "4T", "4L57"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L12", "4L12"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			ingrain: ["5L1", "4L1"],
			knockoff: ["5L33", "4T", "4L36"],
			megadrain: ["5L26", "4L26"],
			morningsun: ["4S0"],
			mudslap: ["4T"],
			naturalgift: ["5L40", "4M", "4L40", "4S0"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			poisonpowder: ["5L15", "4L15"],
			powerwhip: ["5L54", "4L54"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shockwave: ["4M"],
			slam: ["5L43", "4L43"],
			sleeppowder: ["5L5", "4L5"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			strength: ["5M", "4M"],
			stunspore: ["5L29", "4L29"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M", "4S0"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			thief: ["5M", "4M"],
			tickle: ["5L47", "4L47"],
			toxic: ["5M", "4M"],
			vinewhip: ["5L19", "4L19"],
			worryseed: ["4T"],
			wringout: ["5L50", "4L50"],
		},
	},
	kangaskhan: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L13", "4L13", "3L7", "3S1"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L31"],
			circlethrow: ["5E"],
			cometpunch: ["5L1", "4L1", "3L1", "3S1"],
			counter: ["5E", "5D", "4E", "3T", "3E"],
			crunch: ["5L37", "4L31"],
			crushclaw: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E", "3E"],
			dizzypunch: ["5L34", "4L25", "3L43", "3S2"],
			doubleedge: ["5E", "4E", "3T"],
			doublehit: ["5L19", "4L43"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["5D", "4M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M", "3S2"],
			endeavor: ["5E", "4T", "4E"],
			endure: ["5L43", "4M", "4L34", "3T", "3L37"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L7", "5D", "4L7", "3L19"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5E", "4E", "3E"],
			focuspunch: ["5E", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["5L25", "4L19", "3T", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5L46", "4T", "4L37"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L22", "4L22", "3L31"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L55", "4L49", "3L49"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sing: ["3S2"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stomp: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["5L49", "4T", "4L46"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L10", "4L10", "3L13", "3S2"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5E"],
			uproar: ["5E", "4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wish: ["3S0"],
			workup: ["5M"],
			yawn: ["3S0"],
		},
	},
	horsea: {
		inherit: true,
		learnset: {
			agility: ["5L23", "4L23", "3L36"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5L30", "5D", "4M", "4L30"],
			bubble: ["5L1", "5D", "5S0", "4L1", "3L1"],
			bubblebeam: ["5L18", "4L18"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			disable: ["5E", "4E", "3E"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5E", "4E", "3E"],
			dragondance: ["5L38", "4L38", "3L50"],
			dragonpulse: ["5L42", "4M", "4L42"],
			dragonrage: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5L14", "4L14"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L35", "4L35", "3L43"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			leer: ["5L8", "4L8", "3L15"],
			mimic: ["3T"],
			muddywater: ["5E", "4E"],
			naturalgift: ["4M"],
			octazooka: ["5E", "5D", "4E", "3E"],
			outrage: ["5E", "4T"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["5E", "4T", "4E"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L4", "4L4", "3L8"],
			snore: ["4T", "3T"],
			splash: ["5E", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L26", "4T", "4L26", "3L29"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L11", "4L11", "3L22"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	seadra: {
		inherit: true,
		learnset: {
			agility: ["5L23", "4L23", "3L40", "3S0"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5L30", "4M", "4L30"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L18", "4L18"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5L48", "4L48", "3L62"],
			dragonpulse: ["5L57", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5L14", "4L14"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L40", "4L40", "3L51"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	kingdra: {
		inherit: true,
		learnset: {
			agility: ["5L23", "4L23", "3L40", "3S0"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["5L30", "4M", "4L30"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L18", "4L18"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "5S1", "4T"],
			dragondance: ["5L48", "4L48", "3L62"],
			dragonpulse: ["5L57", "5S1", "4M", "4L57"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5L14", "4L14"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L40", "4L40", "3L51"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "5S1", "4M", "3M"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L26", "4T", "4L26", "3L29", "3S0"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["5L1", "4L1"],
		},
	},
	goldeen: {
		inherit: true,
		learnset: {
			agility: ["5L47", "4L47", "3L52"],
			aquaring: ["5L27", "4L27"],
			aquatail: ["5E", "4T", "4E"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L21", "4L21", "3L24"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L11", "4L11", "3L15"],
			horndrill: ["5L41", "4L41", "3L43"],
			hydropump: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			megahorn: ["5L57", "4L51", "3L57"],
			mimic: ["3T"],
			mudshot: ["5E"],
			mudslap: ["5E", "4T", "4E"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			peck: ["5L1", "5D", "4L1", "3L1"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "5D", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["5E"],
			skullbash: ["5E"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			soak: ["5L51"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L7", "4L7", "3L10"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "5L37", "4M", "4L37", "3M", "3L38"],
			waterpulse: ["5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	seaking: {
		inherit: true,
		learnset: {
			agility: ["5L56", "4L56", "3L61"],
			aquaring: ["5L27", "4L27"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5D", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L21", "4L21", "3L24"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L31", "4L31", "3L29"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L11", "4L11", "3L15"],
			horndrill: ["5L47", "4L47", "3L49"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			megahorn: ["5L72", "4L63", "3L69"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["5L1", "4L1", "3L1"],
			poisonjab: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["5D", "4M", "3T"],
			snore: ["4T", "3T"],
			soak: ["5L63"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L1", "4L1", "3L1"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "5L40", "4M", "4L40", "3M", "3L41"],
			waterpulse: ["5L17", "5D", "4M", "4L17", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
		},
	},
	staryu: {
		inherit: true,
		learnset: {
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			bubblebeam: ["5L28", "4L28", "3L28"],
			camouflage: ["5L19", "4L19", "3L19"],
			cosmicpower: ["5L55", "4L51", "3L42", "3S0"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L37", "4M", "4L37"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L1", "4L1", "3L1", "3S1"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L60", "4L55", "3L46", "3S0"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["5D", "4T", "3T"],
			lightscreen: ["5M", "5L42", "4M", "4L42", "3M", "3L37", "3S0"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			minimize: ["5L33", "4L33", "3L33", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			powergem: ["5L51", "4L46"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5L10", "4L10", "3L10", "3S1"],
			recover: ["5L15", "4L15", "3L15", "3S1"],
			recycle: ["5D", "4M"],
			reflect: ["5M", "4M", "3M"],
			reflecttype: ["5L46"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L24", "4T", "4L24", "3T", "3L24"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L6", "5D", "4L6", "3L6", "3S1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	starmie: {
		inherit: true,
		learnset: {
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			confuseray: ["5L28", "4L28", "3L33"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M", "3S0"],
			icywind: ["4T", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5L1", "4L1", "3L1"],
			recover: ["5L1", "4L1", "3L1", "3S0"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L1", "4T", "4L1", "3T", "3L1"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			waterfall: ["5M", "4M", "3M", "3S0"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	mimejr: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			barrier: ["5L1", "4L1"],
			batonpass: ["5L46", "4L46"],
			brickbreak: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5E", "4E"],
			confuseray: ["5E", "4E"],
			confusion: ["5L1", "4L1"],
			copycat: ["5L4", "4L4"],
			doubleslap: ["5L15", "4L15"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M"],
			encore: ["5L11", "4L11"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fakeout: ["5E", "4E"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5E", "4E"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["5E", "4E"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hypnosis: ["5E", "4E"],
			icywind: ["5E"],
			lightscreen: ["5M", "5L22", "4M", "4L22"],
			magiccoat: ["4T"],
			magicroom: ["5E"],
			meditate: ["5L8", "4L8"],
			mimic: ["5L18", "5E", "4L18", "4E"],
			mudslap: ["4T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			powersplit: ["5E"],
			protect: ["5M", "4M"],
			psybeam: ["5L25", "4L25"],
			psychic: ["5M", "5L39", "4M", "4L39"],
			psychup: ["5M", "4M", "4E"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["5L32", "4M", "4L32"],
			reflect: ["5M", "5L22", "4M", "4L22"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roleplay: ["5L43", "4T", "4L43"],
			round: ["5M"],
			safeguard: ["5M", "5L50", "4M", "4L50"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "5L29", "4M", "4L29"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			teeterdance: ["5E", "4E"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			tickle: ["5L1", "4L1"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["5L36", "5E", "4T", "4L36", "4E"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			wakeupslap: ["5E", "4E"],
		},
	},
	mrmime: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5L1", "5D", "4L1", "3L1"],
			batonpass: ["5L46", "4L46", "3L47"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5E", "4E"],
			confusion: ["5L1", "4L1", "3L5"],
			copycat: ["5L4", "4L4"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["5L15", "4L15", "3L15"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			encore: ["5L11", "4L11", "3L25", "3S0"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E", "3E"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S0"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			guardswap: ["5L1", "4L1"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5E", "4E", "3E"],
			icepunch: ["4T", "3T"],
			icywind: ["5E"],
			irondefense: ["4T"],
			lightscreen: ["5M", "5L22", "4M", "4L22", "3M", "3L19"],
			magicalleaf: ["5L1", "4L1", "3L22"],
			magiccoat: ["4T"],
			magicroom: ["5E"],
			meditate: ["5L8", "4L8", "3L12"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["5L18", "5E", "4L18", "4E", "3T", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			powersplit: ["5E"],
			powerswap: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L25", "4L25", "3L29"],
			psychic: ["5M", "5L39", "4M", "4L39", "3M", "3L43", "3S0"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			quickguard: ["5L1"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["5L32", "4M", "4L32", "3L33"],
			reflect: ["5M", "5L22", "4M", "4L22", "3M", "3L19"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["5L43", "4T", "4L43", "3L40"],
			round: ["5M"],
			safeguard: ["5M", "5L50", "4M", "4L50", "3M", "3L50"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "5L29", "4M", "4L29", "3T", "3L8"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			teeterdance: ["5E", "5D", "4E"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T", "3S0"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5L36", "5E", "4T", "4L36", "4E", "3L36", "3E"],
			trickroom: ["5M", "4M"],
			wakeupslap: ["5E", "4E"],
			wideguard: ["5L1"],
			zenheadbutt: ["4T"],
		},
	},
	scyther: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L17", "5S2", "4L17", "3L21"],
			airslash: ["5L53", "4L53"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "5D", "4E", "3E"],
			brickbreak: ["5M", "4M"],
			bugbite: ["4T"],
			bugbuzz: ["5E", "4E"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			cut: ["5M", "4M", "3M"],
			defog: ["5E", "4M"],
			doubleedge: ["3T"],
			doublehit: ["5L49", "4L49"],
			doubleteam: ["5M", "5L37", "4M", "4L37", "3M", "3L41"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["5L61", "4L61"],
			focusenergy: ["5L5", "4L5", "3L6", "3S0"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L25", "5S2", "4T", "4L25", "3T", "3L46"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			knockoff: ["4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["5M", "4E", "3E"],
			mimic: ["3T"],
			morningsun: ["3S1"],
			naturalgift: ["4M"],
			nightslash: ["5L45", "5E", "4L45", "4E"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L9", "4L9", "3L11"],
			quickattack: ["5L1", "5D", "4L1", "3L1", "3S0"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5L33", "5E", "4L33", "4E", "3E", "3S1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			secretpower: ["4M", "3M"],
			silverwind: ["5E", "4M", "4E", "3E", "3S1"],
			slash: ["5L29", "5S2", "4L29", "3L31", "3S1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L57", "4M", "4L57", "3T", "3L36"],
			tailwind: ["5D", "4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "4M"],
			vacuumwave: ["5L1", "4L1"],
			wingattack: ["5L21", "5S2", "4L21", "3L26"],
			xscissor: ["5M", "5L41", "4M", "4L41"],
		},
	},
	scizor: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L17", "4L17", "4S1", "3L21"],
			attract: ["5M", "4M", "3M"],
			brickbreak: ["5M", "4M"],
			bugbite: ["5S2", "4T"],
			bulletpunch: ["5L1", "5S2", "4L1"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doublehit: ["5L49", "4L49"],
			doubleteam: ["5M", "4M", "3M", "3L41"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L13", "4M", "4L13", "3L16"],
			feint: ["5L61", "4L61"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusenergy: ["5L5", "5S3", "4L5", "3L6"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L25", "4T", "4L25", "3T", "3L46", "3S0"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["5L37", "4T", "4L37", "4S1", "3L41"],
			ironhead: ["5L53", "4T", "4L53"],
			knockoff: ["4T"],
			leer: ["5L1", "5S3", "4L1", "3L1"],
			lightscreen: ["5M"],
			metalclaw: ["5L21", "4L21", "3L26", "3S0"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["5L45", "4L45"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L9", "5S3", "4L9", "3L11"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5L33", "4L33"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["5S2", "4M"],
			round: ["5M"],
			safeguard: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			slash: ["5L29", "4L29", "3L31", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5S3", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L57", "5S2", "4M", "4L57", "4S1", "3T", "3L36", "3S0"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			xscissor: ["5M", "5L41", "4M", "4L41", "4S1"],
		},
	},
	smoochum: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			avalanche: ["5L35", "4M", "4L31"],
			blizzard: ["5M", "5L48", "4M", "4L45", "3M", "3L57"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["5E", "5D", "4M"],
			confusion: ["5L15", "4L15", "3L21"],
			copycat: ["5L41", "4L38"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E", "3E"],
			faketears: ["5L28", "4L25", "3L37"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			healbell: ["4T"],
			heartstamp: ["5L21"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5E", "4T", "4E", "3T", "3E"],
			icywind: ["4T", "3T"],
			lick: ["5L5", "4L5", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L31", "4L28"],
			magiccoat: ["4T"],
			meanlook: ["5L25", "4L21", "3L33"],
			meditate: ["5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			perishsong: ["5L45", "4L41", "3L49"],
			pound: ["5L1", "4L1", "3L1"],
			powdersnow: ["5L11", "4L11", "3L13"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L38", "4M", "4L35", "3M", "3L45"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5L18", "4L18", "3L25"],
			skillswap: ["5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L8", "5D", "4L8", "3L9"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			wakeupslap: ["5E"],
			waterpulse: ["4M", "3M"],
			wish: ["5E", "4E", "3E"],
			zenheadbutt: ["4T"],
		},
	},
	jynx: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			avalanche: ["5L39", "4M", "4L33"],
			blizzard: ["5M", "5L60", "4M", "4L55", "3M", "3L67"],
			bodyslam: ["5L44", "4L39", "3T", "3L51"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleslap: ["5L15", "4L15", "3L21"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L28", "4L25", "3L41"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			heartstamp: ["5L21"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5L18", "4T", "4L18", "3T", "3L25"],
			icywind: ["4T", "3T"],
			lick: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			lovelykiss: ["5L1", "4L1", "3L1"],
			magiccoat: ["4T"],
			meanlook: ["5L25", "4L21", "3L35"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			perishsong: ["5L55", "4L49", "3L57"],
			pound: ["5L1", "4L1", "3L1"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			wakeupslap: ["5L33", "4L28"],
			waterpulse: ["4M", "3M"],
			wringout: ["5L49", "4L44"],
			zenheadbutt: ["4T"],
		},
	},
	elekid: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			crosschop: ["5E", "5D", "4E", "3E", "3S0"],
			discharge: ["5L41", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5E", "4E", "3T"],
			electroball: ["5L31"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5E", "4E"],
			firepunch: ["5E", "4T", "4E", "3T", "3E", "3S0"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hammerarm: ["5E"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["5E", "4T", "4E", "3T", "3E", "3S0"],
			karatechop: ["5E", "4E", "3E"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "5L26", "4M", "4L25", "3M", "3L17"],
			lowkick: ["5L11", "4T", "4L10"],
			magnetrise: ["5D", "4T"],
			meditate: ["5E", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollingkick: ["5E", "4E", "3E"],
			round: ["5M"],
			screech: ["5L51", "4L43", "3L33"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["5L21", "4M", "4L19", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L16", "4T", "4L16", "3T", "3L25"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "5L56", "4M", "4L46", "3M", "3L49"],
			thunderbolt: ["5M", "5L46", "4M", "4L37", "3M", "3L41"],
			thunderpunch: ["5L36", "4T", "4L28", "3T", "3L9", "3S0"],
			thundershock: ["5L6", "5D", "4L7"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	electabuzz: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			crosschop: ["3S1"],
			discharge: ["5L44", "4L37"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			electroball: ["5L32"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lightscreen: ["5M", "5L26", "5S3", "4M", "4L25", "4S2", "3M", "3L17"],
			lowkick: ["5L11", "5S3", "4T", "4L10", "4S2"],
			lowsweep: ["5M"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1", "3S0"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5L56", "4L52", "3L36"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["5L21", "5S3", "4M", "4L19", "4S2", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L16", "5S3", "4T", "4L16", "3T", "3L25"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "5L62", "4M", "4L58", "3M", "3L58"],
			thunderbolt: ["5M", "5L50", "4M", "4L43", "3M", "3L47", "3S1"],
			thunderpunch: ["5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			thundershock: ["5L1", "4L1"],
			thunderwave: ["5M", "4M", "3T", "3S1"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	electivire: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			crosschop: ["4S0"],
			dig: ["5M", "4M"],
			discharge: ["5L44", "4L37", "4S1"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M", "4S0"],
			electroball: ["5L32"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firepunch: ["5L1", "4T", "4L1"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "5L68", "4M", "4L67"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T", "4S0"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "5L26", "4M", "4L25", "4S1"],
			lowkick: ["5L1", "4T", "4L1"],
			lowsweep: ["5M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			screech: ["5L56", "4L52"],
			secretpower: ["4M"],
			shockwave: ["5L21", "4M", "4L19"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L16", "4T", "4L16"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "5L62", "4M", "4L58"],
			thunderbolt: ["5M", "5L50", "4M", "4L43", "4S1"],
			thunderpunch: ["5L38", "4T", "4L28", "4S0", "4S1"],
			thundershock: ["5L1", "4L1"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	magby: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bellydrum: ["5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L25", "4L25", "3L43"],
			counter: ["3T"],
			crosschop: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5E", "4E", "3T"],
			ember: ["5L7", "5D", "4L7", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L16", "4L16"],
			fireblast: ["5M", "5L49", "4M", "4L46", "3M", "3L49"],
			firepunch: ["5L34", "4T", "4L28", "3T", "3L19"],
			firespin: ["5L19", "4L19"],
			flameburst: ["5L28"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L43", "4M", "4L37", "3M", "3L37"],
			flareblitz: ["5E", "4E"],
			fling: ["5M", "4M"],
			focusenergy: ["5E"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["5D", "4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["5E", "4M", "3M"],
			karatechop: ["5E", "4E", "3E"],
			lavaplume: ["5L37", "4L34"],
			leer: ["5L1", "4L1", "3L7"],
			machpunch: ["5E", "4E"],
			megakick: ["3T"],
			megapunch: ["5E", "4E", "3T", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["5L1", "4L1", "3L13"],
			smokescreen: ["5L10", "4L10", "3L25"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L46", "4M", "4L43", "3M", "3L31"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5E", "5D", "4T", "4E", "3T", "3E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	magmar: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L26", "5S3", "4L25", "4S2", "3L49"],
			counter: ["3T"],
			crosschop: ["3S1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			ember: ["5L1", "4L1", "3L1", "3S0"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L16", "5S3", "4L16"],
			fireblast: ["5M", "5L62", "4M", "4L54", "3M", "3L57", "3S1"],
			firepunch: ["5L38", "4T", "4L28", "4S2", "3T", "3L1", "3S0"],
			firespin: ["5L21", "5S3", "4L19", "4S2"],
			flameburst: ["5L32"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L50", "4M", "4L41", "3M", "3L41"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["3S1"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lavaplume: ["5L44", "4L36"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["5L1", "4L1", "3L1", "3S0"],
			smokescreen: ["5L11", "5S3", "4L10", "4S2", "3L25"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L56", "4M", "4L49", "3M", "3L33"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T", "3S1"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	magmortar: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			confuseray: ["5L26", "4L25", "4S1"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			ember: ["5L1", "4L1"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feintattack: ["5L16", "4L16"],
			fireblast: ["5M", "5L62", "4M", "4L58"],
			firepunch: ["5L38", "4T", "4L28", "4S1"],
			firespin: ["5L21", "4L19"],
			flameburst: ["5L32"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L50", "4M", "4L43", "4S0", "4S1"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "5L68", "4M", "4L67", "4S0"],
			incinerate: ["5M"],
			irontail: ["4M"],
			lavaplume: ["5L44", "4L37", "4S1"],
			leer: ["5L1", "4L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M", "4S0"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			smog: ["5L1", "4L1"],
			smokescreen: ["5L1", "4L1"],
			snore: ["4T"],
			solarbeam: ["5M", "4M", "4S0"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "5L56", "4M", "4L52"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["5L1", "4T", "4L1"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			willowisp: ["5M", "4M"],
		},
	},
	pinsir: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bind: ["5L4", "4L4", "3L7"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "5L21", "4M", "4L21", "3M", "3L31"],
			bugbite: ["5E"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M", "4E", "3E", "3S0"],
			feint: ["5E", "4E"],
			feintattack: ["5E", "4E", "3E"],
			flail: ["5E", "4E", "3E"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5E", "4E", "3E"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			guillotine: ["5L47", "4L47", "3L37", "3S0"],
			harden: ["5L13", "4L13", "3L19"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			mefirst: ["5E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L18", "4L18", "3L25"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L8", "4L8", "3T", "3L13"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			submission: ["5L42", "4L42", "3L43", "3S0"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5L52", "5E", "4T", "4L52"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "5L38", "4M", "4L38", "3T", "3L49"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L35", "4L35"],
			toxic: ["5M", "4M", "3M"],
			visegrip: ["5L1", "4L1", "3L1"],
			vitalthrow: ["5L25", "4L25"],
			xscissor: ["5M", "5L30", "4M", "4L30"],
		},
	},
	tauros: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T", "3S2"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M", "3S2"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "5L63", "4M", "4L55"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L8", "4L8", "3L8", "3S0", "3S1"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["5D", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["5M", "5L24", "4M", "4L24"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L15", "4L15", "3L19", "3S0"],
			rage: ["5L5", "5D", "4L5", "3L4", "3S0", "3S1"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S2"],
			rest: ["5M", "5L19", "4M", "4L19", "3M", "3L34"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["5D", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L11", "4L11", "3L13", "3S0"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L48", "4M", "4L41", "3T", "3L26"],
			tackle: ["5L1", "4L1", "3L1", "3S1"],
			tailwhip: ["5L3", "4L3", "3L1", "3S1", "3S2"],
			takedown: ["5L41", "4L35", "3L53"],
			thrash: ["5L55", "4L48", "3L43"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["5M"],
			workup: ["5M", "5L29"],
			zenheadbutt: ["5L35", "4T", "4L29"],
		},
	},
	magikarp: {
		inherit: true,
		learnset: {
			bounce: ["5D", "5S5", "4T"],
			flail: ["5L30", "5S5", "4L30", "3L30"],
			splash: ["5L1", "5D", "5S5", "4L1", "4S0", "4S1", "4S2", "4S3", "4S4", "3L1"],
			tackle: ["5L15", "4L15", "3L15"],
		},
	},
	gyarados: {
		inherit: true,
		learnset: {
			aquatail: ["5L35", "4T", "4L35"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L20", "4L20", "3L20"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			darkpulse: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5L44", "4L44", "3L50"],
			dragonpulse: ["4M"],
			dragonrage: ["5L23", "4L23", "3L25"],
			dragontail: ["5M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L41", "4L41", "3L40"],
			hyperbeam: ["5M", "5L47", "4M", "4L47", "3M", "3L55"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L32", "4L32"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			leer: ["5L26", "4L26", "3L30"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L38", "4M", "4L38", "3M", "3L45"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thrash: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L29", "4T", "4L29", "3L35"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lapras: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["5E", "4M"],
			blizzard: ["5M", "4M", "3M", "3S0"],
			block: ["4T"],
			bodyslam: ["5L18", "4L18", "3T", "3L13"],
			brine: ["5L37", "4M", "4L37"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			confuseray: ["5L7", "5D", "4L7", "3L19"],
			curse: ["5E", "4E", "3E"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E", "3E"],
			dragonpulse: ["5E", "4M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5E", "4E"],
			foresight: ["5E", "4E", "3E"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["4T", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			horndrill: ["5E", "5D", "4E", "3E"],
			hydropump: ["5L49", "4L49", "3L49", "3S0"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5L32", "4M", "4L32", "3M", "3L31"],
			iceshard: ["5L10", "4L10"],
			icywind: ["5D", "4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["5L4", "4L4", "3L7"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["4T"],
			perishsong: ["5L27", "4L27", "3L25"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "5L22", "4M", "4L22", "3M", "3L37", "3S0"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L43", "4M", "4L43", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L55", "4L55", "3L55"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sing: ["5L1", "4L1", "3L1"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			tickle: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5L14", "4M", "4L14", "3M"],
			whirlpool: ["5E", "4M", "4E"],
			zenheadbutt: ["4T"],
		},
	},
	ditto: {
		inherit: true,
		learnset: {
			transform: ["5L1", "4L1", "3L1"],
		},
	},
	eevee: {
		inherit: true,
		learnset: {
			attract: ["5M", "5S2", "4M", "4S0", "3M"],
			batonpass: ["5L36", "4L36", "3L36"],
			bite: ["5L29", "4L29", "4S0", "3L30"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["5E", "4E", "3E"],
			covet: ["5E", "4E", "4S0"],
			curse: ["5E", "4E", "3E"],
			detect: ["5E", "4E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M", "5S2"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "4E"],
			flail: ["5E", "4E", "4S1", "3E"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L15", "4L15", "3L16"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "4T", "4L1", "4S0", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "4S1", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L22", "4L22", "4S1", "3L23"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "5S2", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L8", "4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			storedpower: ["5E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5D", "4T", "3T"],
			synchronoise: ["5E"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			takedown: ["5L43", "4L43", "3L42"],
			tickle: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5L57", "4L57", "4S1"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
			yawn: ["5E", "4E"],
		},
	},
	vaporeon: {
		inherit: true,
		learnset: {
			acidarmor: ["5L64", "4L64", "3L47"],
			aquaring: ["5L43", "4L43"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L36", "4L36", "3L36"],
			bite: ["5L29", "4L29", "3L30"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			captivate: ["4M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5L57", "4L57", "3L42"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L71", "4L71", "3L52"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			mimic: ["3T"],
			muddywater: ["5L78", "4L78"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L22", "4L22", "3L23"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L8", "5S0", "4L8", "3L8"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["5L1", "5S0", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L15", "4L15", "3L16"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	jolteon: {
		inherit: true,
		learnset: {
			agility: ["5L64", "4L64", "3L47"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			dig: ["5M", "4M", "3M"],
			discharge: ["5L78", "4L78"],
			doubleedge: ["3T"],
			doublekick: ["5L29", "4L29", "3L30"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pinmissile: ["5L36", "4L36", "3L36"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L22", "4L22", "3L23"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L8", "5S0", "4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["5L1", "5S0", "4L1", "3L1"],
			thunder: ["5M", "5L71", "4M", "4L71", "3M", "3L52"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L43", "4L43"],
			thundershock: ["5L15", "4L15", "3L16"],
			thunderwave: ["5M", "5L57", "4M", "4L57", "3T", "3L42"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	flareon: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L29", "4L29", "3L30"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L15", "4L15", "3L16"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L71", "4M", "4L71", "3M"],
			firefang: ["5L43", "4L43"],
			firespin: ["5L36", "4L36", "3L36"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M", "3L52"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["5L1", "5S0", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			lavaplume: ["5L78", "4L78"],
			leer: ["3L47"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L22", "4L22", "3L23"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L8", "5S0", "4L8", "3L8"],
			scaryface: ["5L64", "4L64"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smog: ["5L57", "4L57", "3L42"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5S0", "4L1", "3L1"],
			tailwhip: ["5L1", "5S0", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	espeon: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L15", "4L15", "3L16"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L43", "4L43"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			morningsun: ["5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			powerswap: ["5L78", "4L78"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L36", "4L36", "3L36", "3S0"],
			psychic: ["5M", "5L64", "4M", "4L64", "3M", "3L47", "3S0"],
			psychup: ["5M", "5L57", "4M", "4L57", "3T", "3L42", "3S0"],
			psyshock: ["5M"],
			quickattack: ["5L22", "4L22", "3L23"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L8", "5S1", "4L8", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L29", "4T", "4L29", "3T", "3L30"],
			tackle: ["5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["5L1", "5S1", "4L1", "3L1"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	umbreon: {
		inherit: true,
		learnset: {
			assurance: ["5L43", "4L43"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			confuseray: ["5L29", "4L29", "3L30"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L36", "4L36", "3L36", "3S0"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			guardswap: ["5L78", "4L78"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S1", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["5L50", "4T", "4L50"],
			meanlook: ["5L57", "4L57", "3L42", "3S0"],
			mimic: ["3T"],
			moonlight: ["5L71", "4L71", "3L52", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5L15", "4L15", "3L16"],
			quickattack: ["5L22", "4L22", "3L23"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L8", "5S1", "4L8", "3L8"],
			screech: ["5L64", "4L64", "3L47", "3S0"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5S1", "4L1", "3L1"],
			tailwhip: ["5L1", "5S1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			workup: ["5M"],
		},
	},
	leafeon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["5L43", "4M", "4L43"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L57", "4L57"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["5L50", "4T", "4L50"],
			leafblade: ["5L71", "4L71"],
			magicalleaf: ["5L36", "4L36"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L22", "4L22"],
			raindance: ["5M", "4M"],
			razorleaf: ["5L15", "4L15"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L8", "5S0", "4L8"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "5L64", "4M", "4L64"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "5L78", "4M", "4L78"],
			synthesis: ["5L29", "4T", "4L29"],
			tackle: ["5L1", "5S0", "4L1"],
			tailwhip: ["5L1", "5S0", "4L1"],
			toxic: ["5M", "4M"],
			workup: ["5M"],
			worryseed: ["4T"],
			xscissor: ["5M", "4M"],
		},
	},
	glaceon: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			barrier: ["5L78", "4L78"],
			bite: ["5L29", "4L29"],
			blizzard: ["5M", "5L71", "4M", "4L71"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "5L64", "4M", "4L64"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["5L1", "5S0", "4T", "4L1"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icefang: ["5L43", "4L43"],
			iceshard: ["5L36", "4L36"],
			icywind: ["5L15", "4T", "4L15"],
			irontail: ["4M"],
			lastresort: ["5L50", "4T", "4L50"],
			mirrorcoat: ["5L57", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L22", "4L22"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L8", "5S0", "4L8"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "5S0", "4L1"],
			tailwhip: ["5L1", "5S0", "4L1"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	porygon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L12", "4L12", "3L9"],
			blizzard: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			conversion: ["5L1", "5S0", "4L1", "3L1"],
			conversion2: ["5L1", "4L1", "3L1"],
			discharge: ["5L40", "4L40"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lockon: ["5L45", "4L45", "3L32"],
			magiccoat: ["5L56", "4T", "4L56"],
			magnetrise: ["5L23", "4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L7", "5S0", "4L7", "3L12"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L18", "4L18", "3L20"],
			recycle: ["5L34", "4M", "4L34", "3L44"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sharpen: ["5L1", "5S0", "4L1", "3L24"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L29", "4T", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5S0", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5L51", "4L51", "3L36"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zapcannon: ["5L62", "4L62", "3L48"],
			zenheadbutt: ["4T"],
		},
	},
	porygon2: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L12", "4L12", "3L9"],
			blizzard: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			conversion: ["5L1", "4L1", "3L1"],
			conversion2: ["5L1", "4L1", "3L1"],
			defensecurl: ["5L1", "4L1", "3T", "3L24"],
			discharge: ["5L40", "4L40"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L67", "4M", "4L67", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lockon: ["5L45", "4L45", "3L32"],
			magiccoat: ["5L56", "4T", "4L56"],
			magnetrise: ["5L23", "4L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L7", "4L7", "3L12"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L18", "4L18", "3L20"],
			recycle: ["5L34", "4M", "4L34", "3L44"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L29", "4T", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["5L51", "4L51", "3L36"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zapcannon: ["5L62", "4L62", "3L48"],
			zenheadbutt: ["4T"],
		},
	},
	porygonz: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			agility: ["5L12", "4L12"],
			blizzard: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			conversion: ["5L1", "4L1"],
			conversion2: ["5L1", "4L1"],
			darkpulse: ["4M"],
			discharge: ["5L40", "4L40"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "5L34", "4M", "4L34"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "5L67", "4M", "4L67"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			lockon: ["5L45", "4L45"],
			magiccoat: ["5L56", "4T", "4L56"],
			magnetrise: ["5L23", "4L23"],
			nastyplot: ["5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M"],
			psybeam: ["5L7", "4L7"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recover: ["5L18", "4L18"],
			recycle: ["4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["5L29", "4T", "4L29"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			triattack: ["5L51", "4L51"],
			trick: ["4T"],
			trickroom: ["5M", "5L1", "4M", "4L1"],
			uproar: ["4T"],
			zapcannon: ["5L62", "4L62"],
			zenheadbutt: ["4T"],
		},
	},
	omanyte: {
		inherit: true,
		learnset: {
			ancientpower: ["5L37", "4T", "4L37", "3L49"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5E", "4E", "3E"],
			bide: ["5E"],
			bite: ["5L7", "5D", "5S0", "4L7", "3L13"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["5L28", "4M", "4L28"],
			bubblebeam: ["5E", "5S0", "4E", "3E"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L55", "4L52", "3L55"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["5D", "4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["5E", "4T", "4E"],
			leer: ["5L19", "4L19", "3L31"],
			mimic: ["3T"],
			muddywater: ["5E", "5D", "4E"],
			mudshot: ["5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L46", "4L46"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L16", "4T", "4L16", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shellsmash: ["5L52"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spikes: ["5E", "4E", "3E"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5E", "5S0", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5L43", "4L43", "3L43"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5E", "4E"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L19"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["5E", "4M"],
			withdraw: ["5L1", "5S0", "4L1", "3L1"],
			wringout: ["5E", "4E"],
		},
	},
	omastar: {
		inherit: true,
		learnset: {
			ancientpower: ["5L37", "4T", "4L37", "3L55"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["5L28", "4M", "4L28"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L75", "4L67", "3L65"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["5L19", "4L19", "3L31"],
			mimic: ["3T"],
			mudshot: ["5L25", "4L25", "3L25"],
			naturalgift: ["4M"],
			protect: ["5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L56", "4L56"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L16", "4T", "4L16", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shellsmash: ["5L67"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spikecannon: ["5L40", "4L40", "3L40"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5L48", "4L48", "3L46"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			withdraw: ["5L1", "4L1", "3L1"],
		},
	},
	kabuto: {
		inherit: true,
		learnset: {
			absorb: ["5L6", "5D", "4L6", "3L13"],
			aerialace: ["3M"],
			ancientpower: ["5L46", "4T", "4L46", "3L55"],
			aquajet: ["5L31", "4L31"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["5E", "4E", "3E"],
			captivate: ["4M"],
			confuseray: ["5E", "5S0", "4E", "3E"],
			dig: ["5M", "5S0", "4M", "4E", "3M", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "5D", "4E", "3E"],
			foresight: ["5E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L1", "5S0", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["5E", "4T", "4E", "3T"],
			irondefense: ["4T"],
			knockoff: ["5E", "4T", "4E", "3E"],
			leer: ["5L11", "4L11", "3L19"],
			megadrain: ["5L36", "4L36", "3L49"],
			metalsound: ["5L41", "4L41", "3L43"],
			mimic: ["3T"],
			mudshot: ["5L16", "5E", "4L16", "4E", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandattack: ["5L21", "4L21", "3L31"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			scratch: ["5L1", "5S0", "4L1", "3L1"],
			screech: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["5D", "4M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["5L51", "4L51"],
		},
	},
	kabutops: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L54", "4T", "4L54", "3L65"],
			aquajet: ["5L31", "4L31"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["5L26", "4M", "4L26", "3T", "3L37"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T", "3L1"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megadrain: ["5L36", "4L36", "3L55"],
			megakick: ["3T"],
			metalsound: ["5L45", "4L45", "3L46"],
			mimic: ["3T"],
			mudshot: ["5L16", "4L16", "3L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L72", "4L72"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandattack: ["5L21", "4L21", "3L31"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slash: ["5L40", "4L40", "3L40"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["5L63", "4L63"],
			xscissor: ["5M", "4M"],
		},
	},
	aerodactyl: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L17", "4L17", "3L8"],
			aircutter: ["4T"],
			ancientpower: ["5L25", "4T", "4L25", "3L29"],
			aquatail: ["4T"],
			assurance: ["5E", "5D", "4E"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "5D", "4L1", "3L15"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L33", "4L33"],
			curse: ["5E", "4E", "3E"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5E", "4E", "3E"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L1", "5S0", "4L1"],
			flamethrower: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "5L81", "4M", "4L73"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L65", "4M", "4L57", "3M", "3L50"],
			icefang: ["5L1", "5S0", "4L1"],
			incinerate: ["5M"],
			ironhead: ["5L57", "4T", "4L49"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L9", "4M", "4L9", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L73", "4M", "4L65", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roost: ["5E", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L1", "4L1", "3L36"],
			secretpower: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			skydrop: ["5M", "5L49"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["5D", "4M"],
			steelwing: ["5E", "5S0", "4M", "4E", "3M", "3E"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L1", "4L1", "3L22"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5E", "4T"],
			takedown: ["5L41", "4L41", "3L43"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "5S0", "4L1"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["5E", "4E", "3E"],
			wingattack: ["5L1", "4L1", "3L1"],
		},
	},
	munchlax: {
		inherit: true,
		learnset: {
			afteryou: ["5E"],
			amnesia: ["5L9", "4L9"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bodyslam: ["5L36", "4L33"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5E", "4E"],
			chipaway: ["5L25"],
			counter: ["5E", "4E"],
			curse: ["5E", "4E", "4S1"],
			defensecurl: ["5L4", "4L4", "4S0"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "5L41", "4M", "4L36"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			lastresort: ["5L57", "4T", "4L49"],
			lick: ["5L12", "5E", "4L12", "4E"],
			metronome: ["5L1", "4L1", "4S0", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["5L49", "5E", "4M", "4L44"],
			odorsleuth: ["5L1", "4L1", "4S1"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M"],
			recycle: ["5L17", "4M", "4L17"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rollout: ["5L44", "4T", "4L41"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			screech: ["5L20", "4L20"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			selfdestruct: ["5E", "4S0"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["5L52"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stockpile: ["5L28", "4L25"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M", "4E"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swallow: ["5L33", "4L28"],
			tackle: ["5L1", "4L1", "4S0", "4S1"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			whirlwind: ["5E", "4E"],
			workup: ["5M"],
			zenheadbutt: ["5E", "4T", "4E"],
		},
	},
	snorlax: {
		inherit: true,
		learnset: {
			afteryou: ["5E"],
			amnesia: ["5L9", "4L9", "3L5"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L17", "4L17", "3L13"],
			blizzard: ["5M", "4M", "3M"],
			block: ["5L41", "4T", "4L36", "3L37"],
			bodyslam: ["5L36", "4L33", "3T", "3L33", "3S0"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5E", "4E", "3E"],
			chipaway: ["5L25"],
			counter: ["5E", "4E", "3T"],
			covet: ["3L42"],
			crunch: ["5L49", "4L44"],
			curse: ["5E", "4E", "3E", "3S0"],
			defensecurl: ["5L4", "4L4", "3T", "3L9"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["5D", "4T", "3T"],
			fissure: ["5E", "4E", "3E", "3S0"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "5L57", "4M", "4L49"],
			gunkshot: ["4T"],
			headbutt: ["4T", "3L17"],
			heavyslam: ["5L52"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M", "3L51"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			lastresort: ["4T"],
			lick: ["5L12", "5E", "4L12", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["3T"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["5D", "4M"],
			refresh: ["3S0"],
			rest: ["5M", "5L28", "4M", "4L25", "3M", "3L25"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L44", "4T", "4L41", "3T", "3L46"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5L33", "4M", "4L28", "3T", "3L37"],
			smackdown: ["5M"],
			snore: ["5L28", "4T", "4L28", "3T", "3L28"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			whirlwind: ["5E", "4E"],
			wildcharge: ["5M"],
			workup: ["5M"],
			yawn: ["5L20", "4L20", "3L21"],
			zenheadbutt: ["4T"],
		},
	},
	articuno: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L36", "4L36", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["5L29", "4T", "4L29"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L71", "4M", "4L71", "3M", "3L73"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L1", "4L1", "3L1"],
			hail: ["5M", "5L85", "4M", "4L85", "3M"],
			haze: ["3S2"],
			healbell: ["3S2"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5L43", "4M", "4L43", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			iceshard: ["5L15", "4L15"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["5L22", "4L22", "4S4", "3L37", "3S0", "3S1"],
			mist: ["5L8", "4L8", "4S4", "3L13", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "5L50", "4M", "4L50", "4S3", "3M", "3L61", "3S1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["5L57", "4M", "4L57", "4S3"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L78", "4L78", "3L85"],
			signalbeam: ["4T"],
			skyattack: ["4T", "3T"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5L64", "4T", "4L64"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
		},
	},
	zapdos: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L43", "4L43", "4S3", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			ancientpower: ["5L29", "4T", "4L29"],
			batonpass: ["3S2"],
			charge: ["5L36", "4L36", "4S3", "3L61", "3S1"],
			chargebeam: ["5M", "4M"],
			defog: ["4M"],
			detect: ["5L15", "4L15", "4S4", "3L37", "3S0", "3S1"],
			discharge: ["5L50", "4L50", "4S3"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5L71", "4L71", "4S4", "3L49", "3S0", "3S1"],
			endure: ["4M", "3T"],
			extrasensory: ["3S2"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			lightscreen: ["5M", "5L64", "4M", "4L64", "3M", "3L73"],
			metalsound: ["3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "5L22", "4M", "4L22"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L85", "4M", "4L85", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["5L57", "4M", "4L57", "4S3"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skyattack: ["4T", "3T"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thunder: ["5M", "5L78", "4M", "4L78", "3M", "3L85"],
			thunderbolt: ["5M", "4M", "3M", "3S2"],
			thundershock: ["5L1", "4L1", "3L1"],
			thunderwave: ["5M", "5L8", "4M", "4L8", "4S4", "3T", "3L13", "3S0"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	moltres: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L15", "4L15", "4S4", "3L25", "3S0", "3S1"],
			aircutter: ["4T"],
			airslash: ["5L50", "4L50", "4S3"],
			ancientpower: ["5L29", "4T", "4L29"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["5L22", "4M", "4L22", "4S4", "3T", "3L37", "3S0", "3S1"],
			extrasensory: ["3S2"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firespin: ["5L8", "4L8", "4S4", "3L13", "3S0"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L36", "4M", "4L36", "4S3", "4S4", "3M", "3L49", "3S0", "3S1", "3S2"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			heatwave: ["5L64", "4T", "4L64", "3L73"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			mimic: ["3T"],
			morningsun: ["3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			overheat: ["5M", "4M", "3M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["5L57", "4M", "4L57", "4S3"],
			round: ["5M"],
			safeguard: ["5M", "5L43", "4M", "4L43", "4S3", "3M", "3L61", "3S1"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			skyattack: ["5L78", "4T", "4L78", "3T", "3L85"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L71", "4M", "4L71"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L85", "4M", "4L85", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			willowisp: ["5M", "4M", "3S2"],
			wingattack: ["5L1", "4L1", "3L1"],
		},
	},
	dratini: {
		inherit: true,
		learnset: {
			agility: ["5L25", "4L25", "3L36"],
			aquajet: ["5E"],
			aquatail: ["5L35", "4T", "4L31"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5E", "5D", "4E", "3E"],
			dragondance: ["5L51", "5E", "4L45", "4E", "3E"],
			dragonpulse: ["5E", "4M"],
			dragonrage: ["5L15", "4L15", "3L22"],
			dragonrush: ["5L41", "5E", "4L35", "4E"],
			dragontail: ["5M", "5L31"],
			endure: ["4M", "3T"],
			extremespeed: ["5E", "4E"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L61", "4M", "4L55", "3M", "3L57"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["5E", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4E", "3E"],
			mimic: ["3T"],
			mist: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			outrage: ["5L55", "4T", "4L51", "3L50"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L45", "4M", "4L41", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["5L21", "4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "5L5", "5D", "4M", "4L5", "3T", "3L8"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L11", "4T", "4L11", "3L15"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5E", "5D", "4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["5L1", "4L1", "3L1"],
		},
	},
	dragonair: {
		inherit: true,
		learnset: {
			agility: ["5L25", "4L25", "3L38"],
			aquatail: ["5L39", "4T", "4L33"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragondance: ["5L61", "4L53"],
			dragonpulse: ["4M"],
			dragonrage: ["5L15", "4L15", "3L22"],
			dragonrush: ["5L47", "4L39"],
			dragontail: ["5M", "5L33"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L75", "4M", "4L67", "3M", "3L65"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["5L67", "4T", "4L61", "3L56"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L53", "4M", "4L47", "3M", "3L47"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			slam: ["5L21", "4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L1", "4T", "4L1", "3L1"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wrap: ["5L1", "4L1", "3L1"],
		},
	},
	dragonite: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L25", "4L25", "3L38", "3S0"],
			aircutter: ["4T"],
			aquatail: ["5L39", "4T", "4L33"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T", "4S2"],
			dragonclaw: ["5M", "4M", "3M"],
			dragondance: ["5L61", "5S3", "4L53", "4S2", "3S1"],
			dragonpulse: ["4M"],
			dragonrage: ["5L15", "4L15", "3L22"],
			dragonrush: ["5L47", "5S4", "5S5", "4L39"],
			dragontail: ["5M", "5L33"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M", "3S1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5S6", "4M", "3M"],
			firepunch: ["5L1", "5S3", "4T", "4L1", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hurricane: ["5L81"],
			hyperbeam: ["5M", "5L75", "5S6", "4M", "4L73", "3M", "3L75", "3S1"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5L67", "5S3", "5S6", "4T", "4L64", "4S2", "3L61", "3S0"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roost: ["5L1", "4M", "4L1"],
			round: ["5M"],
			safeguard: ["5M", "5L53", "5S4", "5S5", "5S6", "4M", "4L47", "3M", "3L47", "3S0"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			skydrop: ["5M"],
			slam: ["5L21", "4L21", "3L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "4S2", "3M"],
			thunderpunch: ["5L1", "5S4", "4T", "4L1", "3T"],
			thunderwave: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L1", "4T", "4L1", "3L1"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wingattack: ["5L55", "5S4", "5S5", "4L55", "3L55", "3S0"],
			wrap: ["5L1", "4L1", "3L1"],
		},
	},
	mewtwo: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5L50", "4L57", "4S1", "3L77"],
			aquatail: ["4T"],
			aurasphere: ["5L93", "5S2", "4L100"],
			avalanche: ["4M"],
			barrier: ["5L1", "4L8", "3L11"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			electroball: ["5S2"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L15", "4L22", "3L44"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			guardswap: ["5L57", "4L64", "4S1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5S3", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			mefirst: ["5L71", "4L79"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			miracleeye: ["5L29", "4L36"],
			mist: ["5L36", "4L43", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			poisonjab: ["5M", "4M"],
			powerswap: ["5L57", "4L64", "4S1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L64", "4M", "4L71", "3M", "3L66", "3S0"],
			psychocut: ["5L43", "4L50", "4S1"],
			psychup: ["5M", "5L22", "4M", "4L29", "3T", "3L33"],
			psyshock: ["5M"],
			psystrike: ["5L100", "5S2", "5S3"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L79", "4L86", "3L44", "3S0"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "5L86", "4M", "4L93", "3M", "3L55", "3S0"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "5S2", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L8", "4T", "4L15", "3T", "3L22", "3S0"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	mew: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			amnesia: ["5L60", "4L60", "4S17"],
			ancientpower: ["5L50", "4T", "4L50", "4S14", "3L50"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			aurasphere: ["5L100", "4L100", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19"],
			avalanche: ["4M"],
			barrier: ["5L40", "4L40", "4S15"],
			batonpass: ["5L80", "4L80"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bugbite: ["4T"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			embargo: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["3S2", "3S3"],
			falseswipe: ["5M", "4M"],
			feintattack: ["3S4", "3S5"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gastroacid: ["4T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gunkshot: ["4T"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["4S20", "3S6", "3S7"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			magnetrise: ["4T"],
			mefirst: ["5L70", "4L70"],
			megakick: ["3T"],
			megapunch: ["5L10", "4L10", "4S16", "3T", "3L20", "3S0"],
			metronome: ["5L20", "4L20", "4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "3T", "3L30", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L90", "4L90"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["3S8", "3S9"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			pluck: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			pound: ["5L1", "4L1", "4S21", "3L1", "3S0", "3S1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L30", "4M", "4L30", "4S19", "3M", "3L40"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			reflecttype: ["5L1"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "4S20", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T", "3S10", "3S11"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T", "4S20"],
			tailwind: ["4T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["4S14", "4S15", "4S16", "4S17", "4S18", "4S19", "4S20"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			transform: ["5L1", "4L1", "4S18", "3L10", "3S0", "3S1"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["5M"],
			voltswitch: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
			worryseed: ["4T"],
			xscissor: ["5M", "4M"],
			zapcannon: ["3S12", "3S13"],
			zenheadbutt: ["4T"],
		},
	},
	chikorita: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E", "3E", "3S1"],
			aromatherapy: ["5L42", "5E", "4L42", "4E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L34", "5E", "4L34", "4E", "3T", "3L29"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frenzyplant: ["3S1"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			grasswhistle: ["5E", "4E", "3E"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			healpulse: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5E", "4E", "3E"],
			irontail: ["4M", "3M"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5E", "4E", "3E"],
			lightscreen: ["5M", "5L31", "4M", "4L31", "3M", "3L36"],
			magicalleaf: ["5L20", "4L20"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L23", "4M", "4L23"],
			naturepower: ["5E", "4E", "3E"],
			poisonpowder: ["5L9", "4L9", "3L15"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L6", "4L6", "3L8", "3S0"],
			reflect: ["5M", "5L17", "4M", "4L17", "3M", "3L12"],
			refresh: ["5E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L39", "4M", "4L39", "3M", "3L43"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L45", "4M", "4L45", "3M", "3L50"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L28", "4L28"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L12", "4T", "4L12", "3L22"],
			tackle: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			toxic: ["5M", "4M", "3M"],
			vinewhip: ["5E", "4E", "3E"],
			worryseed: ["4T"],
			wringout: ["5E", "4E"],
		},
	},
	bayleef: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["5L50", "4L50"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L40", "4L40", "3T", "3L31"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "5L36", "4M", "4L36", "3M", "3L39"],
			magicalleaf: ["5L22", "4L22"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L26", "4M", "4L26"],
			poisonpowder: ["5L1", "4L1", "3L15"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L1", "4L1", "3L1"],
			reflect: ["5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L46", "4M", "4L46", "3M", "3L47"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L54", "4M", "4L54", "3M", "3L55"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L32", "4L32"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L12", "4T", "4L12", "3L23"],
			tackle: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
		},
	},
	meganium: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aromatherapy: ["5L60", "4L60"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L46", "4L46", "3T", "3L31"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frenzyplant: ["5T", "4T"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "5L40", "4M", "4L40", "3M", "3L41"],
			magicalleaf: ["5L22", "4L22"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L26", "4M", "4L26"],
			outrage: ["4T"],
			petaldance: ["5L32", "4L32"],
			poisonpowder: ["5L1", "4L1", "3L15"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L1", "4L1", "3L1"],
			reflect: ["5M", "5L18", "4M", "4L18", "3M", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L54", "4M", "4L54", "3M", "3L51"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L66", "4M", "4L66", "3M", "3L61"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L34", "4L34"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L12", "4T", "4L12", "3L23"],
			tackle: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
		},
	},
	cyndaquil: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blastburn: ["3S1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			covet: ["5E", "4E", "3E"],
			crushclaw: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L22", "4L22", "3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L55", "5E", "4L46", "4E", "3T"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["5L58", "4L49"],
			extrasensory: ["5E", "4E"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			flameburst: ["5E"],
			flamecharge: ["5M", "5L28"],
			flamethrower: ["5M", "5L40", "4M", "4L37", "3M", "3L46"],
			flamewheel: ["5L19", "4L19", "3L27"],
			flareblitz: ["5E", "4E"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			inferno: ["5L46"],
			lavaplume: ["5L37", "4L31"],
			leer: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["5E"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L13", "5E", "4L13", "4E", "3L19", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E", "3S1"],
			rollout: ["5L49", "4T", "4L40", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L6", "4L4", "3L6", "3S0"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L31", "4T", "4L28", "3T", "3L36"],
			tackle: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			thrash: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	quilava: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L24", "4L24", "3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L64", "4L53", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L10", "4L10", "3L12"],
			endure: ["4M", "3T"],
			eruption: ["5L68", "4L57"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			flamecharge: ["5M", "5L35"],
			flamethrower: ["5M", "5L46", "4M", "4L42", "3M", "3L54"],
			flamewheel: ["5L20", "4L20", "3L31"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5L53"],
			lavaplume: ["5L42", "4L35"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L13", "4L13", "3L21"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["5L57", "4T", "4L46", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L31", "4T", "4L31", "3T", "3L42"],
			tackle: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	typhlosion: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blastburn: ["5T", "4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L24", "4L24", "3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L69", "4L53", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["5L74", "4L57"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			firepunch: ["4T", "3T"],
			flamecharge: ["5M", "5L35"],
			flamethrower: ["5M", "5L48", "4M", "4L42", "3M", "3L60", "3S0"],
			flamewheel: ["5L20", "4L20", "3L31", "3S0"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "5L1", "4M", "4L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5L56"],
			lavaplume: ["5L43", "4L35"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L13", "4L13", "3L21", "3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["5L61", "4T", "4L46", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M", "3T"],
			smokescreen: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L31", "4T", "4L31", "3T", "3L45", "3S0"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	totodile: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5E", "4T", "4E", "3E"],
			aquajet: ["5E", "4E"],
			aquatail: ["5L43", "4T", "4L36"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L20"],
			blizzard: ["5M", "4M", "3M"],
			block: ["5E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["5L29"],
			counter: ["3T"],
			crunch: ["5L27", "5E", "4L27", "4E", "3E", "3S1"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4E", "3E"],
			dragondance: ["5E", "4E"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E"],
			flail: ["5L22", "4L22"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydrocannon: ["3S1"],
			hydropump: ["5L50", "5E", "4L43", "4E", "3L52", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L20", "4L20"],
			icepunch: ["5E", "4T", "4E", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L8", "4L8", "3L7", "3S0"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L15", "4L15", "3L27"],
			scratch: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			screech: ["5L36", "4L34", "3L43"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L34", "4L29", "3L35"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["5L48", "4T", "4L41"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thrash: ["5L41", "5E", "4L22", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L6", "4L6", "3L13"],
			waterpledge: ["5T"],
			waterpulse: ["5E", "4M", "3M"],
			watersport: ["5E", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	croconaw: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["5L51", "4L42"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L21"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["5L33"],
			counter: ["3T"],
			crunch: ["5L30", "4L30"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L24", "4L24"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5L60", "4L51", "3L55"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L21", "4L21"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L8", "4L8", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L15", "4L15", "3L28"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L42", "4L39", "3L45"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L39", "4L33", "3L37"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["5L57", "4T", "4L48"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thrash: ["5L48", "4L24"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L13"],
			waterpledge: ["5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	feraligatr: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L30", "4L30"],
			ancientpower: ["4T"],
			aquatail: ["5L63", "4T", "4L50"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L13", "4L13", "3L21"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L37"],
			counter: ["3T"],
			crunch: ["5L32", "4L32"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L24", "4L24"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydrocannon: ["5T", "4T"],
			hydropump: ["5L76", "4L63", "3L58"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L21", "4L21"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L15", "4L15", "3L28"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L50", "4L45", "3L47"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L45", "4L37", "3L38"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["5L71", "4T", "4L58"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thrash: ["5L58", "4L24"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpledge: ["5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	sentret: {
		inherit: true,
		learnset: {
			amnesia: ["5L36", "4L36", "3L49"],
			aquatail: ["4T"],
			assist: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L39", "4L39"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5E", "4E"],
			covet: ["5E", "5D", "4E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L4", "4L4", "3T", "3L4"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["5D", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusenergy: ["5E", "4E", "3E"],
			focuspunch: ["4M", "3M"],
			followme: ["5L19", "4L19", "3L31"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L13", "4L13", "3L12"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hypervoice: ["5L47", "4L47"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["5E", "4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["5E", "4T", "4E"],
			mefirst: ["5L42", "4L42"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			quickattack: ["5L7", "4L7", "3L7"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L28", "4M", "4L28", "3M", "3L40"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scratch: ["5L1", "5D", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["5L25", "4L25", "3L24"],
			slash: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["5L31", "4T", "4L31"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "4E", "3E"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	furret: {
		inherit: true,
		learnset: {
			amnesia: ["5L42", "4L42", "3L59"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L46", "4L46"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			followme: ["5L21", "4L21", "3L37"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L13", "4L13", "3L12"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5L17", "4T", "4L17", "3L19"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypervoice: ["5L56", "4L56"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mefirst: ["5L50", "4L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L32", "4M", "4L32", "3M", "3L48"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["5L28", "4L28", "3L28"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L36", "4T", "4L36"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	hoothoot: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5E", "4E"],
			aircutter: ["4T"],
			airslash: ["5L33", "4L29"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L21", "4L21", "3L34"],
			defog: ["5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "5L57", "4M", "4L49", "3T", "3L48"],
			echoedvoice: ["5M", "5L25"],
			endure: ["4M", "3T"],
			extrasensory: ["5L45", "4L37"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5E", "4E", "3E"],
			feintattack: ["5E", "4E", "3E"],
			flash: ["3M"],
			fly: ["5M", "4M", "3M"],
			foresight: ["5L1", "5D", "4L1", "3L6", "3S0"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L5", "4L5", "3L16"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mirrormove: ["5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5E", "5D", "4E"],
			ominouswind: ["4T"],
			peck: ["5L9", "4L9", "3L11"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychoshift: ["5L49", "4L41"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["5D", "4M"],
			reflect: ["5M", "5L17", "4M", "4L17", "3M", "3L22"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L53", "4M", "4L45"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["5E", "4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5E", "4E", "3E"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["5L41"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			tailwind: ["4T"],
			takedown: ["5L29", "4L25", "3L28"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5L13", "4T", "4L13"],
			whirlwind: ["5E", "4E", "3E"],
			wingattack: ["5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["5L37", "4T", "4L33"],
		},
	},
	noctowl: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["5L37", "4L32"],
			attract: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confusion: ["5L22", "4L22", "3L41"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "5L67", "4M", "4L57", "3T", "3L57"],
			echoedvoice: ["5M", "5L27"],
			endure: ["4M", "3T"],
			extrasensory: ["5L52", "4L42"],
			facade: ["5M", "4M", "3M"],
			flash: ["3M"],
			fly: ["5M", "4M", "3M"],
			foresight: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L1", "4L1", "3L16"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			peck: ["5L9", "4L9", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychoshift: ["5L57", "4L47"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "5L17", "4M", "4L17", "3M", "3L25"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L62", "4M", "4L52"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			silverwind: ["4M"],
			skyattack: ["5L1", "4T", "4L1", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["5L47"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			takedown: ["5L32", "4L27", "3L33"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["5L13", "4T", "4L13"],
			workup: ["5M"],
			zenheadbutt: ["5L42", "4T", "4L37"],
		},
	},
	ledyba: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M", "3S0"],
			agility: ["5L30", "4L30", "3L43"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L22", "4L22", "3L29"],
			bide: ["5E", "4E", "3E"],
			brickbreak: ["5M", "4M", "3M"],
			bugbite: ["5E", "5D", "4T", "4E"],
			bugbuzz: ["5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			cometpunch: ["5L9", "5D", "4L9", "3L15"],
			dig: ["5M", "4M", "3M"],
			dizzypunch: ["5E"],
			doubleedge: ["5L38", "4L38", "3T", "3L50"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["5E", "4M"],
			dynamicpunch: ["3T"],
			encore: ["5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			knockoff: ["5E", "4T", "4E"],
			lightscreen: ["5M", "5L14", "4M", "4L14", "3M", "3L22"],
			machpunch: ["5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E", "3S0"],
			reflect: ["5M", "5L14", "4M", "4L14", "3M", "3L22"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L14", "4M", "4L14", "3M", "3L22"],
			screech: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			silverwind: ["5L25", "5E", "4M", "4L25", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L6", "4L6", "3L8", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L33", "4T", "4L33", "3T", "3L36"],
			swordsdance: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5D", "4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
		},
	},
	ledian: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L36", "4L36", "3L51"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L24", "4L24", "3L33"],
			brickbreak: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L53", "4L53"],
			captivate: ["4M"],
			cometpunch: ["5L1", "4L1", "3L15"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L48", "4L48", "3T", "3L60"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			knockoff: ["4T"],
			lightscreen: ["5M", "5L14", "4M", "4L14", "3M", "3L24"],
			machpunch: ["5L17", "4L17"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			reflect: ["5M", "5L14", "4M", "4L14", "3M", "3L24"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L14", "4M", "4L14", "3M", "3L24"],
			secretpower: ["4M", "3M"],
			silverwind: ["5L29", "4M", "4L29"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L1", "4L1", "3L1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L41", "4T", "4L41", "3T", "3L42"],
			swordsdance: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
		},
	},
	spinarak: {
		inherit: true,
		learnset: {
			agility: ["5L33", "4L33", "3L45"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bugbite: ["5D", "4T"],
			captivate: ["4M"],
			constrict: ["5L8", "4L8", "3L11"],
			crosspoison: ["5L47"],
			dig: ["5M", "4M", "3M", "3S0"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			electroweb: ["5E", "5D"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L22", "4L22", "3L30"],
			gigadrain: ["4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			leechlife: ["5L12", "4L12", "3L23"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["5L15", "4L15", "3L17", "3S0"],
			nightslash: ["5E"],
			pinmissile: ["5L36", "4L36"],
			poisonjab: ["5M", "5L43", "4M", "4L43", "4E"],
			poisonsting: ["5L1", "5D", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E"],
			psychic: ["5M", "5L40", "4M", "4L40", "3M", "3L53"],
			pursuit: ["5E", "4E", "3E"],
			ragepowder: ["5E"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L5", "4L5", "3L6"],
			secretpower: ["4M", "3M"],
			shadowsneak: ["5L19", "4L19"],
			signalbeam: ["5E", "4T", "4E", "3E", "3S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			sonicboom: ["5E", "4E", "3E"],
			spiderweb: ["5L29", "4L29", "3L37"],
			stringshot: ["5L1", "4T", "4L1", "3L1"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L26", "4T", "4L26"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5E", "4E"],
			twineedle: ["5E"],
			venoshock: ["5M"],
		},
	},
	ariados: {
		inherit: true,
		learnset: {
			agility: ["5L37", "4L37", "3L53"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bugbite: ["5L1", "4T", "4L1"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1", "3L1"],
			crosspoison: ["5L55"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L23", "4L23", "3L34"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L12", "4L12", "3L25"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightshade: ["5L15", "4L15", "3L17"],
			pinmissile: ["5L41", "4L41"],
			poisonjab: ["5M", "5L50", "4M", "4L50"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L46", "4M", "4L46", "3M", "3L63"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowsneak: ["5L19", "4L19"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			spiderweb: ["5L32", "4L32", "3L43"],
			stringshot: ["5L1", "4T", "4L1", "3L1"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L28", "4T", "4L28"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
		},
	},
	chinchou: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			amnesia: ["5E", "5D", "4E", "3E"],
			aquaring: ["5L42", "4L39"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5E", "4M"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L31", "4L28"],
			captivate: ["4M"],
			charge: ["5L50", "4L45", "3L49"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L12", "4L17", "3L29"],
			discharge: ["5L39", "4L34"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L28"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L9", "5E", "4L9", "4E", "3L13", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L45", "4L42", "3L41"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T"],
			mimic: ["3T"],
			mist: ["5E", "4E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			shockwave: ["5E", "5D", "4M", "3M"],
			signalbeam: ["5L34", "4T", "4L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L20", "4L20", "3L25"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["5L1", "4L1", "3L5"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5L23", "4L23", "3L37"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "5L6", "5D", "4M", "4L6", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L17", "4L12", "3L17"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["5E", "4M", "4E"],
			wildcharge: ["5M"],
		},
	},
	lanturn: {
		inherit: true,
		learnset: {
			aquaring: ["5L52", "4L47"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L35", "4L30"],
			captivate: ["4M"],
			charge: ["5L64", "4L57", "3L61"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L17", "4L17", "3L32"],
			discharge: ["5L47", "4L40"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5L30"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L9", "4L9", "3L13"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L57", "4L52", "3L50"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L40", "4T", "4L35"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L20", "4L20", "3L25"],
			spitup: ["5L27", "4L27"],
			stockpile: ["5L27", "4L27"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			supersonic: ["5L1", "4L1", "3L1"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L27", "4L27"],
			takedown: ["5L23", "4L23", "3L43"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L12", "4L12", "3L17"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wildcharge: ["5M"],
		},
	},
	togepi: {
		inherit: true,
		learnset: {
			afteryou: ["5L53"],
			ancientpower: ["5L33", "4T", "4L33", "3L21", "3S1"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L41", "4L42", "3L41"],
			bestow: ["5L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["5L1", "4L1", "3L1", "3S0"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["5L45", "4L46", "3T", "3L37"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			encore: ["5L17", "4L19", "3L17"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			extrasensory: ["5E", "4E"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			followme: ["5L21", "4L24", "3L25", "3S1"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			lastresort: ["5L49", "4T", "4L51"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E", "4E"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5L5", "4L6", "3T", "3L4", "3S0"],
			mimic: ["3T"],
			mirrormove: ["5E", "4E", "3E"],
			morningsun: ["5E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			peck: ["5E", "4E", "3E"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychoshift: ["5E", "4E"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			storedpower: ["5E"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L9", "4L10", "3L9", "3S0"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			triattack: ["3S1"],
			trick: ["4T"],
			uproar: ["5D", "4T"],
			waterpulse: ["4M", "3M"],
			wish: ["5L29", "4L28", "3L29"],
			workup: ["5M"],
			yawn: ["5L13", "4L15", "3L13", "3S0"],
			zenheadbutt: ["4T"],
		},
	},
	togetic: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			afteryou: ["5L53"],
			aircutter: ["4T"],
			ancientpower: ["5L33", "4T", "4L33", "3L21"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L41", "4L42", "3L41"],
			bestow: ["5L25"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			charm: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["5L45", "4L46", "3T", "3L37"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			encore: ["5L17", "4L19", "3L17"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			focuspunch: ["4M", "3M"],
			followme: ["5L21", "4L24", "3L25"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			lastresort: ["5L49", "4T", "4L51"],
			lightscreen: ["5M", "4M", "3M"],
			magicalleaf: ["5L1", "4L1", "3L1"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5L1", "4L1", "3T", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L37", "4M", "4L37", "3M", "3L33"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			softboiled: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterpulse: ["4M", "3M"],
			wish: ["5L29", "4L28", "3L29"],
			workup: ["5M"],
			yawn: ["5L13", "4L15", "3L13"],
			zenheadbutt: ["4T"],
		},
	},
	togekiss: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			airslash: ["5L1", "5S0", "4L1"],
			ancientpower: ["4T"],
			attract: ["5M", "4M"],
			aurasphere: ["5L1", "5S0", "4L1"],
			brickbreak: ["5M", "4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M"],
			extremespeed: ["5L1", "5S0", "4L1"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			present: ["5S0"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rollout: ["4T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skyattack: ["5L1", "4T", "4L1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			steelwing: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			twister: ["4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	natu: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M", "3S0"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L23", "4L23", "3L40"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			drillpeck: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5E", "5D", "4E", "3E"],
			feintattack: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L36", "4L36", "3L30", "3S0"],
			gigadrain: ["5D", "4M", "3M"],
			grassknot: ["5M", "4M"],
			guardswap: ["5L47", "4L44"],
			haze: ["5E", "4E", "3E"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L12", "4L12"],
			magiccoat: ["4T"],
			mefirst: ["5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L6", "5D", "4L6", "3L10", "3S0"],
			ominouswind: ["5L44", "4T", "4L39"],
			painsplit: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["5L47", "4L44"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L50", "4M", "4L47", "3M", "3L50"],
			psychoshift: ["5L33", "4L33"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			quickattack: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5E", "4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["5E", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["5E", "4M", "4E", "3M", "3E"],
			storedpower: ["5L39"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E", "4T", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["5E"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			teleport: ["5L9", "4L9", "3L20"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			wish: ["5L28", "4L28", "3L30"],
			zenheadbutt: ["5E", "4T", "4E"],
		},
	},
	xatu: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L23", "4L23", "3L50"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L42", "4L42", "3L35"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			guardswap: ["5L59", "4L54"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L12", "4L12"],
			magiccoat: ["4T"],
			mefirst: ["5L20", "4L20"],
			mimic: ["3T"],
			miracleeye: ["5L17", "4L17"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L6", "4L6", "3L10"],
			ominouswind: ["5L54", "4T", "4L47"],
			painsplit: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			powerswap: ["5L54", "4L54"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L66", "4M", "4L59", "3M", "3L65"],
			psychoshift: ["5L37", "4L37"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["4M", "3M"],
			storedpower: ["5L47"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5L27", "4T", "4L27"],
			telekinesis: ["5M"],
			teleport: ["5L9", "4L9", "3L20"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			wish: ["5L30", "4L30", "3L35"],
			zenheadbutt: ["4T"],
		},
	},
	mareep: {
		inherit: true,
		learnset: {
			afteryou: ["5E"],
			agility: ["5E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E", "3S2"],
			captivate: ["4M"],
			charge: ["5L23", "5E", "4L23", "4E", "3E"],
			chargebeam: ["5M", "4M"],
			cottonguard: ["5L32"],
			cottonspore: ["5L19", "4L19", "3L23", "3S0"],
			defensecurl: ["3T"],
			discharge: ["5L37", "4L28"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			electroball: ["5L28"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flatter: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L5", "4L5", "3L1", "3S1"],
			headbutt: ["4T"],
			healbell: ["4T", "3S2"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["5E", "4M", "3M"],
			lightscreen: ["5M", "5L46", "4M", "4L37", "3M", "3L30"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5E", "4E", "3E"],
			powergem: ["5L50", "4L41"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5D", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			sandattack: ["5E", "4E"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			shockwave: ["5D", "4M", "3M"],
			signalbeam: ["5L41", "4T", "4L32"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S1"],
			takedown: ["5E", "4E", "3E"],
			thunder: ["5M", "5L55", "4M", "4L46", "3M", "3L37", "3S0"],
			thunderbolt: ["5M", "4M", "3M"],
			thundershock: ["5L10", "5D", "4L10", "3L9", "3S0", "3S1", "3S2"],
			thunderwave: ["5M", "5L14", "4M", "4L14", "3T", "3L16", "3S0", "3S2"],
			toxic: ["5M", "4M", "3M"],
			wildcharge: ["5M"],
		},
	},
	flaaffy: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			charge: ["5L25", "4L25"],
			chargebeam: ["5M", "4M"],
			cottonguard: ["5L36"],
			cottonspore: ["5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["5L42", "4L31"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			electroball: ["5L31"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "5L53", "4M", "4L42", "3M", "3L36"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powergem: ["5L59", "4L47"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L47", "4T", "4L36"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "5L65", "4M", "4L53", "3M", "3L45"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thundershock: ["5L1", "4L1", "3L1"],
			thunderwave: ["5M", "5L14", "4M", "4L14", "3T", "3L18"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	ampharos: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charge: ["5L25", "4L25"],
			chargebeam: ["5M", "4M"],
			cottonguard: ["5L40"],
			cottonspore: ["5L20", "4L20", "3L27"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["5L48", "4L34"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			electroball: ["5L33"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["5L1", "4T", "4L1", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "5L63", "4M", "4L51", "3M", "3L42"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powergem: ["5L71", "4L59"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L55", "4T", "4L42"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "5L79", "4M", "4L68", "3M", "3L57"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["5L30", "4T", "4L30", "3T", "3L30"],
			thundershock: ["5L1", "4L1", "3L1"],
			thunderwave: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	azurill: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T"],
			bubble: ["5L10", "4L10", "3L10"],
			captivate: ["4M"],
			charm: ["5L2", "4L2", "3L3"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			encore: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["5M"],
			mimic: ["3T"],
			muddywater: ["5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sing: ["5E", "4E", "3E"],
			slam: ["5L15", "5E", "4L15", "4E", "3L15", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			soak: ["5E"],
			splash: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwhip: ["5L7", "4L7", "3L6"],
			tickle: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L18", "4L18", "3L21"],
			waterpulse: ["4M", "3M"],
			watersport: ["5E"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	marill: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			aquajet: ["5E", "5D", "4E"],
			aquaring: ["5L23", "4L23"],
			aquatail: ["5L37", "4T", "4L37"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T"],
			brickbreak: ["5M", "4M", "3M"],
			bubblebeam: ["5L18", "4L18", "3L21"],
			captivate: ["4M"],
			defensecurl: ["5L2", "5D", "4L2", "3T", "3L3"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["5L27", "4L27", "3T", "3L28"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L42", "4L42", "3L45"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5D", "4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			muddywater: ["5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			perishsong: ["5E", "4E", "3E"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L32", "4M", "4L32", "3M", "3L36"],
			refresh: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L15"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			superpower: ["5E", "4T", "4E"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L7", "4L7", "3L6"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L10"],
			waterpulse: ["4M", "3M"],
			watersport: ["5E"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	azumarill: {
		inherit: true,
		learnset: {
			aquaring: ["5L27", "4L27"],
			aquatail: ["5L47", "4T", "4L47"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bubblebeam: ["5L20", "4L20", "3L24"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["5L33", "4L33", "3T", "3L34"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L54", "4L54", "3L57"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lightscreen: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L40", "4M", "4L40", "3M", "3L45"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L15"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	bonsly: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			block: ["5L22", "4T", "4L22"],
			brickbreak: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			copycat: ["5L1", "4L1"],
			curse: ["5E"],
			defensecurl: ["5E", "4E"],
			dig: ["5M", "4M"],
			doubleedge: ["5L46", "4L46"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			endure: ["5E", "4M"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M"],
			faketears: ["5L1", "4L1"],
			feintattack: ["5L25", "4L25"],
			flail: ["5L6", "4L6"],
			frustration: ["5M", "4M"],
			harden: ["5E", "4E"],
			headbutt: ["5E", "4T", "4E"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			lowkick: ["5L9", "4T", "4L9"],
			mimic: ["5L17", "4L17"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L33", "4M", "4L33"],
			rockthrow: ["5L14", "4L14"],
			rocktomb: ["5M", "5L30", "4M", "4L30"],
			roleplay: ["4T"],
			rollout: ["5E", "4T", "4E"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			sandtomb: ["5E", "4E"],
			secretpower: ["4M"],
			selfdestruct: ["5E", "4E"],
			slam: ["5L38", "4L38"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			stealthrock: ["5E", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5L41", "4T", "4L41"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
		},
	},
	sudowoodo: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			block: ["5L22", "4T", "4L22", "3L33"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			copycat: ["5L1", "4L1"],
			counter: ["3T"],
			curse: ["5E"],
			defensecurl: ["5E", "4E", "3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L46", "4L46", "3T", "3L57"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L25", "4L25", "3L41"],
			firepunch: ["4T", "3T"],
			flail: ["5L1", "5D", "4L1", "3L9"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hammerarm: ["5L49", "4L49"],
			harden: ["5E", "4E"],
			headbutt: ["5E", "4T", "4E"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			lowkick: ["5L1", "4T", "4L1", "3L17"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["5L17", "4L17", "3T", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L33", "4M", "4L33", "3T", "3L25"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L1", "4L1", "3L1"],
			rocktomb: ["5M", "5L30", "4M", "4L30", "3M"],
			roleplay: ["5D", "4T"],
			rollout: ["5E", "5D", "4T", "4E", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			sandtomb: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["5E", "4E", "3T", "3E"],
			slam: ["5L38", "4L38", "3L49"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["5E", "4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L41", "4T", "4L41"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M", "3M"],
			woodhammer: ["5L1", "4L1"],
		},
	},
	hoppip: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L28"],
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5E", "4E", "3E"],
			aromatherapy: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bounce: ["5L46", "5D", "4T", "4L40"],
			bulletseed: ["5L19", "5D", "4M", "4L19", "3M"],
			captivate: ["4M"],
			confusion: ["5E", "4E", "3E"],
			cottonguard: ["5E"],
			cottonspore: ["5L34", "4L28", "3L25"],
			defensecurl: ["3T"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			encore: ["5E", "5D", "4E", "3E"],
			endure: ["5E", "4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L43", "4M", "4L37", "3M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			leechseed: ["5L22", "4L22", "3L20"],
			megadrain: ["5L25", "4L25", "3L30"],
			memento: ["5L49", "4L43"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["5L12", "4L12", "3L13"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4E", "3E"],
			ragepowder: ["5L31"],
			reflect: ["5M", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5E", "4T"],
			silverwind: ["4M"],
			sleeppowder: ["5L16", "4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			splash: ["5L1", "4L1", "3L1"],
			stunspore: ["5L14", "4L14", "3L15"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L4", "5D", "4T", "4L4", "3L5"],
			tackle: ["5L10", "4L10", "3L10"],
			tailwhip: ["5L7", "4L7", "3L5"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "5L37", "4M", "4L31"],
			worryseed: ["5L40", "5E", "4T", "4L34", "4E"],
		},
	},
	skiploom: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L32"],
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bounce: ["5L56", "4T", "4L48"],
			bulletseed: ["5L20", "4M", "4L20", "3M"],
			captivate: ["4M"],
			cottonspore: ["5L40", "4L32", "3L29"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L52", "4M", "4L44", "3M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			leechseed: ["5L24", "4L24", "3L22"],
			megadrain: ["5L28", "4L28", "3L36"],
			memento: ["5L60", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["5L12", "4L12", "3L13"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M"],
			ragepowder: ["5L36"],
			reflect: ["5M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			silverwind: ["4M"],
			sleeppowder: ["5L16", "4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			splash: ["5L1", "4L1", "3L1"],
			stunspore: ["5L14", "4L14", "3L15"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L1", "4T", "4L1", "3L1"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "5L44", "4M", "4L36"],
			worryseed: ["5L48", "4T", "4L40"],
		},
	},
	jumpluff: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L34"],
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bounce: ["5L64", "4T", "4L48"],
			bulletseed: ["5L20", "5S0", "4M", "4L20", "3M"],
			captivate: ["4M"],
			cottonspore: ["5L44", "4L32", "3L33"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L59", "4M", "4L44", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechseed: ["5L24", "5S0", "4L24", "3L22"],
			megadrain: ["5L29", "4L28", "3L44"],
			memento: ["5L69", "4L52"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			poisonpowder: ["5L12", "4L12", "3L13"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M"],
			ragepowder: ["5L39"],
			reflect: ["5M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			silverwind: ["4M"],
			sleeppowder: ["5L16", "5S0", "4L16", "3L17"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			splash: ["5L1", "4L1", "3L1"],
			stunspore: ["5L14", "4L14", "3L15"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L1", "4T", "4L1", "3L1"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "5L49", "4M", "4L36"],
			worryseed: ["5L54", "4T", "4L40"],
		},
	},
	aipom: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L29", "5E", "4L29", "4E", "3L50", "3E"],
			astonish: ["5L8", "4L8", "3L13"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L11", "4L11", "3L18"],
			beatup: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["5E", "4T", "4E"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			covet: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["5L32", "4L32"],
			doubleslap: ["5E", "4E", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E"],
			firepunch: ["5D", "4T", "3T"],
			fling: ["5M", "5L36", "4M", "4L36"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L18", "4L18", "3L31"],
			grassknot: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icepunch: ["4T", "3T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["5L43", "4T", "4L43"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L39", "4L39"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L4", "4L4", "3L6", "3S0"],
			scratch: ["5L1", "4L1", "3L1", "3S0"],
			screech: ["5L25", "5E", "4L25", "4E", "3L43", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["5E", "4T", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L22", "4T", "4L22", "3T", "3L38"],
			switcheroo: ["5E"],
			tailwhip: ["5L1", "4L1", "3L1", "3S0"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			tickle: ["5L15", "4L15", "3L25"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	ambipom: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M"],
			agility: ["5L29", "4L29"],
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			batonpass: ["5L11", "4L11"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doublehit: ["5L32", "4L32"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firepunch: ["4T"],
			fling: ["5M", "5L36", "4M", "4L36"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L18", "4L18"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["5L43", "4T", "4L43"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			mudslap: ["4T"],
			nastyplot: ["5L39", "4L39"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			scratch: ["5L1", "4L1"],
			screech: ["5L25", "4L25"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			spite: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L22", "4T", "4L22"],
			tailwhip: ["5L1", "4L1"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			tickle: ["5L15", "4L15"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	sunkern: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1", "3S0"],
			attract: ["5M", "4M", "3M"],
			bide: ["5E"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5D", "4T"],
			encore: ["5E", "4E", "3E"],
			endeavor: ["5L21", "4T", "4L21", "3L25"],
			endure: ["5E", "4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L41", "4M", "4L41", "3M", "3L42"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L13", "5E", "4L13", "4E", "3E"],
			growth: ["5L1", "4L1", "3L6", "3S0"],
			helpinghand: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5L9", "5E", "4L9", "4E", "3L18"],
			leechseed: ["5L17", "5E", "4L17", "4E", "3E"],
			lightscreen: ["5M", "4M", "3M"],
			megadrain: ["5L5", "5D", "4L5", "3L13"],
			mimic: ["3T"],
			morningsun: ["5E"],
			naturalgift: ["5E", "4M"],
			naturepower: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L29", "4L29"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5L45", "4T", "4L45"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5E", "4E"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L33", "4T", "4L33", "3L37"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			worryseed: ["5L25", "4T", "4L25"],
		},
	},
	sunflora: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bulletseed: ["5L21", "4M", "4L21", "3M", "3L25"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L13", "4L13"],
			growth: ["5L1", "4L1", "3L6"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			ingrain: ["5L9", "4L9", "3L18"],
			leafstorm: ["5L45", "4L43"],
			leechseed: ["5L17", "4L17"],
			lightscreen: ["5M", "4M", "3M"],
			megadrain: ["5L5", "4L5"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			petaldance: ["5L33", "4L33", "3L37"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L29", "4L29", "3L13"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L41", "4M", "4L41", "3M", "3L42"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L37", "4M", "4L37", "3M", "3L30"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			worryseed: ["5L25", "4T", "4L25"],
		},
	},
	yanma: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["5L54", "4L54"],
			ancientpower: ["5L33", "4T", "4L33"],
			attract: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L57", "4L57"],
			captivate: ["4M"],
			defog: ["4M"],
			detect: ["5L17", "4L17", "3L25"],
			doubleedge: ["5E", "3T"],
			doubleteam: ["5M", "5L11", "4M", "4L11", "3M", "3L12"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5E", "5D", "4E"],
			feintattack: ["5E", "4E"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5D", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L38", "4L38", "3L23"],
			leechlife: ["5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			pursuit: ["5L30", "5E", "4L30", "4E"],
			quickattack: ["5L6", "5D", "4L6", "3L6"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			roost: ["4M"],
			round: ["5M"],
			screech: ["5L46", "4L46", "3L49"],
			secretpower: ["5E", "4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["5E", "4T", "4E", "3E"],
			silverwind: ["5E", "4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			sonicboom: ["5L14", "4L14", "3L17"],
			steelwing: ["4M", "3M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L22", "4L22", "3L31"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L27", "4T", "4L27", "3L34"],
			uturn: ["5M", "5L49", "4M", "4L49"],
			whirlwind: ["5E", "4E", "3E"],
			wingattack: ["5L43", "4L43", "3L39"],
		},
	},
	yanmega: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			airslash: ["5L54", "4L49"],
			ancientpower: ["5L33", "4T", "4L33"],
			attract: ["5M", "4M"],
			bugbite: ["5L1", "4T", "4L1"],
			bugbuzz: ["5L57", "4L54"],
			captivate: ["4M"],
			defog: ["4M"],
			detect: ["5L17", "4L17"],
			doubleteam: ["5M", "5L1", "4M", "4L1"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feint: ["5L38", "4L38"],
			flash: ["5M", "4M"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L1", "4L1"],
			ominouswind: ["4T"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			pursuit: ["5L30", "4L30"],
			quickattack: ["5L1", "4L1"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			screech: ["5L46", "4L43"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			slash: ["5L43", "4L38"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			sonicboom: ["5L14", "4L14"],
			steelwing: ["4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			supersonic: ["5L22", "4L22"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["5L27", "4T", "4L27"],
			uturn: ["5M", "5L49", "4M", "4L46"],
		},
	},
	wooper: {
		inherit: true,
		learnset: {
			acidspray: ["5E"],
			afteryou: ["5E"],
			amnesia: ["5L23", "4L23", "3L21"],
			ancientpower: ["5E", "4T", "4E", "3E"],
			aquatail: ["5D", "4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L33", "4M", "4L33", "3M", "3L36"],
			encore: ["5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5L43", "4L43", "3L51"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["5L43", "4L43", "3L51"],
			mudbomb: ["5L19", "4L19"],
			muddywater: ["5L47", "4L47"],
			mudshot: ["5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L5", "5E", "4L5", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L37", "4M", "4L37", "3M", "3L41"],
			recover: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4E", "3E"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			slam: ["5L15", "4L15", "3L11"],
			sleeptalk: ["5E", "4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E", "3E"],
			stockpile: ["5E", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E", "3E"],
			tailwhip: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "5D", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["5L29", "4L29", "3L31"],
		},
	},
	quagsire: {
		inherit: true,
		learnset: {
			amnesia: ["5L24", "4L24", "3L23"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L36", "4M", "4L36", "3M", "3L42"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5L48", "4L48", "3L61"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			irontail: ["4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mist: ["5L48", "4L48", "3L61"],
			mudbomb: ["5L19", "4L19"],
			muddywater: ["5L53", "4L53"],
			mudshot: ["5L9", "4L9", "3L16"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L41", "4M", "4L41", "3M", "3L49"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slam: ["5L15", "4L15", "3L11"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tailwhip: ["5L1", "4L1", "3L1"],
			thief: ["5M"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			yawn: ["5L31", "4L31", "3L35"],
		},
	},
	murkrow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			assurance: ["5L25", "5E", "4L25"],
			astonish: ["5L1", "4L1", "3L9", "3S0"],
			attract: ["5M", "4M", "3M"],
			bravebird: ["5E", "4E"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5E", "5D", "4E", "3E"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			drillpeck: ["5E", "4E", "3E"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5E", "4E", "3E"],
			feintattack: ["5L35", "5E", "4L35", "4E", "3L35"],
			fly: ["5M", "4M", "3M"],
			foulplay: ["5L45"],
			frustration: ["5M", "4M", "3M"],
			haze: ["5L11", "4L11", "3L22"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			meanlook: ["5L41", "4L41", "3L48"],
			mimic: ["3T"],
			mirrormove: ["5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L21", "4L21", "3L27"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			peck: ["5L1", "5D", "4L1", "3L1", "3S0"],
			perishsong: ["5E", "4E", "3E"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M"],
			psychoshift: ["5E", "4E"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5L5", "4L5", "3L14"],
			quash: ["5M", "5L65"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roost: ["5E", "5D", "4M"],
			round: ["5M"],
			screech: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			skyattack: ["5E", "4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["3T"],
			spite: ["4T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L55", "4T", "4L45"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5L51", "4T"],
			taunt: ["5M", "5L31", "4M", "4L31", "3M", "3L40"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "5L61", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			whirlwind: ["5E", "4E", "3E"],
			wingattack: ["5L15", "5E", "4L15", "4E", "3E"],
		},
	},
	honchkrow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			darkpulse: ["5L75", "4M", "4L55"],
			defog: ["4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fly: ["5M", "4M"],
			foulplay: ["5L45"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			haze: ["5L1", "4L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			mudslap: ["4T"],
			nastyplot: ["5L35", "4L35"],
			naturalgift: ["4M"],
			nightslash: ["5L55", "4L45"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			pursuit: ["5L1", "4L1"],
			quash: ["5M", "5L65"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			skyattack: ["4T"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			spite: ["4T"],
			steelwing: ["4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "5L25", "4M", "4L25"],
			swift: ["4T"],
			tailwind: ["4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uproar: ["4T"],
			wingattack: ["5L1", "4L1"],
		},
	},
	misdreavus: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			astonish: ["5L10", "4L10", "3L11"],
			attract: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L14", "4L14", "3L17"],
			curse: ["5E", "4E"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			destinybond: ["5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1", "3S0"],
			grudge: ["5L50", "4L46", "3L53"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hex: ["5L23"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T"],
			imprison: ["5E", "4E", "3E"],
			inferno: ["5D"],
			magiccoat: ["4T"],
			meanlook: ["5L19", "4L19", "3L23"],
			memento: ["5E", "4E"],
			mimic: ["3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["5E", "4T", "4E"],
			painsplit: ["5L32", "4T", "4L28", "3L37"],
			payback: ["5M", "5L37", "4M", "4L32"],
			perishsong: ["5L46", "4L41", "3L45"],
			powergem: ["5L55", "4L50"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L28", "4L23", "3L30"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psywave: ["5L1", "5D", "4L1", "3L1", "3S0"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "5L41", "4M", "4L37", "3M"],
			shadowsneak: ["5E", "4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5L5", "5E", "4T", "4L5", "4E", "3L6", "3S0"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E", "4T", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M"],
			wonderroom: ["5E"],
		},
	},
	mismagius: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			darkpulse: ["4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			echoedvoice: ["5M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icywind: ["4T"],
			luckychant: ["5L1", "4L1"],
			magicalleaf: ["5L1", "4L1"],
			magiccoat: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psywave: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["5L1", "4T", "4L1"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	unown: {
		inherit: true,
		learnset: {
			hiddenpower: ["5L1", "4L1", "3L1"],
		},
	},
	wynaut: {
		inherit: true,
		learnset: {
			charm: ["5L1", "4L1", "3L1", "3S0"],
			counter: ["5L15", "4L15", "3L15"],
			destinybond: ["5L15", "4L15", "3L15"],
			encore: ["5L1", "4L1", "3L1", "3S0"],
			mirrorcoat: ["5L15", "4L15", "3L15"],
			safeguard: ["5L15", "4L15", "3L15"],
			splash: ["5L1", "4L1", "3L1", "3S0"],
			tickle: ["3S0"],
		},
	},
	wobbuffet: {
		inherit: true,
		learnset: {
			charm: ["5D"],
			counter: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			destinybond: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			encore: ["5D"],
			mirrorcoat: ["5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			safeguard: ["5L1", "4L1", "3L1", "3S0", "3S1"],
		},
	},
	girafarig: {
		inherit: true,
		learnset: {
			agility: ["5L14", "4L14", "3L31"],
			amnesia: ["5E", "4E", "3E"],
			assurance: ["5L28", "4L28"],
			astonish: ["5L1", "4L1", "3L7"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L23", "4L23", "3L37"],
			beatup: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "5D", "4L1", "3L13"],
			crunch: ["5L46", "4L46", "3L49"],
			doubleedge: ["3T"],
			doublehit: ["5L32", "4L32"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			growl: ["5L1", "4L1", "3L1"],
			guardswap: ["5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["5E", "4T", "4E", "3E"],
			meanlook: ["5E"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["5L5", "4L5", "3L25"],
			powerswap: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L19", "4L19", "3L43"],
			psychic: ["5M", "5L37", "4M", "4L37", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5E", "4E"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["5E", "4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["5L10", "4L10", "3L19"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5E", "4E", "3E"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["5L41", "4T", "4L41"],
		},
	},
	pineco: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bide: ["5L20", "4L17", "3L29"],
			bodyslam: ["3T"],
			bugbite: ["5L9", "4T", "4L9"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E", "3S1"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L45", "5E", "4L42", "4E", "3T", "3L50"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			explosion: ["5M", "5L34", "4M", "4L31", "3T", "3L36"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gravity: ["5D", "4T"],
			gyroball: ["5M", "5L42", "4M", "4L39"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irondefense: ["5L39", "4T", "4L34"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["5L23", "4M", "4L20"],
			painsplit: ["4T"],
			payback: ["5M", "5L31", "4M", "4L28"],
			pinmissile: ["5E", "4E", "3E", "3S1"],
			powertrick: ["5E", "4E"],
			protect: ["5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			rapidspin: ["5L17", "4L12", "3L22"],
			reflect: ["5M", "4M", "4E", "3M", "3E"],
			refresh: ["3S1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E", "4E"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			sandtomb: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L6", "4L6", "3T", "3L8", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5L28", "4L23", "3L43", "3S1"],
			stealthrock: ["5E", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5E", "4E", "3E"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			takedown: ["5L12", "4L9", "3L15"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5E", "4E"],
			venoshock: ["5M"],
		},
	},
	forretress: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L32"],
			bide: ["5L20", "4L17", "3L29"],
			block: ["4T"],
			bodyslam: ["3T"],
			bugbite: ["5L1", "4T", "4L1"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L56", "4L50", "3T", "3L59"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L42", "4M", "4L33", "3T", "3L39"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L50", "4M", "4L45"],
			headbutt: ["4T"],
			heavyslam: ["5L70"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["5L46", "4T", "4L38"],
			lightscreen: ["5M", "4M", "3M"],
			magnetrise: ["5L60", "4T", "4L57"],
			mimic: ["3T"],
			mirrorshot: ["5L31", "4L31"],
			naturalgift: ["5L23", "4M", "4L20"],
			painsplit: ["4T"],
			payback: ["5M", "5L36", "4M", "4L28"],
			protect: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			rapidspin: ["5L17", "4L12", "3L22"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L1", "4L1", "3T", "3L1"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5L28", "4L23", "3L49"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L12", "4L1", "3L15"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L1", "4L1"],
			venoshock: ["5M"],
			voltswitch: ["5M"],
			zapcannon: ["5L64", "4L62", "3L31"],
		},
	},
	dunsparce: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			ancientpower: ["5L48", "5E", "4T", "4L41", "4E", "3E"],
			aquatail: ["4T"],
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bide: ["5E", "4E", "3E"],
			bite: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			coil: ["5L43"],
			counter: ["3T"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["5L4", "4L5", "3T", "3L4"],
			dig: ["5M", "5L53", "4M", "4L45", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["5L58", "4T", "4L49", "3L41"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flail: ["5L63", "4L53", "3L44"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			glare: ["5L12", "4L13", "3L14"],
			gyroball: ["5M", "4M"],
			headbutt: ["5E", "4T", "4E", "3E"],
			hex: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			magiccoat: ["5E", "4T", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5L24", "4L25", "3L24"],
			rage: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L16", "4T", "4L17", "3T", "3L21"],
			roost: ["5L33", "4M", "4L33"],
			round: ["5M"],
			screech: ["5L28", "4L29", "3L31"],
			secretpower: ["5E", "4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5E", "4M", "3T"],
			snore: ["5E", "4T", "4E", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["5L20", "4T", "4L21", "3L21"],
			stealthrock: ["5D", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5L38", "4L37", "3L34"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5E", "4E"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			yawn: ["5L8", "4L9", "3L11"],
			zenheadbutt: ["4T"],
		},
	},
	gligar: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L27"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5E", "4E"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			crosspoison: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			feint: ["5E", "5D", "4E"],
			feintattack: ["5L23", "4L23", "3L28"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L20", "4T", "4L20", "3T"],
			guillotine: ["5L49", "4L45", "3L52"],
			harden: ["5L9", "4L9", "3L13"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["5L12", "4T", "4L12"],
			metalclaw: ["5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1", "3S0"],
			poisontail: ["5E"],
			powertrick: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L16", "4L16", "3L20"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["5E"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			sandattack: ["5L5", "5D", "4L5", "3L6", "3S0"],
			sandstorm: ["5M", "4M", "3M"],
			sandtomb: ["5E", "4E", "3E"],
			screech: ["5L31", "4L27", "3L44"],
			secretpower: ["4M", "3M"],
			slash: ["5L34", "4L31", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			steelwing: ["4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L38", "4M", "4L34", "3T"],
			tailwind: ["5D", "4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "5L42", "4M", "4L38"],
			venoshock: ["5M"],
			wingattack: ["5E", "4E", "3E"],
			xscissor: ["5M", "5L45", "4M", "4L42"],
		},
	},
	gliscor: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L27"],
			aerialace: ["5M", "4M"],
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "4M"],
			feintattack: ["5L23", "4L23"],
			firefang: ["5L1", "4L1"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["5L20", "4T", "4L20"],
			gigaimpact: ["5M", "4M"],
			guillotine: ["5L49", "4L45"],
			harden: ["5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			icefang: ["5L1", "4L1"],
			irontail: ["4M"],
			knockoff: ["5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L34", "4L31"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M"],
			quickattack: ["5L16", "4L16"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			sandstorm: ["5M", "4M"],
			screech: ["5L31", "4L27"],
			secretpower: ["4M"],
			skyattack: ["4T"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "5L38", "4M", "4L34"],
			tailwind: ["4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunderfang: ["5L1", "4L1"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uturn: ["5M", "5L42", "4M", "4L38"],
			venoshock: ["5M"],
			xscissor: ["5M", "5L45", "4M", "4L42"],
		},
	},
	snubbull: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5L1", "5D", "4L1", "3L8", "3S0"],
			closecombat: ["5E", "5D", "4E"],
			counter: ["3T"],
			crunch: ["5L49", "5E", "4L49", "4E", "3L53", "3E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "5D", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L1", "5E", "4L1", "4E"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["5L19", "4T", "4L19"],
			healbell: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			icefang: ["5L1", "5E", "4L1", "4E"],
			icepunch: ["4T", "3T"],
			incinerate: ["5M"],
			lastresort: ["4T"],
			lick: ["5L13", "4L13", "3L19"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["5E", "4E", "3T", "3E"],
			mimic: ["5E", "3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "5L43", "4M", "4L43"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L31", "4L31", "3L34"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L25", "4M", "4L25", "3M", "3L26"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L1", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			smellingsalts: ["5E", "4E", "3E"],
			snarl: ["5E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			tailwhip: ["5L1", "4L1", "3L4", "3S0"],
			takedown: ["5L37", "4L37", "3L43"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "5E", "4L1", "4E"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	granbull: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L7", "4L7", "3L13"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5L1", "4L1", "3L8"],
			counter: ["3T"],
			crunch: ["5L59", "4L59", "3L61"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["5L19", "4T", "4L19"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icefang: ["5L1", "4L1"],
			icepunch: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lick: ["5L13", "4L13", "3L19"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5L67"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "5L51", "4M", "4L51"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L35", "4L35", "3L38"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L27", "4M", "4L27", "3M", "3L28"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L4"],
			takedown: ["5L43", "4L43", "3L49"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	qwilfish: {
		inherit: true,
		learnset: {
			acidspray: ["5E"],
			aquajet: ["5E", "5D", "4E"],
			aquatail: ["5L45", "4T", "4L45"],
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5L33", "5E", "4M", "4L33"],
			bubblebeam: ["5E", "4E", "3E"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			destinybond: ["5L53", "4L53", "3L45"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L9", "4L9", "3L9", "3S0"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L57", "4L57", "3L37"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			minimize: ["5L9", "4L9", "3L9", "3S0"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			pinmissile: ["5L37", "4L37", "3L21"],
			poisonjab: ["5M", "5L49", "4M", "4L49", "4E"],
			poisonsting: ["5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L29", "4L29", "3L25"],
			rollout: ["5L17", "4T", "4L17", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["5D", "4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5E", "4T", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			spikes: ["5L1", "4L1", "3L1"],
			spitup: ["5L25", "4L25"],
			stockpile: ["5L25", "4L25"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			takedown: ["5L41", "4L41", "3L33"],
			taunt: ["5M", "4M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			toxicspikes: ["5L21", "4L21"],
			venoshock: ["5M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L13", "4L13", "3L13"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	shuckle: {
		inherit: true,
		learnset: {
			acid: ["5E"],
			acupressure: ["5E", "4E"],
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			bide: ["5L1", "4L1", "3L28"],
			bodyslam: ["3T"],
			bugbite: ["5L49", "4T", "4L40"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			constrict: ["5L1", "4L1", "3L1", "3S0"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			encore: ["5L7", "4L9", "3L14", "3S1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			finalgambit: ["5E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L31", "4T", "4L35"],
			guardsplit: ["5L55"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["5E", "4T", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			knockoff: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["5E", "4T", "4E", "3T"],
			naturalgift: ["4M"],
			powersplit: ["5L55"],
			powertrick: ["5L43", "4L48"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "5L25", "4M", "4L27", "3M", "3L37"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5E"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L37", "4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "5L19", "4M", "4L14", "3M", "3L23"],
			sandstorm: ["5M", "4M", "3M"],
			sandtomb: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M", "3S1"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M", "5L1"],
			substitute: ["5M", "4M", "3T", "3S1"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M", "3S1"],
			venoshock: ["5M"],
			withdraw: ["5L1", "4L1", "3L1", "3S0"],
			wrap: ["5L13", "4L22", "3L9", "3S0"],
		},
	},
	heracross: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L13", "4M", "4L13"],
			attract: ["5M", "4M", "3M"],
			bide: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "5L19", "4M", "4L19", "3M", "3L23"],
			bugbite: ["4T"],
			bulkup: ["4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L37", "4L37"],
			counter: ["5L25", "4L25", "3T", "3L30"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5L1", "4M", "4L1", "3T", "3L11"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4E", "3E"],
			feint: ["5L49", "4L49"],
			flail: ["5E", "4E", "3E"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["5E", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L7", "4L7", "3L17"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			harden: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L1", "4L1", "3L6"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megahorn: ["5L55", "5E", "4L55", "3L53"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightslash: ["5L1", "4L1"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E", "4E"],
			reversal: ["5L43", "4L43", "3L45"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5E", "3T"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L31", "4L31", "3L37"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["5M"],
			workup: ["5M"],
		},
	},
	sneasel: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L24", "4L24", "3L36"],
			assist: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["5E", "4M"],
			beatup: ["5L42", "4L38", "3L57"],
			bite: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			crushclaw: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublehit: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E", "3E"],
			falseswipe: ["5M", "4M"],
			feint: ["5E"],
			feintattack: ["5L14", "4L14", "3L22"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L21", "4L21", "3L29"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M", "5L35"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5E", "4T", "4E", "3T"],
			iceshard: ["5L51", "5E", "4L49", "4E"],
			icywind: ["5L28", "4T", "4L28", "3T", "3L43"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lowkick: ["5D", "4T"],
			lowsweep: ["5M"],
			metalclaw: ["5L49", "4L42", "3L64"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			punishment: ["5E", "4E"],
			pursuit: ["5E", "4E"],
			quickattack: ["5L8", "4L8", "3L8", "3S0"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1", "3S0"],
			screech: ["5L10", "4L10", "3L15"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L38", "4L35", "3L50"],
			sleeptalk: ["4M", "3T"],
			snarl: ["5E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5E", "4T", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			taunt: ["5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["5M", "4M"],
		},
	},
	weavile: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			assurance: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M", "4S0"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			darkpulse: ["5L51", "4M", "4L49"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "5L1", "4M", "4L1"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fakeout: ["4S0"],
			falseswipe: ["5M", "4M"],
			feintattack: ["5L14", "4L14"],
			fling: ["5M", "5L42", "4M", "4L38"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L21", "4L21"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M", "5L35"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			iceshard: ["4S0"],
			icywind: ["5L28", "4T", "4L28"],
			irontail: ["4M"],
			knockoff: ["4T"],
			leer: ["5L1", "4L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			metalclaw: ["5L49", "4L42"],
			mudslap: ["4T"],
			nastyplot: ["5L24", "4L24"],
			naturalgift: ["4M"],
			nightslash: ["5L38", "4L35", "4S0"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			reflect: ["5M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			revenge: ["5L1", "4L1"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			scratch: ["5L1", "4L1"],
			screech: ["5L10", "4L10"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L1", "4M", "4L1"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			whirlpool: ["4M"],
			xscissor: ["5M", "4M"],
		},
	},
	teddiursa: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5E", "4E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5L36", "4L36"],
			chipaway: ["5E"],
			closecombat: ["5E", "4E"],
			counter: ["5E", "4E", "3T", "3E"],
			covet: ["5L1", "4L1"],
			crosschop: ["5E", "4E"],
			crunch: ["5E", "5D", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L1", "5E", "5D", "4L1", "4E", "3L19", "3E"],
			feintattack: ["5L15", "4L15", "3L25"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "5L57", "4M", "4L57"],
			focuspunch: ["5D", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L8", "4L8", "3L13"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icepunch: ["4T", "3T"],
			lastresort: ["4T"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lick: ["5L1", "4L1", "3L7", "3S0", "3S1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["5E", "4E", "3E", "3S1"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["5M", "5L43", "4M", "4L43", "3M", "3L31"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M", "3S1"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["5E", "4E", "3T", "3E"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L29", "4L29", "3L37"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["5L43", "4T", "4L43", "3T", "3L43"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			takedown: ["5E", "4E", "3E"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L50", "4L50", "3L49"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			workup: ["5M"],
			yawn: ["5E", "4E", "3E"],
		},
	},
	ursaring: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			covet: ["5L1", "4L1"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L1", "4L1", "3L19"],
			feintattack: ["5L15", "4L15", "3L25"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L8", "4L8", "3L1"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["4T"],
			hammerarm: ["5L67", "4L67"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			lastresort: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			lick: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L47", "4M", "4L47", "3M", "3L31"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scaryface: ["5L38", "4L38"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L29", "4L29", "3L37"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["5L49", "4T", "4L49", "3T", "3L43"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L22", "4L22"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L58", "4L58", "3L49"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			workup: ["5M"],
		},
	},
	slugma: {
		inherit: true,
		learnset: {
			acidarmor: ["5E", "4E", "3E"],
			amnesia: ["5L32", "4L31", "3L29"],
			ancientpower: ["5L28", "4T", "4L26"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L46", "4L46", "3T", "3L50"],
			captivate: ["4M"],
			curse: ["5E", "4E"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L55", "5E", "4T", "4L56"],
			ember: ["5L5", "5D", "4L8", "3L8"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flameburst: ["5L23"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L50", "4M", "4L53", "3M", "3L36"],
			frustration: ["5M", "4M", "3M"],
			harden: ["5L14", "4L16", "3L22"],
			heatwave: ["5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5E", "5D"],
			irondefense: ["4T"],
			lavaplume: ["5L37", "4L38"],
			lightscreen: ["5M", "4M", "3M"],
			memento: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			recover: ["5L19", "4L23"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "5L41", "4M", "4L41", "3T", "3L43"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L10", "4L11", "3L15"],
			rocktomb: ["5M", "4M"],
			rollout: ["5E", "4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			smog: ["5L1", "4L1", "3L1"],
			smokescreen: ["5E", "4E"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E"],
			stockpile: ["5E", "4E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
			yawn: ["5L1", "4L1", "3L1"],
		},
	},
	magcargo: {
		inherit: true,
		learnset: {
			amnesia: ["5L32", "4L31", "3L29"],
			ancientpower: ["5L28", "4T", "4L26"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L52", "4L52", "3T", "3L60"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L67", "4T", "4L66"],
			earthquake: ["5M", "4M", "3M", "3S0"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flameburst: ["5L23"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L59", "4M", "4L61", "3M", "3L36", "3S0"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			harden: ["5L14", "4L16", "3L22"],
			heatwave: ["4T", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			lavaplume: ["5L37", "4L40"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			recover: ["5L19", "4L23"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L44", "4M", "4L45", "3T", "3L48"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L1", "4L1", "3L1"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["5L38"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			smog: ["5L1", "4L1", "3L1"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
			yawn: ["5L1", "4L1", "3L1"],
		},
	},
	swinub: {
		inherit: true,
		learnset: {
			amnesia: ["5L49", "4L49", "3L55"],
			ancientpower: ["5E", "4T", "4E", "3E", "3S0"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["5E"],
			bite: ["5E", "4E", "3E"],
			blizzard: ["5M", "5L44", "4M", "4L44", "3M", "3L46"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			curse: ["5E", "4E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L37", "4M", "4L37", "3M"],
			endeavor: ["4T"],
			endure: ["5L16", "4M", "4L16", "3T", "3L19"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			iceshard: ["5L28", "4L28"],
			iciclecrash: ["5E"],
			iciclespear: ["5E", "4E", "3E"],
			icywind: ["5L25", "4T", "4L25", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["5L40", "4L40", "3L37", "3S0"],
			mudbomb: ["5L20", "4L20"],
			mudshot: ["5E", "4E", "3E", "3S0"],
			mudslap: ["5L13", "4T", "4L13", "3T"],
			mudsport: ["5L4", "4L4"],
			naturalgift: ["4M"],
			odorsleuth: ["5L1", "4L1", "3L1"],
			powdersnow: ["5L8", "4L8", "3L10"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["5E", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L32", "5E", "4L32", "4E", "3L28", "3E"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	piloswine: {
		inherit: true,
		learnset: {
			amnesia: ["5L65", "4L65", "3L70"],
			ancientpower: ["5L1", "4T", "4L1"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L56", "4M", "4L56", "3M", "3L56"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L40", "4M", "4L40", "3M"],
			endeavor: ["4T"],
			endure: ["5L16", "4M", "4L16", "3T", "3L1"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L33", "4L33", "3L33"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["3L1"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L28", "4L28"],
			icywind: ["5L25", "4T", "4L25", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mist: ["5L48", "4L48", "3L42"],
			mudbomb: ["5L20", "4L20"],
			mudslap: ["5L13", "4T", "4L13", "3T"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["5L1", "4L1", "3L1"],
			peck: ["5L1", "4L1"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5L32", "4L32", "3L28"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	mamoswine: {
		inherit: true,
		learnset: {
			ancientpower: ["5L1", "4T", "4L1"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L56", "4M", "4L56"],
			block: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			doublehit: ["5L33", "5S0", "4L33"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L40", "4M", "4L40"],
			endeavor: ["4T"],
			endure: ["5L16", "4M", "4L16"],
			facade: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "5L25", "5S0", "4M", "4L25"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icefang: ["5L28", "5S0", "4L28"],
			icywind: ["4T"],
			ironhead: ["4T"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M"],
			mist: ["5L48", "4L48"],
			mudbomb: ["5L20", "4L20"],
			mudslap: ["5L13", "4T", "4L13"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			odorsleuth: ["5L1", "4L1"],
			peck: ["5L1", "4L1"],
			powdersnow: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L65", "4L65"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "4M"],
			takedown: ["5L32", "5S0", "4L32"],
			toxic: ["5M", "4M"],
		},
	},
	corsola: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			ancientpower: ["5L32", "4T", "4L32", "3L45"],
			aquaring: ["5L37", "5E", "4L37", "4E"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bide: ["5E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubble: ["5L8", "5D", "4L8", "3L12"],
			bubblebeam: ["5L25", "4L25", "3L23"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5E", "5D", "4E", "3E"],
			curse: ["5E", "4E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L53", "4T", "4L53"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L4", "4L4", "3L6"],
			headbutt: ["4T"],
			headsmash: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			iciclespear: ["5E", "4E", "3E"],
			icywind: ["4T"],
			ingrain: ["5E", "4E", "3E"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L28", "4L28"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["5L48", "4L48", "3L39"],
			mist: ["5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			naturepower: ["5E", "4E"],
			powergem: ["5L44", "4L44"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L13", "4L13", "3L17"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["5L16", "4L16", "3L17"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L20", "4L20", "3L34"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikecannon: ["5L40", "4L40", "3L28"],
			stealthrock: ["5D", "4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	remoraid: {
		inherit: true,
		learnset: {
			acidspray: ["5E"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L14", "5E", "4L14", "4E", "3L22", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5D", "4M"],
			bubblebeam: ["5L19", "4L19", "3L22"],
			bulletseed: ["5L27", "4M", "4L27"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			defensecurl: ["3T"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flail: ["5E", "4E"],
			flamethrower: ["5M", "4M", "3M"],
			focusenergy: ["5L23", "4L23", "3L33"],
			frustration: ["5M", "4M", "3M"],
			gunkshot: ["4T"],
			haze: ["5E", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L45", "4M", "4L45", "3M", "3L55"],
			icebeam: ["5M", "5L40", "4M", "4L40", "3M", "3L44"],
			icywind: ["4T"],
			incinerate: ["5M"],
			lockon: ["5L6", "5D", "4L6", "3L11"],
			mimic: ["3T"],
			mudshot: ["5E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L10", "4L10", "3L22"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5E", "5D", "4E", "3E"],
			round: ["5M"],
			scald: ["5M"],
			screech: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			signalbeam: ["5L36", "4T", "4L36"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["5E", "4T", "4E", "3T"],
			soak: ["5L49"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5E", "4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "4E", "3T", "3E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5L32", "5E", "4M", "4L32", "3M"],
			waterspout: ["5E", "4E"],
			whirlpool: ["4M"],
		},
	},
	octillery: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L1", "4L1", "3L22"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubblebeam: ["5L19", "4L19", "3L22"],
			bulletseed: ["5L29", "4M", "4L29", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			constrict: ["5L1", "4L1", "3L11"],
			defensecurl: ["3T"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5L23", "4L23", "3L38"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["5L1", "4T", "4L1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L55", "4M", "4L55", "4S0", "3M", "3L70"],
			icebeam: ["5M", "5L48", "4M", "4L48", "4S0", "3M", "3L54"],
			icywind: ["4T"],
			incinerate: ["5M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			octazooka: ["5L25", "4L25", "4S0", "3L25"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L1", "4L1", "3L22"],
			psychic: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L1", "4L1"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			signalbeam: ["5L42", "4T", "4L42", "4S0"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			soak: ["5L61"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			wringout: ["5L36", "4L36"],
		},
	},
	delibird: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5E", "4E", "3E"],
			avalanche: ["4M"],
			bestow: ["5E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E"],
			fling: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			focuspunch: ["5D", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			gunkshot: ["4T"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			iceball: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5E", "4E"],
			iceshard: ["5E", "5D", "4E"],
			icywind: ["5E", "4T", "3T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			present: ["5L1", "5D", "4L1", "3L1", "3S0"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E", "4E", "3E"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			signalbeam: ["4T"],
			skyattack: ["4T", "3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			splash: ["5E", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	mantyke: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M"],
			agility: ["5L19", "4L19"],
			aircutter: ["4T"],
			amnesia: ["5E"],
			aquaring: ["5L46", "4L46"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bounce: ["5L40", "4T", "4L40"],
			bubble: ["5L1", "4L1"],
			bubblebeam: ["5L10", "4L10"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			confuseray: ["5L37", "4L37"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			frustration: ["5M", "4M"],
			hail: ["5M", "4M"],
			haze: ["5E", "4E"],
			headbutt: ["5L13", "4T", "4L13"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hydropump: ["5L49", "5E", "4L49", "4E"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			mirrorcoat: ["5E", "4E"],
			mudslap: ["4T"],
			mudsport: ["5E", "4E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockslide: ["5M", "4E"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			signalbeam: ["5E", "4E"],
			slam: ["5E", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			splash: ["5E", "4E"],
			substitute: ["5M", "4M"],
			supersonic: ["5L4", "4L4"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L31", "4L31"],
			toxic: ["5M", "4M"],
			twister: ["5E", "4E"],
			waterfall: ["5M", "4M"],
			waterpulse: ["5L28", "4M", "4L28"],
			watersport: ["5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["5E"],
			wingattack: ["5L22", "4L22"],
		},
	},
	mantine: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L19", "4L19", "3L29"],
			aircutter: ["5D", "4T"],
			amnesia: ["5E"],
			aquaring: ["5L46", "4L46"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5L40", "4T", "4L40"],
			brine: ["4M"],
			bubble: ["5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["5L1", "4L1", "3L15"],
			bulldoze: ["5M"],
			bulletseed: ["5L1", "4M", "4L1"],
			captivate: ["4M"],
			confuseray: ["5L37", "4L37", "3L50"],
			defog: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["4T"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E", "3E"],
			headbutt: ["5L13", "4T", "4L13"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L49", "5E", "4L49", "4E", "3E"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "5D", "4E"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L1", "4L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3E"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			signalbeam: ["5L1", "4T", "4L1"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["5E", "4E"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L1", "5D", "4L1", "3L8", "3S0"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			tailwind: ["4T"],
			takedown: ["5L31", "4L31", "3L22"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5E", "4E", "3E"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L28", "4M", "4L28", "3M", "3L43"],
			watersport: ["5E", "4E"],
			whirlpool: ["4M"],
			wideguard: ["5E"],
			wingattack: ["5L22", "4L22", "3L36"],
		},
	},
	skarmory: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L12", "4L12", "3L16"],
			aircutter: ["5L23", "4T", "4L23", "3L29"],
			airslash: ["5L42", "4L39"],
			assurance: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L39"],
			bravebird: ["5E", "4E"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drillpeck: ["5E", "5D", "4E", "3E"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L20", "4L20"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L17", "4L17", "3L26"],
			furycutter: ["4T"],
			guardswap: ["5E", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T"],
			irondefense: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			metalsound: ["5L31", "4L31", "3L45"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L50", "4L45"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			peck: ["5L1", "5D", "4L1", "3L1"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			roost: ["5D", "4M"],
			round: ["5M"],
			sandattack: ["5L6", "4L6", "3L10"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			skyattack: ["5E", "4T", "4E", "3T", "3E"],
			skydrop: ["5M"],
			slash: ["5L45", "4L42"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikes: ["5L28", "4L27", "3L42"],
			stealthrock: ["5E", "4M"],
			steelwing: ["5L34", "4M", "4L34", "3M", "3L32"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L9", "4T", "4L9", "3T", "3L13"],
			swordsdance: ["5M", "4M"],
			tailwind: ["4T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["5E", "4E", "3E"],
			xscissor: ["5M", "4M"],
		},
	},
	houndour: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			beatup: ["5L25", "5E", "4L27", "4E", "3E"],
			bite: ["5L16", "4L17", "3L25"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charm: ["3S1"],
			counter: ["5E", "4E", "3T", "3E"],
			crunch: ["5L49", "4L48", "3L49"],
			darkpulse: ["5D", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			embargo: ["5M", "5L37", "4M", "4L40"],
			ember: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5E", "5D", "4E"],
			feintattack: ["5L32", "4L35", "3L37", "3S1"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L28", "5E", "4L30", "4E"],
			firespin: ["5E", "4E", "3E"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L44", "4M", "4L43", "3M", "3L43"],
			foulplay: ["5L40"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L4", "5D", "4L4", "3L7", "3S0"],
			incinerate: ["5M"],
			inferno: ["5L56"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L52", "5E", "4L53", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["5L20", "4L22", "3L31"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			punishment: ["5E", "4E"],
			pursuit: ["5E", "4E", "3E"],
			rage: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			roar: ["5M", "5L13", "4M", "4L14", "3M", "3L19", "3S1"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			smog: ["5L8", "4L9", "3L13"],
			snarl: ["5E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["5E", "4T", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E", "4T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunderfang: ["5E", "4E"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M", "4E", "3E"],
		},
	},
	houndoom: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			beatup: ["5L26", "4L28"],
			bite: ["5L16", "4L17", "3L27"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["5L56", "4L54", "3L59"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			embargo: ["5M", "5L41", "4M", "4L44"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L35", "4L38", "3L43"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L30", "4L32"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L50", "4M", "4L48", "3M", "3L51"],
			foulplay: ["5L45"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L1", "4L1", "3L1"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			inferno: ["5L65"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L60", "4L60"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			odorsleuth: ["5L20", "4L22", "3L35"],
			overheat: ["5M", "4M", "3M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L13", "4M", "4L14", "3M", "3L19"],
			rocksmash: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			smog: ["5L1", "4L1", "3L13"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	phanpy: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["5L33", "4L33"],
			counter: ["5E", "4E", "3T", "3E"],
			defensecurl: ["5L1", "4L1", "3T", "3L9"],
			doubleedge: ["5L42", "4L42", "3T", "3L49"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endeavor: ["5E", "4T", "4E"],
			endure: ["5L28", "4M", "4L28", "3T", "3L41"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5E", "4E", "3E"],
			flail: ["5L6", "5D", "4L6", "3L17"],
			focusenergy: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			headsmash: ["5E", "4E"],
			heavyslam: ["5E", "5D"],
			hiddenpower: ["5M", "4M", "3M"],
			iceshard: ["5E", "4E"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["5L37", "4L37"],
			mimic: ["3T"],
			mudslap: ["5E", "4T", "3T"],
			naturalgift: ["5L19", "4M", "4L19"],
			odorsleuth: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L33"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5D", "4T"],
			slam: ["5L24", "4L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L10", "4L10", "3L25"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	donphan: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			assurance: ["5L31", "4L31"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bulldoze: ["5M", "5L1"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["5L1", "4L1", "3T", "3L9"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L46", "4M", "4L46", "3M", "3L49"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			flail: ["4L1", "3L17"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L25", "4L25", "3L25"],
			gigaimpact: ["5M", "5L54", "4M", "4L54"],
			growl: ["5L1", "4L1", "3L1"],
			gunkshot: ["4T"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hornattack: ["5L1", "4L1", "3L1"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["5L10", "4T", "4L10"],
			magnitude: ["5L19", "4L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["3L1"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			rapidspin: ["5L6", "4L6", "3L41"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L15", "4T", "4L15", "3T", "3L33"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L39", "4L39"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			slam: ["5L24", "4L24"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			thunderfang: ["5L1", "4L1"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	stantler: {
		inherit: true,
		learnset: {
			astonish: ["5L7", "4L7", "3L11"],
			attract: ["5M", "4M", "3M"],
			bite: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L27", "4M", "4L27", "3M", "3L47"],
			captivate: ["5L53", "4M", "4L49"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L23", "4L23", "3L41"],
			disable: ["5E", "5D", "4E", "3E"],
			doubleedge: ["3T"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			extrasensory: ["5E", "4E", "3E"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L10", "4L10", "3L17"],
			imprison: ["5L49", "4L43"],
			irontail: ["4M", "3M"],
			jumpkick: ["5L43"],
			lastresort: ["4T"],
			leer: ["5L3", "4L3", "3L7", "3S0"],
			lightscreen: ["5M", "4M", "3M"],
			mefirst: ["5L55", "5E", "4L53"],
			megahorn: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			psyshock: ["5M"],
			rage: ["5E"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			roleplay: ["5L33", "4T", "4L33", "3L31"],
			round: ["5M"],
			sandattack: ["5L16", "4L16", "3L27"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["5E", "4T", "4E", "3E"],
			stomp: ["5L13", "4L13", "3L21"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5D", "4L1", "3L1", "3S0"],
			takedown: ["5L21", "4L21", "3L37"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5E", "4E"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			wildcharge: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["5L38", "5E", "4T", "4L38", "4E"],
		},
	},
	smeargle: {
		inherit: true,
		learnset: {
			captivate: ["5D"],
			sketch: ["5L1", "5D", "4L1", "3L1", "3S0"],
			sleeptalk: ["5D"],
		},
	},
	miltank: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bide: ["5L15", "4L15", "3L26"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["5L24", "4L24", "3T", "3L43"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["5L35", "4M", "4L35"],
			counter: ["3T"],
			curse: ["5E", "5D", "4E", "3E"],
			defensecurl: ["5L5", "5D", "4L5", "3T", "3L8"],
			dizzypunch: ["5E", "4E"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L3", "4L3", "3L4"],
			gyroball: ["5M", "5L41", "4M", "4L41"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			healbell: ["5L48", "4T", "4L48", "3L53"],
			heartstamp: ["5E"],
			helpinghand: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["5D", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			milkdrink: ["5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			present: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			punishment: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L19", "4T", "4L19", "3T", "3L34"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5E", "4E", "3T", "3E"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			stomp: ["5L8", "4L8", "3L13"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			wakeupslap: ["5L55", "4L55"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["5L29", "4T", "4L29"],
		},
	},
	raikou: {
		inherit: true,
		learnset: {
			aurasphere: ["4S3"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L78", "4M", "4L78", "3M", "3L81"],
			chargebeam: ["5M", "4M"],
			crunch: ["5L43", "4L43", "3L61", "3S1"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			discharge: ["5L57", "4L57"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quash: ["5M"],
			quickattack: ["5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			raindance: ["5M", "5L71", "4M", "4L71", "3M"],
			reflect: ["5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["5M", "5L85", "4M", "4L71", "3M", "3L71"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L50", "4L50"],
			thundershock: ["5L8", "4L8", "3L11", "3S0"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			weatherball: ["4S3"],
			wildcharge: ["5M"],
			zapcannon: ["4S3"],
		},
	},
	entei: {
		inherit: true,
		learnset: {
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L78", "4M", "4L78", "3M", "3L81"],
			crushclaw: ["4S3"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L8", "4L8", "3L11", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["5L85", "4L85"],
			extrasensory: ["5L64", "4L64"],
			extremespeed: ["4S3"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L71", "4M", "4L71", "3M", "3L71"],
			firefang: ["5L50", "4L50"],
			firespin: ["5L22", "4L22", "4S2", "3L31", "3S0", "3S1"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L36", "4M", "4L36", "4S2", "3M", "3L51", "3S1"],
			flareblitz: ["4S3"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["4S3"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lavaplume: ["5L57", "4L57"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L15", "4M", "4L15", "4S2", "3M", "3L21", "3S0"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L29", "4L29", "4S2", "3L41", "3S0", "3S1"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L43", "4M", "4L43", "3T", "3L61", "3S1"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	suicune: {
		inherit: true,
		learnset: {
			airslash: ["4S4"],
			aquaring: ["4S4"],
			aurorabeam: ["5L29", "4L29", "4S3", "3L41", "3S0", "3S1"],
			avalanche: ["4M"],
			bite: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "5L85", "4M", "4L85", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bubblebeam: ["5L8", "4L8", "3L11", "3S0"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L78", "4M", "4L78", "3M", "3L81"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			extrasensory: ["5L64", "4L64"],
			extremespeed: ["4S4"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L22", "4L22", "4S3", "3L31", "3S0", "3S1", "3S2"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L71", "4L71", "3L71", "3S2"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L50", "4L50"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1", "3S2"],
			mimic: ["3T"],
			mirrorcoat: ["5L43", "4L43", "3L61", "3S1"],
			mist: ["5L36", "4L36", "4S3", "3L51", "3S1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quash: ["5M"],
			raindance: ["5M", "5L15", "4M", "4L15", "4S3", "3M", "3L21", "3S0", "3S2"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M"],
			sheercold: ["4S4"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5L57", "4T", "4L57"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	larvitar: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E", "3E"],
			assurance: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "5D", "5S1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L14"],
			crunch: ["5L41", "4L37", "3L43"],
			curse: ["5E", "4E", "3E"],
			darkpulse: ["5L32", "5D", "4M", "4L28"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E", "3E", "3S0"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L46", "4M", "4L41", "3M", "3L50"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			focusenergy: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L55", "4M", "4L50", "3M", "3L57"],
			irondefense: ["5E", "4E"],
			ironhead: ["5E", "4T", "4E"],
			irontail: ["5E"],
			leer: ["5L1", "5S1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5E", "4E", "3E", "3S0"],
			payback: ["5M", "5L37", "4M", "4L32"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "5L5", "5S1", "4M", "4L5", "3M", "3L8", "3S0"],
			scaryface: ["5L23", "4L19", "3L36"],
			screech: ["5L10", "4L10", "3L15"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["5E", "5D", "4M"],
			stomp: ["5E", "4E", "3E"],
			stoneedge: ["5M", "5L50", "4M", "4L46"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5S1", "4T"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thrash: ["5L28", "4L23", "3L29"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	pupitar: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L14"],
			crunch: ["5L47", "4L41", "3L47"],
			darkpulse: ["5L34", "4M", "4L28"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L54", "4M", "4L47", "3M", "3L56"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L67", "4M", "4L60", "3M", "3L65"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "5L41", "4M", "4L34"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["5L23", "4L19", "3L38"],
			screech: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5L60", "4M", "4L54"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thrash: ["5L28", "4L23", "3L29"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	tyranitar: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L14"],
			counter: ["3T"],
			crunch: ["5L47", "5S1", "5S2", "4L41", "3L47", "3S0"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["5L34", "4M", "4L28"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L54", "5S2", "4M", "4L47", "3M", "3L61", "3S0"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5S1", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "5L82", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L73", "4M", "4L70", "3M", "3L75"],
			icebeam: ["5M", "5S1", "4M", "3M"],
			icefang: ["5L1", "4L1"],
			icepunch: ["4T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			outrage: ["4T"],
			payback: ["5M", "5L41", "5S2", "4M", "4L34"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L19", "4M", "4L14", "3T", "3L22"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			scaryface: ["5L23", "4L19", "3L38", "3S0"],
			screech: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5S2", "3T"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5L63", "5S1", "4M", "4L54"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thrash: ["5L28", "4L23", "3L29", "3S0"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	lugia: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aeroblast: ["5L43", "4L43", "4S2", "4S3", "3L77"],
			aircutter: ["4T"],
			ancientpower: ["5L57", "4T", "4L57", "4S3", "3L88"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brine: ["4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L93", "4M", "4L93", "3M"],
			chargebeam: ["5M", "4M"],
			defog: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragonrush: ["5L15", "4L15"],
			dragontail: ["5M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M", "3S1"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			extrasensory: ["5L23", "4L23", "4S2"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["3S1"],
			flash: ["5M", "4M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L79", "4L79", "3L99"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L9", "4L9", "3L22"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L37", "4L29", "4S2", "3L44", "3S0", "3S1"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychoboost: ["3S1"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			punishment: ["5L50", "4L50", "4S3"],
			raindance: ["5M", "5L29", "4M", "4L29", "4S2", "3M", "3L55", "3S0"],
			recover: ["5L71", "4L23", "3L33", "3S0"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L65", "4M", "4L9", "4S3", "3M", "3L11"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			skyattack: ["5L99", "4T", "4L99"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			weatherball: ["5L1", "5S4", "4L1"],
			whirlpool: ["4M"],
			whirlwind: ["5L1", "5S4", "4L1", "3L1"],
			zenheadbutt: ["4T"],
		},
	},
	hooh: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			ancientpower: ["5L57", "4T", "4L57", "4S2", "3L88"],
			bravebird: ["5L15", "4L15"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L93", "4M", "4L93", "3M"],
			chargebeam: ["5M", "4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			extrasensory: ["5L23", "4L23", "4S1"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L37", "4M", "4L29", "4S1", "3M", "3L44", "3S0"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L79", "4L79", "3L99"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L9", "4L9", "3L22"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L85", "4M", "4L51"],
			nightmare: ["3T"],
			ominouswind: ["4T"],
			overheat: ["5M", "4M", "3M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			punishment: ["5L50", "4L50", "4S2"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L71", "4L23", "3L33", "3S0"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			sacredfire: ["5L43", "4L43", "4S1", "4S2", "3L77"],
			safeguard: ["5M", "5L65", "4M", "4L9", "4S2", "3M", "3L11"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skyattack: ["5L99", "4T", "4L99", "3T"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L29", "4M", "4L29", "4S1", "3M", "3L55", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "4L43", "3T", "3L66", "3S0"],
			tailwind: ["4T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			weatherball: ["5L1", "5S3", "4L1"],
			whirlwind: ["5L1", "5S3", "4L1", "3L1"],
			willowisp: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	celebi: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L28", "4T", "4L28", "3L20", "3S1", "3S3"],
			batonpass: ["5L37", "4L37", "3L40", "3S1"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1", "3S0"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["4T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L64", "4L64", "3L30", "3S1", "3S3"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			healbell: ["5L1", "4T", "4L1", "3L1", "3S0", "3S2", "3S3"],
			healblock: ["5L55", "4L55"],
			healingwish: ["5L73", "4L73", "4S4"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			lastresort: ["4T"],
			leafstorm: ["5L82", "4L82", "4S4"],
			leechseed: ["5L1", "4L1", "3L1", "3S2"],
			lightscreen: ["5M", "4M", "3M"],
			magicalleaf: ["5L19", "4L19"],
			magiccoat: ["4T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["4S4"],
			naturalgift: ["5L46", "4M", "4L46"],
			nightmare: ["3T"],
			perishsong: ["5L91", "4L91", "3L50", "3S1"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L1", "4L1", "4S4", "3L1", "3S0", "3S2"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L10", "4M", "4L10", "3M", "3L10", "3S0", "3S2", "3S3"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			worryseed: ["4T"],
			zenheadbutt: ["4T"],
		},
	},
	treecko: {
		inherit: true,
		learnset: {
			absorb: ["5L6", "5S1", "4L6", "3L6", "3S0"],
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L31", "4L31", "3L31"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulletseed: ["5E", "4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["5E", "4E", "3E"],
			crushclaw: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			detect: ["5L41", "4L41", "3L41"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5E", "4E", "3E"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endeavor: ["5E", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			energyball: ["5M", "5L51", "4M", "4L51"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5L46", "4M", "4L46", "3M", "3L46"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			grasswhistle: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5E", "4E", "3E"],
			leer: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			lowkick: ["4T"],
			magicalleaf: ["5E", "4E"],
			megadrain: ["5L26", "4L26", "3L26"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["5E", "4M"],
			pound: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L16", "4L16", "3L16"],
			quickattack: ["5L11", "4L11", "3L11"],
			razorwind: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			screech: ["5L21", "4L21", "3L21"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["5L36", "4L36", "3L36"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5E", "4T", "4E"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["5E", "4T", "4E"],
		},
	},
	grovyle: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L35", "4L35", "3L35"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			detect: ["5L47", "4L47", "3L47"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L53", "4M", "4L53", "3L53"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L16", "4T", "4L16", "3T", "3L16"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leafblade: ["5L29", "4L29", "3L29"],
			leafstorm: ["5L59", "4L59"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L17", "4L17", "3L17"],
			quickattack: ["5L1", "4L1", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			screech: ["5L23", "4L23", "3L23"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["5L41", "4L41", "3L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["5M", "4M"],
		},
	},
	sceptile: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L35", "4L35", "3L35"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			detect: ["5L51", "4L51", "3L51"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["5S0", "4M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L59", "4M", "4L59", "3L59"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "5S0", "4M"],
			focuspunch: ["4M", "3M"],
			frenzyplant: ["5T", "4T"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T", "3L16"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leafblade: ["5L29", "4L29", "3L29"],
			leafstorm: ["5L67", "5S0", "4L67"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L1", "4L1"],
			outrage: ["4T"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L17", "4L17", "3L17"],
			quickattack: ["5L1", "4L1", "3L1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "5S0", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			screech: ["5L23", "4L23", "3L23"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			slam: ["5L43", "4L43", "3L43"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
			xscissor: ["5M", "5L16", "4M", "4L16"],
		},
	},
	torchic: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			captivate: ["4M"],
			counter: ["5E", "4E", "3T", "3E"],
			crushclaw: ["5E", "4E"],
			curse: ["5E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L10", "5S1", "5S2", "4L10", "3L10", "3S0"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["5E", "4E"],
			feint: ["5E", "4E"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			firespin: ["5L25", "4L25", "3L25"],
			flameburst: ["5E"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L43", "4M", "4L43", "3M", "3L43"],
			focusenergy: ["5L7", "5S1", "5S2", "4L7", "3L7", "3S0"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			lastresort: ["5E", "4T", "4E"],
			lowkick: ["5E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["5L37", "4L37", "3L37"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			overheat: ["5M", "4M", "3M"],
			peck: ["5L16", "4L16", "3L16"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L28", "4L28", "3L28"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5E", "4E", "3E"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L19", "4L19", "3L19"],
			scratch: ["5L1", "5S1", "5S2", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L34", "4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["5E", "4E", "3E"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	combusken: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "5L28", "4M", "4L28", "3M", "3L28"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L16", "4L16", "3L16"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			firepunch: ["4T", "3T"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flareblitz: ["5L54", "4L54"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			lastresort: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["5L43", "4L43", "3L43"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			peck: ["5L17", "4L17", "3L17"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L32", "4L32", "3L32"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L21", "4L21", "3L21"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			skyuppercut: ["5L50", "4L50", "3L50"],
			slash: ["5L39", "4L39", "3L39"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	blaziken: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blastburn: ["5T", "4T"],
			blazekick: ["5L36", "4L36", "3L36", "3S0"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			bravebird: ["5L49", "4L49"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "5L28", "4M", "4L28", "3M", "3L28"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doublekick: ["5L16", "4L16", "3L16"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepledge: ["5T"],
			firepunch: ["5L1", "4T", "4L1", "3T", "3L1"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flareblitz: ["5L66", "5S1", "4L66"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			highjumpkick: ["5L1", "5S1"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mirrormove: ["3L49", "3S0"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			peck: ["5L17", "4L17", "3L17"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L32", "4L32", "3L32"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L21", "4L21", "3L21"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			skyuppercut: ["5L59", "4L59", "3L59", "3S0"],
			slash: ["5L42", "4L42", "3L42", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			stoneedge: ["5M", "5S1", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thunderpunch: ["5S1", "4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	mudkip: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["5E"],
			bide: ["5L15", "4L15", "3L15"],
			bite: ["5E", "4E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			echoedvoice: ["5M"],
			endeavor: ["5L46", "4T", "4L46", "3L46"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			foresight: ["5L19", "4L19", "3L19"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L42", "4L42", "3L42"],
			iceball: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lowkick: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "4E", "3E"],
			mudbomb: ["5E", "4E"],
			mudslap: ["5L6", "5S1", "4T", "4L6", "3T", "3L6", "3S0"],
			mudsport: ["5L24", "4L24", "3L24"],
			naturalgift: ["4M"],
			protect: ["5M", "5L37", "4M", "4L37", "3M", "3L37"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5E", "4E"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			stomp: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			takedown: ["5L28", "4L28", "3L28"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5E", "4E", "3E"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "5S1", "4L10", "3L10", "3S0"],
			waterpledge: ["5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["5L33", "5E", "4M", "4L33", "4E", "3L33"],
			wideguard: ["5E"],
			yawn: ["5E", "4E"],
		},
	},
	marshtomp: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			bide: ["5L15", "4L15", "3L15"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L46", "4M", "4L46", "3M", "3L46"],
			echoedvoice: ["5M"],
			endeavor: ["5L53", "4T", "4L53", "3L53"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			foresight: ["5L20", "4L20", "3L20"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["5L25", "4L25"],
			muddywater: ["5L37", "4L37", "3L37"],
			mudshot: ["5L16", "4L16", "3L16"],
			mudslap: ["5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			protect: ["5M", "5L42", "4M", "4L42", "3M", "3L42"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L31", "4L31", "3L31"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpledge: ["5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	swampert: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bide: ["5L15", "4L15", "3L15"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L52", "5S0", "4M", "4L52", "3M", "3L52"],
			echoedvoice: ["5M"],
			endeavor: ["5L61", "4T", "4L61", "3L61"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L20", "4L20", "3L20"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			hammerarm: ["5L69", "5S0", "4L69"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydrocannon: ["5T", "4T"],
			hydropump: ["5S0"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5S0", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudbomb: ["5L25", "4L25"],
			muddywater: ["5L39", "4L39", "3L39"],
			mudshot: ["5L16", "4L16", "3L16"],
			mudslap: ["5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["3L25"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "5L46", "4M", "4L46", "3M", "3L46"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L31", "4L31", "3L31"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpledge: ["5T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	poochyena: {
		inherit: true,
		learnset: {
			assurance: ["5L29", "4L29"],
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L13", "4L13", "3L13"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			covet: ["5E", "4E", "3E"],
			crunch: ["5L53", "4L53", "3L41"],
			darkpulse: ["5D", "4M"],
			dig: ["5M", "4M", "3M", "3S0"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			embargo: ["5M", "5L41", "4M", "4L41"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			healbell: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L5", "5D", "4L5", "3L5", "3S0"],
			icefang: ["5E", "4E"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			leer: ["5E", "4E", "3E"],
			mefirst: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L17", "4L17", "3L17"],
			payback: ["5M", "4M"],
			poisonfang: ["5E", "5D", "4E", "3E", "3S0"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L21", "4M", "4L21", "3M", "3L21"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L9", "4L9", "3L9"],
			scaryface: ["5L33", "4L33", "3L29"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["5E", "4M", "3T"],
			snarl: ["5E"],
			snatch: ["5E", "4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L49", "5E", "4T", "4L49", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "5L25", "4M", "4L25", "3T", "3L25"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L45", "4L45", "3L33"],
			taunt: ["5M", "5L37", "4M", "4L37", "3M", "3L37"],
			thief: ["5M", "4M", "3M", "3L45"],
			thunderfang: ["5E", "4E"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			yawn: ["5E", "4E", "3E"],
		},
	},
	mightyena: {
		inherit: true,
		learnset: {
			assurance: ["5L32", "4L32"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["3L47"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			embargo: ["5M", "5L47", "4M", "4L47"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L1", "4L1", "3L1"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L17", "4L17", "3L17"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L22", "4M", "4L22", "3M", "3L22"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			scaryface: ["5L37", "4L37", "3L32"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L62", "4T", "4L62"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "5L27", "4M", "4L27", "3T", "3L27"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L52", "4L52", "3L37"],
			taunt: ["5M", "5L42", "4M", "4L42", "3M", "3L42"],
			thief: ["5M", "5L57", "4M", "4L57", "3M", "3L52"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	zigzagoon: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L45", "4L41", "3L41"],
			bestow: ["5L33"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5E", "4E", "3E"],
			covet: ["5L29", "4L29", "3L29"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			extremespeed: ["3S1"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L37", "4L33", "3L33"],
			fling: ["5M", "5L49", "4M", "4L45"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			gunkshot: ["4T"],
			headbutt: ["5L9", "4T", "4L9", "3L9"],
			helpinghand: ["5E", "4T", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["5D", "4T"],
			mimic: ["3T"],
			mudslap: ["5E", "4T", "4E", "3T"],
			mudsport: ["5L21", "4L21", "3L21"],
			naturalgift: ["4M"],
			odorsleuth: ["5L17", "4L17", "3L17"],
			pinmissile: ["5L25", "4L25", "3L25"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L41", "4M", "4L37", "3M", "3L37"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["5E"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandattack: ["5L13", "4L13", "3L13"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			simplebeam: ["5E"],
			sleeptalk: ["5E", "4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			tailwhip: ["5L5", "4L5", "3L5", "3S0", "3S1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			tickle: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "5D", "4T", "4E", "3E"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	linoone: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L59", "4L53", "3L53"],
			bestow: ["5L41"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			covet: ["5L35", "4L35", "3L35"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "5L65", "4M", "4L59"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L29", "4L29", "3L29"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			gunkshot: ["4T"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L23", "4L23", "3L23"],
			naturalgift: ["4M"],
			odorsleuth: ["5L17", "4L17", "3L17"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L53", "4M", "4L47", "3M", "3L47"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandattack: ["5L13", "4L13", "3L13"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L47", "4L41", "3L41"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			switcheroo: ["5L1", "4L1"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwhip: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
		},
	},
	wurmple: {
		inherit: true,
		learnset: {
			bugbite: ["5L15", "4T", "4L15"],
			poisonsting: ["5L5", "4L5", "3L5"],
			snore: ["5D", "4T"],
			stringshot: ["5L1", "4T", "4L1", "3L1"],
			tackle: ["5L1", "4L1", "3L1"],
		},
	},
	silcoon: {
		inherit: true,
		learnset: {
			bugbite: ["4T"],
			harden: ["5L1", "4L1", "3L1"],
			irondefense: ["4T"],
			stringshot: ["4T"],
		},
	},
	beautifly: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "5L31", "4M", "4L31", "3M", "3L31"],
			bugbite: ["4T"],
			bugbuzz: ["5L41", "4L41"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L38", "4M", "4L38", "3M", "3L38"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L13", "4L13", "3L13"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			megadrain: ["5L24", "4L24", "3L24"],
			mimic: ["3T"],
			morningsun: ["5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			quiverdance: ["5L45"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L17", "4L17", "3L17"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			whirlwind: ["5L27", "4L27", "3L27"],
		},
	},
	cascoon: {
		inherit: true,
		learnset: {
			bugbite: ["4T"],
			harden: ["5L1", "4L1", "3L1"],
			irondefense: ["4T"],
			stringshot: ["4T"],
		},
	},
	dustox: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L41", "4L41"],
			captivate: ["4M"],
			confusion: ["5L1", "4L1", "3L1"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L13", "4L13", "3L13"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			lightscreen: ["5M", "5L31", "4M", "4L31", "3M", "3L31"],
			mimic: ["3T"],
			moonlight: ["5L20", "4L20", "3L20"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "5L17", "4M", "4L17", "3M", "3L17"],
			psybeam: ["5L24", "4L24", "3L24"],
			psychic: ["5M", "4M", "3M"],
			quiverdance: ["5L45"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["5L34", "4M", "4L34", "3L34"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "5L38", "4M", "4L38", "3M", "3L38"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			whirlwind: ["5L27", "4L27", "3L27"],
		},
	},
	lotad: {
		inherit: true,
		learnset: {
			absorb: ["5L5", "5D", "4L5", "3L7", "3S0"],
			astonish: ["5L1", "4L1", "3L1", "3S0"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bubblebeam: ["5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "5L45", "4M", "4L43"],
			facade: ["5M", "4M", "3M"],
			flail: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5E", "4M", "3M"],
			grassknot: ["5M", "4M"],
			growl: ["5L3", "4L3", "3L3", "3S0"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			leechseed: ["5E", "5D", "4E", "3E"],
			megadrain: ["5L19", "4L19", "3L43"],
			mimic: ["3T"],
			mist: ["5L11", "4L11", "3L21"],
			naturalgift: ["5L15", "4M", "4L15"],
			naturepower: ["5L7", "4L7", "3L13"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "5L37", "4M", "4L35", "3M", "3L31"],
			razorleaf: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5E", "4E", "3E"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5E", "4T", "4E", "3E"],
			teeterdance: ["5E"],
			thief: ["5M", "4M", "3M"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			watergun: ["5E", "4E", "3E"],
			waterpulse: ["5D", "4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["5L31", "4T", "4L27"],
		},
	},
	lombre: {
		inherit: true,
		learnset: {
			absorb: ["5L5", "4L5", "3L7"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bubblebeam: ["5L25", "4L25"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L11", "4L11", "3L19"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furyswipes: ["5L15", "4L15", "3L25"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			growl: ["5L3", "4L3", "3L3"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5L45", "4L43", "3L49"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["5L7", "4L7", "3L13"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M", "3L37"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L37", "4T", "4L35", "3L43"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["5L19", "4L19", "3L31"],
			whirlpool: ["4M"],
			zenheadbutt: ["5L31", "4T", "4L27"],
		},
	},
	ludicolo: {
		inherit: true,
		learnset: {
			absorb: ["3L1"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5S0"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5S0", "5S1", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5S0"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5S0", "5S1", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			megadrain: ["5L1", "4L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M", "5S1"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5S1", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	seedot: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			beatup: ["5E"],
			bide: ["5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			bulletseed: ["5E", "4M", "3M", "3S1"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			defog: ["5E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "5L43", "4M", "4L43", "3T", "3L43"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			foulplay: ["5E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M", "3S1"],
			grassknot: ["5M", "4M"],
			growth: ["5L7", "4L7", "3L7", "3S0"],
			harden: ["5L3", "4L3", "3L3", "3S0"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			leechseed: ["5E", "4E", "3E"],
			mimic: ["3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			naturepower: ["5L13", "4L13", "3L13"],
			powerswap: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5E", "4E", "3E"],
			razorwind: ["5E", "4E", "3E"],
			refresh: ["3S1"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M", "3S1"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L31", "4M", "4L31", "3M", "3L31"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L21", "4T", "4L21", "3L21"],
			takedown: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["5E", "4T", "4E"],
		},
	},
	nuzleaf: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			extrasensory: ["5L49", "4L49", "3L49"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L19", "4L19", "3L19"],
			falseswipe: ["5M"],
			feintattack: ["5L31", "4L31", "3L31"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			growth: ["5L7", "4L7", "3L7"],
			harden: ["5L3", "4L3", "3L3"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			naturepower: ["5L13", "4L13", "3L13"],
			payback: ["5M", "4M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			razorleaf: ["5L1", "4L1"],
			razorwind: ["5L37", "4L37", "3L37"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L43", "4M", "4L43", "3T", "3L43"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "5L25", "4M", "4L25", "3M", "3L25"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
		},
	},
	shiftry: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M"],
			feintattack: ["5L1", "4L1"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["3L1"],
			harden: ["3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			leafstorm: ["5L49", "4L49"],
			leaftornado: ["5L19"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L1", "4L1"],
			naturalgift: ["4M"],
			naturepower: ["3L1"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pound: ["3L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			razorleaf: ["5L1", "4L1"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["5L1", "4L1"],
			worryseed: ["4T"],
			xscissor: ["5M", "4M"],
		},
	},
	taillow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L34", "4M", "4L34", "3M", "3L34"],
			agility: ["5L43", "4L43", "3L43"],
			aircutter: ["4T"],
			airslash: ["5L53", "4L53"],
			attract: ["5M", "4M", "3M"],
			bravebird: ["5E", "5D", "4E"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["5E", "4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["5M"],
			endeavor: ["5L26", "4T", "4L26", "3L26"],
			endure: ["5D", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			featherdance: ["3S0"],
			fly: ["5M", "4M", "3M"],
			focusenergy: ["5L4", "4L4", "3L4", "3S0"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1", "3S0"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["5L1", "5D", "4L1", "3L1", "3S0"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			quickattack: ["5L8", "4L8", "3L8"],
			rage: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5E", "4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			skyattack: ["5E", "4E", "3T", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["5E", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5E", "4E", "3E"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["5D", "4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			whirlwind: ["5E", "4E"],
			wingattack: ["5L13", "4L13", "3L13"],
			workup: ["5M"],
		},
	},
	swellow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L38", "4M", "4L38", "3M", "3L38"],
			agility: ["5L49", "4L49", "3L49", "3S0"],
			aircutter: ["4T"],
			airslash: ["5L61", "4L61"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["3S0"],
			captivate: ["4M"],
			counter: ["3T"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L19", "4M", "4L19", "3M", "3L19"],
			echoedvoice: ["5M"],
			endeavor: ["5L28", "4T", "4L28", "3L28"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M", "3S0"],
			fly: ["5M", "4M", "3M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			pluck: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			skyattack: ["4T", "3T", "3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			wingattack: ["5L13", "4L13", "3L13"],
			workup: ["5M"],
		},
	},
	wingull: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L42", "4M", "4L42", "3M"],
			agility: ["5L37", "5E", "4L37", "4E", "3L55", "3E"],
			aircutter: ["4T"],
			airslash: ["5L47", "4L47"],
			aquaring: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["5E", "4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			gust: ["5E", "4E", "3E"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hurricane: ["5L50"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["5E", "4T", "4E"],
			mimic: ["3T"],
			mist: ["5L16", "5E", "4L16", "4E", "3L21", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L34", "4L34", "3L43"],
			quickattack: ["5L24", "4L24", "3L31"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L29", "5E", "4M", "4L29"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shockwave: ["5D", "4M", "3M"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L6", "4L6", "3L7"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5E", "5D", "4T", "4E", "3E"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			watergun: ["5L1", "5D", "4L1", "3L1"],
			waterpulse: ["5L19", "4M", "4L19", "3M"],
			watersport: ["5E", "4E", "3E"],
			wingattack: ["5L11", "4L11", "3L13"],
		},
	},
	pelipper: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["4M"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fling: ["5M", "5L43", "4M", "4L43"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			gunkshot: ["4T"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hurricane: ["5L63"],
			hydropump: ["5L57", "4L57", "3L61"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			mimic: ["3T"],
			mist: ["5L16", "4L16", "3L21"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "5L24", "4M", "4L24"],
			pluck: ["5M", "4M"],
			protect: ["5M", "5L25", "4M", "4L25", "3M", "3L25"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5L31", "4M", "4L31"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			shockwave: ["4M", "3M"],
			skyattack: ["4T", "3T"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			soak: ["5L1"],
			spitup: ["5L38", "4L38", "3L47"],
			steelwing: ["4M", "3M"],
			stockpile: ["5L38", "4L38", "3L33"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5L6", "4L6", "3L7"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L38", "4L38", "3L33"],
			swift: ["4T", "3T"],
			tailwind: ["5L50", "4T", "4L50"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5L19", "4M", "4L19", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			wingattack: ["5L1", "4L1", "3L1"],
		},
	},
	ralts: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "5L28", "4M", "4L23", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L43", "4L39", "3S1"],
			confuseray: ["5E", "4E"],
			confusion: ["5L6", "5D", "4L6", "3L6", "3S2"],
			defensecurl: ["3T"],
			destinybond: ["5E", "5D", "4E", "3E"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L10", "4M", "4L10", "3M", "3L11"],
			dreameater: ["5M", "5L50", "4M", "4L45", "3T", "3L46"],
			echoedvoice: ["5M"],
			encore: ["5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L39", "4L34", "3L36"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			grudge: ["5E", "4E"],
			headbutt: ["4T"],
			healpulse: ["5L23"],
			helpinghand: ["5D", "4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L45", "4L43", "3L41"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["5L34", "4L32", "3L31"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L17", "4L17"],
			magicalleaf: ["5L21", "4L21"],
			magiccoat: ["4T"],
			meanlook: ["5E", "4E", "3E"],
			memento: ["5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L32", "4M", "4L28", "3M", "3L26"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M", "3S2"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowsneak: ["5E", "4E"],
			shockwave: ["4M", "3M", "3S2"],
			signalbeam: ["4T"],
			sing: ["3S2"],
			skillswap: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			storedpower: ["5L54"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T"],
			synchronoise: ["5E"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["5L12", "4L12", "3L16"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["4T"],
		},
	},
	kirlia: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "5L31", "4M", "4L25", "3M", "3L21"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L50", "4L45"],
			confusion: ["5L1", "4L1", "3L1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			dreameater: ["5M", "5L59", "4M", "4L53", "3T", "3L54"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L45", "4L39", "3L40"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healpulse: ["5L25"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L53", "4L50", "3L47"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["5L39", "4L36", "3L33"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5L17", "4L17"],
			magicalleaf: ["5L22", "4L22", "3L1"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L36", "4M", "4L31", "3M", "3L26"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			storedpower: ["5L64"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	gardevoir: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "5L33", "4M", "4L25", "3M", "3L21"],
			captivate: ["5L60", "4M", "4L53"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			dreameater: ["5M", "5L73", "4M", "4L65", "3T", "3L60"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "5S0", "4M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L53", "4L45", "3L42"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			healingwish: ["5L1", "4L1"],
			healpulse: ["5L25"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L65", "5S0", "4L60", "3L51"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			imprison: ["5L45", "4L40", "3L33"],
			lightscreen: ["5M", "4M", "3M"],
			magicalleaf: ["5L22", "4L22"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L40", "5S0", "4M", "4L33", "3M", "3L26"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			storedpower: ["5L80"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			teleport: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "5S0", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M"],
			wish: ["5L17", "4L17"],
			zenheadbutt: ["4T"],
		},
	},
	gallade: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			allyswitch: ["5M"],
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			closecombat: ["5L59", "4L53"],
			confusion: ["5L1", "4L1"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "5L1", "4M", "4L1"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "5L50", "4M", "4L45"],
			feint: ["5L45", "4L39"],
			firepunch: ["4T"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["5L17", "4T", "4L17"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["5L25"],
			helpinghand: ["5L39", "4T", "4L36"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			knockoff: ["4T"],
			leafblade: ["5L1", "4L1"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L1", "4L1"],
			painsplit: ["4T"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "5L53", "4M", "4L50"],
			psychic: ["5M", "4M"],
			psychocut: ["5L36", "4L31"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			slash: ["5L22", "4L22"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			stoneedge: ["5M", "4M"],
			storedpower: ["5L64"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "5L31", "4M", "4L25"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			teleport: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["5M"],
			workup: ["5M"],
			xscissor: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	surskit: {
		inherit: true,
		learnset: {
			agility: ["5L31", "4L31", "3L31"],
			aquajet: ["5E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L43", "4L43"],
			blizzard: ["5M", "4M", "3M"],
			bubble: ["5L1", "5D", "4L1", "3L1", "3S0", "3S1"],
			bubblebeam: ["5L25", "4L25", "3L25"],
			bugbite: ["5E", "4T", "4E"],
			captivate: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5D", "4M", "3M"],
			haze: ["5L37", "4L37", "3L37"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5E", "5D", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mindreader: ["5E", "4E", "3E"],
			mist: ["5L37", "4L37", "3L37"],
			mudshot: ["5E", "4E", "3E"],
			mudslap: ["4T"],
			mudsport: ["3S0"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5E", "4E", "3E"],
			psychup: ["5M", "4M", "3T"],
			quickattack: ["5L7", "4L7", "3L7", "3S1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["5E", "4T", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L13", "4L13", "3L13"],
			swift: ["4T", "3T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["5L19", "4L19", "3L19"],
		},
	},
	masquerain: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["5L47", "4L47"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bubble: ["5L1", "4L1", "3L1"],
			bugbite: ["4T"],
			bugbuzz: ["5L61", "4L61"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L22", "4L22", "3L26"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			ominouswind: ["5L1", "4T", "4L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quickattack: ["5L1", "4L1", "3L1"],
			quiverdance: ["5L68"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L26", "4L26", "3L33"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			silverwind: ["5L40", "4M", "4L40", "3L47"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			stunspore: ["5L33", "4L33", "3L40"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L1", "4L1", "3L1"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlwind: ["5L54", "4L54", "3L53"],
		},
	},
	shroomish: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["5E", "4M", "3M"],
			captivate: ["4M"],
			charm: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["5E"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "4E", "3E"],
			falseswipe: ["5M", "4E", "3E", "3S0"],
			flash: ["5M", "4M", "3M"],
			focuspunch: ["5E"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["5L37", "4M", "4L37", "3M", "3L45"],
			grassknot: ["5M", "4M"],
			growth: ["5L33", "4L33", "3L36"],
			headbutt: ["5L21", "4T", "4L21", "3L22"],
			helpinghand: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			leechseed: ["5L13", "4L13", "3L10"],
			megadrain: ["5L17", "4L17", "3L16", "3S0"],
			mimic: ["3T"],
			naturalgift: ["5E", "4M"],
			poisonpowder: ["5L25", "4L25", "3L28"],
			protect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5L41", "5E", "4T", "4L41", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spore: ["5L45", "4L45", "3L54"],
			stunspore: ["5L9", "4L9", "3L7", "3S0"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			tackle: ["5L5", "4L5", "3L4"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			wakeupslap: ["5E", "4E"],
			worryseed: ["5L29", "5E", "4T", "4L29", "4E"],
		},
	},
	breloom: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["5L25", "4L25", "3T", "3L28"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["5L45", "4L45", "3T", "3L54"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["5L29", "4L29"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["5L21", "4T", "4L21", "3L22"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leechseed: ["5L1", "4L1", "3L1"],
			lowsweep: ["5M"],
			machpunch: ["5L23", "4L23", "3L23"],
			megadrain: ["5L17", "4L17", "3L16"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mindreader: ["5L37", "4L37", "3L45"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5L41", "4T", "4L41"],
			seismictoss: ["3T"],
			skyuppercut: ["5L33", "4L33", "3L36"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stunspore: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			venoshock: ["5M"],
			workup: ["5M"],
			worryseed: ["4T"],
		},
	},
	slakoth: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			afteryou: ["5E"],
			amnesia: ["5L25", "4L25", "3L25"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chipaway: ["5L37"],
			counter: ["5L43", "4L37", "3T", "3L37"],
			covet: ["5L31", "4L31", "3L31"],
			crushclaw: ["5E", "4E", "3E"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L19", "4L19", "3L19"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["5L49", "4L43", "3L43"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gunkshot: ["4T"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slackoff: ["5L13", "4L13", "3L13"],
			slash: ["5E", "4E", "3E"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5D", "4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			tickle: ["5E"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			yawn: ["5L1", "4L1", "3L1"],
		},
	},
	vigoroth: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L43"],
			counter: ["5L37", "4L37", "3T", "3L37"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			encore: ["5L1", "4L1", "3L1"],
			endure: ["5L25", "4M", "4L25", "3T", "3L25"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["5L49", "4M", "4L43", "3M", "3L43"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L19", "4L19", "3L19"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L55", "4L49", "3L49"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L31", "4L31", "3L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	slaking: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "4S0", "3M"],
			amnesia: ["5L25", "4L25", "3L25"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L37"],
			counter: ["5L43", "4L37", "3T", "3L37"],
			covet: ["5L31", "4L31", "3L31"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			encore: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L19", "4L19", "3L19"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["5L49", "4L43", "3L43"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "5L55", "4M", "4L49"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M", "4S0"],
			gunkshot: ["4T"],
			hammerarm: ["5L67", "4L61"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			punishment: ["5L61", "4L55"],
			quash: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "4S0", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M", "4S0"],
			shockwave: ["4M", "3M"],
			slackoff: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L36", "4M", "4L36", "3T", "3L36"],
			taunt: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			yawn: ["5L1", "4L1", "3L1"],
		},
	},
	nincada: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			bugbite: ["5E", "4T", "4E"],
			bugbuzz: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "5L45", "4M", "4L45", "3M", "3L45"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L25", "4M", "4L25", "3L25"],
			feintattack: ["5E", "4E", "3E"],
			finalgambit: ["5E"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L14", "4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gust: ["5E", "4E", "3E"],
			harden: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			leechlife: ["5L5", "4L5", "3L5"],
			metalclaw: ["5L38", "4L38", "3L38"],
			mimic: ["3T"],
			mindreader: ["5L19", "4L19", "3L19"],
			mudslap: ["5L31", "4T", "4L31", "3T", "3L31"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L9", "4L9", "3L9"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			silverwind: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			xscissor: ["5M", "4M"],
		},
	},
	ninjask: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L38", "4L38", "3L38"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L45", "4L45", "3L45"],
			bugbite: ["5L1", "4T", "4L1"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L20", "4M", "4L20", "3M", "3L20"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L20", "4T", "4L20", "3T", "3L20"],
			furyswipes: ["5L14", "4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mindreader: ["5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L20", "4L20", "3L20"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			silverwind: ["4M"],
			slash: ["5L31", "4L31", "3L31"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L25", "4M", "4L25", "3T", "3L25"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			xscissor: ["5M", "5L52", "4M", "4L52"],
		},
	},
	shedinja: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["4R", "3R"],
			batonpass: ["4R", "3R"],
			bugbite: ["4T"],
			confuseray: ["5L31", "4L31", "3L31", "3S0"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L14", "4L14", "3L14"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grudge: ["5L45", "4L45", "3L45", "3S0"],
			harden: ["5L1", "4L1", "3L1"],
			healblock: ["5L52", "4L52"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			leechlife: ["5L5", "4L5", "3L5"],
			mimic: ["3T"],
			mindreader: ["5L19", "4L19", "3L19"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L9", "4L9", "3L9"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["4R", "3R"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "5L59", "4M", "4L59", "3M", "3L38", "3S0"],
			shadowclaw: ["5M", "4M"],
			shadowsneak: ["5L38", "4L38"],
			slash: ["4R", "3R"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["5L25", "4T", "4L25", "3L25", "3S0"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["4R", "3R"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			willowisp: ["5M", "4M"],
			xscissor: ["5M", "4M"],
		},
	},
	whismur: {
		inherit: true,
		learnset: {
			astonish: ["5L11", "4L11", "3L11"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			circlethrow: ["5E"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			endeavor: ["5E", "4E"],
			endure: ["4M", "3T"],
			extrasensory: ["5E", "4E", "3E"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			hammerarm: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L15", "4L15", "3L15"],
			hypervoice: ["5L51", "4L45", "3L45"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			pound: ["5L1", "4L1", "3L1", "3S0"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L45", "4M", "4L41", "3M", "3L41"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L35", "4M", "4L35", "3M", "3L35"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5L31", "4L31", "3L31"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5L45", "4M", "4L41", "3T", "3L41"],
			smellingsalts: ["5E", "4E", "3E"],
			smokescreen: ["5E", "4E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L25", "4L25", "3L25"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L21", "4L21", "3L21"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			synchronoise: ["5L41"],
			takedown: ["5E", "4E", "3E"],
			teeterdance: ["3S0"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L5", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["5D", "4T"],
		},
	},
	loudred: {
		inherit: true,
		learnset: {
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L20", "4L20"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L1", "4L1", "3L1"],
			hypervoice: ["5L65", "4L57", "3L57"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L57", "4M", "4L51", "3M", "3L51"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L43", "4M", "4L43", "3M", "3L43"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5L37", "4L37", "3L37"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5L57", "4M", "4L51", "3T", "3L51"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L29", "4L29", "3L29"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L23", "4L23", "3L23"],
			swagger: ["5M", "4M", "3T"],
			synchronoise: ["5L51"],
			taunt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	exploud: {
		inherit: true,
		learnset: {
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L20", "4L20"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			crunch: ["5L40", "4L40"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L1", "4L1", "3L1"],
			hyperbeam: ["5M", "5L79", "4M", "4L71", "3M", "3L40", "3S1"],
			hypervoice: ["5L71", "4L63", "3L63", "3S0"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L1", "4L1"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["5M", "4M", "3M"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L55", "4M", "4L55", "3M", "3L55", "3S0"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L45", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			screech: ["5L37", "4L37", "3L37", "3S1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["5L63", "4M", "4L55", "3T", "3L55", "3S0"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stomp: ["5L29", "4L29", "3L29", "3S1"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L23", "4L23", "3L23"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M", "3T"],
			synchronoise: ["5L55"],
			taunt: ["5M", "4M", "3M"],
			thunderfang: ["5L1", "4L1"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5L1", "4T", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	makuhita: {
		inherit: true,
		learnset: {
			armthrust: ["5L7", "5D", "4L7", "3L10", "3S0"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L25", "4L25", "3L37"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M", "3S0"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5E", "4E"],
			captivate: ["4M"],
			chipaway: ["5E"],
			closecombat: ["5L40", "4L40"],
			counter: ["5E", "4E", "3T", "3E"],
			crosschop: ["5E", "4E", "3E"],
			detect: ["5E", "4E", "3E"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["5E", "4E", "3T", "3E"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5L37", "4M", "4L37", "3T", "3L40"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L13", "4L13", "3L19"],
			feint: ["5E", "4E"],
			feintattack: ["5E", "4E", "3E"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["5E", "4M", "3M"],
			forcepalm: ["5L28", "4L28"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["5L46"],
			helpinghand: ["5E", "5D", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["5D", "4T", "3T"],
			knockoff: ["5L19", "4T", "4L19", "3L28"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5E", "4E", "3E"],
			reversal: ["5L43", "4L43", "3L49"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M", "3S0"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L4", "4L4", "3L4"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L31", "4L31", "3T", "3L46"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			smellingsalts: ["5L22", "4L22", "3L31"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["5L10", "4L10", "3L13"],
			wakeupslap: ["5L34", "5E", "4L34", "4E"],
			whirlpool: ["4M"],
			whirlwind: ["5L16", "4L16", "3L22"],
			wideguard: ["5E"],
			workup: ["5M"],
		},
	},
	hariyama: {
		inherit: true,
		learnset: {
			armthrust: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bellydrum: ["5L27", "4L27", "3L40"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["5L1", "4M", "4L1"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			closecombat: ["5L52", "4L52"],
			counter: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5L47", "4M", "4L47", "3T", "3L44"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L13", "4L13", "3L19"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L1", "4L1", "3L1"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["5L32", "4L32"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["5L62"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			ironhead: ["4T"],
			knockoff: ["5L19", "4T", "4L19", "3L29"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L57", "4L57", "3L55"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5L37", "4L37", "3T", "3L51"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			smellingsalts: ["5L22", "4L22", "3L33"],
			snore: ["4T", "3T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			vacuumwave: ["4T"],
			vitalthrow: ["5L10", "4L10", "3L13"],
			wakeupslap: ["5L42", "4L42"],
			whirlpool: ["4M"],
			whirlwind: ["5L16", "4L16", "3L22"],
			workup: ["5M"],
		},
	},
	nosepass: {
		inherit: true,
		learnset: {
			ancientpower: ["5D", "4T"],
			attract: ["5M", "4M", "3M"],
			block: ["5L19", "5E", "4T", "4L19", "4E", "3L16"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			discharge: ["5L55", "4L49"],
			doubleedge: ["5E", "4E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthpower: ["5L79", "4T", "4L73"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			explosion: ["5M", "4M", "4E", "3T", "3E"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["5M", "4M", "3M"],
			gravity: ["4T"],
			harden: ["5L7", "4L7", "3L7"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			irondefense: ["4T"],
			lockon: ["5L73", "4L67", "3L46"],
			magiccoat: ["4T"],
			magnetrise: ["4T"],
			magnitude: ["5E", "4E", "3E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			powergem: ["5L49", "4L49"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "5L43", "4M", "4L43", "3M", "3L37"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L31", "4M", "4L31", "3T", "3L28", "3S0"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L13", "4L13", "3L13"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5E", "4T", "4E", "3T", "3E"],
			round: ["5M"],
			sandstorm: ["5M", "5L37", "4M", "4L37", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["5E", "4M"],
			stoneedge: ["5M", "5L61", "4M", "4L55"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			taunt: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M", "3S0"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "5L25", "4M", "4L25", "3T", "3L22", "3S0"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			zapcannon: ["5L67", "4L61", "3L43"],
		},
	},
	probopass: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M"],
			block: ["5L1", "4T", "4L1"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			discharge: ["5L55", "4L49"],
			doubleteam: ["5M", "4M"],
			earthpower: ["5L79", "4T", "4L73"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M"],
			firepunch: ["4T"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			irondefense: ["5L1", "4T", "4L1"],
			ironhead: ["4T"],
			lockon: ["5L73", "4L67"],
			magiccoat: ["4T"],
			magnetbomb: ["5L1", "4L1"],
			magnetrise: ["5L1", "4T", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			powergem: ["5L49", "4L49"],
			protect: ["5M", "4M"],
			rest: ["5M", "5L43", "4M", "4L43"],
			return: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L31", "4M", "4L31"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			sandstorm: ["5M", "5L37", "4M", "4L37"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5L61", "4M", "4L55"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			taunt: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "5L25", "4M", "4L25"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			zapcannon: ["5L67", "4L61"],
		},
	},
	skitty: {
		inherit: true,
		learnset: {
			assist: ["5L22", "4L18", "3L19"],
			attract: ["5M", "5L8", "4M", "4L4", "3M", "3L7", "3S2"],
			batonpass: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["5L46", "5E", "5D", "4M", "4L42"],
			chargebeam: ["5M", "4M"],
			charm: ["5L25", "4L22", "3L25"],
			copycat: ["5L18", "4L11"],
			covet: ["5L36", "4L32", "3L31"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L42", "4L39", "3T", "3L39"],
			doubleslap: ["5L15", "4L15", "3L15"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L1", "5E", "4L1", "4E"],
			faketears: ["5E", "4E", "3E"],
			feintattack: ["5L29", "4L25", "3L27"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5L4", "5D", "4L4"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			headbutt: ["4T"],
			healbell: ["5L39", "4T", "4L36", "3L37"],
			helpinghand: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["5E", "4T", "4E"],
			mimic: ["3T"],
			mudbomb: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			payday: ["3S0"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T", "3S1"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			simplebeam: ["5E"],
			sing: ["5L11", "4L8", "3L13"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["5E", "4T", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0", "3S1", "3S2"],
			tailwhip: ["5L1", "4L1", "3L3", "3S0", "3S1", "3S2"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			tickle: ["5E", "5D", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5E", "4E", "3E"],
			wakeupslap: ["5L32", "4L29"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["5E", "4T", "4E"],
		},
	},
	delcatty: {
		inherit: true,
		learnset: {
			attract: ["5M", "5L1", "4M", "4L1", "3M", "3L1", "3S0"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleslap: ["5L1", "4L1", "3L1"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L1", "4L1"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["3L1"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M", "3S0"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["5L1", "4L1", "3L1"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["3S0"],
			swift: ["4T", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			wildcharge: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	sableye: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			astonish: ["5L11", "4L11", "3L13"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["5E", "4M"],
			confuseray: ["5L46", "4L46", "3L37"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			detect: ["5L22", "4L22", "3L25"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5L18", "4L18", "3L21"],
			feint: ["5E", "4E"],
			feintattack: ["5L32", "4L32", "3L29", "3S1"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			flatter: ["5E", "4E"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L4", "5D", "4L4", "3L5", "3S0"],
			foulplay: ["5L50", "5S2"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L15", "4L15", "3L17"],
			gravity: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T"],
			incinerate: ["5M"],
			knockoff: ["5L29", "4T", "4L29", "3L33"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			meanlook: ["5L60", "5E", "4L57", "3L45"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["5E"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["5E", "4E", "3E"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L8", "4L8", "3L9", "3S0"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			powergem: ["5L43", "4L43"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			punishment: ["5L36", "4L36"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5E", "4E", "3E", "3S1"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1", "3S0"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "5L57", "4M", "4L53", "3M", "3L41", "3S1"],
			shadowclaw: ["5M", "5L39", "4M", "4L39"],
			shadowsneak: ["5L25", "4L25"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["5D", "4T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5E", "5D", "4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "5S2", "4T"],
			waterpulse: ["4M", "3M"],
			willowisp: ["5M", "4M"],
			zenheadbutt: ["5L53", "4T", "4L50"],
		},
	},
	mawile: {
		inherit: true,
		learnset: {
			ancientpower: ["5E", "4T", "4E", "3E"],
			astonish: ["5L1", "4L1", "3L1", "3S0"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L31", "4L31", "3L31"],
			bite: ["5L11", "4L11", "3L11"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["5E", "4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			crunch: ["5L36", "4L36", "3L36"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L6", "5D", "4L6", "3L6", "3S0"],
			falseswipe: ["5M", "4E", "3E", "3S1"],
			feintattack: ["5L26", "4L26", "3L26"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5E", "5D", "4E"],
			flamethrower: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			guardswap: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5E", "4E"],
			icepunch: ["5D", "4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["5L41", "4T", "4L41", "3L41", "3S1"],
			ironhead: ["5L56", "4T", "4L56"],
			knockoff: ["4T"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["5E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			poisonfang: ["5E", "4E", "3E"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4E", "3T", "3E"],
			punishment: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M"],
			sing: ["3S1"],
			slam: ["5E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L51", "4L51", "3L46"],
			stockpile: ["5L51", "4L51", "3L46"],
			stoneedge: ["5M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L46", "5E", "4T", "4L46", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L51", "4L51", "3L46"],
			sweetscent: ["5L16", "4L16", "3L16"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			taunt: ["5M", "4M", "3M"],
			thunderfang: ["5E", "4E"],
			thunderpunch: ["4T", "3T"],
			tickle: ["5E", "4E", "3E"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			visegrip: ["5L21", "4L21", "3L21", "3S1"],
		},
	},
	aron: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L43"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			curse: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L50", "4L43", "3T", "3L44"],
			doubleteam: ["5M", "4M", "3M"],
			dragonrush: ["5E", "4E"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["5E", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["5L4", "4L4", "3L4"],
			headbutt: ["5L11", "4T", "4L11", "3L10"],
			headsmash: ["5E", "4E"],
			heavyslam: ["5L46"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			irondefense: ["5L18", "4T", "4L18", "3L17"],
			ironhead: ["5L29", "5E", "4T", "4L29", "4E"],
			irontail: ["5L39", "4M", "4L39", "3M", "3L29"],
			magnetrise: ["4T"],
			metalburst: ["5L53", "4L46"],
			metalclaw: ["5L15", "4L15", "3L13"],
			metalsound: ["5L36", "4L36", "3L39"],
			mimic: ["3T"],
			mudslap: ["5L8", "4T", "4L8", "3T", "3L7"],
			naturalgift: ["4M"],
			protect: ["5M", "5L32", "4M", "4L32", "3M", "3L34"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			screech: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["5E", "4E", "3E"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["5E", "4M"],
			stomp: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5E", "4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L25", "4L25", "3L25"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	lairon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L51"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L62", "4L51", "3T", "3L53"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			heavyslam: ["5L56"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			irondefense: ["5L18", "4T", "4L18", "3L17"],
			ironhead: ["5L29", "4T", "4L29"],
			irontail: ["5L45", "4M", "4L45", "3M", "3L29"],
			magnetrise: ["4T"],
			metalburst: ["5L67", "4L56"],
			metalclaw: ["5L15", "4L15", "3L13"],
			metalsound: ["5L40", "4L40", "3L45"],
			mimic: ["3T"],
			mudslap: ["5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			protect: ["5M", "5L34", "4M", "4L34", "3M", "3L37"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L25", "4L25", "3L25"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
		},
	},
	aggron: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			autotomize: ["5L57"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5L74", "4L57", "3T", "3L63", "3S0"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			heavyslam: ["5L65"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irondefense: ["5L18", "4T", "4L18", "3L17"],
			ironhead: ["5L29", "4T", "4L29"],
			irontail: ["5L48", "4M", "4L48", "3M", "3L29", "3S0", "3S1"],
			lowkick: ["4T"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalburst: ["5L82", "4L65"],
			metalclaw: ["5L15", "4L15", "3L13"],
			metalsound: ["5L40", "4L40", "3L50", "3S0", "3S1"],
			mimic: ["3T"],
			mudslap: ["5L1", "4T", "4L1", "3T", "3L1"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "5L34", "4M", "4L34", "3M", "3L37", "3S0", "3S1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L22", "4M", "4L22", "3M", "3L21"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L25", "4L25", "3L25", "3S1"],
			taunt: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	meditite: {
		inherit: true,
		learnset: {
			acupressure: ["5L39"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bide: ["5L1", "4L1", "3L1", "3S0"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulletpunch: ["5E", "4E"],
			calmmind: ["5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confusion: ["5L8", "4L8", "3L9", "3S0", "3S1"],
			counter: ["3T"],
			detect: ["5L11", "4L11", "3L12", "3S1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["5E", "5D", "4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["5E", "4E", "3T", "3E", "3S1"],
			endure: ["5D", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E", "3E"],
			feint: ["5L22", "4L22"],
			firepunch: ["5E", "4T", "4E", "3T", "3E"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["5L29", "4L29"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			guardswap: ["5E", "4E"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["5L32", "4L32", "3L32"],
			icepunch: ["5E", "4T", "4E", "3T", "3E"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			meditate: ["5L4", "5D", "4L4", "3L4", "3S0"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			poisonjab: ["5M", "4M"],
			powerswap: ["5E", "4E"],
			powertrick: ["5L43", "4L39"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychocut: ["5E", "4E"],
			psychup: ["5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L50", "4L46", "3L44"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L46", "4L43", "3L41"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["5E", "4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M", "3S1"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["5E", "4T", "4E", "3T", "3E"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			vacuumwave: ["4T"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	medicham: {
		inherit: true,
		learnset: {
			acupressure: ["5L42"],
			attract: ["5M", "4M", "3M"],
			bide: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			calmmind: ["5M", "5L25", "4M", "4L25", "3M", "3L28"],
			captivate: ["4M"],
			confusion: ["5L1", "4L1", "3L1"],
			counter: ["3T"],
			detect: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L22", "4L22"],
			firepunch: ["5L1", "4T", "4L1", "3T", "3L1"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			forcepalm: ["5L29", "4L29"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "5L15", "4M", "4L15", "3M", "3L17"],
			highjumpkick: ["5L32", "4L32", "3L32"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["5L1", "4T", "4L1", "3T", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			meditate: ["5L1", "4L1", "3L1"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mindreader: ["5L18", "4L18", "3L22"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			poisonjab: ["5M", "4M"],
			powertrick: ["5L49", "4L42"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "5L36", "4M", "4L36", "3T", "3L36"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L62", "4L55", "3L54"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			reversal: ["5L55", "4L49", "3L46"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T", "3L20"],
			swift: ["4T", "3T"],
			telekinesis: ["5M"],
			thunderpunch: ["5L1", "4T", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			vacuumwave: ["4T"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	electrike: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L28", "4L28", "3L33"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["5L44", "4L44", "3L41"],
			chargebeam: ["5M", "4M"],
			crunch: ["5E", "4E", "3E"],
			curse: ["5E", "4E", "3E"],
			discharge: ["5L41", "5E", "4L41", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			electroball: ["5E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5E", "4E"],
			flameburst: ["5E"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L12", "4L12", "3L12"],
			icefang: ["5E", "5D", "4E"],
			irontail: ["4M", "3M"],
			leer: ["5L9", "4L9", "3L9"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L25", "4L25", "3L25"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L17", "4L17", "3L17"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L36", "4M", "4L36", "3M", "3L28"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shockwave: ["5E", "4M", "3M"],
			signalbeam: ["5D", "4T"],
			sleeptalk: ["4M", "3T"],
			snarl: ["5E"],
			snore: ["4T", "3T"],
			spark: ["5L20", "4L20", "3L20"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5E", "4T", "4E", "3T", "3E"],
			switcheroo: ["5E", "4E"],
			tackle: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "5L52", "4M", "4L49", "3M", "3L36"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L33", "5E", "4L33", "4E"],
			thunderwave: ["5M", "5L4", "5D", "4M", "4L4", "3T", "3L4"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["5E", "4E", "3E"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L49"],
		},
	},
	manectric: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L30", "4L30", "3L39", "3S0"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["5L54", "4L54", "3L53"],
			chargebeam: ["5M", "4M"],
			discharge: ["5L49", "4L49"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firefang: ["5L1", "4L1"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5L1", "4L1", "3L1"],
			hyperbeam: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L25", "4L25", "3L25"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L17", "4L17", "3L17"],
			raindance: ["5M", "4M", "3M", "3S0"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "5L42", "4M", "4L42", "3M", "3L31"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L20", "4L20", "3L20"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "5L66", "4M", "4L61", "3M", "3L45", "3S0"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderfang: ["5L37", "4L37"],
			thunderwave: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			toxic: ["5M", "4M", "3M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L61"],
		},
	},
	plusle: {
		inherit: true,
		learnset: {
			agility: ["5L48", "4L44", "3L47"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L44", "4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["5L38", "4L35", "3L31"],
			chargebeam: ["5M", "4M"],
			copycat: ["5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			electroball: ["5L29"],
			encore: ["5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["5L63"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L21", "4L21", "3L28"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["5L51", "4T", "4L48"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5L56", "4L51"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L7", "4L7", "3L10", "3S1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5D", "4T"],
			sing: ["5E", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L15", "4L15", "3L19"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5E", "4E"],
			swift: ["5L31", "4T", "4L29", "3T"],
			thunder: ["5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "5L3", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			voltswitch: ["5M"],
			watersport: ["3S0"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E"],
		},
	},
	minun: {
		inherit: true,
		learnset: {
			agility: ["5L48", "4L44", "3L47"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L44", "4L42", "3L40"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			charge: ["5L38", "4L35", "3L31"],
			chargebeam: ["5M", "4M"],
			charm: ["5L21", "4L21", "3L28"],
			copycat: ["5L24", "4L24"],
			counter: ["3T"],
			defensecurl: ["3T"],
			discharge: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			echoedvoice: ["5M"],
			electroball: ["5L29"],
			encore: ["5L17", "4L17", "3L22"],
			endure: ["4M", "3T"],
			entrainment: ["5L63"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5L35", "4L31"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			headbutt: ["4T"],
			helpinghand: ["5L10", "4T", "4L10", "3L13"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["4M", "3M"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["3S0"],
			nastyplot: ["5L56", "4L51"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5L7", "4L7", "3L10", "3S1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5D", "4T"],
			sing: ["5E", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spark: ["5L15", "4L15", "3L19"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5E", "4E"],
			swift: ["5L31", "4T", "4L29", "3T"],
			thunder: ["5M", "5L42", "4M", "4L38", "3M", "3L37"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "5L3", "4M", "4L3", "3T", "3L4", "3S0", "3S1"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5L51", "4L48"],
			uproar: ["4T"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E"],
		},
	},
	volbeat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L41", "5E", "4L41", "4E"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L9", "4L9", "3L5"],
			counter: ["3T"],
			dizzypunch: ["5E"],
			doubleedge: ["5L45", "4L45", "3T", "3L37"],
			doubleteam: ["5M", "5L5", "4M", "4L5", "3M", "3L9"],
			dynamicpunch: ["3T"],
			encore: ["5E", "4E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "5L1", "5D", "4M", "4L1", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			helpinghand: ["5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "5L29", "4M", "4L29", "3M", "3L29"],
			psychup: ["5M", "4M", "3T"],
			quickattack: ["5L17", "4L17", "3L17"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["5E", "3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["5L25", "4T", "4L25", "3L25"],
			silverwind: ["5E", "4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailglow: ["5L21", "4L21", "3L21"],
			tailwind: ["5D", "4T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "5D", "4E", "3E"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			zenheadbutt: ["5L37", "4T", "4L37"],
		},
	},
	illumise: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bugbite: ["4T"],
			bugbuzz: ["5L41", "5E", "4L41", "4E"],
			captivate: ["5E", "4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L9", "5D", "4L9", "3L9"],
			confuseray: ["5E"],
			counter: ["3T"],
			covet: ["5L45", "4L45", "3L37"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			encore: ["5L25", "5E", "4L25", "4E", "3L25"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E", "5D"],
			flash: ["5M", "4M", "3M"],
			flatter: ["5L29", "4L29", "3L29"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigadrain: ["4M", "3M"],
			growth: ["5E", "4E", "3E"],
			helpinghand: ["5L33", "4T", "4L33", "3L33"],
			hiddenpower: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			lightscreen: ["5M", "4M", "3M"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			moonlight: ["5L13", "4L13", "3L13"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			quickattack: ["5L17", "4L17", "3L17"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			silverwind: ["5E", "4M", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L5", "4L5", "3L5"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["5D", "4T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			wish: ["5L21", "4L21", "3L21"],
			zenheadbutt: ["5L37", "4T", "4L37"],
		},
	},
	budew: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			cottonspore: ["5E", "4E"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			extrasensory: ["5E", "4E"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["5E", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5E"],
			growth: ["5L4", "4L4"],
			hiddenpower: ["5M", "4M"],
			leafstorm: ["5E", "4E"],
			megadrain: ["5L13", "4L13"],
			mindreader: ["5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["5E", "4M"],
			pinmissile: ["5E", "4E"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			razorleaf: ["5E", "4E"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			seedbomb: ["5E", "4T"],
			shadowball: ["5M", "4M"],
			sleeppowder: ["5E", "4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			spikes: ["5E", "4E"],
			stunspore: ["5L10", "4L10"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5E", "4T", "4E"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			watersport: ["5L7", "4L7"],
			worryseed: ["5L16", "4T", "4L16"],
		},
	},
	roselia: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1", "3S0"],
			aromatherapy: ["5L43", "4L43", "3L53"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["5L25", "5E", "4M", "4L25", "3M", "3L33"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L22", "5E", "4L22", "3L29", "3S1"],
			growth: ["5L4", "4L4", "3L5", "3S0"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5L34", "4L34", "3L41"],
			leafstorm: ["5E", "4E"],
			leechseed: ["5L16", "4L16", "3L21", "3S1"],
			magicalleaf: ["5L19", "4L19", "3L25", "3S1"],
			megadrain: ["5L13", "4L13", "3L17"],
			mimic: ["3T"],
			mindreader: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5E", "4M"],
			nightmare: ["3T"],
			petaldance: ["5L40", "4L40", "3L49"],
			pinmissile: ["5E", "4E", "3E"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L7", "4L7", "3L9", "3S0"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M"],
			razorleaf: ["5E", "4E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5E", "4T"],
			shadowball: ["5M", "4M", "3M"],
			sleeppowder: ["5E", "4E"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5E", "4E", "3E"],
			stunspore: ["5L10", "4L10", "3L13"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["3S1"],
			sweetscent: ["5L31", "4L31", "3L37"],
			swift: ["5D", "4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L46", "5E", "4T", "4L46", "4E", "3L57", "3E"],
			toxic: ["5M", "5L37", "4M", "4L37", "3M", "3L45"],
			toxicspikes: ["5L28", "4L28"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	roserade: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			magicalleaf: ["5L1", "4L1"],
			megadrain: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			sweetscent: ["5L1", "4L1"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			toxic: ["5M", "4M"],
			venoshock: ["5M"],
			weatherball: ["5L1", "4L1"],
			worryseed: ["4T"],
		},
	},
	gulpin: {
		inherit: true,
		learnset: {
			acidarmor: ["5E", "4E", "3E"],
			acidspray: ["5L34"],
			amnesia: ["5L17", "4L17", "3L17"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			curse: ["5E", "4E"],
			defensecurl: ["3T"],
			destinybond: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "4E", "3T", "3E"],
			dynamicpunch: ["3T"],
			encore: ["5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L49", "4T", "4L44"],
			gigadrain: ["5D", "4M", "3M"],
			gunkshot: ["5L59", "5E", "4T", "4L54"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["5E", "4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["5E", "4T", "4E", "3E"],
			poisongas: ["5L9", "4L9", "3L9"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M", "3S0"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L14", "4L14", "3L14", "3S0"],
			sludgebomb: ["5M", "5L44", "4M", "4L39", "3M", "3L39"],
			sludgewave: ["5M"],
			smog: ["5E", "4E", "3E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L39", "4L34", "3L34"],
			stockpile: ["5L39", "4L34", "3L34"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L39", "4L34", "3L34"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "5L28", "4M", "4L28", "3M", "3L28", "3S0"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
			wringout: ["5L54", "4L49"],
			yawn: ["5L6", "4L6", "3L6"],
		},
	},
	swalot: {
		inherit: true,
		learnset: {
			acidspray: ["5L38"],
			amnesia: ["5L17", "4L17", "3L17"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["5L26", "4L26", "3T", "3L26"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			counter: ["3T"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M"],
			encore: ["5L23", "4L23", "3L23"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L59", "4T", "4L52"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["5L73", "4T", "4L66"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			painsplit: ["4T"],
			poisongas: ["5L1", "4L1", "3L1"],
			pound: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludge: ["5L1", "4L1", "3L1"],
			sludgebomb: ["5M", "5L52", "4M", "4L45", "3M", "3L48"],
			sludgewave: ["5M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L45", "4L38", "3L40"],
			stockpile: ["5L45", "4L38", "3L40"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L45", "4L38", "3L40"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "5L30", "4M", "4L30", "3M", "3L31"],
			venoshock: ["5M"],
			waterpulse: ["4M", "3M"],
			wringout: ["5L66", "4L59"],
			yawn: ["5L1", "4L1", "3L1"],
		},
	},
	carvanha: {
		inherit: true,
		learnset: {
			agility: ["5L36", "4L36", "3L43"],
			ancientpower: ["5E", "4T", "4E"],
			aquajet: ["5L31", "4L31"],
			assurance: ["5L26", "4L26"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "5D", "4L1", "3L1", "3S0"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5E", "4M"],
			captivate: ["4M"],
			crunch: ["5L28", "4L28", "3L22"],
			darkpulse: ["5D", "4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			focusenergy: ["5L8", "4L8", "3L13"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L16", "4L16"],
			icywind: ["4T", "3T"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L6", "4L6", "3L7"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L11", "4L11", "3L16", "3S0"],
			screech: ["5L18", "4L18", "3L28"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L21", "4M", "4L21", "3T", "3L37"],
			swift: ["5E", "4T", "3T"],
			takedown: ["5L38", "4L38", "3L31"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5E", "5D", "4E", "3E"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M", "3S0"],
			whirlpool: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	sharpedo: {
		inherit: true,
		learnset: {
			agility: ["5L45", "4L45", "3L53"],
			ancientpower: ["4T"],
			aquajet: ["5L34", "4L34"],
			assurance: ["5L26", "4L26"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L28", "4L28", "3L22"],
			darkpulse: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L1", "4L1"],
			focusenergy: ["5L1", "4L1", "3L1"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L16", "4L16"],
			icywind: ["4T", "3T"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L56", "4L56"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L11", "4L11", "3L16"],
			screech: ["5L18", "4L18", "3L28"],
			secretpower: ["4M", "3M"],
			skullbash: ["5L50", "4L50", "3L48"],
			slash: ["5L30", "4L30", "3L33"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L21", "4M", "4L21", "3T", "3L43"],
			swift: ["4T", "3T"],
			taunt: ["5M", "5L40", "4M", "4L40", "3M", "3L38"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	wailmer: {
		inherit: true,
		learnset: {
			amnesia: ["5L37", "4L37", "3L46"],
			aquaring: ["5E", "4E"],
			astonish: ["5L17", "4L17", "3L23"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T"],
			bounce: ["5L44", "5D", "4T", "4L44"],
			brine: ["5L31", "4M", "4L31"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["5E", "4E", "3T"],
			dive: ["5M", "5L41", "4T", "4L41", "3M"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L4", "4L4", "3L5"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["5L50"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L47", "4L47", "3L50"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mist: ["5L24", "4L24", "3L32"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L27", "4M", "4L27", "3M", "3L37"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L11", "4T", "4L11", "3T", "3L14"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["5E", "5D", "4M", "4E", "3T", "3E"],
			snore: ["5E", "4T", "4E", "3T", "3E"],
			soak: ["5E"],
			splash: ["5L1", "4L1", "3L1"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "4E", "3T", "3E"],
			thrash: ["5E", "4E", "3E"],
			tickle: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L7", "5D", "4L7", "3L10"],
			waterpulse: ["5L21", "4M", "4L21", "3M", "3L28"],
			waterspout: ["5L34", "4L34", "3L41"],
			whirlpool: ["5L14", "4M", "4L14", "3L19"],
			zenheadbutt: ["5E"],
		},
	},
	wailord: {
		inherit: true,
		learnset: {
			amnesia: ["5L37", "4L37", "3L52", "3S0"],
			astonish: ["5L17", "4L17", "3L23"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			bounce: ["5L54", "4T", "4L54"],
			brine: ["5L31", "4M", "4L31"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dive: ["5M", "5L46", "4T", "4L46", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			heavyslam: ["5L70"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L62", "4L62", "3L59", "3S0"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			mist: ["5L24", "4L24", "3L32", "3S1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L27", "4M", "4L27", "3M", "3L37", "3S0", "3S1"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5L1", "4T", "4L1", "3T", "3L1"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["5L1", "4L1", "3L1"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5L21", "4M", "4L21", "3M", "3L28", "3S1"],
			waterspout: ["5L34", "4L34", "3L44", "3S0", "3S1"],
			whirlpool: ["5L14", "4M", "4L14", "3L19"],
		},
	},
	numel: {
		inherit: true,
		learnset: {
			amnesia: ["5L31", "4L25", "3L31"],
			ancientpower: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5E", "5D", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			defensecurl: ["5E", "4E", "3T", "3E"],
			dig: ["5M", "4M", "3M", "3S0"],
			doubleedge: ["5L55", "4L51", "3T", "3L49"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L41", "4T", "4L35"],
			earthquake: ["5M", "5L45", "4M", "4L41", "3M", "3L35"],
			echoedvoice: ["5M"],
			ember: ["5L5", "5D", "4L5", "3L11", "3S0"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flameburst: ["5L21"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L51", "4M", "4L45", "3M", "3L41"],
			focusenergy: ["5L15", "4L15", "3L25"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["5E", "5D", "4T", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			howl: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			ironhead: ["5E"],
			lavaplume: ["5L35", "4L31"],
			magnitude: ["5L11", "4L11", "3L19"],
			mimic: ["3T"],
			mudbomb: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5E", "4T", "4E", "3T", "3E"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5E", "4E", "3E"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E"],
			stealthrock: ["4M"],
			stockpile: ["5E", "4E"],
			stomp: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L25", "4L21", "3L29", "3S0"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
			yawn: ["5E", "4E"],
		},
	},
	camerupt: {
		inherit: true,
		learnset: {
			amnesia: ["5L31", "4L25", "3L31"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L49", "4T", "4L39"],
			earthquake: ["5M", "5L57", "4M", "4L49", "3M", "3L37"],
			echoedvoice: ["5M"],
			ember: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			eruption: ["5L67", "4L57", "3L45"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			fissure: ["5L75", "4L67", "3L55"],
			flameburst: ["5L21"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5L15", "4L15", "3L25"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			lavaplume: ["5L33", "4L31"],
			magnitude: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5L39", "4M", "4L33", "3T", "3L33"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L25", "4L21", "3L29"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
		},
	},
	torkoal: {
		inherit: true,
		learnset: {
			amnesia: ["5L49", "4L49", "3L40"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["5L33", "4L33", "3T", "3L20"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			curse: ["5L12", "4L12", "3L7"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "4E"],
			ember: ["5L1", "5D", "4L1", "3L1"],
			endure: ["5E", "4M", "4E", "3T", "3E"],
			eruption: ["5E", "4E", "3E"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firespin: ["5L17", "4L17", "3L17"],
			fissure: ["5E", "5D", "4E"],
			flail: ["5L52", "4L52", "3L43"],
			flameburst: ["5E"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L28", "4M", "4L28", "3M", "3L30"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5L55", "4T", "4L55", "3L46"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			inferno: ["5L60"],
			irondefense: ["5L44", "4T", "4L44", "3L33"],
			irontail: ["4M", "3M"],
			lavaplume: ["5L39", "4L39"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "5L36", "4M", "4L36", "3M", "3L27"],
			rapidspin: ["5L23", "4L23"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shellsmash: ["5L65"],
			skullbash: ["5E", "4E"],
			sleeptalk: ["5E", "4M", "4E", "3T", "3E"],
			sludgebomb: ["5M", "4M", "3M"],
			smog: ["5L4", "4L4", "3L4"],
			smokescreen: ["5L20", "4L20", "3L14"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["5D", "4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			willowisp: ["5M", "4M"],
			withdraw: ["5L7", "4L7"],
			yawn: ["5E", "4E", "3E"],
		},
	},
	spoink: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5L53", "4T", "4L48", "3L43"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L18", "4L18", "3L25"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			endure: ["5E", "4M", "3T"],
			extrasensory: ["5E", "4E", "3E"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			luckychant: ["5E"],
			magiccoat: ["5L21", "4T", "4L21", "3L28"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["5L10", "4L10", "3L10"],
			payback: ["5M", "5L41", "4M", "4L34"],
			powergem: ["5L48", "4L46"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L14", "4L14", "3L16"],
			psychic: ["5M", "5L46", "4M", "4L41", "3M", "3L34"],
			psychup: ["5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["5M", "5L34"],
			psywave: ["5L7", "5D", "4L7", "3L7"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["5D", "4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "5L29", "4M", "4L29", "3M", "3L37"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "5D", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["5L29", "4T", "4L29", "3T", "3L37"],
			splash: ["5L1", "4L1", "3L1", "3S0"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "4T", "4E", "3E"],
			trickroom: ["5M", "4M"],
			uproar: ["3S0"],
			whirlwind: ["5E"],
			zenheadbutt: ["5L26", "5E", "4T", "4L26", "4E"],
		},
	},
	grumpig: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["5L68", "4T", "4L60", "3L55"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L18", "4L18", "3L25"],
			counter: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["5L21", "4T", "4L21", "3L28"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			odorsleuth: ["5L1", "4L1", "3L1"],
			payback: ["5M", "5L47", "4M", "4L37"],
			powergem: ["5L60", "4L55"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L1", "4L1", "3L1"],
			psychic: ["5M", "5L55", "4M", "4L47", "3M", "3L37"],
			psychup: ["5M", "5L15", "4M", "4L15", "3T", "3L19"],
			psyshock: ["5M", "5L37"],
			psywave: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "5L29", "4M", "4L29", "3M", "3L43"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["5L29", "4T", "4L29", "3T", "3L43"],
			splash: ["5L1", "4L1", "3L1"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["5L26", "4T", "4L26"],
		},
	},
	spinda: {
		inherit: true,
		learnset: {
			assist: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			copycat: ["5L10", "5D", "4L10"],
			counter: ["3T"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E", "3E"],
			dizzypunch: ["5L28", "4L28", "3L27"],
			doubleedge: ["5L46", "4L46", "3T", "3L45"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			encore: ["5E", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "5D", "4E"],
			faketears: ["5E"],
			feintattack: ["5L14", "4L14", "3L12"],
			firepunch: ["4T", "3T"],
			flail: ["5L50", "4L50", "3L49"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5L23", "4L23", "3L23"],
			icepunch: ["4T", "3T"],
			icywind: ["5E", "4T", "3T"],
			lastresort: ["4T"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L19", "4L19", "3L16"],
			psychic: ["5M", "4M", "3M"],
			psychocut: ["5E", "4E"],
			psychup: ["5M", "5L41", "4M", "4L41", "3T", "3L38"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5E"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["5E", "4T", "4E"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sing: ["3S0"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["5E", "4E", "3E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L32", "4T", "4L32"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5D"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			teeterdance: ["5L37", "4L37", "3L34"],
			thief: ["5M", "4M", "3M"],
			thrash: ["5L55", "4L55", "3L56"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "4E", "3E"],
			trickroom: ["5M", "4M"],
			uproar: ["5L5", "4T", "4L5", "3L5", "3S0"],
			waterpulse: ["5E", "4M", "3M"],
			wildcharge: ["5M"],
			wish: ["5E", "4E", "3E"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	trapinch: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "5D", "5S0", "4L1", "3L1"],
			bodyslam: ["3T"],
			bugbite: ["5E", "4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L33", "4L33", "3L33"],
			dig: ["5M", "5L41", "4M", "4L41", "3M", "3L41"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5L65", "5E", "4T", "4L65"],
			earthquake: ["5M", "5L73", "4M", "4L73", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feint: ["5L81", "4L81"],
			feintattack: ["5L17", "4L17", "3L17"],
			fissure: ["5L89", "4L89"],
			flail: ["5E", "4E"],
			focusenergy: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5E", "4T", "4E"],
			gigadrain: ["5D", "4M", "3M"],
			gust: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudshot: ["5E", "4E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			quickattack: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5L9", "4L9", "3L9"],
			sandstorm: ["5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["5L25", "4L25", "3L25"],
			secretpower: ["4M", "3M"],
			signalbeam: ["5E", "5D"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
		},
	},
	vibrava: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			bugbite: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["3L33"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L35", "4L35", "3L35"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L1", "4L1", "3L1"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T"],
			gigadrain: ["4M", "3M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L57", "4M", "4L57", "3M", "3L57"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "5L49", "4M", "4L49", "3M", "3L49"],
			sandtomb: ["5L1", "4L1", "3L1"],
			screech: ["5L41", "4L41", "3L41"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			sonicboom: ["5L1", "4L1"],
			steelwing: ["4M", "3M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L33", "4L33"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
		},
	},
	flygon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			attract: ["5M", "4M", "3M"],
			bite: ["3L1"],
			bodyslam: ["3T"],
			bugbite: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["3L33", "3S0"],
			defog: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T", "4S1"],
			dragonbreath: ["5L35", "4L35", "3L35", "3S0"],
			dragonclaw: ["5M", "5L45", "4M", "4L45", "4S1", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M", "5L65"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "4S1", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L1", "4L1", "3L1"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L57", "4M", "4L57", "3M", "3L65"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1", "3L1"],
			sandstorm: ["5M", "5L49", "4M", "4L49", "3M", "3L53"],
			sandtomb: ["5L1", "4L1", "3L1", "3S0"],
			screech: ["5L41", "4L41", "3L41", "3S0"],
			secretpower: ["4M", "3M"],
			silverwind: ["4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			sonicboom: ["5L1", "4L1"],
			steelwing: ["4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			supersonic: ["5L33", "4L33"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uturn: ["5M", "4M", "4S1"],
		},
	},
	cacnea: {
		inherit: true,
		learnset: {
			absorb: ["5L5", "5D", "4L5", "3L5", "3S0"],
			acid: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			block: ["5E"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["5L49", "4L49", "3L41"],
			counter: ["5E", "4E", "3T", "3E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			destinybond: ["5L57", "4L57", "3L49"],
			disable: ["5E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["5E", "4E", "3T", "3E"],
			encore: ["3S0"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L29", "4L29", "3L29"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5E", "4E", "3E"],
			growth: ["5L9", "4L9", "3L9"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5L25", "4L25", "3L25"],
			leechseed: ["5L13", "4L13", "3L13"],
			leer: ["5L1", "4L1", "3L1", "3S0"],
			lowkick: ["5E", "4T", "4E"],
			magicalleaf: ["5E", "4E"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			needlearm: ["5L45", "4L45", "3L37"],
			payback: ["5M", "5L41", "4M", "4L41"],
			pinmissile: ["5L21", "4L21", "3L21"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1", "3S0"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L17", "4L17", "3L17"],
			sandstorm: ["5M", "5L53", "4M", "4L53", "3M", "3L45"],
			secretpower: ["4M", "3M"],
			seedbomb: ["5E", "4T", "4E"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			smellingsalts: ["5E", "4E"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5L33", "4L33", "3L33"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L37", "4T", "4L37"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			switcheroo: ["5E"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			teeterdance: ["5E", "5D", "4E", "3E"],
			thunderpunch: ["5D", "4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["5E", "4T"],
		},
	},
	cacturne: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			cottonspore: ["5L59", "4L59", "3L47"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			destinybond: ["5L71", "4L71", "3L59"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L29", "4L29", "3L29", "3S0"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			ingrain: ["5L25", "4L25", "3L25", "3S0"],
			leechseed: ["5L13", "4L13", "3L13"],
			leer: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			needlearm: ["5L53", "4L53", "3L41", "3S0"],
			payback: ["5M", "5L47", "4M", "4L47"],
			pinmissile: ["5L21", "4L21", "3L21"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			revenge: ["5L1", "4L1", "3L1"],
			roleplay: ["4T"],
			round: ["5M"],
			sandattack: ["5L17", "4L17", "3L17"],
			sandstorm: ["5M", "5L65", "4M", "4L65", "3M", "3L53"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			seismictoss: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5L35", "4L35", "3L35", "3S0"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L41", "4T", "4L41"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["4T"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	swablu: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5E", "4E", "3E"],
			aircutter: ["4T"],
			astonish: ["5L5", "4L5", "3L8"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			cottonguard: ["5L40"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["5L50", "4M", "4L45"],
			dragonrush: ["5E", "4E"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["3S0"],
			featherdance: ["5E", "5D", "4E"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L13", "4L13", "3L18"],
			growl: ["5L1", "5S1", "4L1", "3L1", "3S0"],
			haze: ["5E", "4E", "3E"],
			healbell: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypervoice: ["5E"],
			icebeam: ["5M", "4M", "3M"],
			mimic: ["3T"],
			mirrormove: ["5L36", "4L36", "3L38"],
			mist: ["5L23", "4L23", "3L28"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L32", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			peck: ["5L1", "5D", "5S1", "4L1", "3L1", "3S0"],
			perishsong: ["5L55", "4L50", "3L48"],
			pluck: ["5M", "4M"],
			powerswap: ["5E", "4E"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5E", "4E", "3E"],
			rage: ["5E", "4E", "3E"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5L45", "4L40", "3L41"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roost: ["5E", "5D", "4M"],
			round: ["5M"],
			safeguard: ["5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["4M", "3M"],
			sing: ["5L9", "4L9", "3L11"],
			skyattack: ["3T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["5E", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			takedown: ["5L28", "4L28", "3L31"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
		},
	},
	altaria: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M", "3S1"],
			aircutter: ["4T"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cottonguard: ["5L46"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L35", "5S2", "4L35", "3L35", "3S0", "3S1"],
			dragonclaw: ["5M", "4M", "3M"],
			dragondance: ["5L39", "4L39", "3L40", "3S0"],
			dragonpulse: ["5L62", "4M", "4L54"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5S2"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furyattack: ["5L13", "4L13", "3L18"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			healbell: ["4T", "3S1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mist: ["5L23", "4L23", "3L28"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L32", "5S2", "4M", "4L32"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			peck: ["5L1", "4L1", "3L1"],
			perishsong: ["5L70", "4L62", "3L54"],
			pluck: ["5M", "5L1", "4M", "4L1"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5L54", "4L46", "3L45", "3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L18", "4M", "4L18", "3M", "3L21"],
			secretpower: ["4M", "3M"],
			sing: ["5L1", "4L1", "3L1"],
			skyattack: ["5L77", "4T", "4L70", "3T", "3L59"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M", "3S1"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			takedown: ["5L28", "5S2", "4L28", "3L31", "3S0"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			uproar: ["4T"],
		},
	},
	zangoose: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M", "3S2"],
			captivate: ["4M"],
			closecombat: ["5L53", "4L53"],
			counter: ["5E", "4E", "3T", "3E", "3S2"],
			crushclaw: ["5L31", "4L31", "3L31", "3S2"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["3T"],
			detect: ["5L40", "4L40", "3L46"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E"],
			doubleedge: ["3T"],
			doublehit: ["5E", "4E"],
			doublekick: ["5E", "4E", "3E"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			embargo: ["5M", "5L27", "4M", "4L27"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "5L44", "4M", "4L44", "3L55"],
			feint: ["5E"],
			finalgambit: ["5E"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flail: ["5E", "4E", "3E"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L14", "4T", "4L14", "3T", "3L13", "3S0"],
			furyswipes: ["5E", "4E"],
			gigadrain: ["4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["5E", "4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			leer: ["5L1", "4L1", "3L4", "3S0", "3S1"],
			lowkick: ["5D", "4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["5E", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			pursuit: ["5L22", "4L22", "3L25"],
			quickattack: ["5L5", "4L5", "3L7", "3S0", "3S1"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5E", "4E", "3E"],
			refresh: ["3S2"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "4E", "3M", "3E"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1", "3S1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L18", "4L18", "3L19"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L9", "4M", "4L9", "3T", "3L10", "3S0", "3S1"],
			taunt: ["5M", "5L35", "4M", "4L35", "3M", "3L37"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
			xscissor: ["5M", "5L48", "4M", "4L48"],
		},
	},
	seviper: {
		inherit: true,
		learnset: {
			aquatail: ["5D", "4T"],
			assurance: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L10", "4L10", "3L10", "3S0", "3S2"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			coil: ["5L64"],
			crunch: ["5L28", "4L28", "3L28", "3S1"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragontail: ["5M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			finalgambit: ["5E"],
			flamethrower: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			glare: ["5L25", "4L25", "3L25", "3S1"],
			haze: ["5L43", "4L43", "3L43"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			irontail: ["5E", "4M", "3M"],
			knockoff: ["4T"],
			lick: ["5L7", "4L7", "3L7", "3S0", "3S2"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L46", "5E", "4L46", "4E"],
			payback: ["5M", "4M"],
			poisonfang: ["5L34", "4L34", "3L34"],
			poisonjab: ["5M", "5L52", "4M", "4L52"],
			poisontail: ["5L16", "4L16", "3L16", "3S0", "3S1"],
			protect: ["5M", "4M", "3M"],
			punishment: ["5E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5E", "4E"],
			screech: ["5L19", "4L19", "3L19", "3S1"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spitup: ["5E", "4E", "3E"],
			stockpile: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "5L37", "4M", "4L37", "3T", "3L37"],
			swallow: ["5E", "4E", "3E"],
			swift: ["4T", "3T"],
			switcheroo: ["5E", "4E"],
			taunt: ["5M", "4M", "3M"],
			thief: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			venoshock: ["5M", "5L55"],
			wrap: ["5L1", "4L1", "3L1", "3S0", "3S2"],
			wringout: ["5L61", "5E", "4L55"],
			xscissor: ["5M", "4M"],
		},
	},
	lunatone: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			blizzard: ["5M", "4M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L7", "3S0"],
			cosmicpower: ["5L34", "4L34", "3L31"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["5D", "4T"],
			earthquake: ["5M", "4M", "3M"],
			embargo: ["5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L53", "4L53", "3L43"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1", "3S0"],
			healblock: ["5L42", "4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			hypnosis: ["5L12", "4L12", "3L19"],
			icebeam: ["5M", "4M", "3M"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			magicroom: ["5L64"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L45", "4M", "4L45", "3M", "3L37", "3S1"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			psywave: ["5L23", "4L23", "3L25"],
			raindance: ["5M", "4M", "3M", "3S1"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "5L20", "4M", "4L20"],
			rockslide: ["5M", "4M", "3T"],
			rockthrow: ["5L9", "4L9", "3L13"],
			rocktomb: ["5M", "4M", "3M", "3S1"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	solrock: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			ancientpower: ["4T"],
			batonpass: ["3S1"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L7", "3S0"],
			cosmicpower: ["5L34", "4L34", "3L31", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			embargo: ["5M", "5L31", "4M", "4L31"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L56", "4M", "4L56", "3T", "3L49"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firespin: ["5L12", "4L12", "3L19"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1", "3S0"],
			healblock: ["5L42", "4L42"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M", "3S1"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			psywave: ["5L23", "4L23", "3L25"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "5L20", "4M", "4L20"],
			rockslide: ["5M", "5L45", "4M", "4L45", "3T", "3L37"],
			rockthrow: ["5L9", "4L9", "3L13"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L53", "4M", "4L53", "3M", "3L43"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M", "3S1"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "4M"],
			wonderroom: ["5L64"],
			zenheadbutt: ["5D", "4T"],
		},
	},
	barboach: {
		inherit: true,
		learnset: {
			amnesia: ["5L18", "4L18", "3L21"],
			aquatail: ["5L35", "4T", "4L35"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E"],
			earthpower: ["5E", "4T"],
			earthquake: ["5M", "5L39", "4M", "4L39", "3M", "3L31"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5L47", "4L47", "3L41"],
			flail: ["5E", "4E"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L43", "4L43", "3L36"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5E", "4E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["5L14", "4L14"],
			muddywater: ["5E"],
			mudshot: ["5E"],
			mudslap: ["5L1", "5D", "4T", "4L1", "3T", "3L1"],
			mudsport: ["5L6", "4L6", "3L6"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L31", "4M", "4L31", "3M", "3L26"],
			return: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["5D", "4M", "3T"],
			snore: ["5L31", "4T", "4L31", "3T", "3L26"],
			spark: ["5E", "5D", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			takedown: ["5E", "4E"],
			thrash: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L11"],
			waterpulse: ["5L22", "4M", "4L22", "3M"],
			watersport: ["5L6", "4L6", "3L6"],
			whirlpool: ["5E", "4M", "4E", "3E"],
		},
	},
	whiscash: {
		inherit: true,
		learnset: {
			amnesia: ["5L18", "4L18", "3L21"],
			aquatail: ["5L39", "4T", "4L39", "4S0"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L45", "4M", "4L45", "4S0", "3M", "3L36"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5L57", "4L57", "3L56"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L51", "4L51", "3L46"],
			gigaimpact: ["5M", "4M", "4S0"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["5L26", "4L26", "3L16"],
			mimic: ["3T"],
			mudbomb: ["5L14", "4L14"],
			mudslap: ["5L1", "4T", "4L1", "3T", "3L1"],
			mudsport: ["5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L33", "4M", "4L33", "3M", "3L26"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["5L33", "4T", "4L33", "3T", "3L26"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tickle: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L11"],
			waterpulse: ["5L22", "4M", "4L22", "3M"],
			watersport: ["5L1", "4L1", "3L1"],
			whirlpool: ["4M"],
			zenheadbutt: ["5L1", "4T", "4L1", "4S0"],
		},
	},
	corphish: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5E", "4T", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			brickbreak: ["5M", "4M", "3M"],
			bubble: ["5L1", "4L1", "3L1", "3S0"],
			bubblebeam: ["5L20", "4L20", "3L19"],
			captivate: ["4M"],
			chipaway: ["5E"],
			counter: ["3T"],
			crabhammer: ["5L38", "4L38", "3L34"],
			crunch: ["5L47", "4L47", "3L43"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["5E", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E"],
			endeavor: ["5E", "5D", "4T", "4E", "3E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			guillotine: ["5L53", "4L53", "3L44"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L7", "5D", "4L7", "3L7"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["5L26", "5E", "4T", "4L26", "4E", "3L25"],
			leer: ["5L13", "4L13", "3L13"],
			metalclaw: ["5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			nightslash: ["5L35", "4L35"],
			payback: ["5M", "4M"],
			protect: ["5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["5E", "4T", "4E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "5L44", "4M", "4L44", "3T", "3L37"],
			taunt: ["5M", "5L32", "4M", "4L32", "3M", "3L31"],
			toxic: ["5M", "4M", "3M"],
			trumpcard: ["5E"],
			visegrip: ["5L10", "4L10", "3L10"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["3S0"],
			whirlpool: ["4M"],
			xscissor: ["5M", "4M"],
		},
	},
	crawdaunt: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bubble: ["5L1", "4L1", "3L1"],
			bubblebeam: ["5L20", "4L20", "3L19"],
			captivate: ["4M"],
			counter: ["3T"],
			crabhammer: ["5L44", "4L44", "3L38", "3S0", "3S1"],
			crunch: ["5L57", "4L57", "3L51"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M", "3M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endeavor: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			guillotine: ["5L65", "4L65", "3L52", "3S0"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L1", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			knockoff: ["5L26", "4T", "4L26", "3L25", "3S1"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightslash: ["5L39", "4L39"],
			payback: ["5M", "4M"],
			protect: ["5M", "5L23", "4M", "4L23", "3M", "3L22"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L30", "4T", "4L30", "3T"],
			swordsdance: ["5M", "5L52", "4M", "4L52", "3T", "3L43", "3S0", "3S1"],
			taunt: ["5M", "5L34", "4M", "4L34", "3M", "3L33", "3S0", "3S1"],
			toxic: ["5M", "4M", "3M"],
			visegrip: ["5L1", "4L1", "3L1"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			xscissor: ["5M", "4M"],
		},
	},
	baltoy: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["5L26", "4T", "4L25", "3L25"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			cosmicpower: ["5L37", "4L45", "3L37"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["5L51", "4T", "4L53"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L60", "4M", "4L71", "3T", "3L45"],
			extrasensory: ["5L43"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			grassknot: ["5M", "4M"],
			gravity: ["5D", "4T"],
			guardsplit: ["5L48"],
			gyroball: ["5M", "4M"],
			harden: ["5L4", "4L3", "3L3"],
			headbutt: ["4T"],
			healblock: ["5L54", "4L61"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["5L11", "4T", "4L7", "3T", "3L7", "3S0"],
			naturalgift: ["4M"],
			powersplit: ["5L48"],
			powertrick: ["5L31", "4L31"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L15", "4L11", "3L11", "3S0"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5L7", "4L5", "3L5"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocktomb: ["5M", "5L18", "4M", "4L15", "3M", "3L15", "3S0"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "5L34", "4M", "4L37", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L21", "4L19", "3T", "3L19"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["5D", "4T"],
		},
	},
	claydol: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			ancientpower: ["5L26", "4T", "4L25", "3L25"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "3L1"],
			cosmicpower: ["5L47", "4L51", "3L42"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			earthpower: ["5L59", "4T", "4L62"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L72", "4M", "4L86", "3T", "3L55"],
			extrasensory: ["5L39"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			guardsplit: ["5L54"],
			gyroball: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			healblock: ["5L64", "4L73"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L36", "4M", "4L36", "3M", "3L36"],
			icebeam: ["5M", "4M", "3M"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mudslap: ["5L11", "4T", "4L7", "3T", "3L7"],
			naturalgift: ["4M"],
			powersplit: ["5L54"],
			powertrick: ["5L31", "4L31"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L15", "4L11", "3L11"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			rapidspin: ["5L1", "4L1", "3L1"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "5L18", "4M", "4L15", "3M", "3L15"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "5L34", "4M", "4L40", "3M", "3L31"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["5L21", "4L19", "3T", "3L19"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			telekinesis: ["5M"],
			teleport: ["5L1", "4L1", "3L1"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	lileep: {
		inherit: true,
		learnset: {
			acid: ["5L8", "5D", "5S0", "4L8", "3L15"],
			amnesia: ["5L29", "4L29", "3L36"],
			ancientpower: ["5L43", "4T", "4L43", "3L43"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			bodyslam: ["3T"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L22", "4L22", "3L29"],
			constrict: ["5L1", "5S0", "4L1", "3L8"],
			curse: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["5E", "4M", "3T"],
			energyball: ["5M", "5L50", "4M", "4L50"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L36", "4T", "4L36"],
			gigadrain: ["5D", "4M", "3M"],
			grassknot: ["5M", "4M"],
			hiddenpower: ["5M", "4M", "3M"],
			ingrain: ["5L15", "4L15", "3L22"],
			megadrain: ["5E"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "5D", "4E", "3E"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			recover: ["5E", "5S0", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "5S0", "4M", "4E", "3T", "3E"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L57", "4L57", "3L50"],
			stealthrock: ["5E", "4M"],
			stockpile: ["5L57", "4L57", "3L50"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L57", "4L57", "3L50"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
			wringout: ["5L64", "5E", "4L64", "4E"],
		},
	},
	cradily: {
		inherit: true,
		learnset: {
			acid: ["5L1", "4L1", "3L1"],
			amnesia: ["5L29", "4L29", "3L36"],
			ancientpower: ["5L36", "4T", "4L36", "3L48"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			bulletseed: ["4M", "3M"],
			captivate: ["4M"],
			confuseray: ["5L22", "4L22", "3L29"],
			constrict: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "5L56", "4M", "4L56"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gastroacid: ["5L46", "4T", "4L46"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			ingrain: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychup: ["3T"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spitup: ["5L66", "4L66", "3L60"],
			stealthrock: ["4M"],
			stockpile: ["5L66", "4L66", "3L60"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5L66", "4L66", "3L60"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			toxic: ["5M", "4M", "3M"],
			worryseed: ["4T"],
			wringout: ["5L76", "4L76"],
		},
	},
	anorith: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L31", "4T", "4L31", "3L37"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			crosspoison: ["5E", "5D", "5S0", "4E"],
			crushclaw: ["5L55", "4L55"],
			curse: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L37", "4T", "4L37", "3T", "3L43"],
			harden: ["5L1", "5S0", "4L1", "3L7"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			irondefense: ["5E", "4T"],
			knockoff: ["5E", "4T", "4E", "3E"],
			metalclaw: ["5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L7", "5S0", "4L7", "3L13"],
			naturalgift: ["4M"],
			protect: ["5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rapidspin: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L49", "4L49", "3L55"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandattack: ["5E", "4E"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "5D", "4L1", "3L1"],
			screech: ["5E", "4E"],
			secretpower: ["4M", "3M"],
			slash: ["5L43", "4L43", "3L49"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["5D", "4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "4E", "3T", "3E"],
			toxic: ["5M", "4M", "3M"],
			watergun: ["5L13", "5S0", "4L13", "3L19"],
			waterpulse: ["5E", "4M", "3M"],
			xscissor: ["5M", "5L61", "4M", "4L61"],
		},
	},
	armaldo: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L31", "4T", "4L31", "3L37"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crushclaw: ["5L67", "4L67"],
			cut: ["5M", "4M", "3M"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["5L37", "4T", "4L37", "3T", "3L46"],
			gigaimpact: ["5M", "4M"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			irondefense: ["4T"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lowkick: ["4T"],
			metalclaw: ["5L19", "4L19", "3L25"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			mudsport: ["5L1", "4L1", "3L1"],
			naturalgift: ["4M"],
			protect: ["5M", "5L25", "4M", "4L25", "3M", "3L31"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockblast: ["5L55", "4L55", "3L64"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			slash: ["5L46", "4L46", "3L55"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["4T"],
			swagger: ["5M", "4M", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			xscissor: ["5M", "5L73", "4M", "4L73"],
		},
	},
	feebas: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			brine: ["5E"],
			captivate: ["5E", "5D", "4M"],
			confuseray: ["5E", "4E", "3E"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonbreath: ["5E", "4E", "3E"],
			dragonpulse: ["5E"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L30", "4L30", "3L30"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			haze: ["5E", "4E"],
			hiddenpower: ["5M", "4M", "3M"],
			hypnosis: ["5E", "4E", "3E"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["5E"],
			lightscreen: ["5M", "4E", "3E"],
			mimic: ["3T"],
			mirrorcoat: ["5E", "5D", "4E", "4S0", "3E"],
			mist: ["5E", "4E"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["5L1", "5D", "4L1", "4S0", "3L1"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L15", "4L15", "3L15"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	milotic: {
		inherit: true,
		learnset: {
			aquaring: ["5L49", "4L49"],
			aquatail: ["5L29", "4T", "4L29"],
			attract: ["5M", "5L41", "4M", "4L41", "3M", "3L45"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["5L25", "4M", "4L25"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L37", "5S3", "4L37", "4S1", "4S2", "3L40"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5S3", "5S4", "4M", "4S1", "3M"],
			icywind: ["4T", "4S2", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lightscreen: ["5M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mirrorcoat: ["5S3"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "5L33", "4M", "4L33", "4S1", "4S2", "3M", "3L35", "3S0"],
			recover: ["5L21", "5S3", "5S4", "4L21", "4S1", "4S2", "3L30", "3S0"],
			refresh: ["5L9", "4L9", "3L15"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L45", "4M", "4L45", "3M", "3L50"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "5S4", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "5S4", "4M", "3M"],
			twister: ["5L17", "4T", "4L17", "3L25", "3S0"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5L13", "4M", "4L13", "3M", "3L20", "3S0"],
			watersport: ["5L5", "4L5", "3L10"],
			whirlpool: ["4M"],
			wrap: ["5L1", "4L1", "3L5"],
		},
	},
	castform: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L50", "4M", "3M"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			defensecurl: ["3T"],
			disable: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			ember: ["5L10", "5D", "4L10", "3L10"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L50", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E", "3E"],
			hail: ["5M", "5L30", "4M", "4L20", "3M", "3L20"],
			headbutt: ["5L20"],
			hex: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L50"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			lastresort: ["4T"],
			luckychant: ["5E", "4E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			ominouswind: ["5E", "5D", "4T", "4E"],
			powdersnow: ["5L10", "4L10", "3L10"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "4E", "3T", "3E"],
			raindance: ["5M", "5L30", "4M", "4L20", "3M", "3L20"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "5L30", "4M", "4L20", "3M", "3L20"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			watergun: ["5L10", "4L10", "3L10"],
			waterpulse: ["5D", "4M", "3M"],
			weatherball: ["5L40", "4L30", "3L30"],
			workup: ["5M"],
		},
	},
	kecleon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L55", "4T", "4L55", "3L49"],
			aquatail: ["4T"],
			astonish: ["5L1", "4L1", "3L1"],
			attract: ["5M", "4M", "3M"],
			bind: ["5L4", "4L4", "3L4"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			disable: ["5E", "4E", "3E"],
			dizzypunch: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fakeout: ["5E", "4E"],
			feint: ["5L14", "4L14"],
			feintattack: ["5L7", "4L7", "3L7"],
			fireblast: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foulplay: ["5E"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			furyswipes: ["5L10", "4L10", "3L12"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lick: ["5L1", "4L1", "3L1"],
			lowkick: ["4T"],
			magiccoat: ["5E", "4T", "4E", "3E"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			nastyplot: ["5E", "4E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psybeam: ["5L18", "4L15", "3L17"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5E", "4E"],
			recycle: ["4M"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scratch: ["5L1", "4L1", "3L1"],
			screech: ["5L32", "4L32", "3L24"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "5L49", "4M", "4L49"],
			shadowsneak: ["5L22", "4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["5E", "4M", "3M"],
			slash: ["5L27", "4L25", "3L31"],
			sleeptalk: ["4M", "3T"],
			snatch: ["5E", "4M", "3M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "5L37", "4M", "4L37", "3T", "3L40"],
			suckerpunch: ["5L43", "4T", "4L43"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			synchronoise: ["5L58"],
			tailwhip: ["5L1", "4L1", "3L1"],
			thief: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5E", "4T", "4E", "3E"],
			trickroom: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			workup: ["5M"],
		},
	},
	shuppet: {
		inherit: true,
		learnset: {
			astonish: ["5E", "4E", "3E"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5E", "4E"],
			curse: ["5L13", "4L13", "3L20"],
			darkpulse: ["4M"],
			destinybond: ["5E", "5D", "4E", "3E"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			embargo: ["5M", "5L43", "4M", "4L38"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L28", "4L28", "3L37", "3S0"],
			flash: ["5M", "4M", "3M"],
			foresight: ["5E", "4E", "3E"],
			frustration: ["5M", "4M", "3M"],
			grudge: ["5L50", "4L46", "3L56"],
			gunkshot: ["5E"],
			headbutt: ["4T"],
			hex: ["5L31"],
			hiddenpower: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			imprison: ["5E", "4E", "3E"],
			knockoff: ["5L1", "4T", "4L1", "3L1"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L8", "5D", "4L8", "3L13"],
			ominouswind: ["5E", "4T"],
			painsplit: ["5D", "4T"],
			payback: ["5M", "4M", "4E"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			screech: ["5L5", "4L5", "3L8"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "5L35", "4M", "4L31", "3M", "3L44", "3S0"],
			shadowsneak: ["5L20", "5E", "4L20", "4E"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["5L46", "4M", "4L43", "3M", "3L49"],
			snore: ["3T"],
			spite: ["5L16", "4T", "4L16", "3L25", "3S0"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L38", "4T", "4L35"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5L55", "4T", "4L50"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "5L23", "4M", "4L23", "3L32", "3S0"],
		},
	},
	banette: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			cottonguard: ["5S1"],
			curse: ["5L1", "4L1", "3L1", "3S0"],
			darkpulse: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			embargo: ["5M", "5L51", "4M", "4L42"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5L28", "5S1", "4L28", "3L39", "3S0"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grudge: ["5L66", "4L58", "3L64"],
			headbutt: ["4T"],
			helpinghand: ["3S0"],
			hex: ["5L31", "5S1"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			knockoff: ["5L1", "4T", "4L1", "3L1"],
			magiccoat: ["4T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			screech: ["5L1", "4L1", "3L1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "5L35", "5S1", "4M", "4L31", "3M", "3L48", "3S0"],
			shadowclaw: ["5M", "4M"],
			shadowsneak: ["5L20", "4L20"],
			shockwave: ["4M", "3M"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["5L58", "4M", "4L51", "3M", "3L55"],
			snore: ["3T"],
			spite: ["5L16", "4T", "4L16", "3L25"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["5L42", "4T", "4L35"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5L75", "4T", "4L66"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "5L23", "4M", "4L23", "3L32"],
		},
	},
	duskull: {
		inherit: true,
		learnset: {
			astonish: ["5L14", "4L14", "3L16", "3S1"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L17", "4L17", "3L23", "3S1"],
			curse: ["5L30", "4L30", "3L34", "3S0"],
			darkpulse: ["5E", "4M"],
			destinybond: ["5E", "4E", "3E"],
			disable: ["5L6", "5D", "4L6", "3L5"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			feintattack: ["5E", "4E", "3E"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			foresight: ["5L9", "4L9", "3L12"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L49", "4L46", "3L49"],
			gravity: ["4T"],
			grudge: ["5E", "4E", "3E"],
			headbutt: ["4T"],
			helpinghand: ["3S1"],
			hex: ["5L38"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			imprison: ["5E", "4E", "3E"],
			leer: ["5L1", "4L1", "3L1"],
			meanlook: ["5L41", "4L38", "3L45", "3S0"],
			memento: ["5E", "4E", "3E"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L1", "4L1", "3L1"],
			ominouswind: ["5E", "4T", "4E"],
			painsplit: ["5E", "5D", "4T", "4E", "3E"],
			payback: ["5M", "5L46", "4M", "4L41"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5L25", "4L25", "3L27", "3S0"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M", "3S1"],
			shadowsneak: ["5L22", "4L22"],
			skillswap: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["5D", "4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "5L33", "4M", "4L33", "3L38", "3S0"],
		},
	},
	dusclops: {
		inherit: true,
		learnset: {
			astonish: ["5L14", "4L14", "3L16"],
			attract: ["5M", "4M", "3M"],
			bind: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L17", "4L17", "3L23"],
			counter: ["3T"],
			curse: ["5L30", "4L30", "3L34"],
			darkpulse: ["4M"],
			disable: ["5L1", "4L1", "3L1"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			embargo: ["5M", "4M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["5L1", "4T", "4L1", "3T"],
			flash: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			foresight: ["5L9", "4L9", "3L12"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L61", "4L61", "3L58"],
			gigaimpact: ["5M", "4M"],
			gravity: ["5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["5L42"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["5L1", "4T", "4L1", "3T"],
			icywind: ["4T", "3T"],
			leer: ["5L1", "4L1", "3L1"],
			meanlook: ["5L49", "4L43", "3L51"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L1", "4L1", "3L1"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "5L58", "4M", "4L51"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			pursuit: ["5L25", "4L25", "3L27"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shadowpunch: ["5L37", "4L37", "3L37"],
			shadowsneak: ["5L22", "4L22"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M", "3M"],
			thunderpunch: ["5L1", "4T", "4L1", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "5L33", "4M", "4L33", "3L41"],
		},
	},
	dusknoir: {
		inherit: true,
		learnset: {
			astonish: ["5L14", "4L14"],
			attract: ["5M", "4M"],
			bind: ["5L1", "4L1"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L17", "4L17"],
			curse: ["5L30", "4L30"],
			darkpulse: ["4M"],
			disable: ["5L1", "4L1"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firepunch: ["5L1", "4T", "4L1"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["5L9", "4L9"],
			frustration: ["5M", "4M"],
			futuresight: ["5L61", "4L61"],
			gigaimpact: ["5M", "4M"],
			gravity: ["5L1", "4T", "4L1"],
			headbutt: ["4T"],
			hex: ["5L42"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["5L1", "4T", "4L1"],
			icywind: ["4T"],
			leer: ["5L1", "4L1"],
			meanlook: ["5L49", "4L43"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightshade: ["5L1", "4L1"],
			ominouswind: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "5L58", "4M", "4L51"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			pursuit: ["5L25", "4L25"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowpunch: ["5L37", "4L37"],
			shadowsneak: ["5L22", "4L22"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunderpunch: ["5L1", "4T", "4L1"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			willowisp: ["5M", "5L33", "4M", "4L33"],
		},
	},
	tropius: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			aircutter: ["4T"],
			airslash: ["5L51", "4L47", "4S0"],
			attract: ["5M", "4M", "3M"],
			bestow: ["5L57"],
			bodyslam: ["5L37", "4L37", "3T", "3L37"],
			bulldoze: ["5M"],
			bulletseed: ["5E", "4M", "3M"],
			captivate: ["4M"],
			curse: ["5E", "4E"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragondance: ["5E", "4E"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigadrain: ["4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L7", "4L7", "3L7"],
			gust: ["5L1", "5D", "4L1", "3L1"],
			headbutt: ["5E", "4T", "4E", "3E"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			leafblade: ["5E", "4E"],
			leafstorm: ["5L71", "5E", "4L61", "4E"],
			leaftornado: ["5L47"],
			leechseed: ["5E", "5D", "4E", "3E"],
			leer: ["5L1", "4L1", "3L1"],
			magicalleaf: ["5L31", "4L31", "3L31"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["5L67", "5E", "4M", "4L57"],
			naturepower: ["5E", "4E", "3E"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			razorleaf: ["5L11", "4L11", "3L11"],
			razorwind: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rocksmash: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			silverwind: ["5D", "4M"],
			slam: ["5E", "4E", "3E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L61", "4M", "4L51", "4S0", "3M", "3L41"],
			steelwing: ["4M", "3M"],
			stomp: ["5L17", "4L17", "3L17"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "4S0", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetscent: ["5L21", "4L21", "3L21"],
			swordsdance: ["5M", "4M", "3T"],
			synthesis: ["5L41", "5E", "4T", "4L41", "4E", "4S0", "3L47"],
			tailwind: ["4T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			whirlwind: ["5L27", "4L27", "3L27"],
			worryseed: ["4T"],
		},
	},
	chingling: {
		inherit: true,
		learnset: {
			astonish: ["5L9", "4L9"],
			attract: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L14", "4L14"],
			curse: ["5E", "4E"],
			disable: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M", "4E"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			entrainment: ["5L25"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5E", "4E"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			growl: ["5L6", "4L6"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hypnosis: ["5E", "4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["5L22", "4T", "4L22"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recover: ["5E", "4E"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "4M"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			storedpower: ["5E"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["5L17", "4T", "4L17"],
			wish: ["5E", "4E"],
			wrap: ["5L1", "4L1"],
			zenheadbutt: ["4T"],
		},
	},
	chimecho: {
		inherit: true,
		learnset: {
			astonish: ["5L9", "4L9", "3L9", "3S0"],
			attract: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L14", "4L14", "3L14"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["3T"],
			disable: ["5E", "4E", "3E"],
			doubleedge: ["5L33", "4L33", "3T", "3L33"],
			doubleteam: ["5M", "4M", "3M"],
			dreameater: ["5M", "4M", "4E", "3T", "3E"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			extrasensory: ["5L46", "4L46"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5E", "4E"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			growl: ["5L6", "4L6", "3L6", "3S0"],
			healbell: ["5L38", "4T", "4L38", "3L38"],
			healingwish: ["5L57", "4L49"],
			healpulse: ["5L49"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hypervoice: ["5D"],
			hypnosis: ["5E", "5D", "4E", "3E"],
			icywind: ["4T", "3T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "4M", "3M", "3L46"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			psywave: ["5L30", "4L30", "3L30"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "5L41", "4M", "4L41", "3M", "3L41"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["5E", "4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			storedpower: ["5E"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			synchronoise: ["5L54"],
			takedown: ["5L22", "4L22", "3L17"],
			taunt: ["5M", "4M", "3M"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["5L17", "4T", "4L17", "3L22"],
			wish: ["5E", "4E"],
			wrap: ["5L1", "5D", "4L1", "3L1", "3S0"],
			yawn: ["5L25", "4L25", "3L25"],
			zenheadbutt: ["4T"],
		},
	},
	absol: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			assurance: ["5E", "4E"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5E", "4E", "3E"],
			bite: ["5L28", "4L28", "3L21", "3S2"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			counter: ["3T"],
			curse: ["5E", "4E", "3E"],
			cut: ["5M", "4M", "3M"],
			darkpulse: ["4M"],
			detect: ["5L49", "4L49"],
			doubleedge: ["5E", "4E", "3T", "3E"],
			doubleteam: ["5M", "5L33", "4M", "4L33", "3M", "3L31", "3S3"],
			dreameater: ["5M", "4M", "3T"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			falseswipe: ["5M", "4M"],
			feint: ["5L1", "5D", "4L1"],
			feintattack: ["5E", "4E", "3E"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			futuresight: ["5L41", "4L41", "3L41", "3S3"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hex: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			knockoff: ["4T"],
			leer: ["5L4", "4L4", "3L5", "3S0", "3S1"],
			magiccoat: ["5E", "4T", "4E", "3E"],
			meanlook: ["5E", "4E"],
			mefirst: ["5L57", "5E", "4L57", "4E"],
			megahorn: ["5E", "5D", "4E"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightslash: ["5L52", "4L52"],
			payback: ["5M", "4M"],
			perishsong: ["5L65", "5E", "4L65", "3L46", "3S3"],
			protect: ["5M", "4M", "3M"],
			psychocut: ["5L60", "4L60"],
			psychup: ["5M", "4M", "3T"],
			punishment: ["5E", "4E"],
			pursuit: ["5L20", "4L20"],
			quickattack: ["5L12", "4L12", "3L13"],
			raindance: ["5M", "4M", "3M"],
			razorwind: ["5L17", "4L17", "3L17", "3S2"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scratch: ["5L1", "4L1", "3L1", "3S0", "3S1"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["5L36", "4L36", "3L36", "3S3"],
			sleeptalk: ["4M", "3T"],
			snarl: ["5E"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			spite: ["4T", "3S1", "3S2"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "4E", "3T", "3E"],
			suckerpunch: ["5L44", "5E", "4T", "4L44", "4E"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5D", "4T"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "5L25", "4M", "4L25", "3T", "3L26", "3S2"],
			taunt: ["5M", "5L9", "4M", "4L9", "3M", "3L9"],
			thief: ["5M", "4M", "3M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			willowisp: ["5M", "4M"],
			wish: ["3S0"],
			xscissor: ["5M", "4M"],
			zenheadbutt: ["5E", "4T", "4E"],
		},
	},
	snorunt: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			avalanche: ["5E", "4M"],
			bide: ["5E", "4E"],
			bite: ["5L10", "4L10", "3L10", "3S0"],
			blizzard: ["5M", "5L46", "4M", "4L46", "3M", "3L43"],
			block: ["5E", "4T", "4E", "3E"],
			bodyslam: ["3T"],
			captivate: ["4M"],
			crunch: ["5L31", "4L31", "3L28"],
			disable: ["5E", "4E"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L4", "4M", "4L4", "3M", "3L7"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			faketears: ["5E"],
			flash: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "5L40", "4M", "4L40", "3M", "3L37"],
			headbutt: ["5L19", "4T", "4L19", "3L19"],
			hex: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M", "3L34"],
			icefang: ["5L28", "4L28"],
			iceshard: ["5L37", "4L37"],
			icywind: ["5L13", "4T", "4L13", "3T", "3L16", "3S0"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["5E", "4T", "4E"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			sing: ["3S0"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spikes: ["5E", "4E", "3E"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["5D", "4M", "3M", "3S0"],
			weatherball: ["5E", "4E"],
		},
	},
	glalie: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M", "3M"],
			avalanche: ["4M"],
			bite: ["5L1", "4L1", "3L1"],
			blizzard: ["5M", "5L51", "4M", "4L51", "3M", "3L53"],
			block: ["4T"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L31", "4L31", "3L28"],
			darkpulse: ["4M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "5L1", "4M", "4L1", "3M", "3L1"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			hail: ["5M", "5L40", "4M", "4L40", "3M", "3L42"],
			headbutt: ["5L19", "4T", "4L19", "3L19"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5L37", "4M", "4L37", "3M", "3L34"],
			icefang: ["5L28", "4L28"],
			icywind: ["5L13", "4T", "4L13", "3T", "3L16"],
			ironhead: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			mimic: ["3T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "5L22", "4M", "4L22", "3M", "3L25"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			sheercold: ["5L59", "4L59", "3L61"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			spite: ["4T"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			swagger: ["5M", "4M", "3T"],
			taunt: ["5M", "4M", "3M"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
		},
	},
	froslass: {
		inherit: true,
		learnset: {
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L51", "4M", "4L51"],
			block: ["4T"],
			captivate: ["5L31", "4M", "4L31"],
			confuseray: ["5L19", "4L19"],
			destinybond: ["5L59", "4L59"],
			doubleteam: ["5M", "5L1", "4M", "4L1"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "5L40", "4M", "4L40"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			iceshard: ["5L37", "4L37"],
			icywind: ["5L13", "4T", "4L13"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["5L22", "4T", "4L22"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			powdersnow: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			wakeupslap: ["5L28", "4L28"],
			waterpulse: ["4M"],
		},
	},
	spheal: {
		inherit: true,
		learnset: {
			aquaring: ["5E", "4E"],
			aquatail: ["5D", "4T"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L25", "4L25", "3L25", "3S0"],
			blizzard: ["5M", "5L43", "4M", "4L43", "3M", "3L43"],
			bodyslam: ["5L19", "4L19", "3T", "3L19"],
			brine: ["4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			charm: ["3S0"],
			curse: ["5E", "4E", "3E"],
			defensecurl: ["5L1", "4L1", "3T", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5L7", "4L7", "3L7"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fissure: ["5E", "4E", "3E"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			iceball: ["5L13", "4L13", "3L13"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T", "3S0"],
			naturalgift: ["4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L37", "4M", "4L37", "3M", "3L37"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["5E", "4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L49", "4L49", "3L49"],
			signalbeam: ["5E", "4T", "4E"],
			sleeptalk: ["5E", "4M", "3T"],
			snore: ["5L37", "4T", "4L37", "3T", "3L37"],
			spitup: ["5E", "4E", "3E"],
			stockpile: ["5E", "4E", "3E"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swallow: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1", "3S0"],
			waterpulse: ["5E", "4M", "3M"],
			watersport: ["5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["5E", "4E", "3E"],
		},
	},
	sealeo: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L25", "4L25", "3L25"],
			blizzard: ["5M", "5L47", "4M", "4L47", "3M", "3L47"],
			bodyslam: ["5L19", "4L19", "3T", "3L19"],
			brine: ["4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			defensecurl: ["3T", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "5L31", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			iceball: ["5L13", "4L13", "3L13"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L55", "4L55", "3L55"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	walrein: {
		inherit: true,
		learnset: {
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			aurorabeam: ["5L25", "4L25", "3L25"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L52", "4M", "4L52", "3M", "3L50"],
			block: ["4T"],
			bodyslam: ["5L19", "4L19", "3T", "3L19"],
			brine: ["5S0", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L1", "4L1"],
			defensecurl: ["3T", "3L1"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			encore: ["5L1", "4L1", "3L1"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1", "3L1"],
			hail: ["5M", "5L31", "5S0", "4M", "4L31", "3M", "3L31"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			iceball: ["5L13", "4L13", "3L13"],
			icebeam: ["5M", "5S0", "4M", "3M"],
			icefang: ["5L44", "4L44"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			powdersnow: ["5L1", "4L1", "3L1"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L39", "4M", "4L39", "3M", "3L39"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L65", "5S0", "4L65", "3L61"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["5L39", "4T", "4L39", "3T", "3L39"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "5L32", "4M", "4L32", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	clamperl: {
		inherit: true,
		learnset: {
			aquaring: ["5E", "5D", "4E"],
			attract: ["5M", "4M", "3M"],
			barrier: ["5E", "4E", "3E"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["5E", "4E", "3T", "3E"],
			brine: ["5E", "4M"],
			captivate: ["5D", "4M"],
			clamp: ["5L1", "4L1", "3L1"],
			confuseray: ["5E", "4E", "3E"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			irondefense: ["5L1", "4T", "4L1", "3L1"],
			mimic: ["3T"],
			muddywater: ["5E", "4E"],
			mudsport: ["5E", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["5E", "4E", "3E"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shellsmash: ["5L51"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L1", "4L1", "3L1"],
			waterpulse: ["5E", "4M", "3M"],
			whirlpool: ["5L1", "5D", "4M", "4L1", "3L1"],
		},
	},
	huntail: {
		inherit: true,
		learnset: {
			aquatail: ["5L46", "4T", "4L46"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L33", "4L33", "3L43"],
			bite: ["5L6", "4L6", "3L8"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["5L28", "4M", "4L28"],
			captivate: ["4M"],
			crunch: ["5L42", "4L42", "3L36"],
			dive: ["5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L51", "4L51", "3L50"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icefang: ["5L24", "4L24"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L19", "4L19", "3L29"],
			screech: ["5L10", "4L10", "3L15"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["4M", "3M"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			superfang: ["4T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L15", "4M", "4L15", "3M", "3L22"],
			whirlpool: ["5L1", "4M", "4L1", "3L1"],
		},
	},
	gorebyss: {
		inherit: true,
		learnset: {
			agility: ["5L10", "4L10", "3L15"],
			amnesia: ["5L19", "4L19", "3L29"],
			aquaring: ["5L24", "4L24"],
			aquatail: ["5L46", "4T", "4L46"],
			attract: ["5M", "4M", "3M"],
			batonpass: ["5L33", "4L33", "3L43"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["4M"],
			captivate: ["5L28", "4M", "4L28"],
			confusion: ["5L6", "4L6", "3L8"],
			dive: ["5M", "5L37", "4T", "4L37", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L51", "4L51", "3L50"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L42", "4M", "4L42", "3M", "3L36"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L15", "4M", "4L15", "3M", "3L22"],
			whirlpool: ["5L1", "4M", "4L1", "3L1"],
		},
	},
	relicanth: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E", "3E"],
			ancientpower: ["5L43", "4T", "4L43", "3L43"],
			aquatail: ["5E", "4T", "4E"],
			attract: ["5M", "4M", "3M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bounce: ["4T"],
			brine: ["5E", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			dive: ["5M", "5L57", "4T", "4L57", "3M"],
			doubleedge: ["5L50", "4L50", "3T", "3L57"],
			doubleteam: ["5M", "4M", "3M"],
			earthpower: ["5D", "4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			harden: ["5L1", "4L1", "3L1"],
			headbutt: ["4T"],
			headsmash: ["5L78", "4L78"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L71", "4L71", "3L64"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			magnitude: ["5E", "4E", "3E"],
			mimic: ["3T"],
			muddywater: ["5E", "4E"],
			mudshot: ["5E"],
			mudslap: ["5E", "4T", "4E", "3T"],
			mudsport: ["5L36", "4L36", "3L36"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L64", "4M", "4L64", "3M", "3L50"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4E", "3T", "3E"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "5L15", "4M", "4L15", "3M", "3L15"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			skullbash: ["5E", "4E", "3E"],
			sleeptalk: ["5E", "5D", "4M", "4E", "3T", "3E"],
			smackdown: ["5M"],
			snore: ["5E", "4T", "4E", "3T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L29", "4L29", "3L29"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L8", "5D", "4L8", "3L8"],
			waterpulse: ["4M", "3M"],
			watersport: ["5E", "4E", "3E"],
			whirlpool: ["4M"],
			yawn: ["5L22", "4L22", "3L22"],
			zenheadbutt: ["5E"],
		},
	},
	luvdisc: {
		inherit: true,
		learnset: {
			agility: ["5L9", "4L9", "3L16"],
			aquajet: ["5E", "4E"],
			aquaring: ["5L46", "5E", "4L37", "4E"],
			attract: ["5M", "5L27", "4M", "4L22", "3M", "3L28"],
			blizzard: ["5M", "4M", "3M"],
			bounce: ["4T"],
			brine: ["5E", "4M"],
			captivate: ["5L51", "5E", "4M", "4L40", "4E"],
			charm: ["5L4", "5D", "4L4", "3L4"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flail: ["5L31", "4L46", "3L40"],
			frustration: ["5M", "4M", "3M"],
			hail: ["5M", "4M", "3M"],
			healpulse: ["5E"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L40"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["5D", "4T", "3T"],
			luckychant: ["5L17", "4L17"],
			mimic: ["3T"],
			mudsport: ["5E", "5D", "4E", "3E"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "5L55", "4M", "4L51", "3M", "3L48"],
			scald: ["5M"],
			secretpower: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			splash: ["5E", "4E", "3E"],
			substitute: ["5M", "4M", "3T"],
			supersonic: ["5E", "4E", "3E"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			sweetkiss: ["5L37", "4L27", "3L36"],
			swift: ["4T", "3T"],
			tackle: ["5L1", "4L1", "3L1"],
			takedown: ["5L14", "4L14", "3L24"],
			toxic: ["5M", "4M", "3M"],
			waterfall: ["5M", "4M", "3M"],
			watergun: ["5L7", "4L7", "3L12"],
			waterpulse: ["5L22", "4M", "4L31", "3M"],
			watersport: ["5E", "4E", "3E"],
			whirlpool: ["4M"],
		},
	},
	bagon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L5", "5D", "4L5", "3L5", "3S0", "3S1"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			crunch: ["5L46", "4L46", "3L41"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["5E"],
			doubleedge: ["5L55", "4L55", "3T", "3L53"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L31", "4L31", "3L33"],
			dragonclaw: ["5M", "5L50", "4M", "4L50", "3M", "3L49"],
			dragondance: ["5E", "5D", "4E", "3E"],
			dragonpulse: ["5E", "4M"],
			dragonrage: ["5E", "4E", "3E"],
			dragonrush: ["5E", "4E"],
			ember: ["5L25", "4L25", "3L25"],
			endure: ["5E", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			firefang: ["5E", "4E"],
			flamethrower: ["5M", "4M", "3M"],
			focusenergy: ["5L20", "4L20", "3L21"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["5L16", "4T", "4L16", "3L17"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["5E", "4E", "3E"],
			incinerate: ["5M"],
			irondefense: ["3S1"],
			leer: ["5L10", "4L10", "3L9"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5D", "4T"],
			protect: ["5M", "4M", "3M"],
			rage: ["5L1", "5S2", "4L1", "3L1", "3S0", "3S1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			scaryface: ["5L40", "4L40", "3L37"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M", "4E"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			thrash: ["5E", "4E", "3E"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5E", "4T", "4E", "3E"],
			wish: ["3S0"],
			zenheadbutt: ["5L35", "4T", "4L35"],
		},
	},
	shelgon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			captivate: ["4M"],
			crunch: ["5L50", "4L50", "3L56"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5L61", "4L61", "3T", "3L78"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L32", "4L32", "3L38"],
			dragonclaw: ["5M", "5L55", "4M", "4L55", "3M", "3L69"],
			dragonpulse: ["4M"],
			ember: ["5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			focusenergy: ["5L20", "4L20", "3L21"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "5L30", "4M", "4L30", "3M", "3L30"],
			rage: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			scaryface: ["5L43", "4L43", "3L47"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["5L37", "4T", "4L37"],
		},
	},
	salamence: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5S3", "4M", "3M", "3S1"],
			aircutter: ["4T"],
			aquatail: ["4T"],
			attract: ["5M", "4M", "3M"],
			bite: ["5L1", "4L1", "3L1"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L53", "4L53", "3L61"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			defog: ["4M"],
			doubleedge: ["5L70", "4L70", "3T", "3L93"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L32", "4L32", "3L38", "3S0"],
			dragonclaw: ["5M", "5L61", "5S3", "4M", "4L61", "4S2", "3M", "3L79", "3S1"],
			dragondance: ["5S3", "3S1"],
			dragonpulse: ["4M"],
			dragontail: ["5M", "5L80"],
			earthquake: ["5M", "4M", "3M"],
			ember: ["5L25", "4L25", "3L25"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "4S2", "3M"],
			firefang: ["5L1", "4L1"],
			flamethrower: ["5M", "4M", "3M"],
			fly: ["5M", "5L50", "4M", "4L50", "3M", "3L50", "3S0"],
			focusenergy: ["5L20", "4L20", "3L21"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["5L1", "4T", "4L1", "3L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hydropump: ["4S2"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			irontail: ["4M", "3M"],
			leer: ["5L1", "4L1", "3L1"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			outrage: ["5S3", "4T"],
			protect: ["5M", "5L30", "4M", "4L30", "3M", "3L30", "3S0"],
			rage: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			refresh: ["3S1"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			roost: ["4M"],
			round: ["5M"],
			scaryface: ["5L43", "4L43", "3L47", "3S0"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			steelwing: ["4M", "3M"],
			stoneedge: ["5M", "4M", "4S2"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			thunderfang: ["5L1", "4L1"],
			toxic: ["5M", "4M", "3M"],
			twister: ["4T"],
			zenheadbutt: ["5L37", "4T", "4L37"],
		},
	},
	beldum: {
		inherit: true,
		learnset: {
			headbutt: ["4T"],
			irondefense: ["4T"],
			ironhead: ["5D", "4T"],
			takedown: ["5L1", "5D", "4L1", "3L1"],
			zenheadbutt: ["5D", "4T"],
		},
	},
	metang: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L44", "4L44", "3L56"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5L32", "4L32"],
			confusion: ["5L1", "4L1", "3L20", "3S0"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L56", "4M", "4L56", "3M", "3L62"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L40", "4T", "4L40", "3L44"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magnetrise: ["5L1", "4T", "4L1"],
			metalclaw: ["5L1", "4L1", "3L20", "3S0"],
			meteormash: ["5L48", "4L48", "3L50"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L36", "4M", "4L36", "3M", "3L38"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			pursuit: ["5L28", "4L28", "3L32"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["3S0"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L24", "4L24", "3L26"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["5L1", "4L1", "3L1", "3S0"],
			telekinesis: ["5M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			zenheadbutt: ["5L52", "4T", "4L52"],
		},
	},
	metagross: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			agility: ["5L44", "5S4", "4L44", "3L66"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			bulletpunch: ["5L32", "5S1", "5S2", "4L32", "4S0"],
			confusion: ["5L1", "4L1", "3L1"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			doubleedge: ["5S4", "5S5", "3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "5S1", "5S3", "5S6", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "4M", "3T"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "4M"],
			hammerarm: ["5L45", "5S1", "5S2", "5S4", "5S5", "4L45", "4S0"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L71", "5S6", "4M", "4L71", "3M", "3L77"],
			icepunch: ["5S2", "4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L40", "5S4", "4T", "4L40", "3L44"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magnetrise: ["5L1", "4T", "4L1"],
			metalclaw: ["5L1", "4L1", "3L1"],
			meteormash: ["5L53", "5S1", "5S3", "5S5", "5S6", "4L53", "4S0", "3L55"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "5S3", "4M", "3M"],
			psychic: ["5M", "5L36", "5S5", "5S6", "4M", "4L36", "3M", "3L38"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			pursuit: ["5L28", "4L28", "3L32"],
			raindance: ["5M", "4M", "3M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L24", "4L24", "3L1"],
			secretpower: ["4M", "3M"],
			selfdestruct: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			sludgebomb: ["5M", "4M", "3M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			takedown: ["5L1", "4L1", "3L1"],
			telekinesis: ["5M"],
			thunderpunch: ["4T", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			zenheadbutt: ["5L62", "5S2", "5S3", "4T", "4L62", "4S0"],
		},
	},
	regirock: {
		inherit: true,
		learnset: {
			ancientpower: ["5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			chargebeam: ["5M", "5L49", "5S3", "4M", "4L49"],
			counter: ["3T"],
			curse: ["5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			drainpunch: ["4M"],
			dynamicpunch: ["3T"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hammerarm: ["5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["4T", "3T"],
			irondefense: ["5L41", "5S3", "4L41", "3L41"],
			ironhead: ["4T"],
			lockon: ["5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rockthrow: ["5L9", "4L9", "4S2", "3L9", "3S0"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stomp: ["5L1", "4L1", "4S2"],
			stoneedge: ["5M", "5L73", "4M", "4L73"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			zapcannon: ["5L65", "5S3", "4L65", "3L49"],
		},
	},
	regice: {
		inherit: true,
		learnset: {
			amnesia: ["5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			chargebeam: ["5M", "5L49", "5S3", "4M", "4L49"],
			counter: ["3T"],
			curse: ["5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hail: ["5M", "4M", "3M"],
			hammerarm: ["5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icebeam: ["5M", "5L73", "4M", "4L73", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["5L9", "4T", "4L9", "4S2", "3T", "3L9", "3S0"],
			ironhead: ["4T"],
			lockon: ["5L57", "5S3", "4L57", "3L57"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stomp: ["5L1", "4L1", "4S2"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			superpower: ["5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			zapcannon: ["5L65", "5S3", "4L65", "3L49"],
		},
	},
	registeel: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			amnesia: ["5L41", "5S3", "4L41", "3L41"],
			ancientpower: ["5L33", "4T", "4L33", "3L33", "3S0", "3S1"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			chargebeam: ["5M", "5L49", "5S3", "4M", "4L49"],
			counter: ["3T"],
			curse: ["5L17", "4L17", "4S2", "3L17", "3S0", "3S1"],
			defensecurl: ["3T"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dynamicpunch: ["3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			explosion: ["5M", "5L1", "4M", "4L1", "3T", "3L1"],
			facade: ["5M", "4M", "3M"],
			flashcannon: ["5M", "5L73", "4M", "4L73"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hammerarm: ["5L81", "4L81"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L89", "4M", "4L89", "3M", "3L65", "3S1"],
			icepunch: ["4T", "3T"],
			irondefense: ["5L41", "4T", "4L41", "3L41"],
			ironhead: ["5L73", "4T", "4L73"],
			lockon: ["5L57", "5S3", "4L57", "3L57"],
			magnetrise: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			metalclaw: ["5L9", "4L9", "4S2", "3L9", "3S0"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			selfdestruct: ["3T"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			stomp: ["5L1", "4L1", "4S2"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5L25", "4T", "4L25", "4S2", "3L25", "3S0", "3S1"],
			swagger: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			zapcannon: ["5L65", "5S3", "4L65", "3L49"],
		},
	},
	latias: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["5L80", "4M", "4L70"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			guardsplit: ["5L75"],
			healingwish: ["5L85", "4L60"],
			healpulse: ["5L65", "5S5"],
			helpinghand: ["5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			mimic: ["3T"],
			mistball: ["5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["5L50", "5S5", "4L50"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			psywave: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["5M", "4M", "3M"],
			reflecttype: ["5L70"],
			refresh: ["5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			watersport: ["5L25", "4L25", "4S3", "4S4", "3L25", "3S0"],
			whirlpool: ["4M"],
			wish: ["5L5", "4L5", "3L5"],
			zenheadbutt: ["5L40", "4T", "4L40", "4S4"],
		},
	},
	latios: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			attract: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M", "3M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			cut: ["5M", "4M", "3M"],
			defog: ["4M"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L20", "4L20", "4S3", "3L20"],
			dragonclaw: ["5M", "4M", "3M"],
			dragondance: ["5L55", "5S5", "4L55", "3L50", "3S1", "3S2"],
			dragonpulse: ["5L80", "4M", "4L70"],
			dreameater: ["5M", "4M", "3T"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			flash: ["5M", "4M", "3M"],
			fly: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			healblock: ["5L5", "4L5"],
			healpulse: ["5L65", "5S5"],
			helpinghand: ["5L10", "4T", "4L10", "3L10"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M", "3M"],
			lusterpurge: ["5L35", "4L35", "4S3", "4S4", "3L35", "3S0", "3S1", "3S2"],
			magiccoat: ["4T"],
			memento: ["5L85", "4L60", "3L5"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powersplit: ["5L75"],
			protect: ["5M", "5L25", "4M", "4L25", "4S3", "4S4", "3M", "3L25", "3S0"],
			psychic: ["5M", "5L60", "5S5", "4M", "4L65", "3M", "3L40", "3S0", "3S1", "3S2"],
			psychoshift: ["5L50", "5S5", "4L50"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			psywave: ["5L1", "4L1", "3L1"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L45", "4L45", "3L45", "3S1", "3S2"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["5L30", "4L30", "4S3", "4S4", "3L30", "3S0"],
			rest: ["5M", "4M", "3M"],
			retaliate: ["5M"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "5L15", "4M", "4L15", "3M", "3L15"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			steelwing: ["4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			tailwind: ["4T"],
			telekinesis: ["5M", "5L70"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			twister: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
			zenheadbutt: ["5L40", "4T", "4L40", "4S4"],
		},
	},
	kyogre: {
		inherit: true,
		learnset: {
			ancientpower: ["5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			aquaring: ["5L30", "4L30", "4S2"],
			aquatail: ["5L65", "4T", "4L65"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			block: ["4T"],
			bodyslam: ["5L15", "4L15", "3T", "3L20", "3S0"],
			brickbreak: ["5M", "4M", "3M"],
			brine: ["4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			defensecurl: ["3T"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["5L80", "4L65", "3T", "3L65", "3S1"],
			doubleteam: ["5M", "4M", "3M"],
			earthquake: ["5M", "4M", "3M"],
			endure: ["4M", "3T"],
			facade: ["5M", "4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M", "3M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hydropump: ["5L90", "4L45", "3L45", "3S0", "3S1"],
			hyperbeam: ["5M", "4M", "3M"],
			icebeam: ["5M", "5L35", "5S3", "5S4", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			icywind: ["4T", "3T"],
			ironhead: ["4T"],
			mimic: ["3T"],
			muddywater: ["5L20", "4L20"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "4L50", "3M", "3L50", "3S1"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			scald: ["5M"],
			scaryface: ["5L5", "4L5", "3L5"],
			secretpower: ["4M", "3M"],
			sheercold: ["5L75", "5S4", "4L60", "3L60", "3S1"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			thunder: ["5M", "5S3", "5S4", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["5L1", "4M", "4L1", "3M", "3L1"],
			waterspout: ["5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			whirlpool: ["4M"],
		},
	},
	groudon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["5L45", "5S3", "4T", "4L15", "4S2", "3L15"],
			block: ["4T"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "5L60", "4M", "4L30", "3M", "3L30", "3S0"],
			bulldoze: ["5M"],
			counter: ["3T"],
			cut: ["5M", "4M", "3M"],
			defensecurl: ["3T"],
			dig: ["5M", "4M", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dragonclaw: ["5M", "4M", "3M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			dynamicpunch: ["3T"],
			earthpower: ["5L65", "5S4", "4T", "4L65"],
			earthquake: ["5M", "5L35", "5S3", "4M", "4L35", "4S2", "3M", "3L35", "3S0"],
			endure: ["4M", "3T"],
			eruption: ["5L50", "5S3", "5S4", "4L50", "4S2", "3L75"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "5L90", "4M", "4L45", "3M", "3L45", "3S0", "3S1"],
			firepunch: ["4T", "3T"],
			fissure: ["5L75", "4L60", "3L60", "3S1"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			hammerarm: ["5L20", "5S4", "4L20"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M", "3M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			lavaplume: ["5L15", "4L15"],
			megakick: ["3T"],
			megapunch: ["3T"],
			mimic: ["3T"],
			mudshot: ["5L1", "4L1", "3L1"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			rest: ["5M", "5L30", "4M", "4L30", "4S2", "3M", "3L50", "3S1"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			rollout: ["4T", "3T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L5", "4L5", "3L5"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			slash: ["4L20", "3L20", "3S0"],
			sleeptalk: ["4M", "3T"],
			smackdown: ["5M"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "5L80", "5S3", "5S4", "4M", "4L65", "3M", "3L65", "3S1"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M", "3T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			uproar: ["4T"],
		},
	},
	rayquaza: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			airslash: ["5L35", "4L35", "4S1"],
			ancientpower: ["5L45", "5S2", "4T", "4L15", "4S1", "3L15"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M", "3M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			bulkup: ["5M", "4M", "3M"],
			bulldoze: ["5M"],
			crunch: ["5L15", "4L15", "3L35"],
			dive: ["5M", "4T", "3M"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5T", "4T"],
			dragonclaw: ["5M", "4M", "4L20", "3M", "3L20"],
			dragondance: ["5L60", "5S2", "4L30", "3L30"],
			dragonpulse: ["5L90", "5S2", "5S3", "4M", "4L75"],
			dragontail: ["5M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M", "3M"],
			echoedvoice: ["5M"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			extremespeed: ["5L75", "5S3", "4L60", "3L60", "3S0"],
			facade: ["5M", "4M", "3M"],
			fireblast: ["5M", "4M", "3M"],
			flamethrower: ["5M", "4M", "3M"],
			fling: ["5M", "4M"],
			fly: ["5M", "5L65", "4M", "4L45", "3M", "3L45", "3S0"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			furycutter: ["4T", "3T"],
			gigaimpact: ["5M", "4M"],
			gyroball: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L80", "5S3", "4M", "4L65", "3M", "3L75"],
			hypervoice: ["5L20", "4L20"],
			icebeam: ["5M", "4M", "3M"],
			icywind: ["4T", "3T"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M", "3M"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			outrage: ["5L50", "5S2", "4T", "4L50", "4S1", "3L65", "3S0"],
			overheat: ["5M", "4M", "3M"],
			protect: ["5M", "4M", "3M"],
			psychup: ["5M", "4M", "3T"],
			raindance: ["5M", "4M", "3M"],
			rest: ["5M", "5L30", "4M", "4L30", "4S1", "3M", "3L50", "3S0"],
			return: ["5M", "4M", "3M"],
			roar: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M", "3M"],
			scaryface: ["5L5", "4L5", "3L5"],
			secretpower: ["4M", "3M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M", "3M"],
			skydrop: ["5M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			surf: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["4T", "3T"],
			swordsdance: ["5M", "4M"],
			tailwind: ["4T"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			twister: ["5L1", "4T", "4L1", "3L1"],
			uproar: ["4T"],
			vcreate: ["5S3"],
			waterfall: ["5M", "4M", "3M"],
			waterpulse: ["4M", "3M"],
			whirlpool: ["4M"],
		},
	},
	jirachi: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			ancientpower: ["4T"],
			bodyslam: ["3T"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "4S3", "4S4", "3L1", "3S0", "3S1"],
			cosmicpower: ["5L60", "5S7", "4L60", "3L45"],
			defensecurl: ["3T"],
			doomdesire: ["5L70", "4L70", "3L50"],
			doubleedge: ["5L40", "4L40", "3T", "3L35"],
			doubleteam: ["5M", "4M", "3M"],
			dracometeor: ["5S6", "4S4"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M", "3M"],
			futuresight: ["5L55", "4L55", "3L40"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["5L45", "4T", "4L45"],
			headbutt: ["4T"],
			healingwish: ["5L50", "5S5", "5S7", "5S8", "4L50"],
			helpinghand: ["5L15", "4T", "4L15", "3L15", "3S2"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			lastresort: ["5L65", "4T", "4L65"],
			lightscreen: ["5M", "4M", "3M"],
			magiccoat: ["4T"],
			metronome: ["3T"],
			mimic: ["3T"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L20", "5S5", "4M", "4L20", "3M", "3L20", "3S2"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			raindance: ["5M", "4M", "3M"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			refresh: ["5L25", "4L25", "3L25", "3S2"],
			rest: ["5M", "5L5", "4M", "4L5", "4S3", "4S4", "3M", "3L5", "3S0", "3S1", "3S2"],
			return: ["5M", "5S8", "4M", "3M"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			sandstorm: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snore: ["4T", "3T"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L10", "5S5", "5S8", "4T", "4L10", "3T", "3L10"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			wish: ["5L1", "5S6", "5S7", "5S8", "4L1", "4S3", "4S4", "3L1", "3S0", "3S1"],
			zenheadbutt: ["5L35", "4T", "4L35"],
		},
	},
	deoxys: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M", "3M"],
			allyswitch: ["5M"],
			avalanche: ["4M"],
			bodyslam: ["3T"],
			brickbreak: ["5M", "4M", "3M"],
			calmmind: ["5M", "4M", "3M"],
			chargebeam: ["5M", "4M"],
			cosmicpower: ["5L73", "4L73", "3L35", "3S3"],
			counter: ["5L97", "4L97", "4S6", "3T", "3L50"],
			cut: ["5M", "4M", "3M"],
			detect: ["4S6"],
			doubleedge: ["3T"],
			doubleteam: ["5M", "4M", "4L17", "4S5", "3M", "3L10"],
			drainpunch: ["4M"],
			dreameater: ["5M", "4M", "3T"],
			dynamicpunch: ["3T"],
			endure: ["4M", "3T"],
			energyball: ["5M", "4M"],
			extremespeed: ["5L97", "4L97", "4S4", "4S5", "3L50"],
			facade: ["5M", "4M", "3M"],
			firepunch: ["4T", "3T"],
			flash: ["5M", "4M", "3M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M", "3M"],
			frustration: ["5M", "4M", "3M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M", "3M"],
			hyperbeam: ["5M", "5L97", "4M", "4L97", "4S7", "3M", "3L50", "3S3"],
			icebeam: ["5M", "4M", "3M"],
			icepunch: ["4T", "3T"],
			icywind: ["4T", "3T"],
			irondefense: ["5L73", "4T", "4L73", "4S4", "3L35"],
			knockoff: ["5L25", "4T", "4L25", "3L15", "3S1", "3S2"],
			leer: ["5L1", "4L1", "4S8", "3L1"],
			lightscreen: ["5M", "4M", "3M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["4T"],
			megakick: ["3T"],
			megapunch: ["3T"],
			meteormash: ["4S7"],
			mimic: ["3T"],
			mirrorcoat: ["5L97", "4L97", "4S6", "3L50"],
			mudslap: ["4T", "3T"],
			naturalgift: ["4M"],
			nightmare: ["3T"],
			nightshade: ["5L9", "4L9", "4S8", "3L5"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M", "3M"],
			psychic: ["5M", "5L41", "4M", "4L41", "3M", "3L25", "3S0", "3S1", "3S2"],
			psychoboost: ["5L89", "5S9", "4L89", "4S4", "4S5", "4S6", "4S7", "4S8", "3L45", "3S3"],
			psychoshift: ["5L57", "4L57"],
			psychup: ["5M", "4M", "3T"],
			psyshock: ["5M"],
			pursuit: ["5L33", "4L33", "3L20", "3S0", "3S2"],
			raindance: ["5M", "4M", "3M"],
			recover: ["5L81", "5S9", "4L81", "3L40", "3S3"],
			recycle: ["4M"],
			reflect: ["5M", "4M", "3M"],
			rest: ["5M", "4M", "3M"],
			return: ["5M", "4M", "3M"],
			rockslide: ["5M", "4M", "3T"],
			rocksmash: ["5M", "4M", "3M"],
			rocktomb: ["5M", "4M", "3M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M", "3M"],
			secretpower: ["4M", "3M"],
			seismictoss: ["3T"],
			shadowball: ["5M", "4M", "3M"],
			shockwave: ["4M", "3M"],
			signalbeam: ["4T"],
			skillswap: ["4M", "3M"],
			sleeptalk: ["4M", "3T"],
			snatch: ["5L49", "4M", "4L49", "3M", "3L30", "3S1"],
			snore: ["4T", "3T"],
			solarbeam: ["5M", "4M", "3M"],
			spikes: ["5L33", "4L33", "3L20", "3S1"],
			stealthrock: ["4M"],
			strength: ["5M", "4M", "3M"],
			substitute: ["5M", "4M", "3T"],
			sunnyday: ["5M", "4M", "3M"],
			superpower: ["5L49", "4T", "4L49", "4S7", "3S0"],
			swagger: ["5M", "4M", "3T"],
			swift: ["5L49", "4T", "4L49", "4S5", "3T", "3L30", "3S2"],
			taunt: ["5M", "4M", "4L25", "3M", "3L15", "3S0"],
			telekinesis: ["5M"],
			teleport: ["5L17", "4L17", "3L10"],
			thunder: ["5M", "4M", "3M"],
			thunderbolt: ["5M", "4M", "3M"],
			thunderpunch: ["4T", "3T"],
			thunderwave: ["5M", "4M", "3T"],
			torment: ["5M", "4M", "3M"],
			toxic: ["5M", "4M", "3M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			waterpulse: ["4M", "3M"],
			wrap: ["5L1", "4L1", "4S8", "3L1"],
			zapcannon: ["5L81", "4L81", "4S4", "3L40"],
			zenheadbutt: ["5L65", "4T", "4L65"],
		},
	},
	turtwig: {
		inherit: true,
		learnset: {
			absorb: ["5L9", "5S0", "5S1", "4L9"],
			amnesia: ["5E", "4E"],
			attract: ["5M", "4M"],
			bite: ["5L21", "4L21"],
			bodyslam: ["5E", "4E"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["5L37", "4L37"],
			curse: ["5L17", "4L17"],
			cut: ["5M", "4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			earthpower: ["5E", "4T"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["5L41", "4M", "4L41"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			growth: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			irontail: ["4M"],
			leafstorm: ["5L45", "4L45"],
			leechseed: ["5L29", "4L29"],
			lightscreen: ["5M", "4M"],
			megadrain: ["5L25", "4L25"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			razorleaf: ["5L13", "4L13"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandtomb: ["5E", "4E"],
			secretpower: ["4M"],
			seedbomb: ["5E", "4T", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			spitup: ["5E", "4E"],
			stealthrock: ["4M"],
			stockpile: ["5E", "5S1", "4E"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["5E", "4T", "4E"],
			swagger: ["5M", "4M"],
			swallow: ["5E", "4E"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5L33", "4T", "4L33"],
			tackle: ["5L1", "5S0", "5S1", "4L1"],
			thrash: ["5E", "4E"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M"],
			wideguard: ["5E"],
			withdraw: ["5L5", "5S0", "5S1", "4L5"],
			worryseed: ["5E", "4T", "4E"],
		},
	},
	grotle: {
		inherit: true,
		learnset: {
			absorb: ["5L9", "4L9"],
			attract: ["5M", "4M"],
			bite: ["5L22", "4L22"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["5L42", "4L42"],
			curse: ["5L17", "4L17"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["5L47", "4M", "4L47"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			irontail: ["4M"],
			leafstorm: ["5L52", "4L52"],
			leechseed: ["5L32", "4L32"],
			lightscreen: ["5M", "4M"],
			megadrain: ["5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			razorleaf: ["5L13", "4L13"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5L37", "4T", "4L37"],
			tackle: ["5L1", "4L1"],
			toxic: ["5M", "4M"],
			withdraw: ["5L1", "4L1"],
			worryseed: ["4T"],
		},
	},
	torterra: {
		inherit: true,
		learnset: {
			absorb: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			bite: ["5L22", "4L22"],
			block: ["4T"],
			bulldoze: ["5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["5L45", "4L45"],
			curse: ["5L17", "4L17"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L32", "5S0", "4M", "4L32"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frenzyplant: ["5T", "4T"],
			frustration: ["5M", "4M"],
			gigadrain: ["5L51", "4M", "4L51"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasspledge: ["5T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			leafstorm: ["5L57", "4L57"],
			leechseed: ["5L33", "4L33"],
			lightscreen: ["5M", "4M"],
			megadrain: ["5L27", "4L27"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5S0", "4T"],
			protect: ["5M", "4M"],
			razorleaf: ["5L1", "4L1"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5S0", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5L39", "4T", "4L39"],
			tackle: ["5L1", "4L1"],
			toxic: ["5M", "4M"],
			withdraw: ["5L1", "4L1"],
			woodhammer: ["5L1", "5S0", "4L1"],
			worryseed: ["4T"],
		},
	},
	chimchar: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L39"],
			aerialace: ["5M", "4M"],
			assist: ["5E", "4E"],
			attract: ["5M", "4M"],
			blazekick: ["5E", "4E"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doublekick: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			ember: ["5L7", "5S1", "5S3", "4L7"],
			encore: ["5E", "4E"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "5L31", "4M", "4L31"],
			fakeout: ["5E", "5S3", "4E"],
			fireblast: ["5M", "4M"],
			firepledge: ["5T"],
			firepunch: ["5E", "4T", "4E"],
			firespin: ["5L33", "4L33"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L47", "4M", "4L41", "4S0", "4S2"],
			flamewheel: ["5L17", "4L17"],
			fling: ["5M", "4M"],
			focusenergy: ["5E", "4E"],
			focuspunch: ["5E", "4M"],
			frustration: ["5M", "4M"],
			furyswipes: ["5L15", "4L15"],
			grassknot: ["5M", "4M", "4S0", "4S2"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			heatwave: ["5E", "4T", "4E"],
			helpinghand: ["5E", "4T", "4E", "4S0", "4S2"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			irontail: ["4M"],
			leer: ["5L1", "5S1", "5S3", "4L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			mudslap: ["4T"],
			nastyplot: ["5L23", "4L23"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			protect: ["5M", "4M"],
			quickguard: ["5E"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M"],
			roleplay: ["4T"],
			rollout: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "5S1", "4L1"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			slackoff: ["5L41", "4L39"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			submission: ["5E"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L9", "5S1", "5S3", "4M", "4L9"],
			thunderpunch: ["5E", "4T", "4E", "4S0", "4S2"],
			torment: ["5M", "5L25", "4M", "4L25"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	monferno: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L46"],
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			captivate: ["4M"],
			closecombat: ["5L36", "4L36"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			ember: ["5L1", "4L1"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feint: ["5L26", "4L26"],
			fireblast: ["5M", "4M"],
			firepledge: ["5T"],
			firepunch: ["4T"],
			firespin: ["5L39", "4L39"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M"],
			flamewheel: ["5L19", "4L19"],
			flareblitz: ["5L56", "4L49"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furyswipes: ["5L16", "4L16"],
			grassknot: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			machpunch: ["5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			rollout: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			slackoff: ["5L49", "4L46"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L9", "4M", "4L9"],
			thunderpunch: ["4T"],
			torment: ["5M", "5L29", "4M", "4L29"],
			toxic: ["5M", "4M"],
			uturn: ["5M", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	infernape: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L52"],
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			blastburn: ["5T", "4T"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			calmmind: ["5M", "5L58", "4M", "4L53"],
			captivate: ["4M"],
			closecombat: ["5L36", "5S0", "4L41"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			ember: ["5L1", "4L1"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feint: ["5L26", "4L29"],
			fireblast: ["5M", "5S0", "4M"],
			firepledge: ["5T"],
			firepunch: ["4T"],
			firespin: ["5L42", "4L45"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M"],
			flamewheel: ["5L19", "4L21"],
			flareblitz: ["5L68", "4L57"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furyswipes: ["5L16", "4L17"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "5S0", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			machpunch: ["5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			punishment: ["5L29", "4L33"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			rollout: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L1", "4M", "4L1"],
			thunderpunch: ["4T"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uturn: ["5M", "5S0", "4M"],
			vacuumwave: ["4T"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	piplup: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			agility: ["5E", "4E"],
			aquaring: ["5E", "4E"],
			attract: ["5M", "4M"],
			bide: ["5L22", "5E", "4L18"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["5L29", "4M", "4L29"],
			bubble: ["5L8", "5S0", "5S3", "4L8"],
			bubblebeam: ["5L18", "4L18"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doublehit: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			drillpeck: ["5L39", "4L39"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			featherdance: ["5E", "5S1", "5S2", "5S3", "4E"],
			flail: ["5E", "4E"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furyattack: ["5L25", "4L25"],
			grassknot: ["5M", "4M"],
			growl: ["5L4", "5S0", "5S3", "4L4"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hydropump: ["5L43", "5E", "5S1", "4L43", "4E"],
			icebeam: ["5M", "4M"],
			icywind: ["5E", "4T"],
			mist: ["5L36", "4L36"],
			mudslap: ["5E", "4T", "4E"],
			mudsport: ["5E", "4E"],
			naturalgift: ["4M"],
			peck: ["5L15", "5S1", "5S2", "4L15"],
			pluck: ["5M", "4M"],
			pound: ["5L1", "5S0", "5S3", "4L1"],
			protect: ["5M", "4M"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M", "5S2"],
			scald: ["5M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["5E", "4T", "4E"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			supersonic: ["5E", "4E"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpledge: ["5T"],
			waterpulse: ["4M"],
			watersport: ["5L11", "5S1", "4L11"],
			whirlpool: ["5L32", "4M", "4L32"],
			yawn: ["5E", "4E"],
		},
	},
	prinplup: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			bide: ["5L24", "4L19"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["5L33", "4M", "4L33"],
			bubble: ["5L8", "4L8"],
			bubblebeam: ["5L19", "4L19"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			drillpeck: ["5L46", "4L46"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furyattack: ["5L28", "4L28"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hydropump: ["5L51", "4L51"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			metalclaw: ["5L16", "4L16"],
			mist: ["5L42", "4L42"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpledge: ["5T"],
			waterpulse: ["4M"],
			watersport: ["5L11", "4L11"],
			whirlpool: ["5L37", "4M", "4L37"],
		},
	},
	empoleon: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aquajet: ["5L36", "5S0", "4L36"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["5L33", "4M", "4L33"],
			bubble: ["5L1", "4L1"],
			bubblebeam: ["5L19", "4L19"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			drillpeck: ["5L52", "4L52"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furyattack: ["5L28", "4L28"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "5S0", "4M"],
			growl: ["5L1", "4L1"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hydrocannon: ["5T", "4T"],
			hydropump: ["5L59", "5S0", "4L59"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "5S0", "4M"],
			icywind: ["4T"],
			irondefense: ["4T"],
			knockoff: ["4T"],
			metalclaw: ["5L16", "4L16"],
			mist: ["5L46", "4L46"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			peck: ["5L15", "4L15"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			steelwing: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "5L24", "4M", "4L19"],
			swordsdance: ["5M", "5L11", "4M", "4L11"],
			tackle: ["5L1", "4L1"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpledge: ["5T"],
			waterpulse: ["4M"],
			whirlpool: ["5L39", "4M", "4L39"],
		},
	},
	starly: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L25", "4M", "4L25"],
			agility: ["5L33", "4L33"],
			aircutter: ["4T"],
			astonish: ["5E", "4E"],
			attract: ["5M", "4M"],
			bravebird: ["5L37", "4L37"],
			captivate: ["4M"],
			defog: ["4M"],
			detect: ["5E"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "5L13", "4M", "4L13"],
			echoedvoice: ["5M"],
			endeavor: ["5L17", "4T", "4L17"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			featherdance: ["5E", "4E"],
			finalgambit: ["5L41"],
			fly: ["5M", "4M"],
			foresight: ["5E", "4E"],
			frustration: ["5M", "4M"],
			furyattack: ["5E", "4E"],
			growl: ["5L1", "4L1", "4S0"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			pursuit: ["5E", "4E"],
			quickattack: ["5L5", "4L5"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			revenge: ["5E"],
			roost: ["5E", "4M"],
			round: ["5M"],
			sandattack: ["5E", "4E"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["5E", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1", "4S0"],
			tailwind: ["4T"],
			takedown: ["5L29", "4L29"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uproar: ["5E"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L21", "4L21"],
			wingattack: ["5L9", "4L9"],
			workup: ["5M"],
		},
	},
	staravia: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L28", "4M", "4L28"],
			agility: ["5L38", "4L38"],
			aircutter: ["4T"],
			attract: ["5M", "4M"],
			bravebird: ["5L43", "4L43"],
			captivate: ["4M"],
			defog: ["4M"],
			doubleteam: ["5M", "5L13", "4M", "4L13"],
			echoedvoice: ["5M"],
			endeavor: ["5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			featherdance: ["5D"],
			finalgambit: ["5L48"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			tailwind: ["5D", "4T"],
			takedown: ["5L33", "4L33"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L23", "4L23"],
			wingattack: ["5L9", "5D", "4L9"],
			workup: ["5M"],
		},
	},
	staraptor: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L28", "4M", "4L28"],
			agility: ["5L41", "4L41"],
			aircutter: ["4T"],
			attract: ["5M", "4M"],
			bravebird: ["5L49", "4L49"],
			captivate: ["4M"],
			closecombat: ["5L34", "4L34"],
			defog: ["4M"],
			doubleteam: ["5M", "5L13", "4M", "4L13"],
			echoedvoice: ["5M"],
			endeavor: ["5L18", "4T", "4L18"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			finalgambit: ["5L57"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M"],
			skyattack: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			steelwing: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			tailwind: ["4T"],
			takedown: ["5L33", "4L33"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			whirlwind: ["5L23", "4L23"],
			wingattack: ["5L1", "4L1"],
			workup: ["5M"],
		},
	},
	bidoof: {
		inherit: true,
		learnset: {
			amnesia: ["5L29", "4L29"],
			aquatail: ["5E", "5D", "4T", "4E"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			curse: ["5L45", "4L45"],
			cut: ["5M", "4M"],
			defensecurl: ["5L9", "5E", "4L9", "4E"],
			dig: ["5M", "4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["5E", "4M"],
			facade: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5E", "4E"],
			grassknot: ["5M", "4M"],
			growl: ["5L5", "4L5"],
			headbutt: ["5L17", "4T", "4L17"],
			hiddenpower: ["5M", "4M"],
			hyperfang: ["5L21", "4L21"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			odorsleuth: ["5E", "4E"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			quickattack: ["5E", "4E"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockclimb: ["5E"],
			rocksmash: ["5M", "4M"],
			rollout: ["5L13", "5E", "4T", "4L13", "4E"],
			round: ["5M"],
			secretpower: ["5D", "4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			skullbash: ["5E"],
			sleeptalk: ["5E", "4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superfang: ["5L37", "4T", "4L37"],
			superpower: ["5L41", "4T", "4L41"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "5D", "4L1", "4S0"],
			takedown: ["5L33", "4L33"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			watersport: ["5E", "4E"],
			workup: ["5M"],
			yawn: ["5L25", "4L25"],
		},
	},
	bibarel: {
		inherit: true,
		learnset: {
			amnesia: ["5L33", "4L33"],
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			curse: ["5L53", "4L53"],
			cut: ["5M", "4M"],
			defensecurl: ["5L9", "4L9"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fling: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			headbutt: ["5L18", "4T", "4L18"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			hyperfang: ["5L23", "4L23"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			irontail: ["4M"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M"],
			rollout: ["5L13", "4T", "4L13"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superfang: ["5L43", "4T", "4L43"],
			superpower: ["5L48", "4T", "4L48"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L38", "4L38"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			watergun: ["5L15", "4L15"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			workup: ["5M"],
			yawn: ["5L28", "4L28"],
		},
	},
	kricketot: {
		inherit: true,
		learnset: {
			bide: ["5L1", "4L1"],
			bugbite: ["5L16", "4T", "4L16"],
			endeavor: ["5D", "4T"],
			growl: ["5L1", "4L1"],
			mudslap: ["4T"],
			snore: ["4T"],
			stringshot: ["4T"],
			strugglebug: ["5L6"],
			uproar: ["5D", "4T"],
		},
	},
	kricketune: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			bide: ["5L1", "4L1"],
			brickbreak: ["5M", "4M"],
			bugbite: ["4T"],
			bugbuzz: ["5L46", "4L34"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "4M"],
			flash: ["5M", "4M"],
			focusenergy: ["5L22", "4L22"],
			frustration: ["5M", "4M"],
			furycutter: ["5L10", "4T", "4L10"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			knockoff: ["4T"],
			leechlife: ["5L14", "4L14"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L42", "4L42"],
			perishsong: ["5L50", "4L38"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			screech: ["5L34", "4L30"],
			secretpower: ["4M"],
			silverwind: ["4M"],
			sing: ["5L18", "4L18"],
			slash: ["5L26", "4L26"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L38", "4M", "4L38"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			xscissor: ["5M", "5L30", "4M", "4L26"],
		},
	},
	shinx: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bite: ["5L17", "4L13"],
			captivate: ["4M"],
			charge: ["5L9", "5D", "4L9"],
			chargebeam: ["5M", "4M"],
			crunch: ["5L33", "4L29"],
			discharge: ["5L41", "4L41"],
			doublekick: ["5E"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firefang: ["5E", "4E"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["5E"],
			hiddenpower: ["5M", "4M"],
			howl: ["5E", "4E"],
			icefang: ["5E", "4E"],
			irontail: ["4M"],
			leer: ["5L5", "4L5"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["5D", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "5D", "4E"],
			protect: ["5M", "4M"],
			quickattack: ["5E", "4E"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "5L21", "4M", "4L21"],
			round: ["5M"],
			scaryface: ["5L37", "4L37"],
			secretpower: ["4M"],
			shockwave: ["5E", "4M"],
			signalbeam: ["5E", "4T"],
			sleeptalk: ["4M"],
			snarl: ["5E"],
			snore: ["4T"],
			spark: ["5L13", "4L13"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			swagger: ["5M", "5L25", "4M", "4L25"],
			swift: ["5E", "4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5E", "4E"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderfang: ["5L29", "5E", "4L29", "4E"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L45"],
		},
	},
	luxio: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bite: ["5L18", "4L13"],
			captivate: ["4M"],
			charge: ["5L9", "4L9"],
			chargebeam: ["5M", "4M"],
			crunch: ["5L38", "4L33"],
			discharge: ["5L48", "4L48"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "5L23", "4M", "4L23"],
			round: ["5M"],
			scaryface: ["5L43", "4L43"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["5L13", "4L13"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			swagger: ["5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderfang: ["5L33", "4L33"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L53"],
		},
	},
	luxray: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bite: ["5L18", "4L13"],
			captivate: ["4M"],
			charge: ["5L1", "4L1"],
			chargebeam: ["5M", "4M"],
			crunch: ["5L42", "4L35"],
			discharge: ["5L56", "4L56"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "5L23", "4M", "4L23"],
			round: ["5M"],
			scaryface: ["5L49", "4L49"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["5L13", "4L13"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "5L28", "4M", "4L28"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderfang: ["5L35", "4L35"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L63"],
		},
	},
	cranidos: {
		inherit: true,
		learnset: {
			ancientpower: ["5L33", "4T", "4L28"],
			assurance: ["5L24", "4L24"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L28"],
			crunch: ["5E", "5S0", "4E"],
			curse: ["5E", "4E"],
			dig: ["5M", "4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			dragonpulse: ["4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["5D", "4T"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusenergy: ["5L6", "4L6"],
			frustration: ["5M", "4M"],
			hammerarm: ["5E", "4E"],
			headbutt: ["5L1", "5S0", "4T", "4L1"],
			headsmash: ["5L46", "4L43"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			ironhead: ["5E", "4T"],
			irontail: ["5E", "4M"],
			leer: ["5L1", "5E", "4L1", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			pursuit: ["5L10", "5S0", "4L10"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L19", "4L19"],
			screech: ["5L42", "4L37"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			slam: ["5E", "4E"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stomp: ["5E", "4E"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			takedown: ["5L15", "5S0", "4L15"],
			thief: ["5M", "4M"],
			thrash: ["5E", "4E"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			whirlwind: ["5E", "4E"],
			zenheadbutt: ["5L37", "4T", "4L33"],
		},
	},
	rampardos: {
		inherit: true,
		learnset: {
			ancientpower: ["5L36", "4T", "4L28"],
			assurance: ["5L24", "4L24"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			chipaway: ["5L28"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endeavor: ["5L30", "4T", "4L30"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focusenergy: ["5L6", "4L6"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["5L1", "4T", "4L1"],
			headsmash: ["5L58", "4L52"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			pursuit: ["5L10", "4L10"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L19", "4L19"],
			screech: ["5L51", "4L43"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			spite: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			takedown: ["5L15", "4L15"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			whirlpool: ["4M"],
			zenheadbutt: ["5L43", "4T", "4L36"],
		},
	},
	shieldon: {
		inherit: true,
		learnset: {
			ancientpower: ["5L28", "4T", "4L28"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bodyslam: ["5E", "5S0", "4E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			curse: ["5E", "4E"],
			dig: ["5M", "4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["5L33", "4M", "4L33"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			fissure: ["5E", "4E"],
			flamethrower: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			focusenergy: ["5E", "4E"],
			frustration: ["5M", "4M"],
			headbutt: ["5E", "4T", "4E"],
			heavyslam: ["5L46"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			irondefense: ["5L19", "4T", "4L19"],
			ironhead: ["5L42", "4T", "4L43"],
			irontail: ["4M"],
			magnetrise: ["4T"],
			metalburst: ["5L37", "4L37"],
			metalsound: ["5L10", "5S0", "4L10"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "5L1", "5S0", "4M", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockblast: ["5E", "4E"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5E", "4E"],
			screech: ["5E", "4E"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			stealthrock: ["5E", "4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "5L24", "4M", "4L24"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L15", "5S0", "4L15"],
			taunt: ["5M", "5L6", "4M", "4L6"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			wideguard: ["5E"],
		},
	},
	bastiodon: {
		inherit: true,
		learnset: {
			ancientpower: ["5L28", "4T", "4L28"],
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			block: ["5L30", "4T", "4L30"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["5L36", "4M", "4L36"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heavyslam: ["5L58"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			irondefense: ["5L19", "4T", "4L19"],
			ironhead: ["5L51", "4T", "4L52"],
			irontail: ["4M"],
			magiccoat: ["4T"],
			magnetrise: ["4T"],
			metalburst: ["5L43", "4L43"],
			metalsound: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "5L1", "4M", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "5L24", "4M", "4L24"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L15", "4L15"],
			taunt: ["5M", "5L1", "4M", "4L1"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
		},
	},
	burmy: {
		inherit: true,
		learnset: {
			bugbite: ["5L15", "5D", "4T", "4L15"],
			hiddenpower: ["5L20", "4L20"],
			protect: ["5L1", "5D", "4L1"],
			snore: ["5D", "4T"],
			stringshot: ["4T"],
			tackle: ["5L10", "4L10"],
		},
	},
	wormadam: {
		inherit: true,
		learnset: {
			attract: ["5M", "5L41", "4M", "4L41"],
			bugbite: ["5L15", "4T", "4L15"],
			bulletseed: ["4M"],
			captivate: ["5L35", "4M", "4L35"],
			confusion: ["5L23", "4L23"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flail: ["5L38", "4L38"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L29", "4L29"],
			hiddenpower: ["5M", "5L20", "4M", "4L20"],
			hyperbeam: ["5M", "4M"],
			leafstorm: ["5L47", "4L47"],
			naturalgift: ["4M"],
			protect: ["5M", "5L10", "4M", "4L10"],
			psybeam: ["5L32", "4L32"],
			psychic: ["5M", "5L44", "4M", "4L44"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			razorleaf: ["5L26", "4L26"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			synthesis: ["4T"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
			worryseed: ["4T"],
		},
	},
	wormadamsandy: {
		inherit: true,
		learnset: {
			attract: ["5M", "5L41", "4M", "4L41"],
			bugbite: ["5L15", "4T", "4L15"],
			bulldoze: ["5M"],
			captivate: ["5L35", "4M", "4L35"],
			confusion: ["5L23", "4L23"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fissure: ["5L47", "4L47"],
			flail: ["5L38", "4L38"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			harden: ["5L29", "4L29"],
			hiddenpower: ["5M", "5L20", "4M", "4L20"],
			hyperbeam: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "5L10", "4M", "4L10"],
			psybeam: ["5L32", "4L32"],
			psychic: ["5M", "5L44", "4M", "4L44"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockblast: ["5L26", "4L26"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
		},
	},
	wormadamtrash: {
		inherit: true,
		learnset: {
			attract: ["5M", "5L41", "4M", "4L41"],
			bugbite: ["5L15", "4T", "4L15"],
			captivate: ["5L35", "4M", "4L35"],
			confusion: ["5L23", "4L23"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flail: ["5L38", "4L38"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["4T"],
			gyroball: ["5M", "4M"],
			hiddenpower: ["5M", "5L20", "4M", "4L20"],
			hyperbeam: ["5M", "4M"],
			irondefense: ["4T"],
			ironhead: ["5L47", "4T", "4L47"],
			magnetrise: ["4T"],
			metalsound: ["5L29", "4L29"],
			mirrorshot: ["5L26", "4L26"],
			naturalgift: ["4M"],
			protect: ["5M", "5L10", "4M", "4L10"],
			psybeam: ["5L32", "4L32"],
			psychic: ["5M", "5L44", "4M", "4L44"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			venoshock: ["5M"],
		},
	},
	mothim: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			airslash: ["5L41", "4L41"],
			attract: ["5M", "4M"],
			bugbite: ["5L15", "4T", "4L15"],
			bugbuzz: ["5L47", "4L47"],
			camouflage: ["5L35", "4L35"],
			captivate: ["4M"],
			confusion: ["5L23", "4L23"],
			defog: ["4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L26", "4L26"],
			hiddenpower: ["5M", "5L20", "4M", "4L20"],
			hyperbeam: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonpowder: ["5L29", "4L29"],
			protect: ["5M", "5L10", "4M", "4L10"],
			psybeam: ["5L32", "4L32"],
			psychic: ["5M", "5L44", "4M", "4L44"],
			psychup: ["5M", "4M"],
			quiverdance: ["5L50"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			silverwind: ["5L38", "4M", "4L38"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			tailwind: ["4T"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
		},
	},
	combee: {
		inherit: true,
		learnset: {
			aircutter: ["5D", "4T"],
			bugbite: ["5L13", "4T", "4L13"],
			endeavor: ["4T"],
			gust: ["5L1", "4L1"],
			mudslap: ["4T"],
			ominouswind: ["4T"],
			snore: ["4T"],
			stringshot: ["4T"],
			sweetscent: ["5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["5D", "4T"],
		},
	},
	vespiquen: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			attackorder: ["5L37", "4L37"],
			attract: ["5M", "4M"],
			bugbite: ["4T"],
			captivate: ["5L33", "4M", "4L33"],
			confuseray: ["5L7", "4L7"],
			cut: ["5M", "4M"],
			defendorder: ["5L13", "4L13"],
			defog: ["4M"],
			destinybond: ["5L43", "4L43"],
			doubleteam: ["5M", "4M"],
			endeavor: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["5L9", "4T", "4L9"],
			furyswipes: ["5L19", "4L19"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L1", "4L1"],
			healorder: ["5L25", "4L25"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			poisonsting: ["5L3", "4L3"],
			powergem: ["5L21", "4L21"],
			protect: ["5M", "4M"],
			pursuit: ["5L15", "4L15"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roost: ["4M"],
			round: ["5M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			slash: ["5L31", "4L31"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			stringshot: ["4T"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "5L39", "4M", "4L39"],
			sweetscent: ["5L1", "4L1"],
			swift: ["4T"],
			tailwind: ["4T"],
			thief: ["5M", "4M"],
			toxic: ["5M", "5L27", "4M", "4L27"],
			uturn: ["5M", "4M"],
			venoshock: ["5M"],
			xscissor: ["5M", "4M"],
		},
	},
	pachirisu: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bestow: ["5E"],
			bide: ["5L1", "4L1"],
			bite: ["5E", "4E"],
			captivate: ["4M"],
			charge: ["5E"],
			chargebeam: ["5M", "4M"],
			charm: ["5L9", "4L9"],
			covet: ["5E", "5D", "4E"],
			cut: ["5M", "4M"],
			defensecurl: ["5E", "4E"],
			dig: ["5M", "4M"],
			discharge: ["5L41", "4L29"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			electroball: ["5L25"],
			endure: ["5L17", "4M", "4L17"],
			facade: ["5M", "4M"],
			faketears: ["5E", "4E"],
			flail: ["5E", "4E"],
			flash: ["5M", "4M"],
			flatter: ["5E", "4E"],
			fling: ["5M", "4M"],
			followme: ["5E"],
			frustration: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperfang: ["5L49"],
			irontail: ["5E", "4M"],
			lastresort: ["5L45", "4T", "4L37"],
			lightscreen: ["5M", "4M"],
			magnetrise: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L5", "5D", "4L5"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["5E", "4T", "4E"],
			round: ["5M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shockwave: ["5D", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spark: ["5L13", "4L13"],
			substitute: ["5M", "4M"],
			superfang: ["5L37", "4T", "4L33"],
			swagger: ["5M", "4M"],
			sweetkiss: ["5L29", "4L25"],
			swift: ["5L21", "4T", "4L21"],
			tailwhip: ["5E"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "5L33", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			voltswitch: ["5M"],
		},
	},
	buizel: {
		inherit: true,
		learnset: {
			agility: ["5L28", "4L28"],
			aquajet: ["5L21", "4L21"],
			aquaring: ["5E"],
			aquatail: ["5L55", "5E"],
			attract: ["5M", "4M"],
			batonpass: ["5E", "4E"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["4M"],
			bulkup: ["5M", "4M"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleslap: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["5E", "4E"],
			furyswipes: ["5E", "4E"],
			growl: ["5L1", "4L1"],
			hail: ["5M", "4M"],
			headbutt: ["5E", "4T", "4E"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			irontail: ["4M"],
			mefirst: ["5E"],
			mudslap: ["5E", "4T", "4E"],
			naturalgift: ["4M"],
			odorsleuth: ["5E", "4E"],
			protect: ["5M", "4M"],
			pursuit: ["5L10", "4L10"],
			quickattack: ["5L3", "4L3"],
			raindance: ["5M", "4M"],
			razorwind: ["5L45", "4L45"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			slash: ["5E", "5D", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["5L1", "4L1"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L15", "4T", "4L15"],
			switcheroo: ["5E"],
			tailslap: ["5E"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			watergun: ["5L6", "5D", "4L6"],
			waterpulse: ["5D", "4M"],
			watersport: ["5L1", "4L1"],
			whirlpool: ["5L36", "4M", "4L36"],
		},
	},
	floatzel: {
		inherit: true,
		learnset: {
			agility: ["5L29", "4L29"],
			aquajet: ["5L21", "4L21"],
			aquatail: ["5L62", "4T"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["4M"],
			bulkup: ["5M", "4M"],
			captivate: ["4M"],
			crunch: ["5L26", "4L26"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icefang: ["5L1", "4L1"],
			icepunch: ["4T"],
			icywind: ["4T"],
			irontail: ["4M"],
			lowkick: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			pursuit: ["5L10", "4L10"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			razorwind: ["5L50", "4L50"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			sonicboom: ["5L1", "4L1"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L15", "4T", "4L15"],
			taunt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			watergun: ["5L6", "4L6"],
			waterpulse: ["4M"],
			watersport: ["5L1", "4L1"],
			whirlpool: ["5L39", "4M", "4L39"],
		},
	},
	cherubi: {
		inherit: true,
		learnset: {
			aromatherapy: ["5E", "4E"],
			attract: ["5M", "4M"],
			bulletseed: ["5D", "4M"],
			captivate: ["4M"],
			defensecurl: ["5E"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5E", "4E"],
			growth: ["5L7", "4L7"],
			healingwish: ["5E"],
			healpulse: ["5E"],
			helpinghand: ["5L13", "4T", "4L13"],
			hiddenpower: ["5M", "4M"],
			leechseed: ["5L10", "4L10"],
			luckychant: ["5L40", "4L40"],
			magicalleaf: ["5L19", "4L19"],
			morningsun: ["5L1"],
			naturalgift: ["5E", "4M"],
			naturepower: ["5E", "4E"],
			protect: ["5M", "4M"],
			razorleaf: ["5E", "4E"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["5E", "4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["5E", "4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "5L37", "4M", "4L37"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "5L22", "4M", "4L22"],
			swagger: ["5M", "4M"],
			sweetscent: ["5E", "4E"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L31", "4L31"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M"],
			weatherball: ["5E", "4E"],
			worryseed: ["5L28", "4T", "4L28"],
		},
	},
	cherrim: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			growth: ["5L1", "4L1"],
			helpinghand: ["5L13", "4T", "4L13"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			leechseed: ["5L10", "4L10"],
			luckychant: ["5L48", "4L48"],
			magicalleaf: ["5L19", "4L19"],
			morningsun: ["5L1"],
			naturalgift: ["4M"],
			petaldance: ["5L25", "4L25"],
			protect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "5L43", "4M", "4L43"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "5L22", "4M", "4L22"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L35", "4L35"],
			toxic: ["5M", "4M"],
			worryseed: ["5L30", "4T", "4L30"],
		},
	},
	shellos: {
		inherit: true,
		learnset: {
			amnesia: ["5E", "4E"],
			ancientpower: ["4T"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			bodyslam: ["5L29", "4L29"],
			brine: ["5E", "4M"],
			captivate: ["4M"],
			clearsmog: ["5E"],
			counter: ["5E", "4E"],
			curse: ["5E", "4E"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fissure: ["5E", "4E"],
			frustration: ["5M", "4M"],
			hail: ["5M", "4M"],
			harden: ["5L4", "4L4"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "5L16", "4M", "4L16"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			memento: ["5E", "4E"],
			mirrorcoat: ["5E", "4E"],
			mist: ["5E"],
			mudbomb: ["5L11", "4L11"],
			muddywater: ["5L37", "4L37"],
			mudslap: ["5L1", "5D", "4T", "4L1"],
			mudsport: ["5L2", "4L2"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M"],
			raindance: ["5M", "5L22", "4M", "4L22"],
			recover: ["5L46", "4L46"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			scald: ["5M"],
			secretpower: ["5D", "4M"],
			sleeptalk: ["4M"],
			sludge: ["5E", "4E"],
			snore: ["4T"],
			spitup: ["5E", "4E"],
			stockpile: ["5E", "4E"],
			stringshot: ["4T"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swallow: ["5E", "4E"],
			toxic: ["5M", "4M"],
			trumpcard: ["5E", "4E"],
			waterpulse: ["5L7", "4M", "4L7"],
			whirlpool: ["4M"],
			yawn: ["5E", "5D", "4E"],
		},
	},
	gastrodon: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			attract: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			block: ["4T"],
			bodyslam: ["5L29", "4L29"],
			brine: ["4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			dig: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			hail: ["5M", "4M"],
			harden: ["5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "5L16", "4M", "4L16"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			mudbomb: ["5L11", "4L11"],
			muddywater: ["5L41", "4L41"],
			mudslap: ["5L1", "4T", "4L1"],
			mudsport: ["5L1", "4L1"],
			naturalgift: ["4M"],
			painsplit: ["4T"],
			protect: ["5M", "4M"],
			raindance: ["5M", "5L22", "4M", "4L22"],
			recover: ["5L54", "4L54"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandstorm: ["5M", "4M"],
			scald: ["5M"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			sludgewave: ["5M"],
			snore: ["4T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			stringshot: ["4T"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			toxic: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpulse: ["5L1", "4M", "4L1"],
			whirlpool: ["4M"],
		},
	},
	gastrodoneast: {
		inherit: true,
		learnset: {},
	},
	drifloon: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aircutter: ["4T"],
			astonish: ["5L6", "4L6"],
			attract: ["5M", "4M"],
			batonpass: ["5L38", "4L33"],
			bodyslam: ["5E", "4E"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			clearsmog: ["5E"],
			constrict: ["5L1", "4L1"],
			cut: ["5M", "4M"],
			defog: ["5E", "4M"],
			destinybond: ["5E", "4E"],
			disable: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "5L46", "4M", "4L43"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			focusenergy: ["5L14", "4L14"],
			frustration: ["5M", "4M"],
			gust: ["5L11", "4L11"],
			gyroball: ["5M", "4M"],
			haze: ["5E", "4E"],
			hex: ["5L22"],
			hiddenpower: ["5M", "4M"],
			hypnosis: ["5E", "5D", "4E"],
			icywind: ["4T"],
			knockoff: ["4T"],
			magiccoat: ["4T"],
			memento: ["5E", "4E"],
			minimize: ["5L1", "5D", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["5L33", "4T", "4L30"],
			painsplit: ["4T"],
			payback: ["5M", "5L17", "4M", "4L17"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "5L43", "4M", "4L38"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["5D", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			spitup: ["5L30", "4L27"],
			stockpile: ["5L27", "4L22"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swallow: ["5L30", "4L27"],
			swift: ["4T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			weatherball: ["5E", "4E"],
			willowisp: ["5M", "4M"],
		},
	},
	drifblim: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aircutter: ["4T"],
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			batonpass: ["5L44", "4L37"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			constrict: ["5L1", "4L1"],
			cut: ["5M", "4M"],
			defog: ["4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "5L56", "4M", "4L51"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fly: ["5M", "4M"],
			focusenergy: ["5L14", "4L14"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L1", "4L1"],
			gyroball: ["5M", "4M"],
			hex: ["5L22"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			magiccoat: ["4T"],
			minimize: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["5L37", "4T", "4L32"],
			painsplit: ["4T"],
			payback: ["5M", "5L17", "4M", "4L17"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "5L51", "4M", "4L44"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			spitup: ["5L32", "4L27"],
			stockpile: ["5L27", "4L22"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swallow: ["5L32", "4L27"],
			swift: ["4T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	buneary: {
		inherit: true,
		learnset: {
			afteryou: ["5L43"],
			agility: ["5L33", "4L33"],
			attract: ["5M", "4M", "4E"],
			batonpass: ["5L26", "4L26"],
			bounce: ["5L56", "4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L46", "4L43"],
			circlethrow: ["5E"],
			copycat: ["5E"],
			cut: ["5M", "4M"],
			defensecurl: ["5L1", "4L1"],
			dig: ["5M", "4M"],
			dizzypunch: ["5L36", "4L36"],
			doublehit: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["5D", "4M"],
			encore: ["5E", "4E"],
			endeavor: ["4T"],
			endure: ["5L6", "4M", "4L6"],
			entrainment: ["5L53"],
			facade: ["5M", "4M"],
			fakeout: ["5E", "5D", "4E"],
			faketears: ["5E", "4E"],
			firepunch: ["5E", "4E"],
			flail: ["5E", "4E"],
			fling: ["5M", "4M"],
			focuspunch: ["5E", "4M"],
			foresight: ["5L1", "5D", "4L1"],
			frustration: ["5M", "5L13", "4M", "4L13"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			healingwish: ["5L63", "4L53"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["5E", "4E"],
			irontail: ["4M"],
			jumpkick: ["5L23", "4L23"],
			lastresort: ["4T"],
			lowkick: ["5E", "4T", "4E"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			quickattack: ["5L16", "4L16"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			skyuppercut: ["5E", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			splash: ["5L1", "4L1"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			sweetkiss: ["5E", "4E"],
			swift: ["4T"],
			switcheroo: ["5E", "4E"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["5E", "4E"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	lopunny: {
		inherit: true,
		learnset: {
			afteryou: ["5L43"],
			agility: ["5L33", "4L33"],
			attract: ["5M", "4M"],
			batonpass: ["5L26", "4L26"],
			blizzard: ["5M", "4M"],
			bounce: ["5L56", "4T", "4L46"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L46", "4L43"],
			cut: ["5M", "4M"],
			defensecurl: ["5L1", "4L1"],
			dig: ["5M", "4M"],
			dizzypunch: ["5L36", "4L36"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M"],
			endeavor: ["4T"],
			endure: ["5L6", "4M", "4L6"],
			entrainment: ["5L53"],
			facade: ["5M", "4M"],
			firepunch: ["4T"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			healingwish: ["5L63", "4L53"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			irontail: ["4M"],
			jumpkick: ["5L23", "4L23"],
			lastresort: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magiccoat: ["5L1", "4T", "4L1"],
			mirrorcoat: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			pound: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			quickattack: ["5L16", "4L16"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "5L13", "4M", "4L13"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			splash: ["5L1", "4L1"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	glameow: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			assist: ["5L29", "4L29"],
			assurance: ["5E", "5D", "4E"],
			attract: ["5M", "5L44", "4M", "4L45"],
			bite: ["5E", "4E"],
			captivate: ["5L32", "4M", "4L32"],
			charm: ["5L25", "4L25"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fakeout: ["5L1", "5D", "4L1"],
			faketears: ["5E", "4E"],
			feintattack: ["5L17", "4L17"],
			flail: ["5E", "4E"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L20", "4L20"],
			growl: ["5L8", "4L8"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M", "5L48"],
			hypnosis: ["5L13", "4L13"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["5E", "4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			quickattack: ["5E", "4E"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5E", "4E"],
			scratch: ["5L5", "4L5"],
			secretpower: ["5D", "4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			slash: ["5L37", "4L37"],
			sleeptalk: ["4M"],
			snatch: ["5E", "4M"],
			snore: ["4T"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5L41", "4T", "4L41"],
			sunnyday: ["5M", "4M"],
			superfang: ["4T"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tailwhip: ["5E", "4E"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uturn: ["5M", "4M"],
			wakeupslap: ["5E"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	purugly: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			assist: ["5L29", "4L29"],
			attract: ["5M", "5L52", "4M", "4L53"],
			bodyslam: ["5L45", "4L45"],
			bulldoze: ["5M"],
			captivate: ["5L32", "4M", "4L32"],
			charm: ["5L25", "4L25"],
			cut: ["5M", "4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fakeout: ["5L1", "4L1"],
			feintattack: ["5L17", "4L17"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L20", "4L20"],
			gigaimpact: ["5M", "4M"],
			growl: ["5L1", "4L1"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M", "5L60"],
			hyperbeam: ["5M", "4M"],
			hypnosis: ["5L13", "4L13"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			scratch: ["5L1", "4L1"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			slash: ["5L37", "4L37"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			superfang: ["4T"],
			swagger: ["5M", "5L38", "4M", "4L38"],
			swift: ["4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M"],
			workup: ["5M"],
		},
	},
	stunky: {
		inherit: true,
		learnset: {
			acidspray: ["5L32"],
			astonish: ["5E", "4E"],
			attract: ["5M", "4M"],
			captivate: ["4M"],
			crunch: ["5E", "4E"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "5L49", "4M", "4L44"],
			facade: ["5M", "4M"],
			feint: ["5L18", "4L18"],
			fireblast: ["5M", "4M"],
			flameburst: ["5E"],
			flamethrower: ["5M", "4M"],
			focusenergy: ["5L1", "4L1"],
			foulplay: ["5E", "5D"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L10", "4L10"],
			haze: ["5E", "4E"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			irontail: ["5E", "4M"],
			leer: ["5E", "4E"],
			memento: ["5L43", "4L37"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L37", "4L31"],
			payback: ["5M", "4M"],
			poisongas: ["5L4", "4L4"],
			protect: ["5M", "4M"],
			punishment: ["5E", "4E"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5E", "4E"],
			scratch: ["5L1", "4L1"],
			screech: ["5L7", "5D", "4L7"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L22", "4L22"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			smog: ["5E", "4E"],
			smokescreen: ["5L14", "4L14"],
			snarl: ["5E"],
			snatch: ["4M"],
			snore: ["4T"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5D", "4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "5L27", "4M", "4L20"],
			venoshock: ["5M"],
		},
	},
	skuntank: {
		inherit: true,
		learnset: {
			acidspray: ["5L32"],
			attract: ["5M", "4M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "5L61", "4M", "4L52"],
			facade: ["5M", "4M"],
			feint: ["5L18", "4L18"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "5L34", "4M", "4L34"],
			focusenergy: ["5L1", "4L1"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			furyswipes: ["5L10", "4L10"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			irontail: ["4M"],
			memento: ["5L51", "4L41"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5L41", "4L31"],
			payback: ["5M", "4M"],
			poisongas: ["5L1", "4L1"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			scratch: ["5L1", "4L1"],
			screech: ["5L7", "4L7"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L22", "4L22"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			smokescreen: ["5L14", "4L14"],
			snatch: ["4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "5L27", "4M", "4L20"],
			venoshock: ["5M"],
		},
	},
	bronzor: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L14", "4L14"],
			confusion: ["5L1", "4L1"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			extrasensory: ["5L19", "4L19"],
			facade: ["5M", "4M"],
			feintattack: ["5L41", "4L41"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5L37", "4L37"],
			grassknot: ["5M", "4M"],
			gravity: ["5D", "4T"],
			gyroball: ["5M", "5L35", "4M", "4L35"],
			healblock: ["5L52", "4L52"],
			heavyslam: ["5L54"],
			hiddenpower: ["5M", "4M"],
			hypnosis: ["5L7", "5D", "4L7"],
			imprison: ["5L12", "4L12"],
			irondefense: ["5L26", "4L26"],
			lightscreen: ["5M", "4M"],
			naturalgift: ["4M"],
			payback: ["5M", "5L49", "4M", "4L49"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "5L30", "4M", "4L30"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["5D", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
		},
	},
	bronzong: {
		inherit: true,
		learnset: {
			ancientpower: ["4T"],
			block: ["5L33", "4T", "4L33"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L14", "4L14"],
			confusion: ["5L1", "4L1"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			explosion: ["5M", "4M"],
			extrasensory: ["5L19", "4L19"],
			facade: ["5M", "4M"],
			feintattack: ["5L50", "4L50"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5L43", "4L43"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			gyroball: ["5M", "5L38", "4M", "4L38"],
			healblock: ["5L67", "4L67"],
			heavyslam: ["5L72"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			hypnosis: ["5L1", "4L1"],
			imprison: ["5L1", "4L1"],
			irondefense: ["5L26", "4L26"],
			ironhead: ["4T"],
			lightscreen: ["5M", "4M"],
			naturalgift: ["4M"],
			payback: ["5M", "5L61", "4M", "4L61"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "5L1", "4M", "4L1"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			rollout: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "5L30", "4M", "4L30"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "5L1", "4M", "4L1"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			telekinesis: ["5M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	chatot: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			agility: ["5E", "4E"],
			aircutter: ["5E", "4T"],
			attract: ["5M", "4M"],
			captivate: ["4M"],
			chatter: ["5L21", "4L21", "4S0"],
			defog: ["5E", "4M"],
			doubleteam: ["5M", "4M"],
			echoedvoice: ["5M", "5L37"],
			encore: ["5E", "4E"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			featherdance: ["5L53", "4L41"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furyattack: ["5L17", "4L17", "4S0"],
			growl: ["5L5", "4L5"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			hypervoice: ["5L57", "4L45"],
			mimic: ["5L33", "4L29"],
			mirrormove: ["5L9", "5D", "4L9", "4S0"],
			mudslap: ["4T"],
			nastyplot: ["5E", "5D", "4E"],
			naturalgift: ["4M"],
			nightshade: ["5E", "4E"],
			ominouswind: ["4T"],
			peck: ["5L1", "4L1"],
			pluck: ["5M", "4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roleplay: ["5D", "4T"],
			roost: ["5L41", "4M", "4L33"],
			round: ["5M", "5L29"],
			secretpower: ["4M"],
			sing: ["5L13", "4L13"],
			skyattack: ["4T"],
			sleeptalk: ["5E", "4M"],
			snore: ["4T"],
			steelwing: ["5E", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			supersonic: ["5E", "4E"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			synchronoise: ["5L49"],
			tailwind: ["4T"],
			taunt: ["5M", "5L25", "4M", "4L25", "4S0"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uproar: ["5L45", "4T", "4L37"],
			uturn: ["5M", "4M"],
			workup: ["5M"],
		},
	},
	spiritomb: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			captivate: ["5E", "4M"],
			confuseray: ["5L1", "4L1"],
			curse: ["5L1", "4L1"],
			darkpulse: ["5L49", "5S0", "4M", "4L49"],
			destinybond: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "5L19", "4M", "4L19"],
			embargo: ["5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feintattack: ["5L7", "4L7"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			grudge: ["5E", "4E"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			hypnosis: ["5L13", "4L13"],
			icywind: ["5D", "4T"],
			imprison: ["5E", "4E"],
			memento: ["5L43", "4L43"],
			nastyplot: ["5L37", "4L37"],
			naturalgift: ["4M"],
			nightmare: ["5E"],
			ominouswind: ["5L25", "4T", "4L25"],
			painsplit: ["5E", "5D", "4T", "4E"],
			protect: ["5M", "4M"],
			psychic: ["5M", "5S0", "4M"],
			psychup: ["5M", "4M"],
			pursuit: ["5L1", "4L1"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowsneak: ["5L1", "5E", "4L1", "4E"],
			shockwave: ["4M"],
			silverwind: ["5S0", "4M"],
			sleeptalk: ["4M"],
			smokescreen: ["5E", "4E"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["5L1", "5D", "4T", "4L1"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5L31", "4T", "4L31"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			uproar: ["4T"],
			waterpulse: ["4M"],
			willowisp: ["5M", "4M"],
		},
	},
	gible: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			bodyslam: ["5E", "4E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			dig: ["5M", "5L31", "4M", "4L31"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5E", "4E"],
			dragonclaw: ["5M", "5L27", "4M", "4L27"],
			dragonpulse: ["4M"],
			dragonrage: ["5L7", "4L7"],
			dragonrush: ["5L37", "4L37"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["5D", "4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			ironhead: ["5E", "4T", "4E"],
			irontail: ["5E"],
			metalclaw: ["5E", "4E"],
			mudshot: ["5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5E", "4T", "4E"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["5E", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L3", "4L3"],
			sandstorm: ["5M", "5L13", "4M", "4L13"],
			sandtomb: ["5L19", "5E", "4L19", "4E"],
			scaryface: ["5E", "4E"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L25", "4L25"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L15", "4L15"],
			thrash: ["5E", "4E"],
			toxic: ["5M", "4M"],
			twister: ["5E", "4T", "4E"],
		},
	},
	gabite: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			attract: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			dig: ["5M", "5L40", "4M", "4L40"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "4T"],
			dragonclaw: ["5M", "5L33", "4M", "4L33"],
			dragonpulse: ["4M"],
			dragonrage: ["5L7", "4L7"],
			dragonrush: ["5L49", "4L49"],
			dualchop: ["5L24"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			sandstorm: ["5M", "5L13", "4M", "4L13"],
			sandtomb: ["5L19", "4L19"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L28", "4L28"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L15", "4L15"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
		},
	},
	garchomp: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L48", "5S1", "4L48"],
			cut: ["5M", "4M"],
			dig: ["5M", "5L40", "5S1", "4M", "4L40"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "4T"],
			dragonclaw: ["5M", "5L33", "5S1", "4M", "4L33"],
			dragonpulse: ["4M"],
			dragonrage: ["5L1", "4L1"],
			dragonrush: ["5L55", "4L55"],
			dragontail: ["5M"],
			dualchop: ["5L24"],
			earthpower: ["4T"],
			earthquake: ["5M", "5S0", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firefang: ["5L1", "4L1"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["5S0", "5S1", "4T"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			sandstorm: ["5M", "5L1", "4M", "4L1"],
			sandtomb: ["5L19", "4L19"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			slash: ["5L28", "4L28"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5S0", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "5S0", "4M"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L15", "4L15"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			whirlpool: ["4M"],
		},
	},
	riolu: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			attract: ["5M", "4M"],
			aurasphere: ["4S0"],
			bite: ["5E", "4E"],
			blazekick: ["5E", "4E"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			bulletpunch: ["5E", "4E", "4S0"],
			captivate: ["4M"],
			circlethrow: ["5E"],
			copycat: ["5L29", "4L29"],
			counter: ["5L6", "4L6"],
			crosschop: ["5E", "4E"],
			crunch: ["5E", "4E"],
			detect: ["5E", "4E"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M", "4S0"],
			earthquake: ["5M", "4M"],
			endure: ["5L1", "4M", "4L1"],
			facade: ["5M", "4M"],
			feint: ["5L15", "4L15"],
			finalgambit: ["5L55"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["5D", "4M"],
			followme: ["5E", "4E"],
			forcepalm: ["5L11", "4L11"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			highjumpkick: ["5E", "4E"],
			icepunch: ["4T"],
			irondefense: ["5E", "4T", "4E"],
			irontail: ["4M"],
			lowkick: ["5E", "4T", "4E"],
			lowsweep: ["5M"],
			magnetrise: ["4T"],
			mindreader: ["5E", "4E"],
			mudslap: ["4T"],
			nastyplot: ["5L47"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			reversal: ["5L19", "4L19"],
			roar: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			screech: ["5L24", "4L24"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M", "4S0"],
			skyuppercut: ["5E", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			vacuumwave: ["5E", "4T", "4E"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	lucario: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			aurasphere: ["5L51", "4L37", "4S0"],
			blazekick: ["4S1"],
			bonerush: ["5L19", "4L19", "4S1"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			bulletpunch: ["5S2", "5S3"],
			calmmind: ["5M", "5L47", "4M"],
			captivate: ["4M"],
			closecombat: ["5L55", "5S3", "4L42"],
			counter: ["5L6", "5S2", "4L6"],
			darkpulse: ["5L1", "4M", "4L1", "4S0"],
			detect: ["5L1", "5S2", "4L1"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dragonpulse: ["5L60", "4M", "4L47", "4S0"],
			drainpunch: ["4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			extremespeed: ["5L65", "4L51"],
			facade: ["5M", "4M"],
			feint: ["5L15", "4L15"],
			flashcannon: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			forcepalm: ["5L11", "4L11", "4S1"],
			foresight: ["5L1", "4L1"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			healpulse: ["5L42"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			irondefense: ["4T"],
			irontail: ["4M"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			magnetrise: ["4T"],
			mefirst: ["5L29", "4L29"],
			metalclaw: ["5L1", "5S2", "4L1"],
			metalsound: ["5L24", "4L24"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			quickattack: ["5L1", "4L1"],
			quickguard: ["5L33"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "5S3", "4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stoneedge: ["5M", "5S3", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M", "4S1"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "5L37", "4M", "4L33"],
			thunderpunch: ["4T"],
			toxic: ["5M", "4M"],
			vacuumwave: ["4T"],
			waterpulse: ["4M", "4S0"],
			workup: ["5M"],
			zenheadbutt: ["4T"],
		},
	},
	hippopotas: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bite: ["5L7", "5D", "4L7"],
			bodyslam: ["5E", "4E"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L31", "4L31"],
			curse: ["5E", "4E"],
			dig: ["5M", "5L19", "4M", "4L19"],
			doubleedge: ["5L44", "4L44"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L37", "4M", "4L37"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fissure: ["5L50", "4L50"],
			frustration: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			revenge: ["5E", "4E"],
			roar: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			sandstorm: ["5M", "4M"],
			sandtomb: ["5L25", "5E", "4L25", "4E"],
			secretpower: ["4M"],
			slackoff: ["5E", "4E"],
			sleeptalk: ["5E", "4M"],
			snore: ["4T"],
			spitup: ["5E", "4E"],
			stealthrock: ["4M"],
			stockpile: ["5E", "5D", "4E"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["5D", "4T"],
			swagger: ["5M", "4M"],
			swallow: ["5E", "4E"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L19", "4L19"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			whirlwind: ["5E"],
			yawn: ["5L13", "4L13"],
		},
	},
	hippowdon: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bite: ["5L1", "4L1"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L31", "4L31"],
			dig: ["5M", "5L19", "4M", "4L19"],
			doubleedge: ["5L50", "4L50"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "5L40", "4M", "4L40"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firefang: ["5L1", "4L1"],
			fissure: ["5L60", "4L60"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icefang: ["5L1", "4L1"],
			ironhead: ["4T"],
			irontail: ["4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5L1", "4L1"],
			sandstorm: ["5M", "4M"],
			sandtomb: ["5L25", "4L25"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T"],
			swagger: ["5M", "4M"],
			tackle: ["5L1", "4L1"],
			takedown: ["5L19", "4L19"],
			thunderfang: ["5L1", "4L1"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			yawn: ["5L1", "4L1"],
		},
	},
	skorupi: {
		inherit: true,
		learnset: {
			acupressure: ["5L17", "4L17"],
			aerialace: ["5M", "4M"],
			agility: ["5E", "5D", "4E"],
			aquatail: ["5D", "4T"],
			attract: ["5M", "4M"],
			bite: ["5L1", "5D", "4L1"],
			brickbreak: ["5M", "4M"],
			bugbite: ["5L34", "4T", "4L34"],
			captivate: ["4M"],
			confuseray: ["5E", "4E"],
			crosspoison: ["5L61", "4L50"],
			crunch: ["5L56", "4L45"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "4M"],
			feintattack: ["5E", "4E"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M", "5L45"],
			irontail: ["5E", "4M"],
			knockoff: ["5L6", "4T", "4L6"],
			leer: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			nightslash: ["5E", "4E"],
			payback: ["5M", "4M"],
			pinmissile: ["5L12", "4L12"],
			poisonfang: ["5L39", "4L39"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1"],
			poisontail: ["5E"],
			protect: ["5M", "4M"],
			pursuit: ["5E", "4E"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			sandattack: ["5E", "4E"],
			scaryface: ["5L23", "4L23"],
			screech: ["5E", "4E"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			slash: ["5E", "4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			toxicspikes: ["5L28", "4L28"],
			twineedle: ["5E"],
			venoshock: ["5M", "5L50"],
			whirlwind: ["5E", "4E"],
			xscissor: ["5M", "4M"],
		},
	},
	drapion: {
		inherit: true,
		learnset: {
			acupressure: ["5L17", "4L17"],
			aerialace: ["5M", "4M"],
			aquatail: ["4T"],
			attract: ["5M", "4M"],
			bite: ["5L1", "4L1"],
			brickbreak: ["5M", "4M"],
			bugbite: ["5L34", "4T", "4L34"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crosspoison: ["5L73", "4L58"],
			crunch: ["5L65", "4L49"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			falseswipe: ["5M", "4M"],
			firefang: ["5L1", "4L1"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M", "5L48"],
			hyperbeam: ["5M", "4M"],
			icefang: ["5L1", "4L1"],
			irontail: ["4M"],
			knockoff: ["5L1", "4T", "4L1"],
			leer: ["5L1", "4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			pinmissile: ["5L12", "4L1"],
			poisonfang: ["5L39", "4L39"],
			poisonjab: ["5M", "4M"],
			poisonsting: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5L23", "4L23"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			strength: ["5M", "4M"],
			strugglebug: ["5M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunderfang: ["5L1", "4L1"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			toxicspikes: ["5L28", "4L28"],
			venoshock: ["5M", "5L56"],
			xscissor: ["5M", "4M"],
		},
	},
	croagunk: {
		inherit: true,
		learnset: {
			acupressure: ["5E"],
			astonish: ["5L1", "5S0", "4L1"],
			attract: ["5M", "4M"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			bulletpunch: ["5E", "4E"],
			captivate: ["4M"],
			counter: ["5E", "4E"],
			crosschop: ["5E", "4E"],
			darkpulse: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["5E", "5D"],
			dynamicpunch: ["5E", "4E"],
			earthquake: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fakeout: ["5E", "4E"],
			feint: ["5E", "4E"],
			feintattack: ["5L17", "4L17"],
			flatter: ["5L50", "4L45"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gunkshot: ["5D", "4T"],
			headbutt: ["5E", "4T", "4E"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			meditate: ["5E", "4E"],
			mefirst: ["5E", "4E"],
			mudbomb: ["5L29", "4L29"],
			mudslap: ["5L3", "5S0", "5S1", "4T", "4L3"],
			nastyplot: ["5L38", "4L36"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L43", "5S1", "4M", "4L38"],
			poisonsting: ["5L8", "5D", "5S0", "5S1", "4L8"],
			protect: ["5M", "4M"],
			pursuit: ["5L15", "4L15"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			revenge: ["5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "5L45", "4M", "4L43"],
			sludgewave: ["5M"],
			smellingsalts: ["5E", "4E"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5L31", "4T", "4L31"],
			sunnyday: ["5M", "4M"],
			superfang: ["4T"],
			swagger: ["5M", "5L24", "4M", "4L24"],
			taunt: ["5M", "5L10", "5S0", "5S1", "4M", "4L10"],
			thief: ["5M", "4M"],
			thunderpunch: ["4T"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			vacuumwave: ["5E", "4T", "4E"],
			venoshock: ["5M", "5L36"],
			wakeupslap: ["5E", "4E"],
			workup: ["5M"],
			xscissor: ["5M", "4M"],
		},
	},
	toxicroak: {
		inherit: true,
		learnset: {
			astonish: ["5L1", "4L1"],
			attract: ["5M", "4M"],
			bounce: ["4T"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			embargo: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feintattack: ["5L17", "4L17"],
			flatter: ["5L62", "4L54"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			gunkshot: ["4T"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lowkick: ["4T"],
			lowsweep: ["5M"],
			mudbomb: ["5L29", "4L29"],
			mudslap: ["5L1", "4T", "4L1"],
			nastyplot: ["5L41", "4L36"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "5L49", "4M", "4L41"],
			poisonsting: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			pursuit: ["5L15", "4L15"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			revenge: ["5L22", "4L22"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "5L54", "4M", "4L49"],
			sludgewave: ["5M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["5L31", "4T", "4L31"],
			sunnyday: ["5M", "4M"],
			superfang: ["4T"],
			swagger: ["5M", "5L24", "4M", "4L24"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "5L10", "4M", "4L10"],
			thief: ["5M", "4M"],
			thunderpunch: ["4T"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			vacuumwave: ["4T"],
			venoshock: ["5M", "5L36"],
			workup: ["5M"],
			xscissor: ["5M", "4M"],
		},
	},
	carnivine: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			bind: ["5L1", "4L1"],
			bite: ["5L7", "4L7"],
			bugbite: ["4T"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			crunch: ["5L41", "4L37"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			feintattack: ["5L27", "4L27"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gastroacid: ["5D", "4T"],
			gigadrain: ["5E", "4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5E"],
			growth: ["5L1", "4L1"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			ingrain: ["5L21", "4L21"],
			knockoff: ["4T"],
			leaftornado: ["5L31"],
			leechseed: ["5E", "4E"],
			magicalleaf: ["5E", "4E"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "4M"],
			powerwhip: ["5L51", "4L47"],
			protect: ["5M", "4M"],
			ragepowder: ["5E"],
			razorleaf: ["5E", "4E"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			slam: ["5E", "4E"],
			sleeppowder: ["5E", "4E"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			spitup: ["5L37", "4L31"],
			stockpile: ["5L37", "4L31"],
			stunspore: ["5E", "4E"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swallow: ["5L37", "4L31"],
			sweetscent: ["5L17", "4L17"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5E", "4T", "4E"],
			thief: ["5M", "4M"],
			toxic: ["5M", "4M"],
			vinewhip: ["5L11", "4L11"],
			worryseed: ["5E", "4T", "4E"],
			wringout: ["5L47", "4L41"],
		},
	},
	finneon: {
		inherit: true,
		learnset: {
			agility: ["5E", "4E"],
			aircutter: ["4T"],
			aquaring: ["5L33", "4L33"],
			aquatail: ["5E", "4T", "4E"],
			attract: ["5M", "5L10", "5D", "4M", "4L10"],
			aurorabeam: ["5E"],
			blizzard: ["5M", "4M"],
			bounce: ["5L45", "4T", "4L45"],
			brine: ["5E", "4M"],
			captivate: ["5L26", "4M", "4L26"],
			charm: ["5E", "4E"],
			defog: ["4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flail: ["5E", "4E"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gust: ["5L17", "4L17"],
			hail: ["5M", "4M"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pound: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			psybeam: ["5E", "4E"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "5L13", "4M", "4L13"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "5L29", "4M", "4L29"],
			scald: ["5M"],
			secretpower: ["4M"],
			signalbeam: ["5E"],
			silverwind: ["5L49", "4M", "4L49"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			soak: ["5L54"],
			splash: ["5E", "4E"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			sweetkiss: ["5E", "5D", "4E"],
			swift: ["4T"],
			tailwind: ["4T"],
			tickle: ["5E", "4E"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "5L42", "4M", "4L42"],
			waterfall: ["5M", "4M"],
			watergun: ["5L6", "4L6"],
			waterpulse: ["5L22", "5D", "4M", "4L22"],
			whirlpool: ["5L38", "4M", "4L38"],
		},
	},
	lumineon: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			aquaring: ["5L35", "4L35"],
			aquatail: ["4T"],
			attract: ["5M", "5L1", "4M", "4L1"],
			blizzard: ["5M", "4M"],
			bounce: ["5L53", "4T", "4L53"],
			brine: ["4M"],
			captivate: ["5L26", "4M", "4L26"],
			defog: ["4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			gust: ["5L17", "4L17"],
			hail: ["5M", "4M"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["4T"],
			payback: ["5M", "4M"],
			pound: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "5L13", "4M", "4L13"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "5L29", "4M", "4L29"],
			scald: ["5M"],
			secretpower: ["4M"],
			silverwind: ["5L59", "4M", "4L59"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			soak: ["5L66"],
			substitute: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tailwind: ["4T"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			uturn: ["5M", "5L48", "4M", "4L48"],
			waterfall: ["5M", "4M"],
			watergun: ["5L1", "4L1"],
			waterpulse: ["5L22", "4M", "4L22"],
			whirlpool: ["5L42", "4M", "4L42"],
		},
	},
	snover: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			avalanche: ["5E", "4M"],
			blizzard: ["5M", "5L41", "4M", "4L41"],
			bulletseed: ["5E", "4M"],
			captivate: ["4M"],
			doubleedge: ["5E", "4E"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M"],
			gigadrain: ["5D", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L13", "4L13"],
			growth: ["5E", "4E"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			iceshard: ["5L26", "4L26"],
			icywind: ["5L9", "4T", "4L9"],
			ingrain: ["5L31", "4L31"],
			irontail: ["4M"],
			leechseed: ["5E", "4E"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			magicalleaf: ["5E", "4E"],
			mist: ["5L21", "5E", "4L21", "4E"],
			mudslap: ["4T"],
			naturalgift: ["5E", "4M"],
			powdersnow: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			razorleaf: ["5L5", "4L5"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["5E", "4T", "4E"],
			shadowball: ["5M", "4M"],
			sheercold: ["5L46", "4L46"],
			skullbash: ["5E", "4E"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stomp: ["5E", "4E"],
			substitute: ["5M", "4M"],
			swagger: ["5M", "5L17", "4M", "4L17"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			woodhammer: ["5L36", "4L36"],
			worryseed: ["4T"],
		},
	},
	abomasnow: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			avalanche: ["4M"],
			blizzard: ["5M", "5L47", "4M", "4L47"],
			block: ["4T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			bulletseed: ["4M"],
			captivate: ["4M"],
			doubleteam: ["5M", "4M"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frostbreath: ["5M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["5L13", "4L13"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["5L1", "4T", "4L1"],
			iceshard: ["5L26", "4L26"],
			icywind: ["5L1", "4T", "4L1"],
			ingrain: ["5L31", "4L31"],
			irontail: ["4M"],
			leer: ["5L1", "4L1"],
			lightscreen: ["5M", "4M"],
			mist: ["5L21", "4L21"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powdersnow: ["5L1", "4L1"],
			protect: ["5M", "4M"],
			raindance: ["5M", "4M"],
			razorleaf: ["5L1", "4L1"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			shadowball: ["5M", "4M"],
			sheercold: ["5L58", "4L58"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			swagger: ["5M", "5L17", "4M", "4L17"],
			swordsdance: ["5M", "4M"],
			synthesis: ["4T"],
			toxic: ["5M", "4M"],
			waterpulse: ["4M"],
			woodhammer: ["5L36", "4L36"],
			worryseed: ["4T"],
		},
	},
	rotom: {
		inherit: true,
		learnset: {
			astonish: ["5L1", "5S0", "4L1"],
			charge: ["5L57", "4L43"],
			chargebeam: ["5M", "4M"],
			confuseray: ["5L1", "4L1"],
			darkpulse: ["4M"],
			discharge: ["5L64", "4L50"],
			doubleteam: ["5M", "5L15", "4M", "4L15"],
			dreameater: ["5M", "4M"],
			electroball: ["5L43"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			hex: ["5L50"],
			hiddenpower: ["5M", "4M"],
			lightscreen: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["5L29", "4T", "4L29"],
			painsplit: ["4T"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["5L22", "5D", "4M", "4L22"],
			signalbeam: ["5D", "4T"],
			sleeptalk: ["4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			substitute: ["5M", "5L36", "4M", "4L36"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thundershock: ["5L1", "5S0", "4T", "4L1"],
			thunderwave: ["5M", "5L1", "5D", "4M", "4L1"],
			toxic: ["5M", "4M"],
			trick: ["5L1", "5S0", "4T", "4L1"],
			uproar: ["5L8", "5S0", "4T", "4L8"],
			voltswitch: ["5M"],
			willowisp: ["5M", "4M"],
		},
	},
	rotomheat: {
		inherit: true,
		learnset: {
			overheat: ["5R", "4R"],
		},
	},
	rotomwash: {
		inherit: true,
		learnset: {
			hydropump: ["5R", "4R"],
		},
	},
	rotomfrost: {
		inherit: true,
		learnset: {
			blizzard: ["5R", "4R"],
		},
	},
	rotomfan: {
		inherit: true,
		learnset: {
			airslash: ["5R", "4R"],
		},
	},
	rotommow: {
		inherit: true,
		learnset: {
			leafstorm: ["5R", "4R"],
		},
	},
	uxie: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			amnesia: ["5L46", "5S2", "4L46", "4S0", "4S1"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "4S0"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endure: ["5L16", "4M", "4L16"],
			energyball: ["5M", "4M"],
			extrasensory: ["5L51", "5S2", "4L51"],
			facade: ["5M", "4M"],
			firepunch: ["4T"],
			flail: ["5L61", "5S2", "4L61"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5L36", "5S2", "4L36", "4S0", "4S1"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			imprison: ["5L6", "4L6"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			memento: ["5L76", "4L76"],
			mudslap: ["4T"],
			naturalgift: ["5L66", "4M", "4L66"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "5L1", "4M", "4L1"],
			return: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M"],
			yawn: ["5L31", "4L31", "4S0", "4S1"],
			zenheadbutt: ["4T"],
		},
	},
	mesprit: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			blizzard: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			charm: ["5L46", "5S2", "4L46", "4S0", "4S1"],
			confusion: ["5L1", "4L1", "4S0"],
			copycat: ["5L61", "5S2", "4L61"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			extrasensory: ["5L51", "5S2", "4L51"],
			facade: ["5M", "4M"],
			firepunch: ["4T"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			healingwish: ["5L76", "4L76"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icepunch: ["4T"],
			imprison: ["5L6", "4L6"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lightscreen: ["5M", "4M"],
			luckychant: ["5L31", "4L31", "4S0", "4S1"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["5L66", "4M", "4L66"],
			protect: ["5M", "5L16", "4M", "4L16"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "5L1", "4M", "4L1"],
			return: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L21", "4T", "4L21", "4S1"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	azelf: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1", "4S0"],
			detect: ["5L16", "4L16"],
			doubleteam: ["5M", "4M"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			explosion: ["5M", "5L76", "4M", "4L76"],
			extrasensory: ["5L51", "5S2", "4L51"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firepunch: ["4T"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			futuresight: ["5L36", "5S2", "4L36", "4S0", "4S1"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			headbutt: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["4T"],
			imprison: ["5L6", "4L6"],
			incinerate: ["5M"],
			irontail: ["4M"],
			knockoff: ["4T"],
			lastresort: ["5L61", "5S2", "4T", "4L61"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["5L46", "5S2", "4L46", "4S0", "4S1"],
			naturalgift: ["5L66", "4M", "4L66"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "5L1", "4M", "4L1"],
			return: ["5M", "4M"],
			roleplay: ["4T"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["5L21", "4T", "4L21", "4S1"],
			taunt: ["5M", "4M"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["4T"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			uproar: ["5L31", "4T", "4L31", "4S0", "4S1"],
			uturn: ["5M", "4M"],
			waterpulse: ["4M"],
			zenheadbutt: ["4T"],
		},
	},
	dialga: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			ancientpower: ["5L10", "4T", "4L10", "4S0"],
			aurasphere: ["5L37", "5S4", "4L37"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			cut: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "5S4", "4T"],
			dragonbreath: ["5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["5S4", "4M"],
			dragontail: ["5M"],
			earthpower: ["5L33", "4T", "4L33", "4S1"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "5L50", "4M", "4L42"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["5L42", "4M"],
			magnetrise: ["4T"],
			metalburst: ["5L24", "4L24"],
			metalclaw: ["5L6", "4L6", "4S0"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			overheat: ["5M", "4M"],
			powergem: ["5L19", "4L19"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			roaroftime: ["5L46", "5S4", "4L40", "4S0", "4S1"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L1", "5S3", "4L1", "4S2"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			slash: ["5L15", "4L15", "4S1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
		},
	},
	palkia: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			ancientpower: ["5L10", "4T", "4L10", "4S0"],
			aquatail: ["5L24", "4T", "4L24"],
			aurasphere: ["5L37", "5S4", "4L37"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["4M"],
			bulkup: ["5M", "4M"],
			bulldoze: ["5M"],
			cut: ["5M", "4M"],
			dive: ["5M", "4T"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "5S4", "4T"],
			dragonbreath: ["5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["5M", "5L28", "4M", "4L28", "4S0"],
			dragonpulse: ["4M"],
			dragontail: ["5M"],
			earthpower: ["5L33", "4T", "4L33", "4S1"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S1"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hydropump: ["5L50", "5S4", "4L42"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			incinerate: ["5M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			outrage: ["4T"],
			powergem: ["5L19", "4L19"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			scaryface: ["5L1", "5S3", "4L1", "4S2"],
			secretpower: ["4M"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			slash: ["5L15", "4L15", "4S1"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spacialrend: ["5L46", "5S4", "4L40", "4S0", "4S1"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			waterpulse: ["5L6", "4M", "4L6", "4S0"],
			whirlpool: ["4M"],
		},
	},
	heatran: {
		inherit: true,
		learnset: {
			ancientpower: ["5L1", "4T", "4L1", "4S2"],
			attract: ["5M", "4M"],
			bugbite: ["4T"],
			bulldoze: ["5M"],
			captivate: ["4M"],
			crunch: ["5L33", "4L33", "4S1"],
			darkpulse: ["4M"],
			dig: ["5M", "4M"],
			doubleteam: ["5M", "4M"],
			dragonpulse: ["4M"],
			earthpower: ["5L73", "4T", "4L73", "4S2"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			eruption: ["4S2"],
			explosion: ["5M", "4M"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			firefang: ["5L17", "4L17"],
			firespin: ["5L57", "5S3", "4L57", "4S0"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["5L81", "4T", "4L81"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["5L65", "5S3", "4T", "4L65", "4S0"],
			lavaplume: ["5L49", "5S3", "4L49", "4S0", "4S1"],
			leer: ["5L9", "4L9"],
			magmastorm: ["5L96", "4L96", "4S2"],
			metalsound: ["5L25", "4L25", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			overheat: ["5M", "4M"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			scaryface: ["5L41", "5S3", "4L41", "4S0", "4S1"],
			secretpower: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "5L88", "4M", "4L88"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			taunt: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	regigigas: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			ancientpower: ["4T"],
			avalanche: ["4M"],
			block: ["4T"],
			brickbreak: ["5M", "4M"],
			bulldoze: ["5M"],
			confuseray: ["5L1", "4L1", "4S0", "4S1"],
			crushgrip: ["5L75", "4L75", "4S2"],
			dizzypunch: ["5L1", "4L1", "4S1"],
			doubleteam: ["5M", "4M"],
			drainpunch: ["4M"],
			earthpower: ["4T"],
			earthquake: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			firepunch: ["5L1", "4T", "4L1"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			foresight: ["5L1", "4L1", "4S1"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "5L100", "4M", "4L100"],
			gravity: ["4T"],
			headbutt: ["4T"],
			heavyslam: ["5L90"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icepunch: ["5L1", "4T", "4L1"],
			icywind: ["4T", "4S2"],
			ironhead: ["4T", "4S2"],
			knockoff: ["5L1", "4L1", "4S1"],
			megapunch: ["4L1"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			payback: ["5M", "5L65", "5S3"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			revenge: ["5L25", "5S3", "4L25"],
			rockclimb: ["4M"],
			rockpolish: ["5M", "4M"],
			rockslide: ["5M", "4M", "4S2"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			smackdown: ["5M"],
			snore: ["4T"],
			stomp: ["4L1", "4S0"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			superpower: ["4T", "4L25", "4S0"],
			swagger: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderpunch: ["5L1", "4T", "4L1"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			wideguard: ["5L40", "5S3"],
			zenheadbutt: ["5L50", "5S3", "4T", "4L50", "4S0"],
		},
	},
	giratina: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			aircutter: ["4T"],
			ancientpower: ["5L10", "4T", "4L10", "4S1"],
			aquatail: ["4T"],
			aurasphere: ["5L37", "5S4", "4L37"],
			bulldoze: ["5M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			destinybond: ["5L24", "4L24"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "4T"],
			dragonbreath: ["5L1", "5S3", "4L1", "4S2"],
			dragonclaw: ["5M", "5L28", "5S4", "4M", "4L28", "4S1"],
			dragonpulse: ["5S4", "4M"],
			dragontail: ["5M"],
			dreameater: ["5M", "4M"],
			earthpower: ["5L33", "4T", "4L33", "4S0"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			fly: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			gigaimpact: ["5M", "4M"],
			gravity: ["4T"],
			headbutt: ["4T"],
			healblock: ["4L50", "4S0"],
			hex: ["5L50"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "4M"],
			icywind: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			ominouswind: ["5L6", "4T", "4L6", "4S1"],
			outrage: ["4T"],
			painsplit: ["4T"],
			payback: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			rockclimb: ["4M"],
			rocksmash: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			scaryface: ["5L1", "5S3", "4L1", "4S2"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "5L42", "4M", "4L42"],
			shadowforce: ["5L46", "5S4", "4L40", "4S0", "4S1"],
			shadowsneak: ["5L19", "4L19"],
			shockwave: ["4M"],
			silverwind: ["4M"],
			slash: ["5L15", "4L15", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			spite: ["4T"],
			steelwing: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			twister: ["4T"],
			willowisp: ["5M", "4M"],
		},
	},
	cresselia: {
		inherit: true,
		learnset: {
			attract: ["5M", "4M"],
			aurorabeam: ["5L29", "4L29", "4S0"],
			calmmind: ["5M", "4M"],
			captivate: ["4M"],
			chargebeam: ["5M", "4M"],
			confusion: ["5L1", "4L1"],
			doubleteam: ["5M", "5L1", "4M", "4L1"],
			dreameater: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "5S2", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["5L38", "5S1", "4L38", "4S0"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "5S2", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "5S2", "4M"],
			icywind: ["4T"],
			lightscreen: ["5M", "4M"],
			lunardance: ["5L84", "4L84"],
			magiccoat: ["4T"],
			mist: ["5L20", "4L20", "4S0"],
			moonlight: ["5L57", "5S1", "4L57"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "5L93", "4M", "4L93"],
			psychocut: ["5L66", "5S1", "4L66"],
			psychoshift: ["5L75", "4L75"],
			psychup: ["5M", "4M"],
			psyshock: ["5M", "5S2"],
			raindance: ["5M", "4M"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "5L11", "4M", "4L11"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			slash: ["5L47", "5S1", "4L47", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			telekinesis: ["5M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	phione: {
		inherit: true,
		learnset: {
			acidarmor: ["5L31", "4L31"],
			ancientpower: ["4T"],
			aquaring: ["5L54", "4L54"],
			blizzard: ["5M", "4M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["5L1", "4L1"],
			bubblebeam: ["5L24", "4L24"],
			charm: ["5L9", "4L9"],
			dive: ["5M", "5L61", "4T", "4L61"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			grassknot: ["5M", "4M", "4S0"],
			hail: ["5M", "4M"],
			healbell: ["4T"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "5L69", "4M", "4L69", "4S0"],
			rest: ["5M", "4M", "4S0"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			scald: ["5M"],
			secretpower: ["4M"],
			signalbeam: ["4T"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["5M", "4M"],
			supersonic: ["5L16", "4L16"],
			surf: ["5M", "4M", "4S0"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpulse: ["5L46", "4M", "4L46"],
			watersport: ["5L1", "4L1"],
			whirlpool: ["5L39", "4M", "4L39"],
		},
	},
	manaphy: {
		inherit: true,
		learnset: {
			acidarmor: ["5L31", "4L31", "4S2"],
			ancientpower: ["4T"],
			aquaring: ["5L54", "4L54", "4S3"],
			blizzard: ["5M", "4M"],
			bounce: ["4T"],
			brine: ["4M"],
			bubble: ["5L1", "4L1", "4S0", "4S1"],
			bubblebeam: ["5L24", "4L24"],
			calmmind: ["5M", "4M"],
			charm: ["5L9", "4L9"],
			dive: ["5M", "5L61", "4T", "4L61"],
			doubleteam: ["5M", "4M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			hail: ["5M", "4M"],
			healbell: ["4T"],
			heartswap: ["5L76", "4L76", "4S2", "4S3"],
			helpinghand: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M"],
			mudslap: ["4T"],
			naturalgift: ["4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			raindance: ["5M", "5L69", "4M", "4L69"],
			reflect: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			scald: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M"],
			signalbeam: ["4T"],
			skillswap: ["4M"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			substitute: ["5M", "4M"],
			supersonic: ["5L16", "4L16"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			tailglow: ["5L1", "4L1", "4S0", "4S1"],
			toxic: ["5M", "4M"],
			uproar: ["4T"],
			uturn: ["5M", "4M"],
			waterfall: ["5M", "4M"],
			waterpulse: ["5L46", "4M", "4L46", "4S2", "4S3"],
			watersport: ["5L1", "4L1", "4S0", "4S1", "4S3"],
			whirlpool: ["5L39", "4M", "4L39", "4S2"],
		},
	},
	darkrai: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			cut: ["5M", "4M"],
			darkpulse: ["5L93", "4M", "4L93", "4S2"],
			darkvoid: ["5L66", "5S4", "4L66", "4S2"],
			disable: ["5L1", "4L1"],
			doubleteam: ["5M", "5L47", "4M", "4L47", "4S2", "4S3"],
			drainpunch: ["4M"],
			dreameater: ["5M", "5L84", "4M", "4L84"],
			embargo: ["5M", "4M", "4L75"],
			endure: ["4M"],
			facade: ["5M", "4M"],
			feintattack: ["5L29", "5S4", "4L29", "4S3"],
			flash: ["5M", "4M"],
			fling: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			focuspunch: ["4M"],
			frustration: ["5M", "4M"],
			gigaimpact: ["5M", "4M"],
			haze: ["5L57", "4L57"],
			headbutt: ["4T"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			hypnosis: ["5L20", "4L20", "4S0", "4S1", "4S3"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			incinerate: ["5M"],
			knockoff: ["4T"],
			lastresort: ["4T"],
			mudslap: ["4T"],
			nastyplot: ["5L75", "4L75"],
			naturalgift: ["4M"],
			nightmare: ["5L38", "5S4", "4L38", "4S0", "4S1", "4S3"],
			nightshade: ["4L1"],
			ominouswind: ["5L1", "5S4", "4T", "4L1"],
			payback: ["5M", "4M"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			pursuit: ["4L29", "4S0"],
			quickattack: ["5L11", "4L11", "4S0"],
			raindance: ["5M", "4M"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roaroftime: ["4S1"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			secretpower: ["4M"],
			shadowball: ["5M", "4M", "4S2"],
			shadowclaw: ["5M", "4M"],
			shockwave: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snatch: ["4M"],
			snore: ["4T"],
			spacialrend: ["4S1"],
			spite: ["4T"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			suckerpunch: ["4T"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			taunt: ["5M", "4M"],
			thief: ["5M", "4M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			torment: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			willowisp: ["5M", "4M"],
			xscissor: ["5M", "4M"],
		},
	},
	shaymin: {
		inherit: true,
		learnset: {
			aircutter: ["4T"],
			aromatherapy: ["5L64", "4L64", "4S0"],
			bulletseed: ["4M"],
			defensecurl: ["4L1"],
			doubleteam: ["5M", "4M"],
			earthpower: ["4T"],
			endeavor: ["4T"],
			endure: ["4M"],
			energyball: ["5M", "5L73", "4M", "4L73", "4S0"],
			facade: ["5M", "4M"],
			flash: ["5M", "4M"],
			frustration: ["5M", "4M"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			grasswhistle: ["4L82"],
			growth: ["5L1", "4L1", "4S1"],
			headbutt: ["4T"],
			healingwish: ["5L91", "4L91"],
			hiddenpower: ["5M", "4M"],
			hyperbeam: ["5M", "4M"],
			lastresort: ["4T"],
			leechseed: ["5L19", "5S2", "4L19", "4S1"],
			luckychant: ["4L91"],
			magicalleaf: ["5L10", "4L10", "4S1"],
			mudslap: ["4T"],
			naturalgift: ["5L46", "4M", "4L46"],
			ominouswind: ["4T"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			rest: ["5M", "4M"],
			return: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			secretpower: ["4M"],
			seedbomb: ["4T"],
			seedflare: ["5L100", "5S2", "4L100", "4S0"],
			sleeptalk: ["4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			substitute: ["5M", "4M", "4S0"],
			sunnyday: ["5M", "4M"],
			swagger: ["5M", "4M"],
			sweetkiss: ["5L82", "4L82"],
			sweetscent: ["5L37", "5S2", "4L37"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			synthesis: ["5L28", "5S2", "4T", "4L28", "4S1"],
			tailwind: ["4T"],
			toxic: ["5M", "4M"],
			worryseed: ["5L55", "4T", "4L55"],
			zenheadbutt: ["4T"],
		},
	},
	arceus: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "4M"],
			ancientpower: ["4T"],
			aquatail: ["4T"],
			avalanche: ["4M"],
			blizzard: ["5M", "4M"],
			brickbreak: ["5M", "4M"],
			brine: ["4M"],
			bulldoze: ["5M"],
			bulletseed: ["4M"],
			calmmind: ["5M", "4M"],
			chargebeam: ["5M", "4M"],
			cosmicpower: ["5L1", "4L1"],
			cut: ["5M", "4M"],
			darkpulse: ["4M"],
			defog: ["4M"],
			dive: ["4T"],
			doubleteam: ["5M", "4M"],
			dracometeor: ["5T", "4T"],
			dragonclaw: ["5M", "4M"],
			dragonpulse: ["4M"],
			dreameater: ["5M", "4M"],
			earthpower: ["5L20", "4T", "4L20"],
			earthquake: ["5M", "4M"],
			echoedvoice: ["5M"],
			endure: ["4M"],
			energyball: ["5M", "4M"],
			extremespeed: ["5L40", "4L40"],
			facade: ["5M", "4M"],
			fireblast: ["5M", "4M"],
			flamethrower: ["5M", "4M"],
			flash: ["5M", "4M"],
			flashcannon: ["5M", "4M"],
			fly: ["5M", "4M"],
			focusblast: ["5M", "4M"],
			frustration: ["5M", "4M"],
			furycutter: ["4T"],
			futuresight: ["5L60", "4L60"],
			gigadrain: ["4M"],
			gigaimpact: ["5M", "4M"],
			grassknot: ["5M", "4M"],
			gravity: ["5L10", "4T", "4L10"],
			hail: ["5M", "4M"],
			headbutt: ["4T"],
			heatwave: ["4T"],
			hiddenpower: ["5M", "4M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L80", "5S1", "4M", "4L80"],
			hypervoice: ["5L30", "4L30"],
			icebeam: ["5M", "4M"],
			icywind: ["4T"],
			incinerate: ["5M"],
			irondefense: ["4T"],
			ironhead: ["4T"],
			irontail: ["4M"],
			judgment: ["5L100", "5S1", "4L100", "4S0"],
			lastresort: ["4T"],
			lightscreen: ["5M", "4M"],
			magiccoat: ["4T"],
			mudslap: ["4T"],
			naturalgift: ["5L1", "4M", "4L1"],
			ominouswind: ["4T"],
			outrage: ["4T"],
			overheat: ["5M", "4M"],
			payback: ["5M", "4M"],
			perishsong: ["5L90", "5S1", "4L90"],
			poisonjab: ["5M", "4M"],
			protect: ["5M", "4M"],
			psychic: ["5M", "4M"],
			psychup: ["5M", "4M"],
			psyshock: ["5M"],
			punishment: ["5L1", "4L1"],
			quash: ["5M"],
			raindance: ["5M", "4M"],
			recover: ["5L70", "5S1", "4L70"],
			recycle: ["4M"],
			reflect: ["5M", "4M"],
			refresh: ["5L50", "4L50"],
			rest: ["5M", "4M"],
			retaliate: ["5M"],
			return: ["5M", "4M"],
			roar: ["5M", "4M"],
			roaroftime: ["4S0"],
			rockclimb: ["4M"],
			rockslide: ["5M", "4M"],
			rocksmash: ["5M", "4M"],
			rocktomb: ["5M", "4M"],
			round: ["5M"],
			safeguard: ["5M", "4M"],
			sandstorm: ["5M", "4M"],
			secretpower: ["4M"],
			seismictoss: ["5L1", "4L1"],
			shadowball: ["5M", "4M"],
			shadowclaw: ["5M", "4M"],
			shadowforce: ["4S0"],
			shockwave: ["4M"],
			signalbeam: ["4T"],
			silverwind: ["4M"],
			sleeptalk: ["4M"],
			sludgebomb: ["5M", "4M"],
			snore: ["4T"],
			solarbeam: ["5M", "4M"],
			spacialrend: ["4S0"],
			stealthrock: ["4M"],
			stoneedge: ["5M", "4M"],
			strength: ["5M", "4M"],
			substitute: ["5M", "4M"],
			sunnyday: ["5M", "4M"],
			surf: ["5M", "4M"],
			swagger: ["5M", "4M"],
			swift: ["4T"],
			swordsdance: ["5M", "4M"],
			tailwind: ["4T"],
			telekinesis: ["5M"],
			thunder: ["5M", "4M"],
			thunderbolt: ["5M", "4M"],
			thunderwave: ["5M", "4M"],
			toxic: ["5M", "4M"],
			trick: ["4T"],
			trickroom: ["5M", "4M"],
			twister: ["4T"],
			waterfall: ["5M", "4M"],
			waterpulse: ["4M"],
			whirlpool: ["4M"],
			willowisp: ["5M", "4M"],
			workup: ["5M"],
			xscissor: ["5M", "4M"],
			zenheadbutt: ["4T"],
		},
	},
	victini: {
		inherit: true,
		learnset: {
			brickbreak: ["5M"],
			chargebeam: ["5M"],
			confusion: ["5L1", "5S0"],
			doubleedge: ["5L65"],
			doubleteam: ["5M"],
			embargo: ["5M"],
			endure: ["5L9", "5S0"],
			energyball: ["5M"],
			facade: ["5M"],
			finalgambit: ["5L81"],
			fireblast: ["5M"],
			flameburst: ["5L41"],
			flamecharge: ["5M", "5L25"],
			flamethrower: ["5M"],
			flareblitz: ["5L73"],
			flash: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L1"],
			frustration: ["5M"],
			fusionbolt: ["5S1"],
			fusionflare: ["5S1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			headbutt: ["5L17"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M", "5L1", "5S0"],
			inferno: ["5L57"],
			lightscreen: ["5M"],
			overheat: ["5M", "5L97"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			psyshock: ["5M"],
			quickattack: ["5L1", "5S0"],
			rest: ["5M"],
			return: ["5M"],
			reversal: ["5L33"],
			rocksmash: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			searingshot: ["5L1", "5S1"],
			shadowball: ["5M"],
			solarbeam: ["5M"],
			storedpower: ["5L89"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uturn: ["5M"],
			vcreate: ["5S1", "5S2"],
			wildcharge: ["5M"],
			willowisp: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["5L49"],
		},
	},
	snivy: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aromatherapy: ["5S0"],
			attract: ["5M"],
			calmmind: ["5M"],
			captivate: ["5E"],
			coil: ["5L31"],
			cut: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M", "5S0"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gastroacid: ["5L40"],
			gigadrain: ["5L34"],
			glare: ["5E"],
			grassknot: ["5M"],
			grasspledge: ["5T"],
			growth: ["5L13", "5S0"],
			hiddenpower: ["5M"],
			irontail: ["5E"],
			leafblade: ["5L28"],
			leafstorm: ["5L43"],
			leaftornado: ["5L16"],
			leechseed: ["5L19"],
			leer: ["5L4"],
			lightscreen: ["5M"],
			magicalleaf: ["5E"],
			meanlook: ["5E"],
			megadrain: ["5L22"],
			mirrorcoat: ["5E"],
			naturalgift: ["5E"],
			protect: ["5M"],
			pursuit: ["5E"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			slam: ["5L25"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			sweetscent: ["5E"],
			swordsdance: ["5M"],
			synthesis: ["5S0"],
			tackle: ["5L1"],
			taunt: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			twister: ["5E"],
			vinewhip: ["5L7"],
			wrap: ["5L10"],
			wringout: ["5L37"],
		},
	},
	servine: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			calmmind: ["5M"],
			coil: ["5L36"],
			cut: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gastroacid: ["5L48"],
			gigadrain: ["5L40"],
			grassknot: ["5M"],
			grasspledge: ["5T"],
			growth: ["5L13"],
			hiddenpower: ["5M"],
			leafblade: ["5L32"],
			leafstorm: ["5L52"],
			leaftornado: ["5L16"],
			leechseed: ["5L20"],
			leer: ["5L1"],
			lightscreen: ["5M"],
			megadrain: ["5L24"],
			protect: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			slam: ["5L28"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			taunt: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			vinewhip: ["5L1"],
			wrap: ["5L1"],
			wringout: ["5L44"],
		},
	},
	serperior: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			calmmind: ["5M"],
			coil: ["5L38"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dragontail: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frenzyplant: ["5T"],
			frustration: ["5M"],
			gastroacid: ["5L56"],
			gigadrain: ["5L44", "5S0"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			grasspledge: ["5T"],
			growth: ["5L13"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leafblade: ["5L32"],
			leafstorm: ["5L62", "5S0"],
			leaftornado: ["5L16"],
			leechseed: ["5L20", "5S0"],
			leer: ["5L1"],
			lightscreen: ["5M"],
			megadrain: ["5L24"],
			protect: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			slam: ["5L28"],
			solarbeam: ["5M"],
			strength: ["5M"],
			substitute: ["5M", "5S0"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			taunt: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			vinewhip: ["5L1"],
			wrap: ["5L1"],
			wringout: ["5L50"],
		},
	},
	tepig: {
		inherit: true,
		learnset: {
			assurance: ["5L31"],
			attract: ["5M"],
			bodyslam: ["5E"],
			covet: ["5E"],
			curse: ["5E"],
			defensecurl: ["5L13"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			ember: ["5L7"],
			endeavor: ["5E"],
			facade: ["5M"],
			fireblast: ["5M"],
			firepledge: ["5T"],
			flamecharge: ["5M", "5L15"],
			flamethrower: ["5M", "5L33"],
			flareblitz: ["5L43"],
			frustration: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			headsmash: ["5L37"],
			heatcrash: ["5L27"],
			heavyslam: ["5E"],
			hiddenpower: ["5M"],
			incinerate: ["5M"],
			magnitude: ["5E"],
			odorsleuth: ["5L9"],
			overheat: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L39"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L21"],
			round: ["5M"],
			sleeptalk: ["5E"],
			smog: ["5L19"],
			solarbeam: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5E"],
			swagger: ["5M"],
			tackle: ["5L1"],
			tailwhip: ["5L3"],
			takedown: ["5L25"],
			taunt: ["5M"],
			thrash: ["5E"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			willowisp: ["5M"],
			yawn: ["5E"],
		},
	},
	pignite: {
		inherit: true,
		learnset: {
			armthrust: ["5L17"],
			assurance: ["5L36"],
			attract: ["5M"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			defensecurl: ["5L13"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			ember: ["5L1"],
			facade: ["5M"],
			fireblast: ["5M"],
			firepledge: ["5T"],
			flamecharge: ["5M", "5L15"],
			flamethrower: ["5M", "5L39"],
			flareblitz: ["5L52"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			headsmash: ["5L44"],
			heatcrash: ["5L31"],
			hiddenpower: ["5M"],
			incinerate: ["5M"],
			lowsweep: ["5M"],
			odorsleuth: ["5L1"],
			overheat: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L47"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L23"],
			round: ["5M"],
			smog: ["5L20"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			tailwhip: ["5L1"],
			takedown: ["5L28"],
			taunt: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			willowisp: ["5M"],
			workup: ["5M"],
		},
	},
	emboar: {
		inherit: true,
		learnset: {
			armthrust: ["5L17"],
			assurance: ["5L38"],
			attract: ["5M"],
			blastburn: ["5T"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			bulldoze: ["5M"],
			defensecurl: ["5L13"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			echoedvoice: ["5M"],
			ember: ["5L1"],
			facade: ["5M"],
			fireblast: ["5M"],
			firepledge: ["5T"],
			flamecharge: ["5M", "5L15"],
			flamethrower: ["5M", "5L43"],
			flareblitz: ["5L62", "5S0"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			hammerarm: ["5L1", "5S0"],
			headsmash: ["5L50", "5S0"],
			heatcrash: ["5L31"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			lowsweep: ["5M"],
			odorsleuth: ["5L1"],
			overheat: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L55"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L23"],
			round: ["5M"],
			scald: ["5M"],
			smackdown: ["5M"],
			smog: ["5L20"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			tailwhip: ["5L1"],
			takedown: ["5L28"],
			taunt: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M", "5S0"],
			willowisp: ["5M"],
			workup: ["5M"],
		},
	},
	oshawott: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			airslash: ["5E"],
			aquajet: ["5L29"],
			aquatail: ["5L35"],
			assurance: ["5E"],
			attract: ["5M"],
			blizzard: ["5M"],
			brine: ["5E"],
			copycat: ["5E"],
			cut: ["5M"],
			detect: ["5E"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			encore: ["5L31"],
			facade: ["5M"],
			falseswipe: ["5M"],
			fling: ["5M"],
			focusenergy: ["5L13"],
			frustration: ["5M"],
			furycutter: ["5L19"],
			grassknot: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L43"],
			icebeam: ["5M"],
			nightslash: ["5E"],
			protect: ["5M"],
			raindance: ["5M"],
			razorshell: ["5L17"],
			rest: ["5M"],
			retaliate: ["5M", "5L37"],
			return: ["5M"],
			revenge: ["5L25"],
			rocksmash: ["5M"],
			round: ["5M"],
			scald: ["5M"],
			screech: ["5E"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L41"],
			tackle: ["5L1"],
			tailwhip: ["5L5"],
			taunt: ["5M"],
			toxic: ["5M"],
			trumpcard: ["5E"],
			waterfall: ["5M"],
			watergun: ["5L7"],
			waterpledge: ["5T"],
			waterpulse: ["5L23"],
			watersport: ["5L11"],
			xscissor: ["5M"],
		},
	},
	dewott: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aquajet: ["5L33"],
			aquatail: ["5L41"],
			attract: ["5M"],
			blizzard: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			encore: ["5L36"],
			facade: ["5M"],
			falseswipe: ["5M"],
			fling: ["5M"],
			focusenergy: ["5L13"],
			frustration: ["5M"],
			furycutter: ["5L20"],
			grassknot: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L52"],
			icebeam: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			razorshell: ["5L17"],
			rest: ["5M"],
			retaliate: ["5M", "5L44"],
			return: ["5M"],
			revenge: ["5L28"],
			rocksmash: ["5M"],
			round: ["5M"],
			scald: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L49"],
			tackle: ["5L1"],
			tailwhip: ["5L1"],
			taunt: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			watergun: ["5L1"],
			waterpledge: ["5T"],
			waterpulse: ["5L25"],
			watersport: ["5L1"],
			xscissor: ["5M"],
		},
	},
	samurott: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aquajet: ["5L33"],
			aquatail: ["5L45"],
			attract: ["5M"],
			blizzard: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			dragontail: ["5M"],
			encore: ["5L38"],
			facade: ["5M"],
			falseswipe: ["5M"],
			fling: ["5M"],
			focusenergy: ["5L13"],
			frustration: ["5M"],
			furycutter: ["5L20"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydrocannon: ["5T"],
			hydropump: ["5L62", "5S0"],
			hyperbeam: ["5M"],
			icebeam: ["5M", "5S0"],
			megahorn: ["5L1", "5S0"],
			protect: ["5M"],
			raindance: ["5M"],
			razorshell: ["5L17"],
			rest: ["5M"],
			retaliate: ["5M", "5L50"],
			return: ["5M"],
			revenge: ["5L28"],
			rocksmash: ["5M"],
			round: ["5M"],
			scald: ["5M"],
			slash: ["5L36"],
			strength: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L57"],
			tackle: ["5L1"],
			tailwhip: ["5L1"],
			taunt: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			watergun: ["5L1"],
			waterpledge: ["5T"],
			waterpulse: ["5L25"],
			watersport: ["5L1"],
			xscissor: ["5M"],
		},
	},
	patrat: {
		inherit: true,
		learnset: {
			afteryou: ["5L23"],
			assurance: ["5E"],
			attract: ["5M"],
			batonpass: ["5L33"],
			bide: ["5L8"],
			bite: ["5L6"],
			crunch: ["5L16"],
			cut: ["5M"],
			detect: ["5L11"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flail: ["5E"],
			fling: ["5M"],
			foresight: ["5E"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			hyperfang: ["5L28"],
			hypnosis: ["5L18"],
			irontail: ["5E"],
			leer: ["5L3"],
			meanlook: ["5L31"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			revenge: ["5E"],
			round: ["5M"],
			sandattack: ["5L13"],
			screech: ["5E"],
			shadowball: ["5M"],
			slam: ["5L36"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superfang: ["5L21"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			thunderbolt: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L26"],
		},
	},
	watchog: {
		inherit: true,
		learnset: {
			afteryou: ["5L25"],
			attract: ["5M"],
			batonpass: ["5L39"],
			bide: ["5L8"],
			bite: ["5L1"],
			confuseray: ["5L20"],
			crunch: ["5L16"],
			cut: ["5M"],
			detect: ["5L11"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			facade: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			hyperfang: ["5L32"],
			hypnosis: ["5L18"],
			leer: ["5L1"],
			lightscreen: ["5M"],
			lowkick: ["5L1"],
			meanlook: ["5L36"],
			protect: ["5M"],
			psychup: ["5M", "5L29"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sandattack: ["5L13"],
			shadowball: ["5M"],
			slam: ["5L43"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superfang: ["5L22"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			workup: ["5M"],
		},
	},
	lillipup: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bite: ["5L8"],
			charm: ["5E"],
			crunch: ["5L22"],
			dig: ["5M"],
			doubleteam: ["5M"],
			endure: ["5E"],
			facade: ["5M"],
			firefang: ["5E"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L40"],
			helpinghand: ["5L12"],
			hiddenpower: ["5M"],
			howl: ["5E"],
			icefang: ["5E"],
			lastresort: ["5L36"],
			leer: ["5L1"],
			lick: ["5E"],
			mudslap: ["5E"],
			odorsleuth: ["5L5"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L29"],
			return: ["5M"],
			reversal: ["5L33"],
			roar: ["5M", "5L26"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5E"],
			shadowball: ["5M"],
			snarl: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			takedown: ["5L15"],
			thunderbolt: ["5M"],
			thunderfang: ["5E"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M", "5L19"],
			yawn: ["5E"],
		},
	},
	herdier: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bite: ["5L1"],
			crunch: ["5L24"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L47"],
			helpinghand: ["5L12"],
			hiddenpower: ["5M"],
			lastresort: ["5L42"],
			leer: ["5L1"],
			odorsleuth: ["5L1"],
			payback: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L33"],
			return: ["5M"],
			reversal: ["5L38"],
			roar: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowball: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			takedown: ["5L15"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M", "5L20"],
		},
	},
	stoutland: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bite: ["5L1"],
			crunch: ["5L24"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			firefang: ["5L1"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L59"],
			helpinghand: ["5L12"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			icefang: ["5L1"],
			lastresort: ["5L51"],
			leer: ["5L1"],
			odorsleuth: ["5L1"],
			payback: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L36"],
			return: ["5M"],
			reversal: ["5L42"],
			roar: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowball: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			takedown: ["5L15"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderfang: ["5L1"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M", "5L20"],
		},
	},
	purrloin: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assist: ["5L6"],
			assurance: ["5L28"],
			attract: ["5M"],
			captivate: ["5L33"],
			charm: ["5E"],
			covet: ["5E"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M"],
			embargo: ["5M"],
			encore: ["5E"],
			facade: ["5M"],
			fakeout: ["5L21"],
			faketears: ["5E"],
			feintattack: ["5E"],
			foulplay: ["5E"],
			frustration: ["5M"],
			furyswipes: ["5L12"],
			grassknot: ["5M"],
			growl: ["5L3"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L24"],
			nastyplot: ["5L42"],
			nightslash: ["5L37"],
			payback: ["5M"],
			payday: ["5E"],
			protect: ["5M"],
			psychup: ["5M"],
			pursuit: ["5L15"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sandattack: ["5L10"],
			scratch: ["5L1"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L30"],
			snarl: ["5E"],
			snatch: ["5L39"],
			substitute: ["5M"],
			suckerpunch: ["5L46"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M", "5L19"],
			toxic: ["5M"],
			yawn: ["5E"],
		},
	},
	liepard: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assist: ["5L1"],
			assurance: ["5L31"],
			attract: ["5M"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M"],
			embargo: ["5M"],
			facade: ["5M"],
			fakeout: ["5L22", "5S0"],
			frustration: ["5M"],
			furyswipes: ["5L12"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growl: ["5L1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L26"],
			hyperbeam: ["5M"],
			nastyplot: ["5L50"],
			nightslash: ["5L43"],
			payback: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			pursuit: ["5L15"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			scratch: ["5L1"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L34"],
			snatch: ["5L47"],
			substitute: ["5M"],
			suckerpunch: ["5L55"],
			sunnyday: ["5M"],
			swagger: ["5M", "5S0"],
			taunt: ["5M", "5L38"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M", "5L19"],
			toxic: ["5M"],
		},
	},
	pansage: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L31"],
			astonish: ["5E"],
			attract: ["5M"],
			bite: ["5L19", "5S0"],
			bulletseed: ["5E", "5S0"],
			covet: ["5E"],
			crunch: ["5L43"],
			cut: ["5M"],
			dig: ["5M", "5S0", "5S2"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M", "5L28"],
			frustration: ["5M"],
			furyswipes: ["5L13"],
			grassknot: ["5M", "5L34"],
			grasswhistle: ["5E"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			leafstorm: ["5E", "5S1"],
			leechseed: ["5L16"],
			leer: ["5L4", "5S1"],
			lick: ["5L7", "5S1"],
			lowkick: ["5E"],
			lowsweep: ["5M"],
			magicalleaf: ["5E"],
			nastyplot: ["5E"],
			naturalgift: ["5L40"],
			payback: ["5M"],
			protect: ["5M"],
			recycle: ["5L37"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M", "5S2"],
			roleplay: ["5E"],
			round: ["5M"],
			scratch: ["5L1"],
			seedbomb: ["5L22", "5S2"],
			shadowclaw: ["5M"],
			solarbeam: ["5M", "5S0", "5S2"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			tickle: ["5E"],
			torment: ["5M", "5L25"],
			toxic: ["5M"],
			vinewhip: ["5L10", "5S1"],
			workup: ["5M"],
		},
	},
	simisage: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			attract: ["5M"],
			brickbreak: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			lick: ["5L1"],
			lowsweep: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			seedbomb: ["5L1"],
			shadowclaw: ["5M"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			workup: ["5M"],
		},
	},
	pansear: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L31"],
			amnesia: ["5L25"],
			astonish: ["5E"],
			attract: ["5M"],
			bite: ["5L19"],
			covet: ["5E"],
			crunch: ["5L43"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fireblast: ["5M", "5L34"],
			firepunch: ["5E"],
			firespin: ["5E"],
			flameburst: ["5L22"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			fling: ["5M", "5L28"],
			frustration: ["5M"],
			furyswipes: ["5L13"],
			grassknot: ["5M"],
			heatwave: ["5E", "5S0"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M", "5L10", "5S0"],
			leer: ["5L4", "5S0"],
			lick: ["5L7", "5S0"],
			lowkick: ["5E"],
			lowsweep: ["5M"],
			nastyplot: ["5E"],
			naturalgift: ["5L40"],
			overheat: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			recycle: ["5L37"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			roleplay: ["5E"],
			round: ["5M"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			sleeptalk: ["5E"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			tickle: ["5E"],
			torment: ["5M"],
			toxic: ["5M"],
			willowisp: ["5M"],
			workup: ["5M"],
			yawn: ["5L16"],
		},
	},
	simisear: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			attract: ["5M"],
			brickbreak: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fireblast: ["5M"],
			flameburst: ["5L1"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			lick: ["5L1"],
			lowsweep: ["5M"],
			overheat: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowclaw: ["5M"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			willowisp: ["5M"],
			workup: ["5M"],
		},
	},
	panpour: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L31"],
			aquaring: ["5E"],
			aquatail: ["5E"],
			astonish: ["5E"],
			attract: ["5M"],
			bite: ["5L19"],
			blizzard: ["5M"],
			brine: ["5L34"],
			covet: ["5E"],
			crunch: ["5L43"],
			cut: ["5M"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fling: ["5M", "5L28"],
			frustration: ["5M"],
			furyswipes: ["5L13"],
			grassknot: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hydropump: ["5E", "5S0"],
			icebeam: ["5M"],
			leer: ["5L4", "5S0"],
			lick: ["5L7", "5S0"],
			lowkick: ["5E"],
			lowsweep: ["5M"],
			mudsport: ["5E"],
			nastyplot: ["5E"],
			naturalgift: ["5L40"],
			payback: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			recycle: ["5L37"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			roleplay: ["5E"],
			round: ["5M"],
			scald: ["5M", "5L22"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M", "5L25"],
			thief: ["5M"],
			tickle: ["5E"],
			torment: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			watergun: ["5L10", "5S0"],
			watersport: ["5L16"],
			workup: ["5M"],
		},
	},
	simipour: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			attract: ["5M"],
			blizzard: ["5M"],
			brickbreak: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			leer: ["5L1"],
			lick: ["5L1"],
			lowsweep: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scald: ["5M", "5L1"],
			shadowclaw: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			workup: ["5M"],
		},
	},
	munna: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			barrier: ["5E"],
			batonpass: ["5E"],
			calmmind: ["5M", "5L35"],
			chargebeam: ["5M"],
			curse: ["5E"],
			defensecurl: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M", "5L41"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			gyroball: ["5M"],
			helpinghand: ["5E"],
			hiddenpower: ["5M"],
			hypnosis: ["5L19"],
			imprison: ["5L13"],
			lightscreen: ["5M"],
			luckychant: ["5L5"],
			magiccoat: ["5E"],
			moonlight: ["5L17"],
			nightmare: ["5L29"],
			protect: ["5M"],
			psybeam: ["5L11"],
			psychic: ["5M", "5L37"],
			psychup: ["5M"],
			psyshock: ["5M"],
			psywave: ["5L1"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["5E"],
			shadowball: ["5M"],
			sleeptalk: ["5E"],
			sonicboom: ["5E"],
			storedpower: ["5L47"],
			substitute: ["5M"],
			swagger: ["5M"],
			swift: ["5E"],
			synchronoise: ["5L25"],
			telekinesis: ["5M", "5L43"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			yawn: ["5L7"],
			zenheadbutt: ["5L23"],
		},
	},
	musharna: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			defensecurl: ["5L1", "5S0"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			gyroball: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			hypnosis: ["5L1", "5S0"],
			lightscreen: ["5M"],
			luckychant: ["5L1", "5S0"],
			protect: ["5M"],
			psybeam: ["5L1", "5S0"],
			psychic: ["5M"],
			psychup: ["5M"],
			psyshock: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
		},
	},
	pidove: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aircutter: ["5L15", "5S0"],
			airslash: ["5L29"],
			attract: ["5M"],
			bestow: ["5E"],
			detect: ["5L22"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M", "5L43"],
			featherdance: ["5L36"],
			fly: ["5M"],
			frustration: ["5M"],
			growl: ["5L4"],
			gust: ["5L1", "5S0"],
			hiddenpower: ["5M"],
			hypnosis: ["5E"],
			leer: ["5L8"],
			luckychant: ["5E"],
			morningsun: ["5E"],
			pluck: ["5M"],
			protect: ["5M"],
			quickattack: ["5L11", "5S0"],
			raindance: ["5M"],
			razorwind: ["5L32"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5L18"],
			round: ["5M"],
			skyattack: ["5L50"],
			steelwing: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M", "5L39"],
			tailwind: ["5L46"],
			taunt: ["5M", "5L25"],
			toxic: ["5M"],
			uproar: ["5E"],
			uturn: ["5M"],
			wish: ["5E"],
			workup: ["5M"],
		},
	},
	tranquill: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aircutter: ["5L15"],
			airslash: ["5L32"],
			attract: ["5M"],
			detect: ["5L23"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M", "5L50"],
			featherdance: ["5L41"],
			fly: ["5M"],
			frustration: ["5M"],
			growl: ["5L1"],
			gust: ["5L1"],
			hiddenpower: ["5M"],
			leer: ["5L1"],
			pluck: ["5M"],
			protect: ["5M"],
			quickattack: ["5L1"],
			raindance: ["5M"],
			razorwind: ["5L36"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5L18"],
			round: ["5M"],
			skyattack: ["5L59"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M", "5L45"],
			tailwind: ["5L54"],
			taunt: ["5M", "5L27"],
			toxic: ["5M"],
			uturn: ["5M"],
			workup: ["5M"],
		},
	},
	unfezant: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aircutter: ["5L15"],
			airslash: ["5L33"],
			attract: ["5M"],
			detect: ["5L23"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M", "5L55"],
			featherdance: ["5L44"],
			fly: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			growl: ["5L1"],
			gust: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			pluck: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			quickattack: ["5L1"],
			raindance: ["5M"],
			razorwind: ["5L38"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5L18"],
			round: ["5M"],
			skyattack: ["5L66"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M", "5L49"],
			tailwind: ["5L60"],
			taunt: ["5M", "5L27"],
			toxic: ["5M"],
			uturn: ["5M"],
			workup: ["5M"],
		},
	},
	blitzle: {
		inherit: true,
		learnset: {
			agility: ["5L36"],
			attract: ["5M"],
			charge: ["5L8"],
			chargebeam: ["5M"],
			discharge: ["5L32"],
			doubleedge: ["5E"],
			doublekick: ["5E"],
			doubleteam: ["5M"],
			endure: ["5E"],
			facade: ["5M"],
			flamecharge: ["5M", "5L18"],
			flash: ["5M"],
			frustration: ["5M"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			mefirst: ["5E"],
			protect: ["5M"],
			pursuit: ["5L22"],
			quickattack: ["5L1"],
			rage: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sandattack: ["5E"],
			screech: ["5E"],
			shockwave: ["5L11", "5E"],
			spark: ["5L25"],
			stomp: ["5L29"],
			substitute: ["5M"],
			swagger: ["5M"],
			tailwhip: ["5L4"],
			takedown: ["5E"],
			thrash: ["5L43"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M", "5L15"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L39"],
		},
	},
	zebstrika: {
		inherit: true,
		learnset: {
			agility: ["5L42"],
			attract: ["5M"],
			charge: ["5L1"],
			chargebeam: ["5M"],
			discharge: ["5L36"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flamecharge: ["5M", "5L18"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			lightscreen: ["5M"],
			overheat: ["5M"],
			protect: ["5M"],
			pursuit: ["5L22"],
			quickattack: ["5L1"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			shockwave: ["5L11"],
			spark: ["5L25"],
			stomp: ["5L31"],
			substitute: ["5M"],
			swagger: ["5M"],
			tailwhip: ["5L1"],
			thrash: ["5L53"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M", "5L1"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L47"],
		},
	},
	roggenrola: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			autotomize: ["5E"],
			bulldoze: ["5M"],
			curse: ["5E"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			explosion: ["5M", "5L40"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			gravity: ["5E"],
			harden: ["5L4"],
			headbutt: ["5L10"],
			heavyslam: ["5E"],
			hiddenpower: ["5M"],
			irondefense: ["5L20"],
			lockon: ["5E"],
			magnitude: ["5E"],
			mudslap: ["5L17"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5L14"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L27"],
			rocksmash: ["5M"],
			rocktomb: ["5M", "5E"],
			round: ["5M"],
			sandattack: ["5L7"],
			sandstorm: ["5M", "5L33"],
			smackdown: ["5M", "5L23"],
			stealthrock: ["5L30"],
			stoneedge: ["5M", "5L36"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			takedown: ["5E"],
			toxic: ["5M"],
		},
	},
	boldore: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bulldoze: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			explosion: ["5M", "5L55"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			harden: ["5L1"],
			headbutt: ["5L1"],
			hiddenpower: ["5M"],
			irondefense: ["5L20"],
			mudslap: ["5L17"],
			powergem: ["5L25"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5L14"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L30"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M", "5L42"],
			smackdown: ["5M", "5L23"],
			stealthrock: ["5L36"],
			stoneedge: ["5M", "5L48"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			toxic: ["5M"],
		},
	},
	gigalith: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bulldoze: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			explosion: ["5M", "5L55"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			harden: ["5L1"],
			headbutt: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			irondefense: ["5L20"],
			mudslap: ["5L17"],
			powergem: ["5L25"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5L14"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L30"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M", "5L42"],
			smackdown: ["5M", "5L23"],
			solarbeam: ["5M"],
			stealthrock: ["5L36"],
			stoneedge: ["5M", "5L48"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			toxic: ["5M"],
		},
	},
	woobat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			aircutter: ["5L21"],
			airslash: ["5L32"],
			amnesia: ["5L29"],
			assurance: ["5L12"],
			attract: ["5M", "5L25"],
			calmmind: ["5M", "5L29"],
			chargebeam: ["5M"],
			charm: ["5E"],
			confusion: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endeavor: ["5L47"],
			energyball: ["5M"],
			facade: ["5M"],
			faketears: ["5E"],
			flash: ["5M"],
			flatter: ["5E"],
			fly: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L36"],
			gust: ["5L8"],
			gyroball: ["5M"],
			heartstamp: ["5L15"],
			helpinghand: ["5E"],
			hiddenpower: ["5M"],
			imprison: ["5L19"],
			knockoff: ["5E"],
			lightscreen: ["5M"],
			odorsleuth: ["5L4"],
			pluck: ["5M"],
			protect: ["5M"],
			psychic: ["5M", "5L41"],
			psychup: ["5M"],
			psyshock: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5E"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			storedpower: ["5E"],
			substitute: ["5M"],
			supersonic: ["5E"],
			swagger: ["5M"],
			synchronoise: ["5E"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uturn: ["5M"],
		},
	},
	swoobat: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			aircutter: ["5L21"],
			airslash: ["5L32"],
			amnesia: ["5L29"],
			assurance: ["5L1"],
			attract: ["5M", "5L25"],
			calmmind: ["5M", "5L29"],
			chargebeam: ["5M"],
			confusion: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endeavor: ["5L47"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L36"],
			gigaimpact: ["5M"],
			gust: ["5L1"],
			gyroball: ["5M"],
			heartstamp: ["5L15"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			imprison: ["5L19"],
			lightscreen: ["5M"],
			odorsleuth: ["5L1"],
			pluck: ["5M"],
			protect: ["5M"],
			psychic: ["5M", "5L41"],
			psychup: ["5M"],
			psyshock: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uturn: ["5M"],
		},
	},
	drilbur: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			crushclaw: ["5E"],
			cut: ["5M"],
			dig: ["5M", "5L19"],
			doubleteam: ["5M"],
			drillrun: ["5L43"],
			earthpower: ["5E"],
			earthquake: ["5M", "5L33"],
			facade: ["5M"],
			fissure: ["5L47"],
			fling: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L12"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L22"],
			irondefense: ["5E"],
			metalclaw: ["5L15"],
			metalsound: ["5E"],
			mudslap: ["5L8"],
			mudsport: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rapidspin: ["5L5", "5E"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5E"],
			rockslide: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M", "5L40"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			skullbash: ["5E"],
			slash: ["5L26"],
			sludgebomb: ["5M"],
			strength: ["5M"],
			submission: ["5E"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L36"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	excadrill: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			cut: ["5M"],
			dig: ["5M", "5L19"],
			doubleteam: ["5M"],
			drillrun: ["5L55"],
			earthquake: ["5M", "5L36"],
			facade: ["5M"],
			fissure: ["5L62"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L12"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L22"],
			horndrill: ["5L31"],
			hyperbeam: ["5M"],
			metalclaw: ["5L15"],
			mudslap: ["5L1"],
			mudsport: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rapidspin: ["5L1"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M", "5L49"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			slash: ["5L26"],
			sludgebomb: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L42"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	audino: {
		inherit: true,
		learnset: {
			afteryou: ["5L40"],
			amnesia: ["5E"],
			attract: ["5M", "5L15"],
			bestow: ["5E"],
			blizzard: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			dig: ["5M"],
			doubleedge: ["5L50"],
			doubleslap: ["5L10", "5S0"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M"],
			encore: ["5E"],
			entrainment: ["5L25"],
			facade: ["5M"],
			fireblast: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			growl: ["5L1"],
			healbell: ["5E"],
			healingwish: ["5E"],
			healpulse: ["5L35", "5S0", "5S1", "5S2"],
			helpinghand: ["5L1", "5S0", "5S1", "5S2"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			incinerate: ["5M"],
			lastresort: ["5L55"],
			lightscreen: ["5M"],
			luckychant: ["5E"],
			pound: ["5L1"],
			present: ["5S1", "5S2"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			psyshock: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			refresh: ["5L5", "5S0", "5S1", "5S2"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["5L20"],
			shadowball: ["5M"],
			simplebeam: ["5L45"],
			sleeptalk: ["5E"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			sweetkiss: ["5E"],
			takedown: ["5L30"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			wildcharge: ["5M"],
			wish: ["5E"],
			workup: ["5M"],
			yawn: ["5E"],
		},
	},
	timburr: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bide: ["5L8"],
			brickbreak: ["5M"],
			bulkup: ["5M", "5L28"],
			chipaway: ["5L24"],
			cometpunch: ["5E"],
			counter: ["5E"],
			detect: ["5E"],
			dig: ["5M"],
			doubleteam: ["5M"],
			drainpunch: ["5E"],
			dynamicpunch: ["5L34"],
			endure: ["5E"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L4"],
			focuspunch: ["5L46"],
			forcepalm: ["5E"],
			foresight: ["5E"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hammerarm: ["5L40"],
			hiddenpower: ["5M"],
			leer: ["5L1"],
			lowkick: ["5L12"],
			lowsweep: ["5M"],
			machpunch: ["5E"],
			payback: ["5M"],
			poisonjab: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			reversal: ["5E"],
			rockslide: ["5M", "5L31"],
			rocksmash: ["5M"],
			rockthrow: ["5L16"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L37"],
			smackdown: ["5M"],
			smellingsalts: ["5E"],
			stoneedge: ["5M", "5L43"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L49"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			wakeupslap: ["5L20"],
			wideguard: ["5E"],
			workup: ["5M"],
		},
	},
	gurdurr: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bide: ["5L1"],
			brickbreak: ["5M"],
			bulkup: ["5M", "5L29"],
			chipaway: ["5L24"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dynamicpunch: ["5L37"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L1"],
			focuspunch: ["5L53"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hammerarm: ["5L45"],
			hiddenpower: ["5M"],
			leer: ["5L1"],
			lowkick: ["5L12"],
			lowsweep: ["5M"],
			payback: ["5M"],
			poisonjab: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockslide: ["5M", "5L33"],
			rocksmash: ["5M"],
			rockthrow: ["5L16"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L41"],
			smackdown: ["5M"],
			stoneedge: ["5M", "5L49"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L57"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			wakeupslap: ["5L20"],
			workup: ["5M"],
		},
	},
	conkeldurr: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bide: ["5L1"],
			brickbreak: ["5M"],
			bulkup: ["5M", "5L29"],
			bulldoze: ["5M"],
			chipaway: ["5L24"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dynamicpunch: ["5L37"],
			earthquake: ["5M"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L1"],
			focuspunch: ["5L53"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hammerarm: ["5L45"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			lowkick: ["5L12"],
			lowsweep: ["5M"],
			payback: ["5M"],
			poisonjab: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockslide: ["5M", "5L33"],
			rocksmash: ["5M"],
			rockthrow: ["5L16"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L41"],
			smackdown: ["5M"],
			stoneedge: ["5M", "5L49"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L57"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			wakeupslap: ["5L20"],
			workup: ["5M"],
		},
	},
	tympole: {
		inherit: true,
		learnset: {
			aquaring: ["5L20"],
			attract: ["5M"],
			bubble: ["5L1"],
			bubblebeam: ["5L12"],
			doubleteam: ["5M"],
			earthpower: ["5E"],
			echoedvoice: ["5M", "5L38"],
			facade: ["5M"],
			flail: ["5L34"],
			frustration: ["5M"],
			growl: ["5L1"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L42"],
			hypervoice: ["5L45"],
			mist: ["5E"],
			mudbomb: ["5E"],
			muddywater: ["5L27"],
			mudshot: ["5L16"],
			mudsport: ["5E"],
			protect: ["5M"],
			raindance: ["5M", "5L31"],
			refresh: ["5E"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M", "5L9"],
			scald: ["5M"],
			sleeptalk: ["5E"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			snore: ["5E"],
			substitute: ["5M"],
			supersonic: ["5L5"],
			surf: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			uproar: ["5L23"],
			waterpulse: ["5E"],
		},
	},
	palpitoad: {
		inherit: true,
		learnset: {
			aquaring: ["5L20"],
			attract: ["5M"],
			bubble: ["5L1"],
			bubblebeam: ["5L12"],
			bulldoze: ["5M"],
			doubleteam: ["5M"],
			echoedvoice: ["5M", "5L42"],
			facade: ["5M"],
			flail: ["5L37"],
			frustration: ["5M"],
			growl: ["5L1"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L47"],
			hypervoice: ["5L51"],
			muddywater: ["5L28"],
			mudshot: ["5L16"],
			protect: ["5M"],
			raindance: ["5M", "5L33"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M", "5L1"],
			scald: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			substitute: ["5M"],
			supersonic: ["5L1"],
			surf: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			uproar: ["5L23"],
		},
	},
	seismitoad: {
		inherit: true,
		learnset: {
			acid: ["5L36"],
			aquaring: ["5L20"],
			attract: ["5M"],
			brickbreak: ["5M"],
			bubble: ["5L1"],
			bubblebeam: ["5L12"],
			bulldoze: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			drainpunch: ["5L44"],
			earthquake: ["5M"],
			echoedvoice: ["5M", "5L49"],
			facade: ["5M"],
			flail: ["5L39"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growl: ["5L1"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L53"],
			hyperbeam: ["5M"],
			hypervoice: ["5L59"],
			muddywater: ["5L28"],
			mudshot: ["5L16"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M", "5L33"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M", "5L1"],
			scald: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			supersonic: ["5L1"],
			surf: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			uproar: ["5L23"],
			venoshock: ["5M"],
		},
	},
	throh: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bide: ["5L5"],
			bind: ["5L1"],
			bodyslam: ["5L29"],
			brickbreak: ["5M"],
			bulkup: ["5M", "5L33"],
			bulldoze: ["5M"],
			circlethrow: ["5L37"],
			dig: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			endure: ["5L41"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L9"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			leer: ["5L1"],
			lowsweep: ["5M"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			revenge: ["5L21"],
			reversal: ["5L53"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			seismictoss: ["5L13"],
			stoneedge: ["5M"],
			stormthrow: ["5L25"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L49"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			vitalthrow: ["5L17"],
			wideguard: ["5L45"],
			workup: ["5M"],
		},
	},
	sawk: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bide: ["5L5"],
			brickbreak: ["5M", "5L29"],
			bulkup: ["5M", "5L33"],
			bulldoze: ["5M"],
			closecombat: ["5L49"],
			counter: ["5L21"],
			dig: ["5M"],
			doublekick: ["5L13"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			endure: ["5L41"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focusenergy: ["5L9"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			karatechop: ["5L25"],
			leer: ["5L1"],
			lowsweep: ["5M", "5L17"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			quickguard: ["5L45"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L37"],
			return: ["5M"],
			reversal: ["5L53"],
			rockslide: ["5M"],
			rocksmash: ["5M", "5L1"],
			rocktomb: ["5M"],
			round: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			workup: ["5M"],
		},
	},
	sewaddle: {
		inherit: true,
		learnset: {
			agility: ["5E"],
			airslash: ["5E"],
			attract: ["5M"],
			batonpass: ["5E"],
			bugbite: ["5L8"],
			bugbuzz: ["5L36"],
			calmmind: ["5M"],
			camouflage: ["5E"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			endure: ["5L29"],
			energyball: ["5M"],
			facade: ["5M"],
			flail: ["5L43"],
			flash: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			mefirst: ["5E"],
			mindreader: ["5E"],
			payback: ["5M"],
			protect: ["5M"],
			razorleaf: ["5L15"],
			razorwind: ["5E"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			screech: ["5E"],
			silverwind: ["5E"],
			solarbeam: ["5M"],
			stringshot: ["5L1"],
			strugglebug: ["5M", "5L22"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			toxic: ["5M"],
		},
	},
	swadloon: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bugbite: ["5L1"],
			calmmind: ["5M"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			grasswhistle: ["5L1"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			payback: ["5M"],
			protect: ["5M", "5L20"],
			razorleaf: ["5L1"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			solarbeam: ["5M"],
			stringshot: ["5L1"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			toxic: ["5M"],
		},
	},
	leavanny: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bugbite: ["5L1"],
			calmmind: ["5M"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			entrainment: ["5L43"],
			facade: ["5M"],
			falseswipe: ["5M", "5L1"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			helpinghand: ["5L32"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			leafblade: ["5L36"],
			leafstorm: ["5L50"],
			lightscreen: ["5M"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			razorleaf: ["5L1"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L29"],
			solarbeam: ["5M"],
			stringshot: ["5L1"],
			strugglebug: ["5M", "5L22"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L46"],
			tackle: ["5L1"],
			toxic: ["5M"],
			xscissor: ["5M", "5L39"],
		},
	},
	venipede: {
		inherit: true,
		learnset: {
			agility: ["5L29"],
			attract: ["5M"],
			bugbite: ["5L22"],
			defensecurl: ["5L1"],
			doubleedge: ["5L43"],
			doubleteam: ["5M"],
			facade: ["5M"],
			frustration: ["5M"],
			gyroball: ["5M"],
			hiddenpower: ["5M"],
			payback: ["5M"],
			pinmissile: ["5E"],
			poisonjab: ["5M"],
			poisonsting: ["5L5"],
			poisontail: ["5L19"],
			protect: ["5M", "5L15"],
			pursuit: ["5L12"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5L40", "5E"],
			rocksmash: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			screech: ["5L8"],
			sludgebomb: ["5M"],
			solarbeam: ["5M"],
			spikes: ["5E"],
			steamroller: ["5L33"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			takedown: ["5E"],
			toxic: ["5M", "5L36"],
			toxicspikes: ["5E"],
			twineedle: ["5E"],
			venoshock: ["5M", "5L26"],
		},
	},
	whirlipede: {
		inherit: true,
		learnset: {
			agility: ["5L32"],
			attract: ["5M"],
			bugbite: ["5L23"],
			defensecurl: ["5L1"],
			doubleedge: ["5L50"],
			doubleteam: ["5M"],
			facade: ["5M"],
			frustration: ["5M"],
			gyroball: ["5M"],
			hiddenpower: ["5M"],
			irondefense: ["5L22"],
			payback: ["5M"],
			poisonjab: ["5M"],
			poisonsting: ["5L1"],
			poisontail: ["5L19"],
			protect: ["5M", "5L15"],
			pursuit: ["5L12"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5L46"],
			rocksmash: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			screech: ["5L1"],
			sludgebomb: ["5M"],
			solarbeam: ["5M"],
			steamroller: ["5L37"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			toxic: ["5M", "5L41"],
			venoshock: ["5M", "5L28"],
		},
	},
	scolipede: {
		inherit: true,
		learnset: {
			agility: ["5L33"],
			attract: ["5M"],
			batonpass: ["5L30"],
			bugbite: ["5L23"],
			bulldoze: ["5M"],
			cut: ["5M"],
			defensecurl: ["5L1"],
			dig: ["5M"],
			doubleedge: ["5L55"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			gyroball: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			megahorn: ["5L1"],
			payback: ["5M"],
			poisonjab: ["5M"],
			poisonsting: ["5L1"],
			poisontail: ["5L19"],
			protect: ["5M", "5L15"],
			pursuit: ["5L12"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5L50"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			screech: ["5L1"],
			sludgebomb: ["5M"],
			solarbeam: ["5M"],
			steamroller: ["5L39"],
			strength: ["5M"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			toxic: ["5M", "5L44"],
			venoshock: ["5M", "5L28"],
			xscissor: ["5M"],
		},
	},
	cottonee: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			attract: ["5M"],
			beatup: ["5E"],
			charm: ["5L28"],
			cottonguard: ["5L37"],
			cottonspore: ["5L17"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			encore: ["5E"],
			endeavor: ["5L44"],
			energyball: ["5M", "5L35"],
			facade: ["5M"],
			faketears: ["5E"],
			flash: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L26"],
			grassknot: ["5M"],
			grasswhistle: ["5E"],
			growth: ["5L4"],
			helpinghand: ["5L31"],
			hiddenpower: ["5M"],
			leechseed: ["5L8"],
			megadrain: ["5L13"],
			memento: ["5E"],
			naturalgift: ["5E"],
			poisonpowder: ["5L22"],
			protect: ["5M"],
			razorleaf: ["5L19"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			solarbeam: ["5M", "5L46"],
			stunspore: ["5L10"],
			substitute: ["5M"],
			sunnyday: ["5M", "5L40"],
			swagger: ["5M"],
			switcheroo: ["5E"],
			taunt: ["5M"],
			tickle: ["5E"],
			toxic: ["5M"],
			worryseed: ["5E"],
		},
	},
	whimsicott: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			beatup: ["5S0"],
			cottonspore: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5S0"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growth: ["5L1"],
			gust: ["5L10"],
			helpinghand: ["5S0"],
			hiddenpower: ["5M"],
			hurricane: ["5L46"],
			hyperbeam: ["5M"],
			leechseed: ["5L1"],
			lightscreen: ["5M"],
			megadrain: ["5L1"],
			protect: ["5M"],
			psychic: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M", "5S0"],
			tailwind: ["5L28"],
			taunt: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uturn: ["5M"],
		},
	},
	petilil: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			afteryou: ["5L44"],
			aromatherapy: ["5L28"],
			attract: ["5M"],
			bide: ["5E"],
			charm: ["5E"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			endure: ["5E"],
			energyball: ["5M", "5L35"],
			entrainment: ["5L37"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L26"],
			grassknot: ["5M"],
			grasswhistle: ["5E"],
			growth: ["5L4"],
			healingwish: ["5E"],
			helpinghand: ["5L31"],
			hiddenpower: ["5M"],
			ingrain: ["5E"],
			leafstorm: ["5L46"],
			leechseed: ["5L8"],
			magicalleaf: ["5L19"],
			megadrain: ["5L13"],
			naturalgift: ["5E"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			sleeppowder: ["5L10"],
			solarbeam: ["5M"],
			stunspore: ["5L22"],
			substitute: ["5M"],
			sunnyday: ["5M", "5L40"],
			swagger: ["5M"],
			sweetscent: ["5E"],
			synthesis: ["5L17"],
			toxic: ["5M"],
			worryseed: ["5E"],
		},
	},
	lilligant: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growth: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leechseed: ["5L1"],
			lightscreen: ["5M"],
			megadrain: ["5L1"],
			petaldance: ["5L46"],
			protect: ["5M"],
			quiverdance: ["5L28"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			synthesis: ["5L1"],
			teeterdance: ["5L10"],
			toxic: ["5M"],
		},
	},
	basculin: {
		inherit: true,
		learnset: {
			agility: ["5E"],
			aquajet: ["5L13"],
			aquatail: ["5L28"],
			attract: ["5M"],
			bite: ["5L10"],
			brine: ["5E"],
			bubblebeam: ["5E"],
			chipaway: ["5L16"],
			crunch: ["5L24"],
			cut: ["5M"],
			dive: ["5M"],
			doubleedge: ["5L36"],
			doubleteam: ["5M"],
			facade: ["5M"],
			finalgambit: ["5L51"],
			flail: ["5L46"],
			frustration: ["5M"],
			hail: ["5M"],
			headbutt: ["5L7"],
			hiddenpower: ["5M"],
			icebeam: ["5M"],
			muddywater: ["5E"],
			mudshot: ["5E"],
			protect: ["5M"],
			rage: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			revenge: ["5E"],
			round: ["5M"],
			scald: ["5M"],
			scaryface: ["5L41"],
			soak: ["5L32"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swift: ["5E"],
			tackle: ["5L1"],
			takedown: ["5L20"],
			taunt: ["5M"],
			thrash: ["5L56"],
			toxic: ["5M"],
			uproar: ["5L4"],
			waterfall: ["5M"],
			watergun: ["5L1"],
			whirlpool: ["5E"],
		},
	},
	sandile: {
		inherit: true,
		learnset: {
			assurance: ["5L16"],
			attract: ["5M"],
			beatup: ["5E"],
			bite: ["5L4"],
			bulldoze: ["5M"],
			counter: ["5E"],
			crunch: ["5L28"],
			cut: ["5M"],
			dig: ["5M", "5L31"],
			doubleedge: ["5E"],
			doubleteam: ["5M"],
			earthquake: ["5M", "5L43"],
			embargo: ["5M", "5L22"],
			facade: ["5M"],
			firefang: ["5E"],
			focusenergy: ["5E"],
			foulplay: ["5L37"],
			frustration: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			meanlook: ["5E"],
			mudslap: ["5L19"],
			payback: ["5M"],
			protect: ["5M"],
			pursuit: ["5E"],
			rage: ["5L1"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockclimb: ["5E"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L7"],
			sandstorm: ["5M", "5L40"],
			sandtomb: ["5L13"],
			scaryface: ["5L34"],
			sludgebomb: ["5M"],
			snarl: ["5E"],
			stoneedge: ["5M"],
			substitute: ["5M"],
			swagger: ["5M", "5L25"],
			taunt: ["5M"],
			thief: ["5M"],
			thrash: ["5L46"],
			thunderfang: ["5E"],
			torment: ["5M", "5L10"],
			toxic: ["5M"],
			uproar: ["5E"],
		},
	},
	krokorok: {
		inherit: true,
		learnset: {
			assurance: ["5L16"],
			attract: ["5M"],
			bite: ["5L1"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			crunch: ["5L28"],
			cut: ["5M"],
			dig: ["5M", "5L32"],
			doubleteam: ["5M"],
			earthquake: ["5M", "5L48"],
			embargo: ["5M", "5L22"],
			facade: ["5M"],
			fling: ["5M"],
			foulplay: ["5L40"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			lowsweep: ["5M"],
			mudslap: ["5L19"],
			payback: ["5M"],
			protect: ["5M"],
			rage: ["5L1"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M", "5L44"],
			sandtomb: ["5L13"],
			scaryface: ["5L36"],
			shadowclaw: ["5M"],
			sludgebomb: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M", "5L25"],
			taunt: ["5M"],
			thief: ["5M"],
			thrash: ["5L52"],
			torment: ["5M", "5L10"],
			toxic: ["5M"],
		},
	},
	krookodile: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L16"],
			attract: ["5M"],
			bite: ["5L1"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			bulldoze: ["5M"],
			crunch: ["5L28"],
			cut: ["5M"],
			dig: ["5M", "5L32"],
			doubleteam: ["5M"],
			dragonclaw: ["5M"],
			dragontail: ["5M"],
			earthquake: ["5M", "5L54"],
			embargo: ["5M", "5L22"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			foulplay: ["5L42"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			lowsweep: ["5M"],
			mudslap: ["5L19"],
			outrage: ["5L60"],
			payback: ["5M"],
			protect: ["5M"],
			rage: ["5L1"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M", "5L48"],
			sandtomb: ["5L13"],
			scaryface: ["5L36"],
			shadowclaw: ["5M"],
			sludgebomb: ["5M"],
			smackdown: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M", "5L25"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M", "5L10"],
			toxic: ["5M"],
		},
	},
	darumaka: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bellydrum: ["5L30"],
			brickbreak: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			encore: ["5E"],
			endure: ["5E"],
			facade: ["5M", "5L19"],
			fireblast: ["5M"],
			firefang: ["5L11"],
			firepunch: ["5L22"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			flamewheel: ["5E"],
			flareblitz: ["5L33"],
			fling: ["5M"],
			focusenergy: ["5E"],
			focuspunch: ["5E"],
			frustration: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			hammerarm: ["5E"],
			headbutt: ["5L14"],
			hiddenpower: ["5M"],
			incinerate: ["5M", "5L6"],
			overheat: ["5M", "5L42"],
			protect: ["5M"],
			rage: ["5L9"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L3"],
			round: ["5M"],
			sleeptalk: ["5E"],
			solarbeam: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L39"],
			swagger: ["5M"],
			tackle: ["5L1"],
			takedown: ["5E"],
			taunt: ["5M", "5L35"],
			thief: ["5M"],
			thrash: ["5L27"],
			toxic: ["5M"],
			uproar: ["5L17"],
			uturn: ["5M"],
			willowisp: ["5M"],
			workup: ["5M", "5L25"],
			yawn: ["5E"],
		},
	},
	darmanitan: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bellydrum: ["5L30", "5S0"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			bulldoze: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M", "5L19"],
			fireblast: ["5M"],
			firefang: ["5L11"],
			firepunch: ["5L22"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			flareblitz: ["5L33", "5S0"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			hammerarm: ["5L35", "5S0"],
			headbutt: ["5L14"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M", "5L1"],
			overheat: ["5M", "5L54"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			rage: ["5L1"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			smackdown: ["5M"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L47"],
			swagger: ["5M", "5L17"],
			tackle: ["5L1"],
			taunt: ["5M", "5L39"],
			thief: ["5M"],
			thrash: ["5L27", "5S0"],
			torment: ["5M"],
			toxic: ["5M"],
			uturn: ["5M"],
			willowisp: ["5M"],
			workup: ["5M", "5L25"],
		},
	},
	maractus: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			acupressure: ["5L29"],
			aerialace: ["5M"],
			afteryou: ["5L57"],
			attract: ["5M"],
			bounce: ["5E"],
			bulletseed: ["5E"],
			cottonguard: ["5L55"],
			cottonspore: ["5L18"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L26"],
			grassknot: ["5M"],
			grasswhistle: ["5E"],
			growth: ["5L6"],
			hiddenpower: ["5M"],
			ingrain: ["5L33"],
			leechseed: ["5E"],
			megadrain: ["5L13"],
			needlearm: ["5L22"],
			peck: ["5L1"],
			petaldance: ["5L38"],
			pinmissile: ["5L10"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			seedbomb: ["5E"],
			solarbeam: ["5M", "5L50"],
			spikes: ["5E"],
			substitute: ["5M"],
			suckerpunch: ["5L42"],
			sunnyday: ["5M", "5L45"],
			swagger: ["5M"],
			sweetscent: ["5L3"],
			synthesis: ["5L15"],
			toxic: ["5M"],
			woodhammer: ["5E"],
			worryseed: ["5E"],
		},
	},
	dwebble: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			block: ["5E"],
			bugbite: ["5L23"],
			bulldoze: ["5M"],
			counter: ["5E"],
			curse: ["5E"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			endure: ["5E"],
			facade: ["5M"],
			feintattack: ["5L13"],
			flail: ["5L41"],
			frustration: ["5M"],
			furycutter: ["5L1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			irondefense: ["5E"],
			nightslash: ["5E"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5L5"],
			rockpolish: ["5M", "5L19"],
			rockslide: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rockwrecker: ["5L43"],
			round: ["5M"],
			sandattack: ["5L11"],
			sandstorm: ["5M"],
			sandtomb: ["5E"],
			shadowclaw: ["5M"],
			shellsmash: ["5L37"],
			slash: ["5L31"],
			smackdown: ["5M", "5L17"],
			solarbeam: ["5M"],
			spikes: ["5E"],
			stealthrock: ["5L24"],
			stoneedge: ["5M"],
			strength: ["5M"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			toxic: ["5M"],
			withdraw: ["5L7"],
			xscissor: ["5M", "5L35"],
		},
	},
	crustle: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bugbite: ["5L23"],
			bulldoze: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			feintattack: ["5L13"],
			flail: ["5L50"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5L1"],
			rockpolish: ["5M", "5L19"],
			rockslide: ["5M", "5L29"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rockwrecker: ["5L55"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M"],
			shadowclaw: ["5M"],
			shellsmash: ["5L1"],
			slash: ["5L31"],
			smackdown: ["5M", "5L17"],
			solarbeam: ["5M"],
			stealthrock: ["5L24"],
			stoneedge: ["5M"],
			strength: ["5M"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			toxic: ["5M"],
			withdraw: ["5L1"],
			xscissor: ["5M", "5L38"],
		},
	},
	scraggy: {
		inherit: true,
		learnset: {
			amnesia: ["5E"],
			attract: ["5M"],
			brickbreak: ["5M", "5L20"],
			bulkup: ["5M"],
			chipaway: ["5L27"],
			counter: ["5E"],
			crunch: ["5L38"],
			detect: ["5E"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dragonclaw: ["5M"],
			dragondance: ["5E"],
			dragontail: ["5M"],
			drainpunch: ["5E"],
			facade: ["5M", "5L42"],
			fakeout: ["5E"],
			feintattack: ["5L9", "5E"],
			firepunch: ["5E"],
			fling: ["5M"],
			focusblast: ["5M"],
			focuspunch: ["5L49"],
			frustration: ["5M"],
			grassknot: ["5M"],
			headbutt: ["5L12", "5S0"],
			headsmash: ["5L53"],
			hiddenpower: ["5M"],
			highjumpkick: ["5L31", "5S0"],
			icepunch: ["5E"],
			incinerate: ["5M"],
			leer: ["5L1", "5S0"],
			lowkick: ["5L1", "5S0"],
			lowsweep: ["5M"],
			payback: ["5M", "5L23"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockclimb: ["5L45"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L5"],
			scaryface: ["5L34"],
			sludgebomb: ["5M"],
			smackdown: ["5M"],
			snarl: ["5E"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M", "5L16"],
			taunt: ["5M"],
			thunderpunch: ["5E"],
			torment: ["5M"],
			toxic: ["5M"],
			workup: ["5M"],
			zenheadbutt: ["5E"],
		},
	},
	scrafty: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			brickbreak: ["5M", "5L20"],
			bulkup: ["5M"],
			chipaway: ["5L27"],
			crunch: ["5L38"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dragonclaw: ["5M"],
			dragontail: ["5M"],
			drainpunch: ["5S0"],
			facade: ["5M", "5L45"],
			feintattack: ["5L1"],
			firepunch: ["5S0"],
			fling: ["5M"],
			focusblast: ["5M"],
			focuspunch: ["5L58"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			headbutt: ["5L12"],
			headsmash: ["5L65"],
			hiddenpower: ["5M"],
			highjumpkick: ["5L31"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			lowkick: ["5L1"],
			lowsweep: ["5M"],
			payback: ["5M", "5L23", "5S0"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockclimb: ["5L51"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			scaryface: ["5L34"],
			sludgebomb: ["5M"],
			smackdown: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M", "5S0"],
			sunnyday: ["5M"],
			swagger: ["5M", "5L16"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			workup: ["5M"],
		},
	},
	sigilyph: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aircutter: ["5L21"],
			airslash: ["5L41"],
			ancientpower: ["5E"],
			attract: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			cosmicpower: ["5L48"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			gravity: ["5L38"],
			gust: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			hypnosis: ["5L4"],
			icebeam: ["5M"],
			lightscreen: ["5M", "5L24"],
			miracleeye: ["5L1"],
			mirrormove: ["5L34"],
			pluck: ["5M"],
			protect: ["5M"],
			psybeam: ["5L18"],
			psychic: ["5M", "5L44"],
			psychoshift: ["5E"],
			psychup: ["5M"],
			psyshock: ["5M"],
			psywave: ["5L8"],
			raindance: ["5M"],
			reflect: ["5M", "5L28"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5E"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			skillswap: ["5E"],
			skyattack: ["5L51"],
			smackdown: ["5M"],
			solarbeam: ["5M"],
			steelwing: ["5E"],
			storedpower: ["5E"],
			substitute: ["5M"],
			swagger: ["5M"],
			synchronoise: ["5L31"],
			tailwind: ["5L11"],
			telekinesis: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			whirlwind: ["5L14"],
		},
	},
	yamask: {
		inherit: true,
		learnset: {
			astonish: ["5L1"],
			attract: ["5M"],
			calmmind: ["5M"],
			curse: ["5L29"],
			destinybond: ["5L49"],
			disable: ["5L5", "5E"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endure: ["5E"],
			energyball: ["5M"],
			facade: ["5M"],
			faketears: ["5E"],
			flash: ["5M"],
			frustration: ["5M"],
			grudge: ["5L41"],
			guardsplit: ["5L33"],
			haze: ["5L9"],
			healblock: ["5E"],
			hex: ["5L17"],
			hiddenpower: ["5M"],
			imprison: ["5E"],
			meanlook: ["5L45"],
			memento: ["5E"],
			nastyplot: ["5E"],
			nightmare: ["5E"],
			nightshade: ["5L13"],
			ominouswind: ["5L25"],
			payback: ["5M"],
			powersplit: ["5L33"],
			protect: ["5M", "5L1"],
			psychic: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M", "5L37"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			willowisp: ["5M", "5L21"],
		},
	},
	cofagrigus: {
		inherit: true,
		learnset: {
			astonish: ["5L1"],
			attract: ["5M"],
			calmmind: ["5M"],
			curse: ["5L29"],
			destinybond: ["5L57"],
			disable: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			grudge: ["5L45"],
			guardsplit: ["5L33"],
			haze: ["5L1"],
			hex: ["5L17"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			meanlook: ["5L51"],
			nightshade: ["5L13"],
			ominouswind: ["5L25"],
			payback: ["5M"],
			powersplit: ["5L33"],
			protect: ["5M", "5L1"],
			psychic: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			scaryface: ["5L34"],
			shadowball: ["5M", "5L39"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			willowisp: ["5M", "5L21"],
		},
	},
	tirtouga: {
		inherit: true,
		learnset: {
			ancientpower: ["5L18"],
			aquajet: ["5L15", "5S0"],
			aquatail: ["5L41"],
			attract: ["5M"],
			bide: ["5L1", "5E"],
			bite: ["5L8", "5S0"],
			blizzard: ["5M"],
			bodyslam: ["5E", "5S0"],
			brine: ["5L28"],
			bulldoze: ["5M"],
			crunch: ["5L21"],
			curse: ["5L35"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			flail: ["5E"],
			frustration: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L51"],
			icebeam: ["5M"],
			irondefense: ["5E"],
			knockoff: ["5E"],
			protect: ["5M", "5L11", "5S0"],
			raindance: ["5M", "5L48"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L45"],
			rocksmash: ["5M"],
			rockthrow: ["5E"],
			rocktomb: ["5M"],
			rollout: ["5L5"],
			round: ["5M"],
			sandstorm: ["5M"],
			scald: ["5M"],
			shellsmash: ["5L38"],
			slam: ["5E"],
			smackdown: ["5M", "5L31"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			watergun: ["5L1"],
			waterpulse: ["5E"],
			whirlpool: ["5E"],
			wideguard: ["5L25"],
			withdraw: ["5L1"],
		},
	},
	carracosta: {
		inherit: true,
		learnset: {
			ancientpower: ["5L18"],
			aquajet: ["5L15"],
			aquatail: ["5L45"],
			attract: ["5M"],
			bide: ["5L1"],
			bite: ["5L8"],
			blizzard: ["5M"],
			brine: ["5L28"],
			bulldoze: ["5M"],
			crunch: ["5L21"],
			curse: ["5L35"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			hydropump: ["5L61"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			protect: ["5M", "5L11"],
			raindance: ["5M", "5L56"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L51"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			sandstorm: ["5M"],
			scald: ["5M"],
			shellsmash: ["5L40"],
			smackdown: ["5M", "5L31"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			waterfall: ["5M"],
			watergun: ["5L1"],
			wideguard: ["5L25"],
			withdraw: ["5L1"],
		},
	},
	archen: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L28"],
			aerialace: ["5M"],
			agility: ["5L21"],
			ancientpower: ["5L18"],
			attract: ["5M"],
			bite: ["5E"],
			bulldoze: ["5M"],
			crunch: ["5L35"],
			cut: ["5M"],
			defog: ["5E"],
			dig: ["5M"],
			doubleteam: ["5M", "5L8", "5S0"],
			dragonbreath: ["5L31"],
			dragonclaw: ["5M", "5L48"],
			dragonpulse: ["5E"],
			earthpower: ["5E"],
			earthquake: ["5M"],
			endeavor: ["5L38"],
			facade: ["5M"],
			frustration: ["5M"],
			headsmash: ["5E", "5S0"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			knockoff: ["5E"],
			leer: ["5L1"],
			pluck: ["5M", "5L15"],
			protect: ["5M"],
			quickattack: ["5L1"],
			quickguard: ["5L25"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L45"],
			rocksmash: ["5M"],
			rockthrow: ["5L5"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			scaryface: ["5L11", "5S0"],
			shadowclaw: ["5M"],
			smackdown: ["5M"],
			steelwing: ["5E"],
			stoneedge: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thrash: ["5L51"],
			torment: ["5M"],
			toxic: ["5M"],
			uturn: ["5M", "5L41"],
			wingattack: ["5L1", "5S0"],
		},
	},
	archeops: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L28"],
			aerialace: ["5M"],
			agility: ["5L21"],
			ancientpower: ["5L18"],
			attract: ["5M"],
			bulldoze: ["5M"],
			crunch: ["5L35"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M", "5L8"],
			dragonbreath: ["5L31"],
			dragonclaw: ["5M", "5L56"],
			dragontail: ["5M"],
			earthquake: ["5M"],
			endeavor: ["5L40"],
			facade: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			pluck: ["5M", "5L15"],
			protect: ["5M"],
			quickattack: ["5L1"],
			quickguard: ["5L25"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L51"],
			rocksmash: ["5M"],
			rockthrow: ["5L1"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			scaryface: ["5L11"],
			shadowclaw: ["5M"],
			smackdown: ["5M"],
			stoneedge: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thrash: ["5L61"],
			torment: ["5M"],
			toxic: ["5M"],
			uturn: ["5M", "5L45"],
			wingattack: ["5L1"],
		},
	},
	trubbish: {
		inherit: true,
		learnset: {
			acidspray: ["5L12"],
			amnesia: ["5L40"],
			attract: ["5M"],
			clearsmog: ["5L34"],
			curse: ["5E"],
			doubleslap: ["5L14"],
			doubleteam: ["5M"],
			explosion: ["5M", "5L47"],
			facade: ["5M"],
			frustration: ["5M"],
			gunkshot: ["5L45"],
			haze: ["5E"],
			hiddenpower: ["5M"],
			mudsport: ["5E"],
			payback: ["5M"],
			poisongas: ["5L1"],
			pound: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			recycle: ["5L3"],
			rest: ["5M"],
			return: ["5M"],
			rockblast: ["5E"],
			rollout: ["5E"],
			round: ["5M"],
			sandattack: ["5E"],
			selfdestruct: ["5E"],
			sludge: ["5L18"],
			sludgebomb: ["5M", "5L29"],
			sludgewave: ["5M"],
			spikes: ["5E"],
			stockpile: ["5L23"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swallow: ["5L23"],
			takedown: ["5L25"],
			thief: ["5M"],
			toxic: ["5M", "5L36"],
			toxicspikes: ["5L7"],
			venoshock: ["5M"],
		},
	},
	garbodor: {
		inherit: true,
		learnset: {
			acidspray: ["5L12"],
			amnesia: ["5L46"],
			attract: ["5M"],
			bodyslam: ["5L25"],
			clearsmog: ["5L34"],
			doubleslap: ["5L14"],
			doubleteam: ["5M"],
			explosion: ["5M", "5L59"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			gunkshot: ["5L54"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			payback: ["5M"],
			poisongas: ["5L1"],
			pound: ["5L1"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			recycle: ["5L1"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			round: ["5M"],
			sludge: ["5L18"],
			sludgebomb: ["5M", "5L29"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			solarbeam: ["5M"],
			stockpile: ["5L23"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swallow: ["5L23"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			toxic: ["5M", "5L39"],
			toxicspikes: ["5L1"],
			venoshock: ["5M"],
		},
	},
	zorua: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			agility: ["5L37"],
			attract: ["5M"],
			calmmind: ["5M"],
			captivate: ["5E"],
			counter: ["5E"],
			cut: ["5M"],
			darkpulse: ["5E"],
			detect: ["5E"],
			dig: ["5M"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L41"],
			extrasensory: ["5E"],
			facade: ["5M"],
			faketears: ["5L9"],
			feintattack: ["5L17"],
			fling: ["5M"],
			foulplay: ["5L29"],
			frustration: ["5M"],
			furyswipes: ["5L13"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			imprison: ["5L53"],
			incinerate: ["5M"],
			leer: ["5L1"],
			memento: ["5E"],
			nastyplot: ["5L49"],
			nightdaze: ["5L57"],
			payback: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			punishment: ["5L45"],
			pursuit: ["5L5"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			round: ["5M"],
			scaryface: ["5L21"],
			scratch: ["5L1"],
			shadowball: ["5M"],
			snarl: ["5E"],
			snatch: ["5E"],
			substitute: ["5M"],
			suckerpunch: ["5E"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			taunt: ["5M", "5L25"],
			thief: ["5M"],
			torment: ["5M", "5L33"],
			toxic: ["5M"],
			uturn: ["5M"],
		},
	},
	zoroark: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			agility: ["5L39", "5S0"],
			attract: ["5M"],
			calmmind: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L44", "5S0"],
			facade: ["5M"],
			feintattack: ["5L17"],
			flamethrower: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			foulplay: ["5L29"],
			frustration: ["5M"],
			furyswipes: ["5L13"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L1"],
			hyperbeam: ["5M"],
			imprison: ["5L59"],
			incinerate: ["5M"],
			leer: ["5L1"],
			lowsweep: ["5M"],
			nastyplot: ["5L54"],
			nightdaze: ["5L64"],
			nightslash: ["5L30"],
			payback: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			punishment: ["5L49", "5S0"],
			pursuit: ["5L1"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			scaryface: ["5L21"],
			scratch: ["5L1"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			snarl: ["5S0"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			taunt: ["5M", "5L25"],
			thief: ["5M"],
			torment: ["5M", "5L34"],
			toxic: ["5M"],
			uturn: ["5M", "5L1"],
		},
	},
	minccino: {
		inherit: true,
		learnset: {
			afteryou: ["5L49"],
			aquatail: ["5E"],
			attract: ["5M"],
			calmmind: ["5M"],
			captivate: ["5L39"],
			charm: ["5L27"],
			dig: ["5M"],
			doubleslap: ["5L13"],
			doubleteam: ["5M"],
			echoedvoice: ["5M", "5L33"],
			encore: ["5L15"],
			endure: ["5E"],
			facade: ["5M"],
			faketears: ["5E"],
			flail: ["5E"],
			fling: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			growl: ["5L3"],
			helpinghand: ["5L7"],
			hiddenpower: ["5M"],
			hypervoice: ["5L43"],
			irontail: ["5E"],
			knockoff: ["5E"],
			lastresort: ["5L45"],
			mudslap: ["5E"],
			pound: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			sing: ["5L21"],
			slam: ["5L37"],
			sleeptalk: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swift: ["5L19"],
			tailslap: ["5L25"],
			tailwhip: ["5E"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			tickle: ["5L9"],
			toxic: ["5M"],
			uturn: ["5M"],
			wakeupslap: ["5L31"],
			workup: ["5M"],
		},
	},
	cinccino: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bulletseed: ["5L1"],
			calmmind: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			helpinghand: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			lightscreen: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockblast: ["5L1"],
			round: ["5M"],
			safeguard: ["5M"],
			sing: ["5L1"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tailslap: ["5L1"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			tickle: ["5L1"],
			toxic: ["5M"],
			uturn: ["5M"],
			workup: ["5M"],
		},
	},
	gothita: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			captivate: ["5E"],
			chargebeam: ["5M"],
			charm: ["5L46"],
			confusion: ["5L3"],
			darkpulse: ["5E"],
			doubleslap: ["5L14"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M", "5L19"],
			energyball: ["5M"],
			facade: ["5M"],
			faketears: ["5L10"],
			feintattack: ["5L24"],
			flash: ["5M"],
			flatter: ["5L28"],
			fling: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			grassknot: ["5M"],
			healblock: ["5L33"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			magicroom: ["5L48"],
			meanlook: ["5E"],
			miracleeye: ["5E"],
			mirrorcoat: ["5E"],
			payback: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			psybeam: ["5L16"],
			psychic: ["5M", "5L37"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M", "5L40"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			tickle: ["5L7"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uproar: ["5E"],
		},
	},
	gothorita: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			charm: ["5L50"],
			confusion: ["5L1"],
			doubleslap: ["5L14"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M", "5L19"],
			energyball: ["5M"],
			facade: ["5M"],
			faketears: ["5L1"],
			feintattack: ["5L24"],
			flash: ["5M"],
			flatter: ["5L28", "5S0", "5S1"],
			fling: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31", "5S0", "5S1"],
			grassknot: ["5M"],
			healblock: ["5L34"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			magicroom: ["5L53"],
			payback: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			psybeam: ["5L16"],
			psychic: ["5M", "5L39"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25", "5S0", "5S1"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M", "5L43"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			tickle: ["5L1"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
		},
	},
	gothitelle: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			brickbreak: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			charm: ["5L54"],
			confusion: ["5L1"],
			doubleslap: ["5L14"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M", "5L19"],
			energyball: ["5M"],
			facade: ["5M"],
			faketears: ["5L1"],
			feintattack: ["5L24"],
			flash: ["5M"],
			flatter: ["5L28"],
			fling: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			healblock: ["5L34"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			lightscreen: ["5M"],
			lowsweep: ["5M"],
			magicroom: ["5L59"],
			payback: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			psybeam: ["5L16"],
			psychic: ["5M", "5L39"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M", "5L45"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			tickle: ["5L1"],
			torment: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
		},
	},
	solosis: {
		inherit: true,
		learnset: {
			acidarmor: ["5E"],
			astonish: ["5E"],
			attract: ["5M"],
			calmmind: ["5M"],
			charm: ["5L19"],
			confuseray: ["5E"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endeavor: ["5L28"],
			energyball: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			gyroball: ["5M"],
			healblock: ["5L46"],
			hiddenpower: ["5M", "5L14"],
			imprison: ["5E"],
			lightscreen: ["5M", "5L16"],
			nightshade: ["5E"],
			painsplit: ["5L33"],
			protect: ["5M"],
			psychic: ["5M", "5L37"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25"],
			psywave: ["5L1"],
			raindance: ["5M"],
			recover: ["5L24"],
			reflect: ["5M", "5L3"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L7"],
			round: ["5M"],
			safeguard: ["5M"],
			secretpower: ["5E"],
			shadowball: ["5M"],
			skillswap: ["5L40"],
			snatch: ["5L10"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trick: ["5E"],
			trickroom: ["5M"],
			wonderroom: ["5L48"],
		},
	},
	duosion: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			charm: ["5L19"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endeavor: ["5L28"],
			energyball: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			gyroball: ["5M"],
			healblock: ["5L50"],
			hiddenpower: ["5M", "5L14"],
			lightscreen: ["5M", "5L16"],
			painsplit: ["5L34"],
			protect: ["5M"],
			psychic: ["5M", "5L39"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25"],
			psywave: ["5L1"],
			raindance: ["5M"],
			recover: ["5L24"],
			reflect: ["5M", "5L1"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			skillswap: ["5L43"],
			snatch: ["5L1"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			wonderroom: ["5L53"],
		},
	},
	reuniclus: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			charm: ["5L19"],
			dizzypunch: ["5L41"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			endeavor: ["5L28"],
			energyball: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			futuresight: ["5L31"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			healblock: ["5L54"],
			hiddenpower: ["5M", "5L14"],
			hyperbeam: ["5M"],
			lightscreen: ["5M", "5L16"],
			painsplit: ["5L34"],
			protect: ["5M"],
			psychic: ["5M", "5L39"],
			psychup: ["5M"],
			psyshock: ["5M", "5L25"],
			psywave: ["5L1"],
			raindance: ["5M"],
			recover: ["5L24"],
			reflect: ["5M", "5L1"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			skillswap: ["5L45"],
			snatch: ["5L1"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			wonderroom: ["5L59"],
		},
	},
	ducklett: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L15"],
			aircutter: ["5E"],
			airslash: ["5L27"],
			aquaring: ["5L24"],
			attract: ["5M"],
			bravebird: ["5L41"],
			brine: ["5E"],
			bubblebeam: ["5L19"],
			defog: ["5L6"],
			dive: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			featherdance: ["5L21"],
			fly: ["5M"],
			frustration: ["5M"],
			gust: ["5E"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hurricane: ["5L46"],
			icebeam: ["5M"],
			luckychant: ["5E"],
			mefirst: ["5E"],
			mirrormove: ["5E"],
			pluck: ["5M"],
			protect: ["5M"],
			raindance: ["5M", "5L34"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5L30"],
			round: ["5M"],
			scald: ["5M"],
			steelwing: ["5E"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			tailwind: ["5L37"],
			toxic: ["5M"],
			watergun: ["5L1"],
			waterpulse: ["5L13"],
			watersport: ["5L3"],
			wingattack: ["5L9"],
		},
	},
	swanna: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L15"],
			airslash: ["5L27"],
			aquaring: ["5L24"],
			attract: ["5M"],
			bravebird: ["5L47"],
			bubblebeam: ["5L19"],
			defog: ["5L1"],
			dive: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			featherdance: ["5L21"],
			fly: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			hurricane: ["5L55"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			pluck: ["5M"],
			protect: ["5M"],
			raindance: ["5M", "5L34"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5L30"],
			round: ["5M"],
			scald: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			tailwind: ["5L40"],
			toxic: ["5M"],
			watergun: ["5L1"],
			waterpulse: ["5L13"],
			watersport: ["5L1"],
			wingattack: ["5L1"],
		},
	},
	vanillite: {
		inherit: true,
		learnset: {
			acidarmor: ["5L31"],
			astonish: ["5L7"],
			attract: ["5M"],
			autotomize: ["5E"],
			avalanche: ["5L19"],
			blizzard: ["5M", "5L49"],
			doubleteam: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			hail: ["5M", "5L40"],
			harden: ["5L4"],
			hiddenpower: ["5M"],
			icebeam: ["5M", "5L35"],
			iceshard: ["5E"],
			iciclespear: ["5L1"],
			icywind: ["5L13"],
			imprison: ["5E"],
			irondefense: ["5E"],
			lightscreen: ["5M"],
			magnetrise: ["5E"],
			mirrorcoat: ["5L44"],
			mirrorshot: ["5L26"],
			mist: ["5L16"],
			naturalgift: ["5E"],
			powdersnow: ["5E"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sheercold: ["5L53"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M", "5L22"],
			toxic: ["5M"],
			uproar: ["5L10"],
			waterpulse: ["5E"],
		},
	},
	vanillish: {
		inherit: true,
		learnset: {
			acidarmor: ["5L31"],
			astonish: ["5L1"],
			attract: ["5M"],
			avalanche: ["5L19"],
			blizzard: ["5M", "5L53"],
			doubleteam: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			hail: ["5M", "5L42"],
			harden: ["5L1"],
			hiddenpower: ["5M"],
			icebeam: ["5M", "5L36"],
			iciclespear: ["5L1"],
			icywind: ["5L13"],
			lightscreen: ["5M"],
			mirrorcoat: ["5L47"],
			mirrorshot: ["5L26"],
			mist: ["5L16"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sheercold: ["5L58"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M", "5L22"],
			toxic: ["5M"],
			uproar: ["5L1"],
		},
	},
	vanilluxe: {
		inherit: true,
		learnset: {
			acidarmor: ["5L31"],
			astonish: ["5L1"],
			attract: ["5M"],
			avalanche: ["5L19"],
			blizzard: ["5M", "5L59"],
			doubleteam: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hail: ["5M", "5L42"],
			harden: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			icebeam: ["5M", "5L36"],
			iciclespear: ["5L1"],
			icywind: ["5L13"],
			lightscreen: ["5M"],
			mirrorcoat: ["5L50"],
			mirrorshot: ["5L26"],
			mist: ["5L16"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sheercold: ["5L67"],
			substitute: ["5M"],
			swagger: ["5M"],
			taunt: ["5M", "5L22"],
			toxic: ["5M"],
			uproar: ["5L1"],
			weatherball: ["5L1"],
		},
	},
	deerling: {
		inherit: true,
		learnset: {
			agility: ["5E"],
			aromatherapy: ["5L28", "5S0"],
			attract: ["5M"],
			batonpass: ["5E"],
			camouflage: ["5L1"],
			charm: ["5L36"],
			doubleedge: ["5L46"],
			doublekick: ["5L10"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			energyball: ["5M", "5L32"],
			facade: ["5M"],
			faketears: ["5E"],
			feintattack: ["5L16", "5S0"],
			flash: ["5M"],
			frustration: ["5M"],
			grassknot: ["5M"],
			grasswhistle: ["5E"],
			growl: ["5L4"],
			hiddenpower: ["5M"],
			jumpkick: ["5L24", "5S0"],
			leechseed: ["5L13"],
			lightscreen: ["5M"],
			naturalgift: ["5E"],
			naturepower: ["5L41"],
			odorsleuth: ["5E"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			sandattack: ["5L7"],
			shadowball: ["5M"],
			sleeptalk: ["5E"],
			solarbeam: ["5M", "5L51"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			synthesis: ["5E"],
			tackle: ["5L1"],
			takedown: ["5L20", "5S0"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M"],
			worryseed: ["5E"],
		},
	},
	sawsbuck: {
		inherit: true,
		learnset: {
			aromatherapy: ["5L28"],
			attract: ["5M"],
			camouflage: ["5L1"],
			charm: ["5L36"],
			cut: ["5M"],
			doubleedge: ["5L52"],
			doublekick: ["5L10"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			energyball: ["5M", "5L32"],
			facade: ["5M"],
			feintattack: ["5L16"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growl: ["5L1"],
			hiddenpower: ["5M"],
			hornleech: ["5L37"],
			hyperbeam: ["5M"],
			jumpkick: ["5L24"],
			leechseed: ["5L13"],
			lightscreen: ["5M"],
			megahorn: ["5L1"],
			naturepower: ["5L44"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			sandattack: ["5L1"],
			shadowball: ["5M"],
			solarbeam: ["5M", "5L60"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			takedown: ["5L20"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	emolga: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L30"],
			aerialace: ["5M"],
			agility: ["5L46"],
			airslash: ["5E"],
			astonish: ["5E"],
			attract: ["5M"],
			batonpass: ["5E"],
			charge: ["5L10"],
			chargebeam: ["5M"],
			charm: ["5E"],
			covet: ["5E"],
			cut: ["5M"],
			discharge: ["5L50"],
			doubleteam: ["5M", "5L19"],
			electroball: ["5L26"],
			encore: ["5L38"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			frustration: ["5M"],
			hiddenpower: ["5M"],
			irontail: ["5E"],
			lightscreen: ["5M", "5L34"],
			protect: ["5M"],
			pursuit: ["5L16"],
			quickattack: ["5L4"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roost: ["5E"],
			round: ["5M"],
			shockwave: ["5L22", "5E"],
			spark: ["5L13"],
			substitute: ["5M"],
			swagger: ["5M"],
			tailwhip: ["5L7"],
			taunt: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thundershock: ["5L1"],
			thunderwave: ["5M"],
			tickle: ["5E"],
			toxic: ["5M"],
			uturn: ["5M"],
			voltswitch: ["5M", "5L42"],
			wildcharge: ["5M"],
		},
	},
	karrablast: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bugbite: ["5E"],
			bugbuzz: ["5L28", "5S0"],
			counter: ["5E"],
			cut: ["5M"],
			doubleedge: ["5L56"],
			doubleteam: ["5M"],
			endure: ["5L8"],
			energyball: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M", "5L25", "5S0"],
			feintattack: ["5E"],
			flail: ["5L49", "5S1"],
			frustration: ["5M"],
			furyattack: ["5L16", "5S0"],
			furycutter: ["5L13"],
			headbutt: ["5L20", "5S0"],
			hiddenpower: ["5M"],
			hornattack: ["5E"],
			knockoff: ["5E"],
			leer: ["5L4"],
			megahorn: ["5E", "5S1"],
			peck: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			scaryface: ["5L40"],
			screech: ["5E"],
			slash: ["5L32"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L52"],
			takedown: ["5L37", "5S1"],
			toxic: ["5M"],
			xscissor: ["5M", "5L44", "5S1"],
		},
	},
	escavalier: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bugbuzz: ["5L28"],
			cut: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M", "5L25"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyattack: ["5L16"],
			gigaimpact: ["5M", "5L56"],
			headbutt: ["5L20"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			irondefense: ["5L40"],
			ironhead: ["5L37"],
			leer: ["5L1"],
			peck: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			quickguard: ["5L1"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			reversal: ["5L49"],
			rocksmash: ["5M"],
			round: ["5M"],
			slash: ["5L32"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L52"],
			toxic: ["5M"],
			twineedle: ["5L1"],
			xscissor: ["5M", "5L44"],
		},
	},
	foongus: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			astonish: ["5L8"],
			attract: ["5M"],
			bide: ["5L12"],
			bodyslam: ["5E"],
			clearsmog: ["5L39"],
			defensecurl: ["5E"],
			doubleteam: ["5M"],
			endure: ["5E"],
			energyball: ["5M"],
			facade: ["5M"],
			feintattack: ["5L20"],
			flash: ["5M"],
			frustration: ["5M"],
			gastroacid: ["5E"],
			gigadrain: ["5L28"],
			grassknot: ["5M"],
			growth: ["5L6", "5E"],
			hiddenpower: ["5M"],
			ingrain: ["5L18"],
			megadrain: ["5L15"],
			payback: ["5M"],
			poisonpowder: ["5E"],
			protect: ["5M"],
			ragepowder: ["5L45"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rollout: ["5E"],
			round: ["5M"],
			sludgebomb: ["5M"],
			solarbeam: ["5M", "5L43"],
			spore: ["5L50"],
			stunspore: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			sweetscent: ["5L24"],
			synthesis: ["5L35"],
			toxic: ["5M", "5L32"],
			venoshock: ["5M"],
		},
	},
	amoonguss: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			astonish: ["5L1"],
			attract: ["5M"],
			bide: ["5L1"],
			clearsmog: ["5L43"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			feintattack: ["5L20"],
			flash: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L28"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growth: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			ingrain: ["5L18"],
			megadrain: ["5L15"],
			payback: ["5M"],
			protect: ["5M"],
			ragepowder: ["5L54"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sludgebomb: ["5M"],
			solarbeam: ["5M", "5L49"],
			spore: ["5L62"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			sweetscent: ["5L24"],
			synthesis: ["5L35"],
			toxic: ["5M", "5L32"],
			venoshock: ["5M"],
		},
	},
	frillish: {
		inherit: true,
		learnset: {
			absorb: ["5L5"],
			acidarmor: ["5E"],
			attract: ["5M"],
			blizzard: ["5M"],
			brine: ["5L32"],
			bubble: ["5L1"],
			bubblebeam: ["5L13"],
			confuseray: ["5E"],
			constrict: ["5E"],
			dive: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			hail: ["5M"],
			hex: ["5L43"],
			hiddenpower: ["5M"],
			hydropump: ["5L49"],
			icebeam: ["5M"],
			mist: ["5E"],
			nightshade: ["5L9"],
			ominouswind: ["5L27"],
			painsplit: ["5E"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			raindance: ["5M", "5L37"],
			recover: ["5L17", "5E"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			scald: ["5M"],
			shadowball: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			waterfall: ["5M"],
			waterpulse: ["5L22"],
			watersport: ["5L1"],
			waterspout: ["5L61"],
			willowisp: ["5M"],
			wringout: ["5L55"],
		},
	},
	jellicent: {
		inherit: true,
		learnset: {
			absorb: ["5L1"],
			attract: ["5M"],
			blizzard: ["5M"],
			brine: ["5L32", "5S0"],
			bubble: ["5L1"],
			bubblebeam: ["5L13"],
			dive: ["5M"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hail: ["5M"],
			hex: ["5L45"],
			hiddenpower: ["5M"],
			hydropump: ["5L53"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			nightshade: ["5L1"],
			ominouswind: ["5L27", "5S0"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			raindance: ["5M", "5L37", "5S0"],
			recover: ["5L17"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			scald: ["5M"],
			shadowball: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			waterfall: ["5M"],
			waterpulse: ["5L22", "5S0"],
			watersport: ["5L1"],
			waterspout: ["5L69"],
			willowisp: ["5M"],
			wringout: ["5L61"],
		},
	},
	alomomola: {
		inherit: true,
		learnset: {
			aquajet: ["5L9"],
			aquaring: ["5L5"],
			attract: ["5M"],
			blizzard: ["5M"],
			brine: ["5L41"],
			calmmind: ["5M"],
			dive: ["5M"],
			doubleslap: ["5L13"],
			doubleteam: ["5M"],
			endure: ["5E"],
			facade: ["5M"],
			frustration: ["5M"],
			hail: ["5M"],
			healingwish: ["5L57"],
			healpulse: ["5L17"],
			helpinghand: ["5L49"],
			hiddenpower: ["5M"],
			hydropump: ["5L61"],
			icebeam: ["5M"],
			lightscreen: ["5M"],
			mirrorcoat: ["5E"],
			mist: ["5E"],
			painsplit: ["5E"],
			pound: ["5L1"],
			protect: ["5M", "5L21"],
			psychic: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			refresh: ["5E"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M", "5L45"],
			scald: ["5M"],
			shadowball: ["5M"],
			soak: ["5L33"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			tickle: ["5E"],
			toxic: ["5M"],
			wakeupslap: ["5L29"],
			waterfall: ["5M"],
			waterpulse: ["5L25"],
			watersport: ["5L1"],
			wideguard: ["5L53"],
			wish: ["5L37"],
		},
	},
	joltik: {
		inherit: true,
		learnset: {
			agility: ["5L37"],
			attract: ["5M"],
			bugbite: ["5L18"],
			bugbuzz: ["5L48"],
			chargebeam: ["5M"],
			crosspoison: ["5E"],
			cut: ["5M"],
			disable: ["5E"],
			discharge: ["5L45"],
			doubleteam: ["5M"],
			electroball: ["5L29"],
			electroweb: ["5L15"],
			energyball: ["5M"],
			facade: ["5M"],
			feintattack: ["5E"],
			flash: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L12"],
			gastroacid: ["5L23"],
			hiddenpower: ["5M"],
			leechlife: ["5L1"],
			lightscreen: ["5M"],
			pinmissile: ["5E"],
			poisonjab: ["5M"],
			poisonsting: ["5E"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5E"],
			round: ["5M"],
			screech: ["5L7"],
			signalbeam: ["5L34"],
			slash: ["5L26"],
			spiderweb: ["5L1"],
			stringshot: ["5L1"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			suckerpunch: ["5L40"],
			swagger: ["5M"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M", "5L4"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			xscissor: ["5M"],
		},
	},
	galvantula: {
		inherit: true,
		learnset: {
			agility: ["5L40"],
			attract: ["5M"],
			bugbite: ["5L18"],
			bugbuzz: ["5L60"],
			chargebeam: ["5M"],
			cut: ["5M"],
			discharge: ["5L54"],
			doubleteam: ["5M"],
			electroball: ["5L29"],
			electroweb: ["5L15"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L12"],
			gastroacid: ["5L23"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leechlife: ["5L1"],
			lightscreen: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			screech: ["5L7"],
			signalbeam: ["5L34"],
			slash: ["5L26"],
			spiderweb: ["5L1"],
			stringshot: ["5L1"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			suckerpunch: ["5L46"],
			swagger: ["5M"],
			thief: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M", "5L1"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			xscissor: ["5M"],
		},
	},
	ferroseed: {
		inherit: true,
		learnset: {
			bulletseed: ["5E"],
			curse: ["5L9"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			explosion: ["5M", "5L55"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M", "5L52"],
			frustration: ["5M"],
			gravity: ["5E"],
			gyroball: ["5M", "5L21"],
			harden: ["5L1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			ingrain: ["5L35"],
			irondefense: ["5L26"],
			ironhead: ["5L43"],
			leechseed: ["5E"],
			metalclaw: ["5L14"],
			mirrorshot: ["5L30"],
			payback: ["5M", "5L47"],
			pinmissile: ["5L18"],
			poisonjab: ["5M"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5E"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			rollout: ["5L6"],
			round: ["5M"],
			seedbomb: ["5E"],
			selfdestruct: ["5L38"],
			solarbeam: ["5M"],
			spikes: ["5E"],
			stealthrock: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			worryseed: ["5E"],
		},
	},
	ferrothorn: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			bulldoze: ["5M"],
			curse: ["5L1"],
			cut: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			explosion: ["5M", "5L67"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M", "5L61"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M", "5L21"],
			harden: ["5L1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			ingrain: ["5L35"],
			irondefense: ["5L26"],
			ironhead: ["5L46"],
			metalclaw: ["5L14"],
			mirrorshot: ["5L30"],
			payback: ["5M", "5L53"],
			pinmissile: ["5L18"],
			poisonjab: ["5M"],
			powerwhip: ["5L40"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockclimb: ["5L1"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			rollout: ["5L1"],
			round: ["5M"],
			sandstorm: ["5M"],
			selfdestruct: ["5L38"],
			shadowclaw: ["5M"],
			solarbeam: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M"],
			tackle: ["5L1"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
		},
	},
	klink: {
		inherit: true,
		learnset: {
			autotomize: ["5L31"],
			bind: ["5L21"],
			charge: ["5L6"],
			chargebeam: ["5M", "5L26"],
			discharge: ["5L42"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			geargrind: ["5L16"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M", "5L57"],
			lockon: ["5L51"],
			metalsound: ["5L45"],
			mirrorshot: ["5L36"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			screech: ["5L39"],
			shiftgear: ["5L48"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunderbolt: ["5M"],
			thundershock: ["5L11"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			visegrip: ["5L1"],
			voltswitch: ["5M"],
			zapcannon: ["5L54"],
		},
	},
	klang: {
		inherit: true,
		learnset: {
			autotomize: ["5L31"],
			bind: ["5L21"],
			charge: ["5L1"],
			chargebeam: ["5M", "5L26"],
			discharge: ["5L44"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			geargrind: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M", "5L64"],
			lockon: ["5L56"],
			metalsound: ["5L48"],
			mirrorshot: ["5L36"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			screech: ["5L40"],
			shiftgear: ["5L52"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunderbolt: ["5M"],
			thundershock: ["5L1"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			visegrip: ["5L1"],
			voltswitch: ["5M"],
			zapcannon: ["5L60"],
		},
	},
	klinklang: {
		inherit: true,
		learnset: {
			autotomize: ["5L31"],
			bind: ["5L21"],
			charge: ["5L1"],
			chargebeam: ["5M", "5L25"],
			discharge: ["5L44"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			geargrind: ["5L1"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M", "5L72"],
			lockon: ["5L60"],
			metalsound: ["5L48"],
			mirrorshot: ["5L36"],
			protect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			screech: ["5L40"],
			shiftgear: ["5L54"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thundershock: ["5L1"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			visegrip: ["5L1"],
			voltswitch: ["5M"],
			zapcannon: ["5L66"],
		},
	},
	tynamo: {
		inherit: true,
		learnset: {
			chargebeam: ["5L1"],
			spark: ["5L1"],
			tackle: ["5L1"],
			thunderwave: ["5L1"],
		},
	},
	eelektrik: {
		inherit: true,
		learnset: {
			acid: ["5L19"],
			acidspray: ["5L49"],
			acrobatics: ["5M"],
			attract: ["5M"],
			bind: ["5L9"],
			chargebeam: ["5M", "5L1"],
			coil: ["5L54"],
			crunch: ["5L39"],
			discharge: ["5L29"],
			doubleteam: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			gastroacid: ["5L64"],
			headbutt: ["5L1"],
			hiddenpower: ["5M"],
			lightscreen: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			spark: ["5L1"],
			substitute: ["5M"],
			swagger: ["5M"],
			thrash: ["5L74"],
			thunder: ["5M"],
			thunderbolt: ["5M", "5L44"],
			thunderwave: ["5M", "5L1"],
			toxic: ["5M"],
			uturn: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5L59"],
			zapcannon: ["5L69"],
		},
	},
	eelektross: {
		inherit: true,
		learnset: {
			acid: ["5L1"],
			acrobatics: ["5M"],
			attract: ["5M"],
			brickbreak: ["5M"],
			chargebeam: ["5M"],
			crunch: ["5L1"],
			crushclaw: ["5L1"],
			cut: ["5M"],
			discharge: ["5L1"],
			doubleteam: ["5M"],
			dragonclaw: ["5M"],
			dragontail: ["5M"],
			facade: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			headbutt: ["5L1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			lightscreen: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			uturn: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
		},
	},
	elgyem: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			astonish: ["5E"],
			attract: ["5M"],
			barrier: ["5E"],
			calmmind: ["5M", "5L43"],
			chargebeam: ["5M"],
			confusion: ["5L1"],
			disable: ["5E"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M"],
			embargo: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			growl: ["5L4"],
			guardsplit: ["5L50"],
			guardswap: ["5E"],
			headbutt: ["5L18"],
			healblock: ["5L8"],
			hiddenpower: ["5M", "5L22"],
			imprison: ["5L25"],
			lightscreen: ["5M"],
			miracleeye: ["5L11"],
			nastyplot: ["5E"],
			powersplit: ["5L50"],
			powerswap: ["5E"],
			protect: ["5M"],
			psybeam: ["5L15"],
			psychic: ["5M", "5L39"],
			psychup: ["5M", "5L36"],
			psyshock: ["5M"],
			raindance: ["5M"],
			recover: ["5L46"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			simplebeam: ["5L29"],
			skillswap: ["5E"],
			substitute: ["5M"],
			swagger: ["5M"],
			synchronoise: ["5L53"],
			telekinesis: ["5M"],
			teleport: ["5E"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			wonderroom: ["5L56"],
			zenheadbutt: ["5L32"],
		},
	},
	beheeyem: {
		inherit: true,
		learnset: {
			allyswitch: ["5M"],
			attract: ["5M"],
			calmmind: ["5M", "5L45"],
			chargebeam: ["5M"],
			confusion: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M"],
			embargo: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			growl: ["5L1"],
			guardsplit: ["5L56"],
			headbutt: ["5L18"],
			healblock: ["5L1"],
			hiddenpower: ["5M", "5L22"],
			hyperbeam: ["5M"],
			imprison: ["5L25"],
			lightscreen: ["5M"],
			miracleeye: ["5L1"],
			powersplit: ["5L58"],
			protect: ["5M"],
			psybeam: ["5L15"],
			psychic: ["5M", "5L39"],
			psychup: ["5M", "5L36"],
			psyshock: ["5M"],
			raindance: ["5M"],
			recover: ["5L50"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			simplebeam: ["5L29"],
			substitute: ["5M"],
			swagger: ["5M"],
			synchronoise: ["5L63"],
			telekinesis: ["5M"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			wonderroom: ["5L68"],
			zenheadbutt: ["5L32"],
		},
	},
	litwick: {
		inherit: true,
		learnset: {
			acid: ["5E"],
			acidarmor: ["5E"],
			astonish: ["5L1"],
			attract: ["5M"],
			calmmind: ["5M"],
			captivate: ["5E"],
			clearsmog: ["5E"],
			confuseray: ["5L10"],
			curse: ["5L43"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			ember: ["5L1"],
			endure: ["5E"],
			energyball: ["5M"],
			facade: ["5M"],
			fireblast: ["5M"],
			firespin: ["5L7"],
			flameburst: ["5L20"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			haze: ["5E"],
			heatwave: ["5E"],
			hex: ["5L28"],
			hiddenpower: ["5M"],
			imprison: ["5L24"],
			incinerate: ["5M"],
			inferno: ["5L38"],
			memento: ["5L33"],
			minimize: ["5L3"],
			nightshade: ["5L13"],
			overheat: ["5M", "5L61"],
			painsplit: ["5L55"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M", "5L49"],
			smog: ["5L5"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			willowisp: ["5M", "5L16"],
		},
	},
	lampent: {
		inherit: true,
		learnset: {
			astonish: ["5L1"],
			attract: ["5M"],
			calmmind: ["5M"],
			confuseray: ["5L10"],
			curse: ["5L45"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			ember: ["5L1"],
			energyball: ["5M"],
			facade: ["5M"],
			fireblast: ["5M"],
			firespin: ["5L7"],
			flameburst: ["5L20"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			hex: ["5L28"],
			hiddenpower: ["5M"],
			imprison: ["5L24"],
			incinerate: ["5M"],
			inferno: ["5L38"],
			memento: ["5L33"],
			minimize: ["5L1"],
			nightshade: ["5L13"],
			overheat: ["5M", "5L69"],
			painsplit: ["5L61"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			psychup: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M", "5L53"],
			smog: ["5L1"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			willowisp: ["5M", "5L16"],
		},
	},
	chandelure: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			calmmind: ["5M"],
			confuseray: ["5L1"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			embargo: ["5M"],
			energyball: ["5M", "5S0"],
			facade: ["5M"],
			fireblast: ["5M"],
			flameburst: ["5L1"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			flash: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			heatwave: ["5S0"],
			hex: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			overheat: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M", "5S0"],
			psychup: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M", "5S0"],
			smog: ["5L1"],
			solarbeam: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			willowisp: ["5M"],
		},
	},
	axew: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L7"],
			attract: ["5M"],
			counter: ["5E"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonclaw: ["5M", "5L28", "5S1"],
			dragondance: ["5L32"],
			dragonpulse: ["5L41", "5E"],
			dragonrage: ["5L10", "5S0", "5S1", "5S2"],
			dualchop: ["5L13"],
			endeavor: ["5E"],
			endure: ["5E", "5S1"],
			facade: ["5M"],
			falseswipe: ["5M", "5L24"],
			fling: ["5M"],
			focusenergy: ["5E"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L61", "5S2"],
			guillotine: ["5L51"],
			harden: ["5E"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			irontail: ["5E"],
			leer: ["5L4"],
			nightslash: ["5E"],
			outrage: ["5L56", "5S2"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			razorwind: ["5E"],
			rest: ["5M"],
			return: ["5M", "5S1"],
			reversal: ["5E"],
			roar: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L16"],
			scratch: ["5L1", "5S0", "5S2"],
			slash: ["5L20"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L46"],
			taunt: ["5M", "5L36"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	fraxure: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L1"],
			attract: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonclaw: ["5M", "5L28"],
			dragondance: ["5L32"],
			dragonpulse: ["5L42"],
			dragonrage: ["5L1"],
			dragontail: ["5M"],
			dualchop: ["5L13"],
			facade: ["5M"],
			falseswipe: ["5M", "5L24"],
			fling: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L66"],
			guillotine: ["5L54"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			outrage: ["5L60"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L16"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			slash: ["5L20"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L48"],
			taunt: ["5M", "5L36"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	haxorus: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L1"],
			attract: ["5M"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonclaw: ["5M", "5L28"],
			dragondance: ["5L32", "5S0"],
			dragonpulse: ["5L42"],
			dragonrage: ["5L1"],
			dragontail: ["5M"],
			dualchop: ["5L13", "5S0"],
			earthquake: ["5M", "5S0"],
			facade: ["5M"],
			falseswipe: ["5M", "5L24"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M", "5L74"],
			grassknot: ["5M"],
			guillotine: ["5L58"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			outrage: ["5L66"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L16"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			slash: ["5L20"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L50"],
			taunt: ["5M", "5L36"],
			toxic: ["5M"],
			xscissor: ["5M", "5S0"],
		},
	},
	cubchoo: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5E"],
			attract: ["5M"],
			avalanche: ["5E"],
			bide: ["5L9", "5S0"],
			blizzard: ["5M", "5L45"],
			brine: ["5L21"],
			charm: ["5L29"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			encore: ["5E"],
			endure: ["5L25"],
			facade: ["5M"],
			flail: ["5L36"],
			fling: ["5M"],
			focuspunch: ["5E"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L17"],
			grassknot: ["5M"],
			growl: ["5L5", "5S0"],
			hail: ["5M", "5L49"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			icebeam: ["5M"],
			icepunch: ["5E"],
			icywind: ["5L13", "5S0"],
			nightslash: ["5E"],
			powdersnow: ["5L1", "5S0"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M", "5L41"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowclaw: ["5M"],
			sheercold: ["5L57"],
			slash: ["5L33"],
			sleeptalk: ["5E"],
			strength: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			thrash: ["5L53"],
			toxic: ["5M"],
			yawn: ["5E"],
		},
	},
	beartic: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bide: ["5L1"],
			blizzard: ["5M", "5L45"],
			brickbreak: ["5M"],
			brine: ["5L21"],
			bulkup: ["5M"],
			bulldoze: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			dive: ["5M"],
			doubleteam: ["5M"],
			echoedvoice: ["5M"],
			endure: ["5L25"],
			facade: ["5M"],
			flail: ["5L36"],
			fling: ["5M"],
			focusblast: ["5M"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L17"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			growl: ["5L1"],
			hail: ["5M", "5L53"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			icebeam: ["5M"],
			iciclecrash: ["5L37"],
			icywind: ["5L1"],
			powdersnow: ["5L1"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M", "5L41"],
			return: ["5M"],
			roar: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowclaw: ["5M"],
			sheercold: ["5L66"],
			slash: ["5L33"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			superpower: ["5L1"],
			surf: ["5M"],
			swagger: ["5M", "5L29"],
			swordsdance: ["5M"],
			taunt: ["5M"],
			thrash: ["5L59"],
			toxic: ["5M"],
		},
	},
	cryogonal: {
		inherit: true,
		learnset: {
			acidarmor: ["5L29"],
			acrobatics: ["5M"],
			attract: ["5M"],
			aurorabeam: ["5L25"],
			bind: ["5L1"],
			blizzard: ["5M"],
			confuseray: ["5L45"],
			doubleteam: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			frostbreath: ["5M"],
			frustration: ["5M"],
			hail: ["5M"],
			haze: ["5L21"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			icebeam: ["5M", "5L33"],
			iceshard: ["5L5"],
			icywind: ["5L17"],
			lightscreen: ["5M", "5L37"],
			mist: ["5L21"],
			nightslash: ["5L57"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rapidspin: ["5L13"],
			recover: ["5L49"],
			reflect: ["5M", "5L37"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sharpen: ["5L9"],
			sheercold: ["5L61"],
			slash: ["5L41"],
			solarbeam: ["5M", "5L53"],
			substitute: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
		},
	},
	shelmet: {
		inherit: true,
		learnset: {
			acid: ["5L4"],
			acidarmor: ["5L32"],
			attract: ["5M"],
			batonpass: ["5E"],
			bide: ["5L8"],
			bodyslam: ["5L40", "5S1"],
			bugbuzz: ["5L44", "5S1"],
			curse: ["5L13"],
			doubleedge: ["5E"],
			doubleteam: ["5M"],
			encore: ["5E", "5S1"],
			endure: ["5E"],
			energyball: ["5M"],
			facade: ["5M"],
			feint: ["5E"],
			finalgambit: ["5L56"],
			frustration: ["5M"],
			gigadrain: ["5L37", "5S1"],
			guardsplit: ["5E"],
			guardswap: ["5L52"],
			hiddenpower: ["5M"],
			leechlife: ["5L1"],
			megadrain: ["5L20", "5S0"],
			mindreader: ["5E"],
			mudslap: ["5E"],
			protect: ["5M", "5L28", "5S0"],
			pursuit: ["5E"],
			raindance: ["5M"],
			recover: ["5L49"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sludgebomb: ["5M"],
			spikes: ["5E"],
			strugglebug: ["5M", "5L16", "5S0"],
			substitute: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			venoshock: ["5M"],
			yawn: ["5L25", "5S0"],
		},
	},
	accelgor: {
		inherit: true,
		learnset: {
			acidspray: ["5L1"],
			agility: ["5L32"],
			attract: ["5M"],
			bugbuzz: ["5L44"],
			doubleteam: ["5M", "5L1"],
			energyball: ["5M"],
			facade: ["5M"],
			finalgambit: ["5L56"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L37"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leechlife: ["5L1"],
			mefirst: ["5L28"],
			megadrain: ["5L20"],
			powerswap: ["5L52"],
			protect: ["5M"],
			quickattack: ["5L1"],
			raindance: ["5M"],
			recover: ["5L49"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			sludgebomb: ["5M"],
			strugglebug: ["5M", "5L16"],
			substitute: ["5M"],
			swagger: ["5M"],
			swift: ["5L25"],
			toxic: ["5M"],
			uturn: ["5M", "5L40"],
			venoshock: ["5M"],
		},
	},
	stunfisk: {
		inherit: true,
		learnset: {
			astonish: ["5E"],
			attract: ["5M"],
			bide: ["5L5"],
			bounce: ["5L35"],
			bulldoze: ["5M"],
			camouflage: ["5L17"],
			curse: ["5E"],
			dig: ["5M"],
			discharge: ["5L25"],
			doubleteam: ["5M"],
			earthpower: ["5E"],
			earthquake: ["5M"],
			endure: ["5L30"],
			facade: ["5M"],
			fissure: ["5L61"],
			flail: ["5L55"],
			flash: ["5M"],
			frustration: ["5M"],
			hiddenpower: ["5M"],
			mudbomb: ["5L21"],
			muddywater: ["5L40"],
			mudshot: ["5L13"],
			mudslap: ["5L1"],
			mudsport: ["5L1"],
			painsplit: ["5E"],
			payback: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			revenge: ["5L50"],
			rockslide: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			scald: ["5M"],
			shockwave: ["5E"],
			sleeptalk: ["5E"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			spark: ["5E"],
			spite: ["5E"],
			stoneedge: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M", "5L45"],
			thundershock: ["5L9"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			yawn: ["5E"],
		},
	},
	mienfoo: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			attract: ["5M"],
			aurasphere: ["5L61"],
			batonpass: ["5E"],
			bounce: ["5L49"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			calmmind: ["5M", "5L25"],
			detect: ["5L9"],
			dig: ["5M"],
			doubleslap: ["5L17"],
			doubleteam: ["5M"],
			drainpunch: ["5L33"],
			endure: ["5E"],
			facade: ["5M"],
			fakeout: ["5L13"],
			feint: ["5E"],
			fling: ["5M"],
			focusblast: ["5M"],
			forcepalm: ["5L29"],
			frustration: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			highjumpkick: ["5L53"],
			jumpkick: ["5L37"],
			knockoff: ["5E"],
			lowkick: ["5E"],
			lowsweep: ["5M"],
			meditate: ["5L5"],
			mefirst: ["5E"],
			payback: ["5M"],
			poisonjab: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			psychup: ["5M"],
			quickguard: ["5L45"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			reversal: ["5L57"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			smellingsalts: ["5E"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swift: ["5L21"],
			swordsdance: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			uturn: ["5M", "5L41"],
			vitalthrow: ["5E"],
			workup: ["5M"],
		},
	},
	mienshao: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			attract: ["5M"],
			aurasphere: ["5L70"],
			bounce: ["5L49"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			calmmind: ["5M", "5L25"],
			detect: ["5L1"],
			dig: ["5M"],
			doubleslap: ["5L17"],
			doubleteam: ["5M"],
			drainpunch: ["5L33"],
			facade: ["5M"],
			fakeout: ["5L1"],
			fling: ["5M"],
			focusblast: ["5M"],
			forcepalm: ["5L29"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			highjumpkick: ["5L56"],
			hyperbeam: ["5M"],
			jumpkick: ["5L37"],
			lowsweep: ["5M"],
			meditate: ["5L1"],
			payback: ["5M"],
			poisonjab: ["5M"],
			pound: ["5L1"],
			protect: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			reversal: ["5L63"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swift: ["5L21"],
			swordsdance: ["5M"],
			taunt: ["5M"],
			toxic: ["5M"],
			uturn: ["5M", "5L41"],
			wideguard: ["5L45"],
			workup: ["5M"],
		},
	},
	druddigon: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			attract: ["5M"],
			bite: ["5L9"],
			bulldoze: ["5M"],
			chargebeam: ["5M"],
			chipaway: ["5L31"],
			crunch: ["5L25"],
			crushclaw: ["5E"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonclaw: ["5M", "5L27"],
			dragonrage: ["5L18"],
			dragontail: ["5M", "5L45"],
			earthquake: ["5M"],
			facade: ["5M"],
			feintattack: ["5E"],
			firefang: ["5E"],
			flamethrower: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			glare: ["5E"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L5"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			irontail: ["5E"],
			leer: ["5L1", "5S0"],
			metalclaw: ["5E"],
			nightslash: ["5L40"],
			outrage: ["5L62"],
			payback: ["5M"],
			poisontail: ["5E"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			revenge: ["5L35"],
			roar: ["5M"],
			rockclimb: ["5L49"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L13"],
			scratch: ["5L1", "5S0"],
			shadowclaw: ["5M"],
			slash: ["5L21"],
			sludgebomb: ["5M"],
			smackdown: ["5M"],
			snatch: ["5E"],
			strength: ["5M"],
			substitute: ["5M"],
			suckerpunch: ["5E"],
			sunnyday: ["5M"],
			superpower: ["5L55"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thunderfang: ["5E"],
			torment: ["5M"],
			toxic: ["5M"],
		},
	},
	golett: {
		inherit: true,
		learnset: {
			astonish: ["5L1"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			curse: ["5L40"],
			defensecurl: ["5L1"],
			doubleteam: ["5M"],
			dynamicpunch: ["5L30"],
			earthquake: ["5M", "5L45"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			focuspunch: ["5L55"],
			frustration: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M"],
			hammerarm: ["5L50"],
			hiddenpower: ["5M"],
			icebeam: ["5M"],
			irondefense: ["5L17"],
			lowsweep: ["5M"],
			magnitude: ["5L25"],
			megapunch: ["5L21"],
			mudslap: ["5L5"],
			nightshade: ["5L35"],
			pound: ["5L1"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L9"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			shadowpunch: ["5L13"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			toxic: ["5M"],
		},
	},
	golurk: {
		inherit: true,
		learnset: {
			astonish: ["5L1"],
			brickbreak: ["5M"],
			bulldoze: ["5M"],
			chargebeam: ["5M"],
			curse: ["5L40"],
			defensecurl: ["5L1"],
			doubleteam: ["5M"],
			dynamicpunch: ["5L30"],
			earthquake: ["5M", "5L50"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			focuspunch: ["5L70"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gyroball: ["5M", "5S0"],
			hammerarm: ["5L60", "5S0"],
			heavyslam: ["5L43"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M", "5S0"],
			icebeam: ["5M"],
			irondefense: ["5L17"],
			lowsweep: ["5M"],
			magnitude: ["5L25"],
			megapunch: ["5L21"],
			mudslap: ["5L1"],
			nightshade: ["5L35"],
			pound: ["5L1"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			rollout: ["5L9"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			shadowpunch: ["5L13", "5S0"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			telekinesis: ["5M"],
			thief: ["5M"],
			thunderbolt: ["5M"],
			toxic: ["5M"],
		},
	},
	pawniard: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L33"],
			attract: ["5M"],
			brickbreak: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L41"],
			facade: ["5M"],
			falseswipe: ["5M"],
			feintattack: ["5L17"],
			fling: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L9"],
			grassknot: ["5M"],
			guillotine: ["5L62"],
			headbutt: ["5E"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			irondefense: ["5L46"],
			ironhead: ["5L54"],
			leer: ["5L6"],
			lowsweep: ["5M"],
			meanlook: ["5E"],
			metalclaw: ["5L25"],
			metalsound: ["5L38"],
			nightslash: ["5L49"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			psychocut: ["5E"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			revenge: ["5E"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			scaryface: ["5L22"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			slash: ["5L30"],
			stealthrock: ["5E"],
			substitute: ["5M"],
			suckerpunch: ["5E"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L57"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M", "5L14"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	bisharp: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			assurance: ["5L33"],
			attract: ["5M"],
			brickbreak: ["5M"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L41"],
			facade: ["5M"],
			falseswipe: ["5M"],
			feintattack: ["5L17"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			guillotine: ["5L71"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			irondefense: ["5L46"],
			ironhead: ["5L57"],
			leer: ["5L1"],
			lowsweep: ["5M"],
			metalburst: ["5L1"],
			metalclaw: ["5L25"],
			metalsound: ["5L38"],
			nightslash: ["5L49"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandstorm: ["5M"],
			scaryface: ["5L22"],
			scratch: ["5L1"],
			shadowclaw: ["5M"],
			slash: ["5L30"],
			stoneedge: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L63"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M", "5L1"],
			toxic: ["5M"],
			xscissor: ["5M"],
		},
	},
	bouffalant: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			amnesia: ["5E"],
			attract: ["5M"],
			bulldoze: ["5M"],
			cut: ["5M"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			focusenergy: ["5L36"],
			frustration: ["5M"],
			furyattack: ["5L11"],
			gigaimpact: ["5M", "5L61"],
			headbutt: ["5E"],
			headcharge: ["5L31"],
			hiddenpower: ["5M"],
			hornattack: ["5L16"],
			ironhead: ["5E"],
			leer: ["5L1"],
			megahorn: ["5L41"],
			mudshot: ["5E"],
			mudslap: ["5E"],
			payback: ["5M"],
			poisonjab: ["5M"],
			protect: ["5M"],
			pursuit: ["5L1"],
			rage: ["5L6"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			revenge: ["5L26"],
			reversal: ["5L46"],
			rockclimb: ["5E"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L21"],
			skullbash: ["5E"],
			stomp: ["5E"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L56"],
			taunt: ["5M"],
			thrash: ["5L51"],
			toxic: ["5M"],
			wildcharge: ["5M"],
			workup: ["5M"],
		},
	},
	rufflet: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L23"],
			airslash: ["5L41"],
			attract: ["5M"],
			bravebird: ["5L59"],
			bulkup: ["5M"],
			crushclaw: ["5L46"],
			cut: ["5M"],
			defog: ["5L32"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			furyattack: ["5L5"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L14"],
			leer: ["5L1"],
			peck: ["5L1"],
			pluck: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L19"],
			shadowclaw: ["5M"],
			skydrop: ["5M", "5L50"],
			slash: ["5L28"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tailwind: ["5L37"],
			thrash: ["5L64"],
			toxic: ["5M"],
			uturn: ["5M"],
			whirlwind: ["5L55"],
			wingattack: ["5L10"],
			workup: ["5M"],
		},
	},
	braviary: {
		inherit: true,
		learnset: {
			aerialace: ["5M", "5L23", "5S0"],
			airslash: ["5L41"],
			attract: ["5M"],
			bravebird: ["5L63"],
			bulkup: ["5M"],
			crushclaw: ["5L46"],
			cut: ["5M"],
			defog: ["5L32"],
			doubleteam: ["5M"],
			facade: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			furyattack: ["5L1"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M", "5L14", "5S0"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			peck: ["5L1"],
			pluck: ["5M"],
			protect: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L19", "5S0"],
			shadowclaw: ["5M"],
			skydrop: ["5M", "5L50"],
			slash: ["5L28"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			superpower: ["5L51"],
			swagger: ["5M"],
			tailwind: ["5L37"],
			thrash: ["5L70"],
			toxic: ["5M"],
			uturn: ["5M"],
			whirlwind: ["5L57"],
			wingattack: ["5L1", "5S0"],
			workup: ["5M"],
		},
	},
	vullaby: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			airslash: ["5L41"],
			attract: ["5M"],
			bravebird: ["5L59"],
			cut: ["5M"],
			darkpulse: ["5L46"],
			defog: ["5L32"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L50"],
			facade: ["5M"],
			faketears: ["5E"],
			feintattack: ["5L23"],
			flatter: ["5L19"],
			fly: ["5M"],
			frustration: ["5M"],
			furyattack: ["5L5"],
			gust: ["5L1"],
			hiddenpower: ["5M"],
			incinerate: ["5M"],
			knockoff: ["5E"],
			leer: ["5L1"],
			meanlook: ["5E"],
			mirrormove: ["5L64"],
			nastyplot: ["5L14"],
			payback: ["5M"],
			pluck: ["5M", "5L10"],
			protect: ["5M"],
			psychup: ["5M"],
			punishment: ["5L28"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			roost: ["5E"],
			round: ["5M"],
			scaryface: ["5E"],
			shadowball: ["5M"],
			steelwing: ["5E"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tailwind: ["5L37"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			uturn: ["5M"],
			whirlwind: ["5L55"],
		},
	},
	mandibuzz: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			airslash: ["5L41"],
			attract: ["5M"],
			bonerush: ["5L51"],
			bravebird: ["5L63"],
			cut: ["5M"],
			darkpulse: ["5L46"],
			defog: ["5L32"],
			doubleteam: ["5M"],
			embargo: ["5M", "5L50"],
			facade: ["5M"],
			feintattack: ["5L23", "5S0"],
			flatter: ["5L19", "5S0"],
			fly: ["5M"],
			frustration: ["5M"],
			furyattack: ["5L1"],
			gigaimpact: ["5M"],
			gust: ["5L1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			leer: ["5L1"],
			mirrormove: ["5L70"],
			nastyplot: ["5L14", "5S0"],
			payback: ["5M"],
			pluck: ["5M", "5L1", "5S0"],
			protect: ["5M"],
			psychup: ["5M"],
			punishment: ["5L28"],
			raindance: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowball: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tailwind: ["5L37"],
			taunt: ["5M"],
			thief: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			uturn: ["5M"],
			whirlwind: ["5L57"],
		},
	},
	heatmor: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			amnesia: ["5L46"],
			attract: ["5M"],
			bind: ["5L11"],
			bodyslam: ["5E"],
			bugbite: ["5L36"],
			curse: ["5E"],
			cut: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			facade: ["5M"],
			feintattack: ["5E"],
			fireblast: ["5M"],
			firespin: ["5L16"],
			flameburst: ["5L31"],
			flamethrower: ["5M", "5L51"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			furyswipes: ["5L21"],
			gigaimpact: ["5M"],
			heatwave: ["5E"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			incinerate: ["5M", "5L1"],
			inferno: ["5L61"],
			lick: ["5L1"],
			nightslash: ["5E"],
			odorsleuth: ["5L6"],
			protect: ["5M"],
			pursuit: ["5E"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L41"],
			sleeptalk: ["5E"],
			snatch: ["5L26"],
			solarbeam: ["5M"],
			spitup: ["5L56"],
			stockpile: ["5L56"],
			substitute: ["5M"],
			suckerpunch: ["5E"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swallow: ["5L56"],
			taunt: ["5M"],
			thief: ["5M"],
			tickle: ["5E"],
			toxic: ["5M"],
			willowisp: ["5M"],
			wrap: ["5E"],
		},
	},
	durant: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			agility: ["5L16"],
			attract: ["5M"],
			batonpass: ["5E"],
			bite: ["5L11"],
			bugbite: ["5L26"],
			crunch: ["5L31"],
			cut: ["5M"],
			dig: ["5M", "5L41"],
			doubleteam: ["5M"],
			endure: ["5E"],
			energyball: ["5M"],
			entrainment: ["5L46"],
			facade: ["5M"],
			feintattack: ["5E"],
			flashcannon: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L6"],
			gigaimpact: ["5M"],
			guillotine: ["5L61"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			irondefense: ["5L56"],
			ironhead: ["5L36"],
			metalclaw: ["5L21"],
			metalsound: ["5L66"],
			protect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rockclimb: ["5E"],
			rockpolish: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sandattack: ["5L1"],
			sandstorm: ["5M"],
			screech: ["5E"],
			shadowclaw: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunderfang: ["5E"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			visegrip: ["5L1"],
			xscissor: ["5M", "5L51"],
		},
	},
	deino: {
		inherit: true,
		learnset: {
			assurance: ["5E"],
			astonish: ["5E"],
			attract: ["5M"],
			bite: ["5L9"],
			bodyslam: ["5L48"],
			crunch: ["5L25"],
			darkpulse: ["5E"],
			doublehit: ["5E"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonbreath: ["5L17"],
			dragonpulse: ["5L32"],
			dragonrage: ["5L1", "5S0"],
			dragonrush: ["5L42"],
			dragontail: ["5M"],
			earthpower: ["5E"],
			facade: ["5M"],
			firefang: ["5E"],
			focusenergy: ["5L4"],
			frustration: ["5M"],
			headbutt: ["5L12"],
			headsmash: ["5E"],
			hiddenpower: ["5M"],
			hypervoice: ["5L58"],
			icefang: ["5E"],
			incinerate: ["5M"],
			outrage: ["5L62"],
			protect: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L20"],
			rocksmash: ["5M"],
			round: ["5M"],
			scaryface: ["5L52"],
			screech: ["5E"],
			slam: ["5L28"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			tackle: ["5L1", "5S0"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderfang: ["5E"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L38"],
		},
	},
	zweilous: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			bite: ["5L1"],
			bodyslam: ["5L48"],
			crunch: ["5L25"],
			doublehit: ["5L1"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonbreath: ["5L17"],
			dragonpulse: ["5L32"],
			dragonrage: ["5L1"],
			dragonrush: ["5L42"],
			dragontail: ["5M"],
			facade: ["5M"],
			focusenergy: ["5L1"],
			frustration: ["5M"],
			headbutt: ["5L12"],
			hiddenpower: ["5M"],
			hypervoice: ["5L64"],
			incinerate: ["5M"],
			outrage: ["5L71"],
			protect: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L20"],
			rocksmash: ["5M"],
			round: ["5M"],
			scaryface: ["5L55"],
			slam: ["5L28"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L38"],
		},
	},
	hydreigon: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			attract: ["5M"],
			bite: ["5L1"],
			bodyslam: ["5L48"],
			bulldoze: ["5M"],
			chargebeam: ["5M"],
			crunch: ["5L25"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonbreath: ["5L17", "5S0"],
			dragonpulse: ["5L32"],
			dragonrage: ["5L1"],
			dragonrush: ["5L42"],
			dragontail: ["5M"],
			earthquake: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M"],
			fireblast: ["5M"],
			flamethrower: ["5M", "5S0"],
			flashcannon: ["5M"],
			fly: ["5M"],
			focusblast: ["5M", "5S0"],
			focusenergy: ["5L1"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			headbutt: ["5L12"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			hypervoice: ["5L68", "5S0"],
			incinerate: ["5M"],
			outrage: ["5L79"],
			payback: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			roar: ["5M", "5L20"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			scaryface: ["5L55"],
			slam: ["5L28"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			taunt: ["5M"],
			thief: ["5M"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			triattack: ["5L1"],
			uturn: ["5M"],
			workup: ["5M", "5L38"],
		},
	},
	larvesta: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			amnesia: ["5L80"],
			bugbite: ["5L40"],
			bugbuzz: ["5L70"],
			calmmind: ["5M"],
			doubleedge: ["5L50"],
			doubleteam: ["5M"],
			ember: ["5L1"],
			endure: ["5E"],
			facade: ["5M"],
			fireblast: ["5M"],
			flamecharge: ["5M", "5L30"],
			flamethrower: ["5M"],
			flamewheel: ["5L60"],
			flareblitz: ["5L100"],
			foresight: ["5E"],
			frustration: ["5M"],
			harden: ["5E"],
			hiddenpower: ["5M"],
			incinerate: ["5M"],
			leechlife: ["5L10"],
			lightscreen: ["5M"],
			magnetrise: ["5E"],
			morningsun: ["5E"],
			overheat: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			solarbeam: ["5M"],
			stringshot: ["5L1", "5E"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			takedown: ["5L20"],
			thrash: ["5L90"],
			toxic: ["5M"],
			uturn: ["5M"],
			wildcharge: ["5M"],
			willowisp: ["5M"],
			zenheadbutt: ["5E"],
		},
	},
	volcarona: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			bugbuzz: ["5L70", "5S1"],
			calmmind: ["5M"],
			doubleteam: ["5M"],
			ember: ["5L1"],
			facade: ["5M"],
			fierydance: ["5L100"],
			fireblast: ["5M"],
			firespin: ["5L30", "5S0"],
			flamecharge: ["5M"],
			flamethrower: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			gust: ["5L1", "5S0"],
			heatwave: ["5L60"],
			hiddenpower: ["5M"],
			hurricane: ["5L90"],
			hyperbeam: ["5M", "5S1"],
			incinerate: ["5M"],
			leechlife: ["5L1", "5S0"],
			lightscreen: ["5M"],
			overheat: ["5M", "5S1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			quiverdance: ["5L59", "5S1"],
			ragepowder: ["5L80"],
			rest: ["5M"],
			return: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			silverwind: ["5L50"],
			solarbeam: ["5M"],
			stringshot: ["5L1", "5S0"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			uturn: ["5M"],
			whirlwind: ["5L40"],
			wildcharge: ["5M"],
			willowisp: ["5M"],
		},
	},
	cobalion: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			calmmind: ["5M"],
			closecombat: ["5L73"],
			cut: ["5M"],
			doublekick: ["5L7"],
			doubleteam: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M"],
			flashcannon: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			helpinghand: ["5L25", "5S0", "5S1"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			ironhead: ["5L37", "5S0", "5S1"],
			leer: ["5L1"],
			metalburst: ["5L67"],
			metalclaw: ["5L13"],
			poisonjab: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			quickattack: ["5L1"],
			quickguard: ["5L55", "5S2"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L31", "5S0", "5S1"],
			return: ["5M"],
			roar: ["5M"],
			rockpolish: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sacredsword: ["5L42", "5S0", "5S1", "5S2"],
			safeguard: ["5M"],
			sandstorm: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L49", "5S2"],
			takedown: ["5L19"],
			taunt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			workup: ["5M", "5L61", "5S2"],
			xscissor: ["5M"],
		},
	},
	terrakion: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			bulldoze: ["5M"],
			calmmind: ["5M"],
			closecombat: ["5L73"],
			cut: ["5M"],
			doublekick: ["5L7"],
			doubleteam: ["5M"],
			earthquake: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			helpinghand: ["5L25", "5S0", "5S1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			quickattack: ["5L1"],
			quickguard: ["5L55", "5S2"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L31", "5S0", "5S1"],
			return: ["5M"],
			roar: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L37", "5S0", "5S1"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			sacredsword: ["5L42", "5S0", "5S1", "5S2"],
			safeguard: ["5M"],
			sandstorm: ["5M"],
			smackdown: ["5M", "5L13"],
			stoneedge: ["5M", "5L67"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L49", "5S2"],
			takedown: ["5L19"],
			taunt: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L61", "5S2"],
			xscissor: ["5M"],
		},
	},
	virizion: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			calmmind: ["5M"],
			closecombat: ["5L73"],
			cut: ["5M"],
			doublekick: ["5L7"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M"],
			flash: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigadrain: ["5L37", "5S0", "5S1"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			helpinghand: ["5L25", "5S0", "5S1"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			leafblade: ["5L67"],
			leer: ["5L1"],
			lightscreen: ["5M"],
			magicalleaf: ["5L13"],
			protect: ["5M"],
			psychup: ["5M"],
			quickattack: ["5L1"],
			quickguard: ["5L55", "5S2"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L31", "5S0", "5S1"],
			return: ["5M"],
			roar: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sacredsword: ["5L42", "5S0", "5S1", "5S2"],
			safeguard: ["5M"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L49", "5S2"],
			takedown: ["5L19"],
			taunt: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L61", "5S2"],
			xscissor: ["5M"],
		},
	},
	tornadus: {
		inherit: true,
		learnset: {
			acrobatics: ["5M"],
			aerialace: ["5M"],
			agility: ["5L37", "5S0"],
			aircutter: ["5L25", "5S0"],
			airslash: ["5L43", "5S2"],
			astonish: ["5L1", "5S1"],
			attract: ["5M"],
			bite: ["5L13"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			crunch: ["5L49"],
			darkpulse: ["5L73"],
			doubleteam: ["5M"],
			embargo: ["5M"],
			extrasensory: ["5L31", "5S0"],
			facade: ["5M"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			gust: ["5L1", "5S1"],
			hammerarm: ["5L79", "5S2"],
			hiddenpower: ["5M", "5S2"],
			hurricane: ["5L67", "5S2"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M", "5L61"],
			rest: ["5M"],
			return: ["5M"],
			revenge: ["5L19", "5S0"],
			rocksmash: ["5M"],
			round: ["5M"],
			skydrop: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M", "5L7"],
			tailwind: ["5L55"],
			taunt: ["5M"],
			thief: ["5M"],
			thrash: ["5L85"],
			torment: ["5M"],
			toxic: ["5M"],
			uproar: ["5L1", "5S1"],
			uturn: ["5M"],
		},
	},
	thundurus: {
		inherit: true,
		learnset: {
			agility: ["5L37", "5S0"],
			astonish: ["5L1", "5S1"],
			attract: ["5M"],
			bite: ["5L13"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			charge: ["5L55"],
			chargebeam: ["5M"],
			crunch: ["5L49"],
			darkpulse: ["5L73"],
			discharge: ["5L43"],
			doubleteam: ["5M"],
			embargo: ["5M"],
			facade: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M", "5S2"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hammerarm: ["5L79", "5S2"],
			healblock: ["5L31", "5S0"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			incinerate: ["5M"],
			nastyplot: ["5L61"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			revenge: ["5L19", "5S0"],
			rocksmash: ["5M"],
			round: ["5M"],
			shockwave: ["5L25", "5S0"],
			skydrop: ["5M"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M", "5L7"],
			taunt: ["5M"],
			thief: ["5M"],
			thrash: ["5L85"],
			thunder: ["5M", "5L67", "5S2"],
			thunderbolt: ["5M"],
			thundershock: ["5L1", "5S1"],
			thunderwave: ["5M"],
			torment: ["5M"],
			toxic: ["5M"],
			uproar: ["5L1", "5S1"],
			uturn: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M", "5S2"],
		},
	},
	reshiram: {
		inherit: true,
		learnset: {
			ancientpower: ["5L15"],
			blueflare: ["5L100", "5S2"],
			crunch: ["5L71"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T", "5S2"],
			dragonbreath: ["5L29", "5S0"],
			dragonclaw: ["5M"],
			dragonpulse: ["5L54", "5S1"],
			dragonrage: ["5L1"],
			dragontail: ["5M"],
			echoedvoice: ["5M"],
			extrasensory: ["5L43", "5S0", "5S1"],
			facade: ["5M"],
			fireblast: ["5M", "5L78"],
			firefang: ["5L1"],
			flamecharge: ["5M"],
			flamethrower: ["5M", "5L22"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			fusionflare: ["5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			hypervoice: ["5L92"],
			imprison: ["5L8", "5S1"],
			incinerate: ["5M"],
			lightscreen: ["5M"],
			mist: ["5S2"],
			outrage: ["5L85"],
			overheat: ["5M"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L36", "5S0"],
			solarbeam: ["5M"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
			willowisp: ["5M"],
		},
	},
	zekrom: {
		inherit: true,
		learnset: {
			ancientpower: ["5L15"],
			boltstrike: ["5L100", "5S2"],
			chargebeam: ["5M"],
			crunch: ["5L71"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonbreath: ["5L29", "5S0"],
			dragonclaw: ["5M", "5L54", "5S1"],
			dragonrage: ["5L1"],
			dragontail: ["5M"],
			echoedvoice: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			fusionbolt: ["5L50", "5S0", "5S1", "5S2"],
			gigaimpact: ["5M"],
			haze: ["5S2"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			hypervoice: ["5L92"],
			imprison: ["5L8", "5S1"],
			lightscreen: ["5M"],
			outrage: ["5L85", "5S2"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L36", "5S0"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			thunder: ["5M", "5L78"],
			thunderbolt: ["5M", "5L22"],
			thunderfang: ["5L1"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			voltswitch: ["5M"],
			wildcharge: ["5M"],
			zenheadbutt: ["5L43", "5S0", "5S1"],
		},
	},
	landorus: {
		inherit: true,
		learnset: {
			attract: ["5M"],
			block: ["5L1", "5S1"],
			brickbreak: ["5M"],
			bulkup: ["5M"],
			bulldoze: ["5M", "5L19"],
			calmmind: ["5M"],
			dig: ["5M"],
			doubleteam: ["5M"],
			earthpower: ["5L43"],
			earthquake: ["5M", "5L55", "5S0"],
			explosion: ["5M"],
			extrasensory: ["5L31"],
			facade: ["5M"],
			fissure: ["5L67", "5S0"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hammerarm: ["5L79"],
			hiddenpower: ["5M"],
			hyperbeam: ["5M"],
			imprison: ["5L7"],
			mudshot: ["5L1", "5S1"],
			outrage: ["5L85"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			punishment: ["5L13"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			rockslide: ["5M", "5L49", "5S0"],
			rocksmash: ["5M"],
			rockthrow: ["5L25"],
			rocktomb: ["5M", "5L1", "5S1"],
			round: ["5M"],
			sandstorm: ["5M", "5L61", "5S0"],
			sludgebomb: ["5M"],
			sludgewave: ["5M"],
			smackdown: ["5M"],
			stoneedge: ["5M", "5L73"],
			strength: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L37"],
			toxic: ["5M"],
			uturn: ["5M"],
		},
	},
	kyurem: {
		inherit: true,
		learnset: {
			ancientpower: ["5L15"],
			blizzard: ["5M", "5L78"],
			cut: ["5M"],
			doubleteam: ["5M"],
			dracometeor: ["5T"],
			dragonbreath: ["5L29"],
			dragonclaw: ["5M"],
			dragonpulse: ["5L57", "5S0", "5S1"],
			dragonrage: ["5L1"],
			dragontail: ["5M"],
			echoedvoice: ["5M"],
			endeavor: ["5L71", "5S0"],
			facade: ["5M"],
			flashcannon: ["5M"],
			fling: ["5M"],
			fly: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			glaciate: ["5L50", "5S0", "5S1"],
			hail: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			hypervoice: ["5L92"],
			icebeam: ["5M", "5L22"],
			icywind: ["5L1"],
			imprison: ["5L8", "5S0", "5S1"],
			lightscreen: ["5M"],
			outrage: ["5L85"],
			payback: ["5M"],
			protect: ["5M"],
			psychic: ["5M"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockslide: ["5M"],
			rocksmash: ["5M"],
			rocktomb: ["5M"],
			round: ["5M"],
			safeguard: ["5M"],
			scaryface: ["5L43", "5S1"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			slash: ["5L36"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			toxic: ["5M"],
		},
	},
	keldeo: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			aquajet: ["5L1"],
			aquatail: ["5L37"],
			bubblebeam: ["5L13"],
			calmmind: ["5M"],
			closecombat: ["5L73"],
			cut: ["5M"],
			doublekick: ["5L7"],
			doubleteam: ["5M"],
			facade: ["5M"],
			falseswipe: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			hail: ["5M"],
			helpinghand: ["5L25"],
			hiddenpower: ["5M"],
			hydropump: ["5L67"],
			hyperbeam: ["5M"],
			leer: ["5L1"],
			poisonjab: ["5M"],
			protect: ["5M"],
			psychup: ["5M"],
			quickguard: ["5L55"],
			raindance: ["5M"],
			reflect: ["5M"],
			rest: ["5M"],
			retaliate: ["5M", "5L31"],
			return: ["5M"],
			roar: ["5M"],
			rocksmash: ["5M"],
			round: ["5M"],
			sacredsword: ["5L43"],
			safeguard: ["5M"],
			scald: ["5M"],
			secretsword: ["5T"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			surf: ["5M"],
			swagger: ["5M"],
			swordsdance: ["5M", "5L49"],
			takedown: ["5L19"],
			taunt: ["5M"],
			toxic: ["5M"],
			workup: ["5M", "5L61"],
			xscissor: ["5M"],
		},
	},
	meloetta: {
		inherit: true,
		learnset: {
			acrobatics: ["5M", "5L26"],
			brickbreak: ["5M"],
			calmmind: ["5M"],
			chargebeam: ["5M"],
			closecombat: ["5L78"],
			confusion: ["5L11"],
			doubleteam: ["5M"],
			dreameater: ["5M"],
			echoedvoice: ["5M", "5L36"],
			embargo: ["5M"],
			energyball: ["5M"],
			facade: ["5M"],
			flash: ["5M"],
			fling: ["5M"],
			focusblast: ["5M"],
			frustration: ["5M"],
			gigaimpact: ["5M"],
			grassknot: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M"],
			hypervoice: ["5L64"],
			lightscreen: ["5M"],
			lowsweep: ["5M"],
			payback: ["5M"],
			perishsong: ["5L85"],
			protect: ["5M"],
			psybeam: ["5L31"],
			psychic: ["5M", "5L57"],
			psychup: ["5M"],
			psyshock: ["5M"],
			quickattack: ["5L6"],
			raindance: ["5M"],
			relicsong: ["5T"],
			rest: ["5M"],
			retaliate: ["5M"],
			return: ["5M"],
			rocksmash: ["5M"],
			roleplay: ["5L71"],
			round: ["5M", "5L1"],
			safeguard: ["5M"],
			shadowball: ["5M"],
			shadowclaw: ["5M"],
			sing: ["5L16"],
			stoneedge: ["5M"],
			strength: ["5M"],
			substitute: ["5M"],
			sunnyday: ["5M"],
			swagger: ["5M"],
			teeterdance: ["5L21", "5S1"],
			telekinesis: ["5M"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			trickroom: ["5M"],
			uturn: ["5M", "5L43"],
			wakeupslap: ["5L50"],
			workup: ["5M"],
		},
	},
	genesect: {
		inherit: true,
		learnset: {
			aerialace: ["5M"],
			blizzard: ["5M"],
			bugbuzz: ["5L55"],
			chargebeam: ["5M"],
			doubleteam: ["5M"],
			energyball: ["5M"],
			explosion: ["5M"],
			facade: ["5M"],
			flamecharge: ["5M", "5L18"],
			flamethrower: ["5M"],
			flash: ["5M"],
			flashcannon: ["5M"],
			fly: ["5M"],
			frustration: ["5M"],
			furycutter: ["5L7"],
			gigaimpact: ["5M"],
			hiddenpower: ["5M"],
			honeclaws: ["5M"],
			hyperbeam: ["5M", "5L73"],
			icebeam: ["5M"],
			lightscreen: ["5M"],
			lockon: ["5L11"],
			magnetbomb: ["5L22"],
			magnetrise: ["5L1"],
			metalclaw: ["5L1"],
			metalsound: ["5L33"],
			protect: ["5M"],
			psychic: ["5M"],
			quickattack: ["5L1"],
			reflect: ["5M"],
			rest: ["5M"],
			return: ["5M"],
			rockpolish: ["5M"],
			round: ["5M"],
			screech: ["5L1"],
			selfdestruct: ["5L77"],
			shadowclaw: ["5M"],
			signalbeam: ["5L40"],
			simplebeam: ["5L62"],
			slash: ["5L29"],
			solarbeam: ["5M"],
			strugglebug: ["5M"],
			substitute: ["5M"],
			swagger: ["5M"],
			technoblast: ["5L1"],
			thunder: ["5M"],
			thunderbolt: ["5M"],
			thunderwave: ["5M"],
			toxic: ["5M"],
			triattack: ["5L44"],
			uturn: ["5M"],
			xscissor: ["5M", "5L51"],
			zapcannon: ["5L66"],
		},
	},
};
